import { BULB, MAIN_LOGO } from '../constants/assetConstants';
import ChangeProfileIcon from '../assets/images/settings/changepic.svg';
// this is a duplicate need to figure out if it is this png or the svg below
// import EditIcon from '../assets/images/settings/edit.png';
import EyeIcon from '../assets/images/settings/eye.svg';
import FigureIcon from '../assets/images/settings/Figure.svg';
// can refactor this to be less nested later
// pick a method.. either all svgs as consts or all svgs as imports
import ProfileIcon from '../assets/images/settings/profile.svg';

const ArchiveIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99818 19.2H14.0168C17.6536 19.2 19.2075 17.6462 19.2075 14.0094V9.99075C19.2075 6.35391 17.6536 4.80005 14.0168 4.80005H9.99818C6.36135 4.80005 4.80749 6.35391 4.80749 9.99075V12.5898C4.80308 12.6159 4.80078 12.6426 4.80078 12.6698C4.80078 12.6974 4.80308 12.7245 4.80749 12.7509V14.0094C4.80749 17.6462 6.36135 19.2 9.99818 19.2ZM5.81214 13.1721V14.0094C5.81214 17.097 6.91056 18.1954 9.99818 18.1954H14.0168C17.1044 18.1954 18.2028 17.097 18.2028 14.0094V13.1721H16.1801C15.8586 13.1721 15.5706 13.3463 15.43 13.6343L14.8339 14.8332C14.5191 15.4627 13.8895 15.8512 13.1863 15.8512H10.822C10.0852 15.8512 9.50255 15.4895 9.17436 14.8332L8.57827 13.6343C8.43762 13.3463 8.14962 13.1721 7.82813 13.1721H5.81214ZM5.81214 12.1675H7.82813C8.53139 12.1675 9.16097 12.556 9.47576 13.1855L10.0719 14.3844C10.2259 14.6925 10.4737 14.8466 10.822 14.8466H13.1863C13.5078 14.8466 13.7958 14.6724 13.9364 14.3844L14.5325 13.1855C14.8473 12.556 15.4769 12.1675 16.1801 12.1675H18.2028V9.99075C18.2028 6.90312 17.1044 5.8047 14.0168 5.8047H9.99818C6.91056 5.8047 5.81214 6.90312 5.81214 9.99075V12.1675Z"
        fill="currentColor"
      />
    </svg>
  );
};
const ArrowDownIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M19.0054 8.0084C18.7449 7.73027 18.3225 7.73027 18.062 8.0084L12.0008 14.4792L5.9396 8.0084C5.67908 7.73027 5.25669 7.73027 4.99617 8.0084C4.73565 8.28653 4.73565 8.73746 4.99617 9.01559L11.5302 15.9912C11.7907 16.2693 12.2131 16.2693 12.4736 15.9912C12.4848 15.9793 12.4955 15.967 12.5057 15.9545L19.0054 9.01559C19.2659 8.73746 19.2659 8.28653 19.0054 8.0084Z"
        fill="currentColor"
      />
    </svg>
  );
};
const SelectArrowDownIcon = (props) => {
  return (
    <svg
      width="16"
      height="8"
      viewBox="0 0 16 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M7.99981 7.54188C7.41832 7.54188 6.83684 7.31759 6.39657 6.87733L0.98048 1.46123C0.73958 1.22033 0.73958 0.821599 0.98048 0.580699C1.22138 0.339799 1.62011 0.339799 1.86101 0.580699L7.27711 5.99679C7.67584 6.39552 8.32377 6.39552 8.72251 5.99679L14.1386 0.580699C14.3795 0.339799 14.7782 0.339799 15.0191 0.580699C15.26 0.821599 15.26 1.22033 15.0191 1.46123L9.60304 6.87733C9.16277 7.31759 8.58129 7.54188 7.99981 7.54188Z"
        fill="#5A5C61"
      />
    </svg>
  );
};
const BinIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.23865 6.33357L9.0955 7.18597C8.46767 7.22005 7.84106 7.26805 7.2159 7.3315L5.84958 7.46546C5.57497 7.49225 5.37404 7.73336 5.40083 8.01466C5.42762 8.29597 5.67544 8.49689 5.95674 8.4701L6.4494 8.4218L7.27619 16.8624C7.34986 17.9072 7.44363 19.1999 9.78111 19.1999H14.081C16.4185 19.1999 16.5123 17.9072 16.5859 16.8624L17.2815 8.40993C17.4894 8.42919 17.6974 8.44927 17.9054 8.4701H17.9589C18.2135 8.4701 18.4345 8.27587 18.4546 8.01466C18.4814 7.74006 18.2804 7.49225 18.0058 7.46546C16.9267 7.35954 15.8481 7.2727 14.7712 7.2126L14.7709 7.21096L14.6236 6.34027L14.6229 6.33633C14.5225 5.72016 14.3724 4.7998 12.8085 4.7998H11.0537C9.49428 4.7998 9.34603 5.68932 9.23888 6.33219L9.23865 6.33357ZM16.2785 8.32356C13.3233 8.08899 10.3756 8.037 7.45097 8.32341L8.28084 16.7954L8.28097 16.7973C8.35454 17.8139 8.38214 18.1952 9.78111 18.1952H14.081C15.4875 18.1952 15.5143 17.8135 15.5813 16.7954L16.2785 8.32356ZM13.639 6.50771L13.7501 7.16384C12.538 7.11603 11.3285 7.10523 10.1231 7.14238L10.2366 6.50101L10.2376 6.49498C10.3372 5.90429 10.3529 5.81115 11.0604 5.81115H12.8152C13.5252 5.81115 13.5452 5.92501 13.639 6.50771ZM13.043 15.5161H10.8126C10.538 15.5161 10.3103 15.2883 10.3103 15.0137C10.3103 14.7391 10.538 14.5114 10.8126 14.5114H13.043C13.3176 14.5114 13.5453 14.7391 13.5453 15.0137C13.5453 15.2883 13.3176 15.5161 13.043 15.5161ZM10.2567 12.837H13.6055C13.8801 12.837 14.1078 12.6093 14.1078 12.3347C14.1078 12.0601 13.8801 11.8323 13.6055 11.8323H10.2567C9.98209 11.8323 9.75437 12.0601 9.75437 12.3347C9.75437 12.6093 9.98209 12.837 10.2567 12.837Z"
        fill="currentColor"
      />
    </svg>
  );
};
const BulbIcon = (props) => {
  return <img src={BULB} />;
};
const CameraIcon = (props) => {
  return (
    <svg
      width="24"
      height="21"
      viewBox="0 0 24 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.56341 20.4955H12.5842C16.4126 20.4955 18.0076 19.0666 18.1387 15.439L19.8593 16.6441C20.588 17.153 21.2241 17.3149 21.7215 17.3149C22.1495 17.3149 22.4964 17.1993 22.7162 17.072C23.1904 16.8291 24.0001 16.1583 24.0001 14.4812V6.00304C24.0001 4.32593 23.1904 3.66665 22.7162 3.41219C22.242 3.16929 21.2357 2.8917 19.8593 3.85171L18.1387 5.05678C18.0077 1.42905 16.4127 0 12.5842 0H5.56341C1.56145 0 0 1.56145 0 5.56341V14.9321C0 17.6155 1.45736 20.4955 5.56341 20.4955ZM18.1476 13.3015V7.19432L20.8656 5.2975C21.3861 4.93894 21.7562 4.90424 21.9066 4.98521C22.0569 5.06617 22.242 5.37846 22.242 6.01461V14.4812C22.242 15.1057 22.0685 15.4296 21.9066 15.5106C21.7562 15.5915 21.3861 15.5568 20.8656 15.1983L18.1476 13.3015ZM1.75808 5.56341C1.75808 2.54459 2.54459 1.75808 5.56341 1.75808H12.5842C15.603 1.75808 16.3895 2.54459 16.3895 5.56341V14.9321C16.3895 17.9509 15.603 18.7375 12.5842 18.7375H5.56341C2.25543 18.7375 1.75808 16.3548 1.75808 14.9321V5.56341Z"
        fill="currentColor"
      />
    </svg>
  );
};
const CloseCircleIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99687 15.1998C4.02515 15.1998 0.796875 11.9715 0.796875 7.9998C0.796875 4.02808 4.02515 0.799805 7.99687 0.799805C11.9686 0.799805 15.1969 4.02808 15.1969 7.9998C15.1969 11.9715 11.9686 15.1998 7.99687 15.1998ZM7.99687 1.80446C4.58106 1.80446 1.80153 4.58399 1.80153 7.9998C1.80153 11.4156 4.58106 14.1952 7.99687 14.1952C11.4127 14.1952 14.1922 11.4156 14.1922 7.9998C14.1922 4.58399 11.4127 1.80446 7.99687 1.80446ZM6.10134 10.3975C5.97408 10.3975 5.84683 10.3506 5.74636 10.2501C5.55213 10.0559 5.55213 9.73441 5.74636 9.54018L7.28683 7.99971L5.74636 6.45925C5.55213 6.26501 5.55213 5.94353 5.74636 5.74929C5.9406 5.55506 6.26208 5.55506 6.45632 5.74929L7.99678 7.28976L9.53725 5.74929C9.73148 5.55506 10.053 5.55506 10.2472 5.74929C10.4414 5.94353 10.4414 6.26501 10.2472 6.45925L8.70674 7.99971L10.2472 9.54018C10.4414 9.73441 10.4414 10.0559 10.2472 10.2501C10.1467 10.3506 10.0195 10.3975 9.89222 10.3975C9.76497 10.3975 9.63771 10.3506 9.53725 10.2501L7.99678 8.70967L6.45632 10.2501C6.36255 10.3506 6.2286 10.3975 6.10134 10.3975Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const CloseIcon = (props) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <title>{props?.title || ''}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5703 17.4852C16.0857 18.0006 16.9405 18.0006 17.4559 17.4852C17.9713 16.9698 17.9713 16.115 17.4559 15.5996L10.8563 9L17.4559 2.4004C17.9713 1.885 17.9713 1.03019 17.4559 0.514786C16.9405 -0.000616216 16.0857 -0.000616216 15.5703 0.514785L8.97069 7.11438L2.37096 0.514658C1.85556 -0.000744722 1.00075 -0.000744551 0.485347 0.514658C-0.0300558 1.03006 -0.0300557 1.88487 0.485346 2.40028L7.08507 9L0.485346 15.5997C-0.030056 16.1151 -0.030056 16.9699 0.485346 17.4853C1.00075 18.0007 1.85556 18.0007 2.37096 17.4853L8.97069 10.8856L15.5703 17.4852Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const CloseIcon2 = (props) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.88546 11.0911C10.2028 11.4004 10.729 11.4004 11.0463 11.0911C11.3636 10.7819 11.3636 10.269 11.0463 9.95976L6.98341 6L11.0463 2.04024C11.3636 1.731 11.3636 1.21811 11.0463 0.908871C10.729 0.59963 10.2028 0.599629 9.88546 0.908871L5.82258 4.86863L1.75963 0.908794C1.44233 0.599552 0.916087 0.599553 0.598793 0.908794C0.281498 1.21804 0.281497 1.73092 0.598792 2.04016L4.66175 6L0.598792 9.95983C0.281497 10.2691 0.281499 10.782 0.598792 11.0912C0.916086 11.4004 1.44233 11.4004 1.75963 11.0912L5.82258 7.13137L9.88546 11.0911Z"
        fill="currentColor"
      />
    </svg>
  );
};
const CloseIconSmall = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6312 11.3941C10.8374 11.6002 11.1793 11.6002 11.3855 11.3941C11.5916 11.1879 11.5916 10.846 11.3855 10.6398L8.74565 8L11.3855 5.36016C11.5916 5.154 11.5916 4.81207 11.3855 4.60591C11.1793 4.39975 10.8374 4.39975 10.6312 4.60591L7.9914 7.24575L5.35151 4.60586C5.14535 4.3997 4.80342 4.3997 4.59726 4.60586C4.3911 4.81202 4.3911 5.15395 4.59726 5.36011L7.23715 8L4.59726 10.6399C4.3911 10.8461 4.3911 11.188 4.59726 11.3941C4.80342 11.6003 5.14535 11.6003 5.35151 11.3941L7.9914 8.75425L10.6312 11.3941Z"
        fill="currentColor"
      />
    </svg>
  );
};
const CollectionIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0069 4.7998C8.29077 4.7998 6.94538 5.13965 6.043 6.04202C5.14062 6.9444 4.80078 8.2898 4.80078 10.006V13.9937C4.80078 15.7098 5.14062 17.0552 6.043 17.9576C6.94538 18.86 8.29077 19.1998 10.0069 19.1998H13.9946C15.7108 19.1998 17.0562 18.86 17.9586 17.9576C18.8609 17.0552 19.2008 15.7098 19.2008 13.9937V10.006C19.2008 8.2898 18.8609 6.9444 17.9586 6.04202C17.0562 5.13965 15.7108 4.7998 13.9946 4.7998H10.0069ZM5.90847 10.006C5.90847 8.39905 6.23325 7.41829 6.82626 6.82528C7.41926 6.23227 8.40002 5.9075 10.0069 5.9075H11.4008V11.3998H5.90847V10.006ZM5.90847 12.5998V13.9937C5.90847 15.6006 6.23325 16.5813 6.82626 17.1743C7.41926 17.7673 8.40002 18.0921 10.0069 18.0921H11.4008V12.5998H5.90847ZM12.6008 12.5998V18.0921H13.9946C15.6015 18.0921 16.5823 17.7673 17.1753 17.1743C17.7683 16.5813 18.0931 15.6006 18.0931 13.9937V12.5998H12.6008ZM18.0931 11.3998V10.006C18.0931 8.39905 17.7683 7.41829 17.1753 6.82528C16.5823 6.23227 15.6015 5.9075 13.9946 5.9075H12.6008V11.3998H18.0931Z"
        fill="currentColor"
      />
    </svg>
  );
};
const CommentIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7952 18.5586C11.1033 18.966 11.5386 19.1998 12.0008 19.1998C12.4629 19.1998 12.8983 18.966 13.2064 18.5586L14.211 17.2228C14.2445 17.1827 14.2914 17.156 14.345 17.156H14.6799C17.6402 17.156 19.2008 15.5998 19.2008 12.6477V9.30815C19.2008 6.35602 17.6402 4.7998 14.6799 4.7998H9.32171C6.36134 4.7998 4.80078 6.35602 4.80078 9.30815V12.6477C4.80078 16.4013 6.52878 17.156 9.32171 17.156H9.6566C9.69008 17.1627 9.77046 17.1961 9.79055 17.2228L10.7952 18.5586ZM5.80543 9.30815C5.80543 6.91706 6.92394 5.80166 9.32171 5.80166H14.6799C17.0776 5.80166 18.1961 6.91706 18.1961 9.30815V12.6477C18.1961 15.0388 17.0776 16.1542 14.6799 16.1542H14.345C13.9766 16.1542 13.6283 16.3278 13.4073 16.6217L12.4026 17.9575C12.1682 18.2647 11.8333 18.2647 11.5989 17.9575L10.5943 16.6217C10.3866 16.3479 9.99818 16.1542 9.6566 16.1542H9.32171C6.84357 16.1542 5.80543 15.6666 5.80543 12.6477V9.30815Z"
        fill="currentColor"
      />
    </svg>
  );
};

const CrownIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1619 13.1448H4.88936C4.39556 13.1448 3.89509 12.7911 3.72827 12.3307L0.96566 4.59672C0.625339 3.62247 0.872238 3.17538 1.13916 2.97519C1.40608 2.775 1.90655 2.65489 2.74734 3.25546L5.3498 5.11721C5.42987 5.16392 5.50327 5.18394 5.55666 5.1706C5.61671 5.15058 5.66343 5.09719 5.69679 5.00377L6.87123 1.87415C7.2249 0.939937 7.74539 0.799805 8.02565 0.799805C8.30592 0.799805 8.82641 0.939937 9.18008 1.87415L10.3545 5.00377C10.3879 5.09052 10.4346 5.15058 10.4947 5.1706C10.5547 5.19061 10.6281 5.1706 10.7015 5.11054L13.1438 3.3689C14.038 2.72829 14.5585 2.85508 14.8454 3.06194C15.1257 3.27547 15.3859 3.74925 15.0189 4.78356L12.323 12.3307C12.1562 12.7911 11.6557 13.1448 11.1619 13.1448ZM1.80645 3.85602C1.8198 3.94944 1.84649 4.0829 1.91322 4.2564L4.67583 11.9904C4.70252 12.0571 4.82263 12.1438 4.88936 12.1438H11.1619C11.2354 12.1438 11.3555 12.0571 11.3755 11.9904L14.0714 4.44992C14.1648 4.19634 14.1915 4.02285 14.1981 3.92275C14.0981 3.95612 13.9446 4.02952 13.7244 4.18967L11.2821 5.93131C10.9484 6.16487 10.5547 6.23827 10.201 6.1315C9.84737 6.02473 9.56044 5.74447 9.41363 5.36411L8.23919 2.23449C8.15244 2.00094 8.07237 1.8875 8.02565 1.83411C7.97894 1.8875 7.89887 2.00094 7.81212 2.22782L6.63768 5.35744C6.49755 5.7378 6.21061 6.01806 5.85027 6.12483C5.4966 6.2316 5.09622 6.15819 4.76925 5.92464L2.16679 4.06288C2.01332 3.95612 1.8932 3.88939 1.80645 3.85602ZM11.6955 15.16H4.35524C4.08165 15.16 3.85477 14.9332 3.85477 14.6596C3.85477 14.386 4.08165 14.1591 4.35524 14.1591H11.6955C11.9691 14.1591 12.196 14.386 12.196 14.6596C12.196 14.9332 11.9691 15.16 11.6955 15.16ZM6.35713 9.82166H9.69361C9.9672 9.82166 10.1941 9.59478 10.1941 9.32119C10.1941 9.0476 9.9672 8.82072 9.69361 8.82072H6.35713C6.08354 8.82072 5.85666 9.0476 5.85666 9.32119C5.85666 9.59478 6.08354 9.82166 6.35713 9.82166Z"
        fill="currentColor"
      />
    </svg>
  );
};
const DownloadIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0101 19.1998H9.99148C6.35464 19.1998 4.80078 17.6459 4.80078 14.0091V9.9905C4.80078 6.35367 6.35464 4.7998 9.99148 4.7998H13.3403C13.4569 4.7998 13.565 4.84082 13.6508 4.90904C13.6662 4.92085 13.6811 4.93356 13.6953 4.94715L19.0534 10.3053C19.0916 10.3434 19.1228 10.3874 19.1465 10.4351C19.1812 10.5031 19.2008 10.5797 19.2008 10.6603V14.0091C19.2008 17.6459 17.6469 19.1998 14.0101 19.1998ZM18.1961 11.1626V14.0091C18.1961 17.0967 17.0977 18.1952 14.0101 18.1952H9.99148C6.90385 18.1952 5.80543 17.0967 5.80543 14.0091V9.9905C5.80543 6.90287 6.90385 5.80446 9.99148 5.80446H12.838V7.98119C12.838 10.2718 13.7288 11.1626 16.0194 11.1626H18.1961ZM9.96491 15.8502C9.97367 15.8507 9.98251 15.851 9.99148 15.851L10.0079 15.8507C10.1233 15.847 10.2377 15.8045 10.3312 15.7182C10.3364 15.7135 10.3415 15.7086 10.3465 15.7036L11.686 14.3641C11.8802 14.1699 11.8802 13.8484 11.686 13.6541C11.4918 13.4599 11.1703 13.4599 10.976 13.6541L10.4938 14.1364V11.33C10.4938 11.0554 10.2661 10.8277 9.99148 10.8277C9.71687 10.8277 9.48915 11.0554 9.48915 11.33V14.1364L9.00688 13.6541C8.81265 13.4599 8.49116 13.4599 8.29693 13.6541C8.1027 13.8483 8.1027 14.1698 8.29693 14.364L9.61222 15.6793C9.64862 15.7213 9.69219 15.7572 9.74167 15.7846C9.81141 15.8249 9.88782 15.8463 9.96491 15.8502ZM13.8426 7.98119V6.5144L17.4862 10.1579H16.0194C14.2914 10.1579 13.8426 9.70919 13.8426 7.98119Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DownloadHollowIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <mask
        id="mask0_3140_9808"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3140_9808)">
        <path
          d="M3.33301 18.3346V16.668H16.6663V18.3346H3.33301ZM9.99967 15.0013L4.16634 7.5013H7.49967V1.66797H12.4997V7.5013H15.833L9.99967 15.0013ZM9.99967 12.293L12.4163 9.16797H10.833V3.33464H9.16634V9.16797H7.58301L9.99967 12.293Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

const EditIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.35631 18.7223C5.68261 19.0326 6.13625 19.1998 6.62172 19.1998C6.70334 19.1998 6.78169 19.1932 6.86305 19.1864C6.90863 19.1826 6.95515 19.1788 7.00373 19.1759L9.56637 18.7382C10.0518 18.6586 10.6726 18.3243 11.0069 17.9662L17.5408 11.0503C19.1723 9.32325 19.1246 7.62013 17.3976 5.98863C15.6706 4.35714 13.9674 4.40489 12.3359 6.13189L5.80199 13.0478C5.45977 13.398 5.16531 14.0427 5.1096 14.5281L4.81513 17.1067C4.74351 17.7434 4.94247 18.3323 5.35631 18.7223ZM13.2034 6.9357C13.7446 6.36268 14.2778 5.98067 14.8906 5.98067C15.3841 5.98067 15.9332 6.23535 16.5699 6.84815C18.0104 8.2011 17.6522 9.17204 16.6654 10.2226L15.7857 11.1537C14.0723 10.8628 12.7065 9.55885 12.3305 7.86069L13.2034 6.9357ZM11.3798 8.86812L6.66947 13.8596C6.5103 14.0267 6.32725 14.4247 6.29542 14.6555L6.00095 17.234C5.96912 17.4967 6.03279 17.7115 6.17604 17.8468C6.31929 17.9821 6.53417 18.0299 6.79681 17.9901L9.35945 17.5524C9.59025 17.5126 9.97226 17.3057 10.1314 17.1385L14.8434 12.151C13.2477 11.6465 11.9683 10.4353 11.3798 8.86812Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const EditIconV3 = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      {...props}>
      <path
        d="M5.70788 6.18529C6.3685 6.18529 6.90404 5.64975 6.90404 4.98913C6.90404 4.32851 6.3685 3.79297 5.70788 3.79297C5.04726 3.79297 4.51172 4.32851 4.51172 4.98913C4.51172 5.64975 5.04726 6.18529 5.70788 6.18529Z"
        stroke="#FEFFFF"
        stroke-width="0.67284"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.09841 1.39844H5.70609C2.71569 1.39844 1.51953 2.5946 1.51953 5.585V9.17348C1.51953 12.1639 2.71569 13.36 5.70609 13.36H9.29457C12.285 13.36 13.4811 12.1639 13.4811 9.17348V6.18308"
        stroke="#FEFFFF"
        stroke-width="0.67284"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.7723 1.75052L9.60125 3.92155C9.51751 4.00528 9.43378 4.16676 9.42182 4.28638L9.30221 5.11771C9.26034 5.41675 9.46967 5.62608 9.76871 5.58421L10.6 5.46459C10.7137 5.44665 10.8811 5.3689 10.9649 5.28517L13.1359 3.11414C13.5127 2.73735 13.6861 2.30673 13.1359 1.7565C12.5797 1.1943 12.1491 1.37373 11.7723 1.75052Z"
        stroke="#FEFFFF"
        stroke-width="0.67284"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.4609 2.0625C11.6463 2.72039 12.1607 3.23474 12.8186 3.42014L11.4609 2.0625Z"
        fill="#FEFFFF"
      />
      <path
        d="M11.4609 2.0625C11.6463 2.72039 12.1607 3.23474 12.8186 3.42014"
        stroke="#FEFFFF"
        stroke-width="0.67284"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.92188 11.5371L4.87041 9.55741C5.34289 9.24043 6.0247 9.27631 6.44934 9.64114L6.64671 9.81459C7.11321 10.2153 7.86679 10.2153 8.33329 9.81459L10.8213 7.67944C11.2878 7.27873 12.0414 7.27873 12.5079 7.67944L13.4828 8.51675"
        stroke="#FEFFFF"
        stroke-width="0.67284"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const FileUploadIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0062 15.2008H5.98757C2.35074 15.2008 0.796875 13.6469 0.796875 10.0101V5.99148C0.796875 2.35464 2.35074 0.800781 5.98757 0.800781H9.33641C9.45296 0.800781 9.56106 0.8418 9.64689 0.910014C9.66229 0.921822 9.67715 0.934535 9.69139 0.948123L15.0495 6.30626C15.0877 6.34439 15.1189 6.38842 15.1426 6.4361C15.1772 6.50406 15.1969 6.58063 15.1969 6.66125V10.0101C15.1969 13.6469 13.643 15.2008 10.0062 15.2008ZM14.1922 7.16356V10.0101C14.1922 13.0977 13.0938 14.1961 10.0062 14.1961H5.98757C2.89994 14.1961 1.80153 13.0977 1.80153 10.0101V5.99148C1.80153 2.90385 2.89994 1.80543 5.98757 1.80543H8.83408V3.98217C8.83408 6.27277 9.72487 7.16356 12.0155 7.16356H14.1922ZM5.48521 11.3496C5.48521 11.6242 5.71293 11.8519 5.98753 11.8519C6.26214 11.8519 6.48986 11.6242 6.48986 11.3496V8.54325L6.97209 9.02549C7.07256 9.12595 7.19981 9.17284 7.32707 9.17284C7.45432 9.17284 7.58158 9.12595 7.68204 9.02549C7.87628 8.83125 7.87628 8.50977 7.68204 8.31553L6.3666 7.00008C6.31899 6.94526 6.25916 6.90087 6.18988 6.87214C6.18339 6.86932 6.17684 6.86664 6.17025 6.86411C6.06598 6.82259 5.95222 6.81966 5.84811 6.84967C5.76885 6.87217 5.69428 6.91427 5.63256 6.976L5.62917 6.97942L4.29302 8.31556C4.09879 8.5098 4.09879 8.83129 4.29302 9.02552C4.48726 9.21975 4.80874 9.21975 5.00298 9.02552L5.48521 8.54329V11.3496ZM9.83873 3.98217V2.51538L13.4823 6.15891H12.0155C10.2875 6.15891 9.83873 5.71017 9.83873 3.98217Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const FullScreenIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.0931 9.78442C18.0931 10.0872 18.3442 10.3383 18.6469 10.3383C18.9497 10.3383 19.2008 10.0872 19.2008 9.78442V5.35365C19.2008 5.2705 19.1818 5.19125 19.1481 5.12003C19.1217 5.06267 19.0851 5.00909 19.0383 4.96222C18.9905 4.91448 18.9358 4.87738 18.8772 4.85092C18.8069 4.81816 18.7288 4.7998 18.6469 4.7998H14.2162C13.9134 4.7998 13.6623 5.05088 13.6623 5.35365C13.6623 5.65642 13.9134 5.9075 14.2162 5.9075H17.3102L12.717 10.5007C12.5029 10.7148 12.5029 11.0693 12.717 11.2835C12.8278 11.3942 12.9681 11.4459 13.1084 11.4459C13.2487 11.4459 13.389 11.3942 13.4998 11.2835L18.0931 6.69018V9.78442ZM5.35463 19.1998H9.7854C10.0882 19.1998 10.3392 18.9487 10.3392 18.646C10.3392 18.3432 10.0882 18.0921 9.7854 18.0921H6.69115L11.2844 13.4988C11.4986 13.2847 11.4986 12.9302 11.2844 12.7161C11.0703 12.5019 10.7158 12.5019 10.5017 12.7161L5.90847 17.3093V14.2152C5.90847 13.9124 5.6574 13.6613 5.35463 13.6613C5.05186 13.6613 4.80078 13.9124 4.80078 14.2152V18.646C4.80078 18.7279 4.81915 18.806 4.85194 18.8763C4.87839 18.9349 4.91548 18.9896 4.9632 19.0373C5.06501 19.1391 5.19177 19.191 5.32055 19.1987C5.33183 19.1994 5.34319 19.1998 5.35463 19.1998Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const HeadsetIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 10.4445C5 6.5789 8.13444 3.5 12 3.5C15.8656 3.5 19 6.5789 19 10.4445V18.2222C19 18.4328 19.0077 18.6367 19.0151 18.8305C19.0529 19.8255 19.0806 20.5556 18 20.5556H12V19.5H18V18H15C14.4477 18 14 17.5523 14 17V13C14 12.4477 14.4477 12 15 12H18V10C18 6.99 15.01 4.5 12 4.5C8.99 4.5 6 6.99 6 10V12H9C9.55228 12 10 12.4477 10 13V17C10 17.5523 9.55228 18 9 18H7.33333C6.04222 18 5 17.18 5 15.8889V10.4445ZM9 13V17H7.5C6.675 17 6 16.55 6 16V13H9ZM18 13V17H15V13H18Z"
        fill="currentColor"
      />
    </svg>
  );
};

const HeartIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M 12.0008 18.3269 C 11.7932 18.3269 11.5922 18.3001 11.4248 18.2398 C 8.8663 17.3624 4.8008 14.248 4.8008 9.6467 C 4.8008 7.3025 6.6962 5.4004 9.027 5.4004 C 10.1589 5.4004 11.2172 5.8424 12.0008 6.6328 C 12.7844 5.8424 13.8426 5.4004 14.9745 5.4004 C 17.3053 5.4004 19.2008 7.3092 19.2008 9.6467 C 19.2008 14.2547 15.1353 17.3624 12.5768 18.2398 C 12.4093 18.3001 12.2084 18.3269 12.0008 18.3269 Z Z"
        fill="#E4291D"
      />
    </svg>
  );
};
const HeartLineIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M12.0008 18.3269C11.7932 18.3269 11.5922 18.3001 11.4248 18.2398C8.86627 17.3624 4.80078 14.248 4.80078 9.64672C4.80078 7.30253 6.69622 5.40039 9.02701 5.40039C10.1589 5.40039 11.2172 5.84244 12.0008 6.63276C12.7844 5.84244 13.8426 5.40039 14.9745 5.40039C17.3053 5.40039 19.2008 7.30923 19.2008 9.64672C19.2008 14.2547 15.1353 17.3624 12.5768 18.2398C12.4093 18.3001 12.2084 18.3269 12.0008 18.3269ZM9.02701 6.40504C7.25213 6.40504 5.80543 7.85844 5.80543 9.64672C5.80543 14.2212 10.2058 16.7663 11.753 17.2955C11.8735 17.3356 12.1347 17.3356 12.2553 17.2955C13.7958 16.7663 18.2028 14.2279 18.2028 9.64672C18.2028 7.85844 16.7561 6.40504 14.9812 6.40504C13.9632 6.40504 13.0188 6.88058 12.4093 7.70439C12.2218 7.9589 11.7932 7.9589 11.6056 7.70439C10.9827 6.87388 10.0451 6.40504 9.02701 6.40504Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const ImageIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="72"
      height="56"
      viewBox="0 0 72 56"
      fill="none"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.3418 39.989H32.6472C26.5886 39.989 24 37.4004 24 31.3418V24.6472C24 18.5886 26.5886 16 32.6472 16H39.3418C45.4004 16 47.989 18.5886 47.989 24.6472V29.9793C48.0036 30.0688 48.0037 30.1606 47.989 30.2509V31.3418C47.989 37.4004 45.4004 39.989 39.3418 39.989ZM46.3154 30.4918V31.3418C46.3154 36.4855 44.4855 38.3154 39.3418 38.3154H32.6472C29.5764 38.3154 27.6867 37.6632 26.6623 36.043L31.5538 32.7589C32.1228 32.3684 32.9708 32.413 33.484 32.8482L33.8523 33.1717C35.0461 34.1871 36.9095 34.1871 38.0922 33.1717L42.7338 29.1884C43.2917 28.7087 44.2401 28.7087 44.7979 29.1884L46.3154 30.4918ZM46.3154 28.2806L45.8914 27.9165C44.6975 26.9011 42.8342 26.9011 41.6515 27.9165L37.0099 31.8998C36.4632 32.3795 35.5147 32.3795 34.9569 31.8998L34.5887 31.5762C33.4952 30.6501 31.8327 30.5497 30.6277 31.3642L26.0039 34.4686C25.7771 33.6004 25.6737 32.5647 25.6737 31.3418V24.6472C25.6737 19.5035 27.5035 17.6737 32.6472 17.6737H39.3418C44.4855 17.6737 46.3154 19.5035 46.3154 24.6472V28.2806ZM32.6472 26.5998C30.9512 26.5998 29.5788 25.2274 29.5788 23.5314C29.5788 21.8355 30.9512 20.4631 32.6472 20.4631C34.3432 20.4631 35.7156 21.8355 35.7156 23.5314C35.7156 25.2274 34.3432 26.5998 32.6472 26.5998ZM32.6472 22.1367C31.8773 22.1367 31.2525 22.7616 31.2525 23.5314C31.2525 24.3013 31.8773 24.9261 32.6472 24.9261C33.4171 24.9261 34.0419 24.3013 34.0419 23.5314C34.0419 22.7616 33.4171 22.1367 32.6472 22.1367Z"
        fill="currentColor"
      />
    </svg>
  );
};
const InfoIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0008 19.1998C8.02906 19.1998 4.80078 15.9715 4.80078 11.9998C4.80078 8.02808 8.02906 4.7998 12.0008 4.7998C15.9725 4.7998 19.2008 8.02808 19.2008 11.9998C19.2008 15.9715 15.9725 19.1998 12.0008 19.1998ZM12.0008 5.80446C8.58497 5.80446 5.80543 8.58399 5.80543 11.9998C5.80543 15.4156 8.58497 18.1952 12.0008 18.1952C15.4166 18.1952 18.1961 15.4156 18.1961 11.9998C18.1961 8.58399 15.4166 5.80446 12.0008 5.80446ZM12.0008 15.1082C11.7262 15.1082 11.4985 14.8805 11.4985 14.6059V11.257C11.4985 10.9824 11.7262 10.7547 12.0008 10.7547C12.2754 10.7547 12.5031 10.9824 12.5031 11.257V14.6059C12.5031 14.8805 12.2754 15.1082 12.0008 15.1082ZM11.7463 10.1011C11.8266 10.1346 11.9137 10.1546 12.0008 10.1546C12.0879 10.1546 12.1749 10.1346 12.2553 10.1011C12.3357 10.0676 12.4093 10.0207 12.4763 9.96041C12.5366 9.89343 12.5835 9.82646 12.617 9.73939C12.6505 9.65901 12.6706 9.57195 12.6706 9.48488C12.6706 9.39781 12.6505 9.31074 12.617 9.23036C12.5835 9.14999 12.5366 9.07632 12.4763 9.00934C12.4093 8.94906 12.3357 8.90218 12.2553 8.86869C12.0946 8.80171 11.907 8.80171 11.7463 8.86869C11.6659 8.90218 11.5922 8.94906 11.5253 9.00934C11.465 9.07632 11.4181 9.14999 11.3846 9.23036C11.3511 9.31074 11.331 9.39781 11.331 9.48488C11.331 9.57195 11.3511 9.65901 11.3846 9.73939C11.4181 9.82646 11.465 9.89343 11.5253 9.96041C11.5922 10.0207 11.6659 10.0676 11.7463 10.1011Z"
        fill="currentColor"
      />
    </svg>
  );
};
const LightIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.7357 28.6483H16.5801C16.0886 28.6483 15.463 28.5925 15.0496 28.1679C14.6474 27.7546 14.6586 27.2407 14.6698 26.8944V25.9001C11.8545 24.0233 10 20.7611 10 17.6554C10 14.7172 11.3183 11.969 13.6085 10.1257C15.8987 8.28232 18.9038 7.58968 21.842 8.23764C24.6349 8.85208 27.048 10.7178 28.2992 13.2314C30.7235 18.1134 28.3886 23.3976 24.6573 25.9113V26.7491C24.6684 27.0731 24.6796 27.6652 24.2216 28.1344C23.8753 28.4696 23.3837 28.6483 22.7357 28.6483ZM16.3344 26.9614C16.3582 26.9614 16.3861 26.9634 16.4181 26.9658C16.4611 26.9689 16.5114 26.9726 16.569 26.9726H22.7357C22.8475 26.9726 22.9257 26.9614 22.9703 26.9502V26.8385V25.4309C22.9703 25.1404 23.1267 24.8611 23.3725 24.7159C26.6793 22.7162 28.869 18.1469 26.7799 13.9575C25.7521 11.8908 23.7635 10.3603 21.4622 9.85753C19.0267 9.32129 16.5354 9.89105 14.6363 11.4216C12.7371 12.9521 11.6534 15.2199 11.6534 17.6554C11.6534 20.7611 13.7984 23.4423 15.921 24.7271C16.178 24.8835 16.3232 25.1516 16.3232 25.4421V26.9502C16.3344 26.9502 16.3344 26.9502 16.3344 26.9614ZM19.6414 22.0571C19.4962 22.0571 19.351 22.0236 19.2281 21.9454C18.8259 21.7108 18.6918 21.1969 18.9153 20.8059L19.8649 19.1525H18.9264C18.3679 19.1525 17.9098 18.9067 17.664 18.4934C17.4183 18.0688 17.4406 17.5549 17.7199 17.0634L18.9153 14.9854C19.1499 14.5833 19.6638 14.4492 20.0548 14.6726C20.457 14.9072 20.591 15.4211 20.3676 15.8122L19.418 17.4767H20.3564C20.915 17.4767 21.3731 17.7225 21.6188 18.1359C21.8646 18.5604 21.8423 19.0743 21.563 19.5658L20.3676 21.6438C20.2112 21.9119 19.9319 22.0571 19.6414 22.0571ZM23.3168 31.9665C23.395 31.9888 23.4732 32 23.5514 32C23.9201 32 24.2552 31.7654 24.3558 31.3855C24.4787 30.9387 24.2217 30.4695 23.7749 30.3466C21.0713 29.5757 18.2002 29.5757 15.4966 30.3466C15.0498 30.4806 14.7816 30.9387 14.9157 31.3855C15.0498 31.8324 15.5078 32.0894 15.9547 31.9665C18.3678 31.2738 20.9037 31.2738 23.3168 31.9665Z"
        fill="currentColor"
      />
    </svg>
  );
};
const MetadataIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0698 16.3721H14.4186C16.1153 16.3721 17.4884 14.9991 17.4884 13.3023V13.0233H19.7209V20.5581V26.6977C19.7209 28.3944 21.094 29.7674 22.7907 29.7674H23.6279V29.8232C23.6279 31.0177 24.5991 32 25.8046 32H29.8233C31.0288 32 32 31.0288 32 29.8232V28.0372C32 26.8428 31.0288 25.8605 29.8233 25.8605H25.8046C24.6102 25.8605 23.6279 26.8316 23.6279 28.0372V28.093H22.7907C22.0205 28.093 21.3953 27.4679 21.3953 26.6977V21.3953H23.6279V21.4511C23.6279 22.6456 24.5991 23.6279 25.8046 23.6279H29.8233C31.0288 23.6279 32 22.6567 32 21.4511V19.6651C32 18.4707 31.0288 17.4884 29.8233 17.4884H25.8046C24.6102 17.4884 23.6279 18.4595 23.6279 19.6651V19.7209H21.3953V13.0233H23.6279V13.0791C23.6279 14.2735 24.5991 15.2558 25.8046 15.2558H29.8233C31.0288 15.2558 32 14.2846 32 13.0791V11.293C32 10.0986 31.0288 9.11628 29.8233 9.11628H25.8046C24.6102 9.11628 23.6279 10.0875 23.6279 11.293V11.3488H20.5581H17.4884V11.0698C17.4884 9.37302 16.1153 8 14.4186 8H11.0698C9.37302 8 8 9.37302 8 11.0698V13.3023C8 14.9991 9.37302 16.3721 11.0698 16.3721ZM25.3023 28.9302L25.3023 29.8232C25.3023 30.0912 25.5367 30.3256 25.8046 30.3256H29.8233C30.0912 30.3256 30.3256 30.0912 30.3256 29.8232V28.0372C30.3256 27.7693 30.0912 27.5349 29.8233 27.5349H25.8046C25.5367 27.5349 25.3023 27.7693 25.3023 28.0372L25.3023 28.9302ZM25.3023 21.4511L25.3023 20.5581L25.3023 19.6651C25.3023 19.3972 25.5367 19.1628 25.8046 19.1628H29.8233C30.0912 19.1628 30.3256 19.3972 30.3256 19.6651V21.4511C30.3256 21.7191 30.0912 21.9535 29.8233 21.9535H25.8046C25.5367 21.9535 25.3023 21.7191 25.3023 21.4511ZM15.814 12.186L15.814 11.0698C15.814 10.2995 15.1888 9.67442 14.4186 9.67442H11.0698C10.2995 9.67442 9.67442 10.2995 9.67442 11.0698V13.3023C9.67442 14.0726 10.2995 14.6977 11.0698 14.6977H14.4186C15.1888 14.6977 15.814 14.0726 15.814 13.3023L15.814 12.186ZM25.3023 12.186L25.3023 13.0791C25.3023 13.347 25.5367 13.5814 25.8046 13.5814H29.8233C30.0912 13.5814 30.3256 13.347 30.3256 13.0791V11.293C30.3256 11.0251 30.0912 10.7907 29.8233 10.7907H25.8046C25.5367 10.7907 25.3023 11.0251 25.3023 11.293L25.3023 12.186Z"
        fill="currentColor"
      />
    </svg>
  );
};
const MoreIcon = (props) => {
  return (
    <svg
      width="24"
      height="7"
      viewBox="0 0 24 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.38462 6.76923C1.51385 6.76923 0 5.25538 0 3.38462C0 1.51385 1.51385 0 3.38462 0C5.25538 0 6.76923 1.51385 6.76923 3.38462C6.76923 5.25538 5.25538 6.76923 3.38462 6.76923ZM3.38462 1.84615C2.53538 1.84615 1.84615 2.53538 1.84615 3.38462C1.84615 4.23385 2.53538 4.92308 3.38462 4.92308C4.23385 4.92308 4.92308 4.23385 4.92308 3.38462C4.92308 2.53538 4.23385 1.84615 3.38462 1.84615ZM20.6154 6.76923C18.7446 6.76923 17.2308 5.25538 17.2308 3.38461C17.2308 1.51385 18.7446 0 20.6154 0C22.4862 0 24 1.51385 24 3.38461C24 5.25538 22.4862 6.76923 20.6154 6.76923ZM20.6154 1.84615C19.7662 1.84615 19.0769 2.53538 19.0769 3.38461C19.0769 4.23385 19.7662 4.92308 20.6154 4.92308C21.4646 4.92308 22.1538 4.23385 22.1538 3.38461C22.1538 2.53538 21.4646 1.84615 20.6154 1.84615ZM8.61539 3.38462C8.61539 5.25538 10.1292 6.76923 12 6.76923C13.8708 6.76923 15.3846 5.25538 15.3846 3.38462C15.3846 1.51385 13.8708 0 12 0C10.1292 0 8.61539 1.51385 8.61539 3.38462ZM10.4615 3.38462C10.4615 2.53538 11.1508 1.84615 12 1.84615C12.8492 1.84615 13.5385 2.53538 13.5385 3.38462C13.5385 4.23385 12.8492 4.92308 12 4.92308C11.1508 4.92308 10.4615 4.23385 10.4615 3.38462Z"
        fill="#A3A4A6"
      />
    </svg>
  );
};
export const PlusIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.2008 18.3998C11.2008 18.8371 11.5634 19.1998 12.0008 19.1998C12.4381 19.1998 12.8008 18.8371 12.8008 18.3998V12.7998H18.4008C18.8381 12.7998 19.2008 12.4371 19.2008 11.9998C19.2008 11.5625 18.8381 11.1998 18.4008 11.1998H12.8008V5.5998C12.8008 5.16247 12.4381 4.7998 12.0008 4.7998C11.5634 4.7998 11.2008 5.16247 11.2008 5.5998V11.1998H5.60078C5.16345 11.1998 4.80078 11.5625 4.80078 11.9998C4.80078 12.4371 5.16345 12.7998 5.60078 12.7998H11.2008V18.3998Z"
        fill="currentColor"
      />
    </svg>
  );
};
const ProductIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.6391 23.9665H15.3274C21.1022 23.9665 23.7129 21.6212 23.9488 16.1701C23.9819 16.0808 24 15.9847 24 15.8848C24 15.8016 23.9874 15.7209 23.9641 15.6447C23.9657 15.54 23.9665 15.4343 23.9665 15.3274V8.6391C23.9665 2.58616 21.3804 0 15.3274 0H8.6391C2.58616 0 0 2.58616 0 8.6391V15.3274C0 21.3804 2.58616 23.9665 8.6391 23.9665ZM22.2944 15.0487V8.6391C22.2944 3.50023 20.4663 1.67208 15.3274 1.67208H8.6391C3.50023 1.67208 1.67208 3.50023 1.67208 8.6391V15.0487H22.2944ZM22.2423 16.7208H1.72423C2.05475 20.8013 3.99494 22.2944 8.6391 22.2944H15.3274C19.9716 22.2944 21.9118 20.8013 22.2423 16.7208Z"
        fill="currentColor"
      />
    </svg>
  );
};

const ProjectIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.856 6.72532C9.82846 6.9311 9.82689 7.16546 9.82683 7.45817H14.1701C14.17 7.16546 14.1684 6.9311 14.1409 6.72532C14.1134 6.5199 14.0648 6.38833 13.9995 6.29611C13.8887 6.13983 13.5859 5.9075 12.5435 5.9075H11.4534C10.411 5.9075 10.1082 6.13983 9.99743 6.29611C9.93209 6.38833 9.8835 6.5199 9.856 6.72532ZM9.27298 8.56599L9.26129 8.56587H8.59161C7.19829 8.56587 6.55336 8.8857 6.24982 9.23771C5.94459 9.59168 5.85272 10.1288 5.93951 10.8939L5.9405 10.9033L5.95774 11.0826C7.2267 11.9211 8.63541 12.4685 10.0819 12.7131V12.6645L10.0819 12.641V12.6409C10.0818 12.4956 10.0818 12.343 10.0961 12.2175C10.1108 12.088 10.1512 11.8649 10.3342 11.6864C10.5143 11.5108 10.736 11.4734 10.8635 11.4596C10.9898 11.4459 11.144 11.4459 11.294 11.446L11.3171 11.446H12.6798L12.7029 11.446C12.8529 11.4459 13.0071 11.4459 13.1334 11.4596C13.2609 11.4734 13.4826 11.5108 13.6627 11.6864C13.8456 11.8649 13.8861 12.088 13.9008 12.2175C13.9151 12.343 13.9151 12.4956 13.915 12.6409V12.641L13.915 12.6645V12.6986C15.3714 12.4355 16.7841 11.8791 18.0515 11.0233L18.0633 10.9025L18.0639 10.8961L18.0639 10.8961C18.1476 10.1306 18.0547 9.59281 17.7482 9.2381C17.4437 8.88561 16.7984 8.56587 15.4053 8.56587H14.7356L14.7239 8.56599L14.7122 8.56587H9.28467L9.27298 8.56599ZM11.1896 13.3552C11.1896 13.3506 11.1896 13.346 11.1896 13.3415V12.6645C11.1896 12.6237 11.1896 12.5871 11.1897 12.5539C11.2276 12.5537 11.2696 12.5537 11.3171 12.5537H12.6798C12.7273 12.5537 12.7693 12.5537 12.8072 12.5539C12.8073 12.5871 12.8073 12.6237 12.8073 12.6645V13.3291V13.3291V13.3292V13.3292V13.3292V13.3293V13.3293V13.3293V13.3294V13.3294V13.3295V13.3295V13.3295V13.3296V13.3296V13.3296V13.3297V13.3297V13.3298V13.3298V13.3298V13.3299V13.3299V13.3299V13.33V13.33V13.33V13.3301V13.3301V13.3301V13.3302V13.3302V13.3302V13.3303V13.3303V13.3303V13.3304V13.3304V13.3305V13.3305V13.3305V13.3306V13.3306V13.3306V13.3307V13.3307V13.3307V13.3307V13.3308V13.3308V13.3308V13.3309V13.3309V13.3309V13.331V13.331V13.331V13.3311V13.3311V13.3311V13.3312V13.3312V13.3312V13.3313V13.3313V13.3313V13.3313V13.3314V13.3314V13.3314V13.3315V13.3315V13.3315V13.3316V13.3316V13.3316V13.3316V13.3317V13.3317V13.3317V13.3318V13.3318V13.3318V13.3318V13.3319V13.3319V13.3319V13.332V13.332V13.332V13.332V13.3321V13.3321V13.3321V13.3321V13.3322V13.3322V13.3322V13.3323V13.3323V13.3323V13.3323V13.3324V13.3324V13.3324V13.3324V13.3325V13.3325V13.3325V13.3325V13.3326V13.3326V13.3326V13.3326V13.3327V13.3327V13.3327V13.3327V13.3328V13.3328V13.3328V13.3328V13.3329V13.3329V13.3329V13.3329V13.333V13.333V13.333V13.333V13.3331V13.3331V13.3331V13.3331V13.3332V13.3332V13.3332V13.3332V13.3333V13.3333V13.3333V13.3333V13.3334V13.3334V13.3334C12.8072 13.339 12.8072 13.3446 12.8073 13.3502C12.8073 13.5351 12.8057 13.6664 12.7903 13.7775C12.7755 13.8846 12.7526 13.9292 12.7384 13.949L12.7383 13.9491C12.7286 13.9626 12.6268 14.1045 11.9984 14.1045C11.3719 14.1045 11.2692 13.9635 11.2592 13.9498C11.2452 13.9304 11.2223 13.8867 11.2072 13.781C11.1915 13.671 11.1896 13.5398 11.1896 13.3552ZM10.0987 13.8375C10.102 13.871 10.1059 13.9043 10.1106 13.9374C10.1403 14.1451 10.2051 14.3835 10.3631 14.6009C10.6972 15.0607 11.2759 15.2122 11.9984 15.2122C12.725 15.2122 13.3052 15.0587 13.6382 14.595C13.7951 14.3764 13.8587 14.1373 13.8875 13.9297C13.8923 13.8951 13.8963 13.8601 13.8996 13.8251C15.2926 13.5987 16.6562 13.1293 17.916 12.4108L17.8316 13.2752C17.8019 13.5796 18.0246 13.8505 18.329 13.8802C18.6335 13.9099 18.9043 13.6872 18.9341 13.3828L19.1654 11.0132C19.2585 10.158 19.2008 9.22507 18.5865 8.51395C17.9694 7.79973 16.9216 7.45817 15.4053 7.45817H15.2778C15.2778 7.17884 15.2777 6.86872 15.2388 6.57837C15.1982 6.27474 15.1105 5.94813 14.9033 5.6557C14.4689 5.04268 13.6816 4.7998 12.5435 4.7998H11.4534C10.3153 4.7998 9.52798 5.04268 9.09362 5.6557C8.88642 5.94813 8.79874 6.27474 8.75809 6.57837C8.71923 6.86872 8.71911 7.17884 8.71913 7.45817H8.59161C7.07551 7.45817 6.02724 7.79963 5.41094 8.51434C4.79748 9.22575 4.74191 10.1586 4.83833 11.0139L5.34891 16.3262L5.34886 16.3263L5.34968 16.3337C5.42541 17.0231 5.60418 17.7909 6.24462 18.3616C6.87682 18.925 7.84932 19.1998 9.27298 19.1998H14.7239C16.1476 19.1998 17.1201 18.925 17.7523 18.3616C18.3927 17.7909 18.5715 17.0231 18.6472 16.3337C18.6806 16.0297 18.4612 15.7561 18.1571 15.7227C17.8531 15.6893 17.5795 15.9087 17.5461 16.2128C17.4788 16.826 17.3407 17.2446 17.0153 17.5346C16.6817 17.8319 16.0393 18.0921 14.7239 18.0921H9.27298C7.95755 18.0921 7.31521 17.8319 6.98157 17.5346C6.65683 17.2452 6.51867 16.8277 6.45116 16.2164L6.09009 12.4597C7.34815 13.165 8.7087 13.6274 10.0987 13.8375Z"
        fill="currentColor"
      />
    </svg>
  );
};

const RenderIcon = (props) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7657 22.1668C11.2579 22.5891 11.8808 22.8002 12.5137 22.8002C13.1365 22.8002 13.7694 22.589 14.2616 22.1567L15.8489 20.7993C16.0297 20.6585 16.4215 20.5077 16.6325 20.5077H18.3403C19.8271 20.5077 21.0326 19.3012 21.0326 17.8131V16.1038C21.0326 15.8926 21.1732 15.5005 21.3139 15.3296L22.6701 13.7409C23.5039 12.7656 23.5139 11.2272 22.6701 10.2318L21.3139 8.64318C21.1732 8.47225 21.0226 8.08012 21.0226 7.86897V6.15967C21.0226 4.67158 19.817 3.46502 18.3302 3.46502H16.6224C16.4115 3.46502 15.9996 3.32425 15.8389 3.18348L14.2516 1.8261C13.2671 0.99156 11.7301 0.99156 10.7456 1.8261L9.15832 3.18348C8.98754 3.32425 8.59575 3.47507 8.38478 3.47507H6.64684C5.16004 3.47507 3.95453 4.68163 3.95453 6.16973V7.87903C3.95453 8.09018 3.81389 8.49236 3.68329 8.64318L2.31704 10.2519C1.49328 11.2373 1.49328 12.7656 2.31704 13.7409L3.68329 15.3497C3.81389 15.5005 3.95453 15.9027 3.95453 16.1138V17.8332C3.95453 19.3213 5.16004 20.5278 6.64684 20.5278H8.40487C8.61584 20.5278 9.01767 20.6686 9.17841 20.8094L10.7657 22.1668ZM5.46142 6.16973C5.46142 5.51617 5.99385 4.98327 6.64684 4.98327H8.38478C8.9574 4.98327 9.69075 4.7118 10.1428 4.33977L11.72 2.97234C12.142 2.62042 12.8552 2.62042 13.2671 2.97234L14.8644 4.33977C15.3064 4.7118 16.0498 4.98327 16.6224 4.98327H18.3302C18.9832 4.98327 19.5157 5.51617 19.5157 6.16973V7.88908C19.5157 8.45214 19.7769 9.18614 20.1586 9.6386L21.5148 11.2272C21.8664 11.6395 21.8664 12.3634 21.5148 12.7757L20.1486 14.3744C19.7769 14.8268 19.5056 15.5608 19.5056 16.1239V17.8332C19.5056 18.4867 18.9732 19.0196 18.3202 19.0196H16.6124C16.0498 19.0196 15.3165 19.2811 14.8644 19.6631L13.2771 21.0205C12.8552 21.3724 12.142 21.3724 11.7301 21.0205L10.1328 19.6531C9.69075 19.2811 8.94735 19.0096 8.38478 19.0096H6.63679C5.98381 19.0096 5.45137 18.4767 5.45137 17.8231V16.1038C5.45137 15.5307 5.18013 14.7765 4.81848 14.3643L3.46228 12.7656C3.12072 12.3634 3.12072 11.6395 3.46228 11.2272L4.82852 9.61849C5.20022 9.17608 5.46142 8.45215 5.46142 7.87903V6.16973ZM12.3869 8.38184H9.79155V15.6212H11.2254V12.9413H12.3643L13.6821 15.6212H15.2164V15.5516L13.7101 12.581C13.9046 12.4898 14.0801 12.3812 14.2365 12.2551C14.466 12.0695 14.6428 11.8391 14.7671 11.564C14.8945 11.2855 14.9583 10.9524 14.9583 10.5646C14.9583 10.0906 14.8547 9.69116 14.6476 9.36632C14.4405 9.04147 14.1441 8.79618 13.7586 8.63045C13.3762 8.46471 12.919 8.38184 12.3869 8.38184ZM11.2254 11.7778V9.55028H12.3869C12.6418 9.55028 12.8537 9.59503 13.0225 9.68453C13.1914 9.77403 13.3173 9.9033 13.4001 10.0724C13.483 10.2414 13.5244 10.4419 13.5244 10.674C13.5244 10.8928 13.4814 11.085 13.3953 11.2507C13.3125 11.4165 13.1882 11.5458 13.0225 11.6386C12.8568 11.7314 12.6481 11.7778 12.3964 11.7778H11.2254Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7657 22.1668C11.2579 22.589 11.8808 22.8002 12.5137 22.8002C13.1365 22.8002 13.7694 22.589 14.2616 22.1567L15.8489 20.7993C16.0297 20.6585 16.4215 20.5077 16.6325 20.5077H18.3403C19.8271 20.5077 21.0326 19.3012 21.0326 17.8131V16.1038C21.0326 15.8926 21.1732 15.5005 21.3139 15.3296L22.6701 13.7409C23.5039 12.7656 23.5139 11.2272 22.6701 10.2318L21.3139 8.64318C21.1732 8.47225 21.0226 8.08012 21.0226 7.86897V6.15967C21.0226 4.67158 19.817 3.46502 18.3302 3.46502H16.6224C16.4115 3.46502 15.9996 3.32425 15.8389 3.18348L14.2516 1.8261C13.2671 0.99156 11.7301 0.99156 10.7456 1.8261L9.15832 3.18348C8.98754 3.32425 8.59575 3.47507 8.38478 3.47507H6.64684C5.16004 3.47507 3.95453 4.68163 3.95453 6.16973V7.87903C3.95453 8.09018 3.81389 8.49236 3.68329 8.64318L2.31704 10.2519C1.49328 11.2373 1.49328 12.7656 2.31704 13.7409L3.68329 15.3497C3.81389 15.5005 3.95453 15.9027 3.95453 16.1138V17.8332C3.95453 19.3213 5.16004 20.5278 6.64684 20.5278H8.40487C8.61584 20.5278 9.01767 20.6686 9.17841 20.8094L10.7657 22.1668ZM5.46142 6.16973C5.46142 5.51617 5.99385 4.98327 6.64684 4.98327H8.38478C8.9574 4.98327 9.69075 4.7118 10.1428 4.33977L11.72 2.97234C12.142 2.62042 12.8552 2.62042 13.2671 2.97234L14.8644 4.33977C15.3064 4.7118 16.0498 4.98327 16.6224 4.98327H18.3302C18.9832 4.98327 19.5157 5.51617 19.5157 6.16973V7.88908C19.5157 8.45214 19.7769 9.18614 20.1586 9.6386L21.5148 11.2272C21.8664 11.6395 21.8664 12.3634 21.5148 12.7757L20.1486 14.3744C19.7769 14.8268 19.5056 15.5608 19.5056 16.1239V17.8332C19.5056 18.4867 18.9732 19.0196 18.3202 19.0196H16.6124C16.0498 19.0196 15.3165 19.2811 14.8644 19.6631L13.2771 21.0205C12.8552 21.3724 12.142 21.3724 11.7301 21.0205L10.1328 19.6531C9.69075 19.2811 8.94735 19.0096 8.38478 19.0096H6.63679C5.98381 19.0096 5.45137 18.4767 5.45137 17.8231V16.1038C5.45137 15.5307 5.18013 14.7765 4.81848 14.3643L3.46228 12.7656C3.12072 12.3634 3.12072 11.6395 3.46228 11.2272L4.82852 9.61849C5.20022 9.17608 5.46142 8.45214 5.46142 7.87903V6.16973Z"
        fill="#F46A35"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.46625 6.16934C5.46625 5.51578 5.99868 4.98288 6.65167 4.98288H8.38961C8.96223 4.98288 9.69558 4.71141 10.1476 4.33938L11.7249 2.97194C12.1468 2.62003 12.8601 2.62003 13.2719 2.97194L14.8692 4.33938C15.3113 4.71141 16.0547 4.98288 16.6273 4.98288H18.3351C18.9881 4.98288 19.5205 5.51578 19.5205 6.16934V7.88869C19.5205 8.45175 19.7817 9.18575 20.1634 9.63821L21.5196 11.2268C21.8712 11.6391 21.8712 12.363 21.5196 12.7753L20.1534 14.374C19.7817 14.8264 19.5105 15.5604 19.5105 16.1235V17.8328C19.5105 18.4863 18.978 19.0192 18.325 19.0192H16.6172C16.0547 19.0192 15.3213 19.2807 14.8692 19.6627L13.282 21.0201C12.8601 21.372 12.1468 21.372 11.7349 21.0201L10.1376 19.6527C9.69558 19.2807 8.95218 19.0092 8.38961 19.0092H6.64162C5.98864 19.0092 5.4562 18.4763 5.4562 17.8227V16.1034C5.4562 15.5303 5.18496 14.7762 4.82331 14.3639L3.46711 12.7652C3.12555 12.363 3.12555 11.6391 3.46711 11.2268L4.83335 9.6181C5.20505 9.17569 5.46625 8.45175 5.46625 7.87863V6.16934ZM12.3917 8.38145H9.79638V15.6208H11.2303V12.9409H12.3691L13.6869 15.6208H15.2212V15.5512L13.7149 12.5806C13.9095 12.4894 14.0849 12.3808 14.2414 12.2547C14.4708 12.0691 14.6476 11.8387 14.7719 11.5636C14.8994 11.2852 14.9631 10.952 14.9631 10.5642C14.9631 10.0902 14.8595 9.69077 14.6524 9.36592C14.4453 9.04108 14.149 8.79579 13.7634 8.63005C13.3811 8.46432 12.9238 8.38145 12.3917 8.38145ZM11.2303 11.7774V9.54989H12.3917C12.6466 9.54989 12.8585 9.59464 13.0274 9.68414C13.1962 9.77364 13.3221 9.90291 13.405 10.072C13.4878 10.241 13.5292 10.4416 13.5292 10.6736C13.5292 10.8924 13.4862 11.0846 13.4002 11.2504C13.3173 11.4161 13.1931 11.5454 13.0274 11.6382C12.8617 11.731 12.653 11.7774 12.4012 11.7774H11.2303Z"
        fill="#F46A35"
      />
    </svg>
  );
};

export const ReRenderIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="20"
      viewBox="0 0 25 20"
      fill="none"
      {...props}>
      <path
        d="M10.2412 7.30762H12.5166C13.6195 7.30766 14.4094 7.56565 14.9248 8.08008C15.4401 8.5945 15.6992 9.38428 15.6992 10.4912V12.7666C15.695 13.8693 15.4362 14.6575 14.9219 15.1709C14.4075 15.6842 13.6194 15.9414 12.5166 15.9414H10.2412C9.13425 15.9414 8.34442 15.684 7.83008 15.1699C7.31572 14.6556 7.05762 13.8651 7.05762 12.7578V10.4834C7.05762 9.38039 7.31574 8.59245 7.83008 8.0791C8.34443 7.56576 9.13404 7.30764 10.2412 7.30762ZM10.2412 8.3584C9.4586 8.35841 8.91325 8.47542 8.56934 8.81934C8.22542 9.16325 8.10841 9.7086 8.1084 10.4912V12.7666C8.10842 13.5491 8.22544 14.0946 8.56934 14.4385C8.91326 14.7823 9.45865 14.8994 10.2412 14.8994H12.5166C13.2991 14.8994 13.8446 14.7824 14.1885 14.4385C14.5324 14.0946 14.6494 13.5491 14.6494 12.7666V10.4912C14.6494 9.70865 14.5323 9.16326 14.1885 8.81934C13.8446 8.47544 13.2991 8.35842 12.5166 8.3584H10.2412Z"
        fill="white"
        stroke="#2D3136"
        stroke-width="0.2"
      />
      <path
        d="M13.4912 4.05762H15.7666C16.8695 4.05766 17.6594 4.31565 18.1748 4.83008C18.6901 5.3445 18.9492 6.13428 18.9492 7.24121V9.5166C18.945 10.6193 18.6862 11.4075 18.1709 11.9209C17.6554 12.4343 16.8649 12.6914 15.7578 12.6914H15.166C14.8797 12.6912 14.6416 12.4523 14.6416 12.166V10.4834C14.6416 9.70079 14.5235 9.15546 14.1797 8.81152C13.8358 8.46759 13.2905 8.34961 12.5078 8.34961H10.833C10.5466 8.34961 10.3076 8.11066 10.3076 7.82422V7.24121C10.3076 6.13828 10.5656 5.34845 11.0801 4.83301C11.5945 4.31762 12.3842 4.05764 13.4912 4.05762ZM13.4912 5.1084C12.7129 5.10841 12.17 5.22339 11.8262 5.56152C11.4821 5.89996 11.3626 6.43684 11.3584 7.20703L11.3574 7.30762H12.5166C13.6195 7.30766 14.4094 7.56565 14.9248 8.08008C15.4401 8.5945 15.6992 9.38428 15.6992 10.4912V11.6504L15.7998 11.6494C16.5702 11.6452 17.1078 11.5258 17.4463 11.1816C17.7844 10.8378 17.8994 10.2949 17.8994 9.5166V7.24121C17.8994 6.45865 17.7823 5.91326 17.4385 5.56934C17.0946 5.22544 16.5491 5.10842 15.7666 5.1084H13.4912Z"
        fill="white"
        stroke="#2D3136"
        stroke-width="0.2"
      />
      <path
        d="M23.291 10.2002C23.5952 10.2002 23.8559 10.4224 23.916 10.7109L23.9287 10.8379C23.9174 15.5077 20.1198 19.3037 15.4619 19.3037C15.2346 19.3035 15.0217 19.1774 14.9111 18.9834C14.7994 18.7762 14.8003 18.5391 14.9189 18.334L16.0918 16.3799L16.0928 16.377C16.2691 16.0749 16.6586 15.9777 16.9697 16.1592C17.2711 16.335 17.3691 16.7224 17.1895 17.0332L16.8877 17.5361L16.6445 17.9424L17.1055 17.834C20.2754 17.0874 22.6532 14.2391 22.6533 10.8379C22.6533 10.4905 22.9437 10.2003 23.291 10.2002Z"
        fill="currentColor"
        stroke="#2D3136"
        strokeWidth="0.4"
      />
      <path
        d="M9.06543 1.24219C9.26514 1.2423 9.45339 1.3399 9.57129 1.49512L9.61719 1.56543C9.72794 1.77242 9.72684 2.0082 9.6084 2.21289L8.43555 4.16895C8.25751 4.46567 7.86633 4.56832 7.55957 4.38086L7.55859 4.37988L7.45703 4.30371C7.24114 4.1056 7.18288 3.77332 7.34668 3.50488L7.34766 3.50293L7.89258 2.59473L7.43262 2.70215C4.24866 3.44929 1.87988 6.30064 1.87988 9.7041C1.87969 10.0517 1.58887 10.3418 1.24121 10.3418C0.8937 10.3416 0.603707 10.0516 0.603516 9.7041C0.603516 5.04221 4.40353 1.24219 9.06543 1.24219Z"
        fill="currentColor"
        stroke="#2D3136"
        strokeWidth="0.4"
      />
    </svg>
  );
};

export const RestoreIcon = (props) => {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.69368 15.1998H5.67507C2.03824 15.1998 0.484375 13.6459 0.484375 10.0091V5.9905C0.484375 2.35367 2.03824 0.799805 5.67507 0.799805H9.02391C9.14046 0.799805 9.24856 0.840824 9.33439 0.909037C9.34979 0.920845 9.36465 0.933558 9.37889 0.947146L14.737 6.30529C14.7752 6.34341 14.8064 6.38745 14.8301 6.43512C14.8647 6.50308 14.8844 6.57965 14.8844 6.66027V10.0091C14.8844 13.6459 13.3305 15.1998 9.69368 15.1998ZM13.8797 7.16259V10.0091C13.8797 13.0967 12.7813 14.1952 9.69368 14.1952H5.67507C2.58744 14.1952 1.48903 13.0967 1.48903 10.0091V5.9905C1.48903 2.90287 2.58744 1.80446 5.67507 1.80446H8.52158V3.98119C8.52158 6.2718 9.41237 7.16259 11.703 7.16259H13.8797ZM7.01461 11.8509C6.88735 11.8509 6.7601 11.804 6.65963 11.7036C6.4654 11.5093 6.4654 11.1879 6.65963 10.9936L7.14186 10.5114H4.33554C4.06093 10.5114 3.83321 10.2837 3.83321 10.0091C3.83321 9.73446 4.06093 9.50674 4.33554 9.50674H7.14186L6.65963 9.02451C6.55917 8.92404 6.51228 8.79679 6.51228 8.66953C6.51228 8.54228 6.55917 8.41502 6.65963 8.31456C6.85386 8.12032 7.17535 8.12032 7.36958 8.31456L8.70912 9.65409C8.79619 9.74116 8.84307 9.85502 8.84977 9.96218V10.0693C8.83637 10.1631 8.79619 10.2502 8.72921 10.3306L8.70242 10.3573L7.36289 11.6969C7.26912 11.804 7.14186 11.8509 7.01461 11.8509ZM9.52623 3.98119V2.5144L13.1698 6.15794H11.703C9.97498 6.15794 9.52623 5.70919 9.52623 3.98119Z"
        fill="currentColor"
      />
    </svg>
  );
};

const RemoveIcon = (props) => {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.69368 15.1998H5.67507C2.03824 15.1998 0.484375 13.6459 0.484375 10.0091V5.9905C0.484375 2.35367 2.03824 0.799805 5.67507 0.799805H9.02391C9.14046 0.799805 9.24856 0.840824 9.33439 0.909037C9.34979 0.920845 9.36465 0.933558 9.37889 0.947146L14.737 6.30529C14.7752 6.34341 14.8064 6.38745 14.8301 6.43512C14.8647 6.50308 14.8844 6.57965 14.8844 6.66027V10.0091C14.8844 13.6459 13.3305 15.1998 9.69368 15.1998ZM13.8797 7.16259V10.0091C13.8797 13.0967 12.7813 14.1952 9.69368 14.1952H5.67507C2.58744 14.1952 1.48903 13.0967 1.48903 10.0091V5.9905C1.48903 2.90287 2.58744 1.80446 5.67507 1.80446H8.52158V3.98119C8.52158 6.2718 9.41237 7.16259 11.703 7.16259H13.8797ZM7.01461 11.8509C6.88735 11.8509 6.7601 11.804 6.65963 11.7036C6.4654 11.5093 6.4654 11.1879 6.65963 10.9936L7.14186 10.5114H4.33554C4.06093 10.5114 3.83321 10.2837 3.83321 10.0091C3.83321 9.73446 4.06093 9.50674 4.33554 9.50674H7.14186L6.65963 9.02451C6.55917 8.92404 6.51228 8.79679 6.51228 8.66953C6.51228 8.54228 6.55917 8.41502 6.65963 8.31456C6.85386 8.12032 7.17535 8.12032 7.36958 8.31456L8.70912 9.65409C8.79619 9.74116 8.84307 9.85502 8.84977 9.96218V10.0693C8.83637 10.1631 8.79619 10.2502 8.72921 10.3306L8.70242 10.3573L7.36289 11.6969C7.26912 11.804 7.14186 11.8509 7.01461 11.8509ZM9.52623 3.98119V2.5144L13.1698 6.15794H11.703C9.97498 6.15794 9.52623 5.70919 9.52623 3.98119Z"
        fill="currentColor"
      />
    </svg>
  );
};

const RoomsIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.71089 1.99693L7.71163 1.99654C7.93331 1.87808 8.18826 1.87808 8.40993 1.99654L8.41068 1.99693L12.7354 4.33425C12.7811 4.35896 12.8239 4.41631 12.8239 4.50993C12.8239 4.60355 12.7811 4.6609 12.7354 4.68561L8.41068 7.02293L8.40989 7.02335C8.18824 7.14177 7.93332 7.14177 7.71168 7.02335L7.71089 7.02293L3.38614 4.68561C3.34044 4.6609 3.29771 4.60355 3.29771 4.50993C3.29771 4.41631 3.34044 4.35896 3.38614 4.33425L7.71089 1.99693ZM8.93378 1.02054C8.38492 0.72649 7.73664 0.72649 7.18779 1.02054L7.18601 1.0215L2.85925 3.35989C1.96694 3.84241 1.96705 5.17751 2.85936 5.66003L7.18601 7.99836L7.18779 7.99932C7.73664 8.29337 8.38492 8.29337 8.93378 7.99932L8.93556 7.99836L13.2623 5.65997C14.1546 5.17745 14.1545 3.84235 13.2622 3.35983L8.93556 1.02149L8.93378 1.02054ZM2.17637 7.24629C2.05012 7.18313 1.90847 7.27287 1.90847 7.41076C1.90847 7.71664 1.66051 7.9646 1.35463 7.9646C1.04875 7.9646 0.800781 7.71664 0.800781 7.41076C0.800781 6.4428 1.81546 5.82638 2.67282 6.25608L6.69638 8.27599C7.3783 8.62232 7.8169 9.32466 7.8169 10.0955V13.9062C7.8169 14.8742 6.80222 15.4906 5.94487 15.0609L1.92362 13.0421L1.92131 13.041C1.23939 12.6946 0.800781 11.9923 0.800781 11.2214V9.96897C0.800781 9.66309 1.04875 9.41512 1.35463 9.41512C1.66051 9.41512 1.90847 9.66309 1.90847 9.96897V11.2214C1.90847 11.5694 2.10746 11.8927 2.42186 12.0528L2.4229 12.0534L6.44119 14.0706C6.56743 14.1338 6.70921 14.0441 6.70921 13.9062V10.0955C6.70921 9.7476 6.51023 9.42431 6.19583 9.26415L6.19479 9.26362L2.17637 7.24629ZM13.3287 6.25608C14.1861 5.82638 15.2008 6.4428 15.2008 7.41076V11.2214C15.2008 11.9923 14.7622 12.6946 14.0803 13.041L14.0779 13.0421L10.057 15.0607C9.19967 15.4904 8.18466 14.8742 8.18466 13.9062V10.0955C8.18466 9.32466 8.62327 8.62233 9.30519 8.276L9.30749 8.27483L13.3287 6.25608ZM13.8251 7.24635L9.80678 9.26361L9.80574 9.26414C9.49134 9.4243 9.29235 9.7476 9.29235 10.0955V13.9062C9.29235 14.0441 9.43396 14.1338 9.56019 14.0707L13.5787 12.0534L13.5797 12.0528C13.8941 11.8927 14.0931 11.5694 14.0931 11.2214V7.41076C14.0931 7.27285 13.9513 7.18313 13.8251 7.24635Z"
        fill="#5A5C61"
      />
    </svg>
  );
};
export const SearchIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M7.35824 13.8361C3.73987 13.8361 0.800781 10.9147 0.800781 7.31807C0.800781 3.72143 3.73987 0.800003 7.35824 0.800003C10.9766 0.800003 13.9157 3.72143 13.9157 7.31807C13.9157 10.9147 10.9766 13.8361 7.35824 13.8361ZM7.35824 1.80278C4.29809 1.80278 1.80962 4.27631 1.80962 7.31807C1.80962 10.3598 4.29809 12.8334 7.35824 12.8334C10.4184 12.8334 12.9069 10.3598 12.9069 7.31807C12.9069 4.27631 10.4184 1.80278 7.35824 1.80278Z"
        fill="currentColor"
      />
      <path
        d="M13.5192 15.2001C13.4654 15.2001 13.4116 15.1934 13.3646 15.1867C13.0485 15.1466 12.4768 14.9327 12.154 13.9767C11.9858 13.4753 12.0463 12.9739 12.3221 12.5928C12.5978 12.2118 13.0619 11.9979 13.5932 11.9979C14.2792 11.9979 14.8173 12.2586 15.0594 12.7199C15.3015 13.1811 15.2343 13.7694 14.8509 14.3377C14.3734 15.053 13.8555 15.2001 13.5192 15.2001ZM13.1157 13.6625C13.23 14.0101 13.3915 14.1839 13.4991 14.1973C13.6067 14.2107 13.8084 14.0836 14.0169 13.7828C14.212 13.4953 14.2254 13.2881 14.1784 13.1945C14.1313 13.1009 13.943 13.0006 13.5932 13.0006C13.3847 13.0006 13.23 13.0675 13.1426 13.1811C13.0619 13.2948 13.0485 13.4686 13.1157 13.6625Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const SettingsIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}>
      <title>{props?.title || ''}</title>
      <g clipPath="url(#clip0_2894_141533)">
        <path
          fill="currentColor"
          d="M19.43 12.98c.04-.32.07-.64.07-.98 0-.34-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46a.5.5 0 00-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65A.488.488 0 0014 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1a.566.566 0 00-.18-.03c-.17 0-.34.09-.43.25l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98 0 .33.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46a.5.5 0 00.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.06.02.12.03.18.03.17 0 .34-.09.43-.25l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zm-1.98-1.71c.04.31.05.52.05.73 0 .21-.02.43-.05.73l-.14 1.13.89.7 1.08.84-.7 1.21-1.27-.51-1.04-.42-.9.68c-.43.32-.84.56-1.25.73l-1.06.43-.16 1.13-.2 1.35h-1.4l-.19-1.35-.16-1.13-1.06-.43c-.43-.18-.83-.41-1.23-.71l-.91-.7-1.06.43-1.27.51-.7-1.21 1.08-.84.89-.7-.14-1.13c-.03-.31-.05-.54-.05-.74 0-.2.02-.43.05-.73l.14-1.13-.89-.7-1.08-.84.7-1.21 1.27.51 1.04.42.9-.68c.43-.32.84-.56 1.25-.73l1.06-.43.16-1.13.2-1.35h1.39l.19 1.35.16 1.13 1.06.43c.43.18.83.41 1.23.71l.91.7 1.06-.43 1.27-.51.7 1.21-1.07.85-.89.7.14 1.13zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"></path>
      </g>
      <defs>
        <clipPath id="clip0_2894_141533">
          <path fill="currentColor" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};
const ShareIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99148 19.1998H14.0101C17.6469 19.1998 19.2008 17.6459 19.2008 14.0091V12.6696C19.2008 12.395 18.9731 12.1672 18.6985 12.1672C18.4239 12.1672 18.1961 12.395 18.1961 12.6696V14.0091C18.1961 17.0967 17.0977 18.1952 14.0101 18.1952H9.99148C6.90385 18.1952 5.80543 17.0967 5.80543 14.0091V9.9905C5.80543 6.90287 6.90385 5.80446 9.99148 5.80446H11.331C11.6056 5.80446 11.8333 5.57673 11.8333 5.30213C11.8333 5.02753 11.6056 4.7998 11.331 4.7998H9.99148C6.35464 4.7998 4.80078 6.35367 4.80078 9.9905V14.0091C4.80078 17.6459 6.35464 19.1998 9.99148 19.1998ZM18.6985 9.01934C18.4239 9.01934 18.1961 8.79162 18.1961 8.51701V6.5144L13.0255 11.685C12.9251 11.7855 12.7978 11.8324 12.6705 11.8324C12.5433 11.8324 12.416 11.7855 12.3156 11.685C12.1213 11.4908 12.1213 11.1693 12.3156 10.9751L17.4862 5.80446H15.4836C15.209 5.80446 14.9813 5.57673 14.9813 5.30213C14.9813 5.02753 15.209 4.7998 15.4836 4.7998H18.6985C18.9731 4.7998 19.2008 5.02753 19.2008 5.30213V8.51701C19.2008 8.79162 18.9731 9.01934 18.6985 9.01934Z"
        fill="currentColor"
      />
    </svg>
  );
};
const ShareIconNew = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 16 16"
      fill="none"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.99148 15.1998H10.0101C13.6469 15.1998 15.2008 13.6459 15.2008 10.0091V8.66957C15.2008 8.39497 14.9731 8.16725 14.6985 8.16725C14.4239 8.16725 14.1961 8.39497 14.1961 8.66957V10.0091C14.1961 13.0967 13.0977 14.1952 10.0101 14.1952H5.99148C2.90385 14.1952 1.80543 13.0967 1.80543 10.0091V5.9905C1.80543 2.90287 2.90385 1.80446 5.99148 1.80446H7.33101C7.60562 1.80446 7.83334 1.57673 7.83334 1.30213C7.83334 1.02753 7.60562 0.799805 7.33101 0.799805H5.99148C2.35464 0.799805 0.800781 2.35367 0.800781 5.9905V10.0091C0.800781 13.6459 2.35464 15.1998 5.99148 15.1998ZM14.6985 5.01934C14.4239 5.01934 14.1961 4.79162 14.1961 4.51701V2.5144L9.02553 7.68501C8.92506 7.78547 8.79781 7.83236 8.67055 7.83236C8.54329 7.83236 8.41604 7.78547 8.31557 7.68501C8.12134 7.49078 8.12134 7.16929 8.31557 6.97506L13.4862 1.80446H11.4836C11.209 1.80446 10.9813 1.57673 10.9813 1.30213C10.9813 1.02753 11.209 0.799805 11.4836 0.799805H14.6985C14.9731 0.799805 15.2008 1.02753 15.2008 1.30213V4.51701C15.2008 4.79162 14.9731 5.01934 14.6985 5.01934Z"
        fill="#5A5C61"
      />
    </svg>
  );
};
const StyleIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6505 18.4195C11.4481 18.5672 11.2645 18.688 11.0905 18.7887C10.9718 20.061 10.4225 21.2338 9.51889 22.1473C8.65951 22.9955 7.5546 23.5201 6.3046 23.6763L3.5479 23.9777C3.42513 23.9888 3.30236 24 3.17959 24C2.34254 24 1.53896 23.6652 0.936284 23.0625C0.244319 22.3705 -0.0905032 21.4107 0.0211041 20.4286L0.322444 17.683C0.593218 15.1419 2.55491 13.213 5.06495 12.9211C5.20024 12.6693 5.35919 12.4386 5.53442 12.2364L7.25317 10.0713C10.2108 6.37705 16.2041 1.93508 20.5903 0.171683C21.5166 -0.18546 22.5099 0.0265938 23.1907 0.696238C23.8938 1.39936 24.1059 2.40383 23.7376 3.31901C21.9742 7.71634 17.5434 13.6985 13.8492 16.6561L11.6505 18.4195ZM12.8112 15.3614L10.9315 16.8742C10.6953 15.982 10.2262 15.176 9.53005 14.4799C8.82768 13.7775 7.98728 13.2858 7.04986 13.04L8.54782 11.1315C8.76284 10.8636 8.99463 10.5916 9.24121 10.3169C11.6392 10.3176 13.6072 12.2305 13.6798 14.622C13.3868 14.886 13.0967 15.1333 12.8112 15.3614ZM15.1416 13.1938C14.5721 11.0465 12.8599 9.35764 10.6993 8.8217C13.7169 5.94552 17.9278 3.06195 21.1929 1.74535C21.6394 1.57794 21.9295 1.82347 22.0077 1.9016C22.1193 2.00204 22.3536 2.29222 22.1862 2.70517C20.8815 5.98003 18.0105 10.1823 15.1416 13.1938ZM1.98539 17.8728C2.20514 15.7851 3.93925 14.6386 5.60103 14.5715C5.62606 14.5719 5.65132 14.5711 5.67676 14.5692L5.6796 14.5692H5.82469H6.01855C6.07809 14.5722 6.13353 14.5762 6.18174 14.5802C6.98531 14.6806 7.73308 15.0601 8.33576 15.6628C8.93844 16.2655 9.29559 16.9574 9.39603 17.7498C9.41835 17.9284 9.42952 18.107 9.42952 18.2744L9.42955 18.2825C9.4246 19.3021 9.02338 20.2544 8.31353 20.9643C7.73317 21.5446 6.96308 21.9018 6.1037 22.0134L3.35816 22.3147C2.90057 22.3705 2.44298 22.2031 2.11932 21.8795C1.79566 21.5446 1.62825 21.087 1.68405 20.6183L1.98539 17.8728Z"
        fill="currentColor"
      />
    </svg>
  );
};

const SupportIcon = (props) => {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.21398 15.6279H14.4651C18.4034 15.6279 19.6 14.4313 19.6 10.493C19.6 10.1269 19.2964 9.82326 18.9303 9.82326C18.073 9.82326 17.3675 9.11777 17.3675 8.26046C17.3675 7.40316 18.073 6.69767 18.9303 6.69767C19.2964 6.69767 19.6 6.39405 19.6 6.02791V5.13488C19.6 1.19665 18.4034 0 14.4651 0H8.21398H5.53491C1.59668 0 0.400024 1.19665 0.400024 5.13488V5.5814C0.400024 5.94754 0.703652 6.25116 1.06979 6.25116C1.92709 6.25116 2.63258 6.95665 2.63258 7.81395C2.63258 8.67126 1.92709 9.37674 1.06979 9.37674C0.703652 9.37674 0.400024 9.68037 0.400024 10.0465V10.493C0.400024 14.4313 1.59668 15.6279 5.53491 15.6279H8.21398ZM7.54421 14.2884H5.53491C2.39147 14.2884 1.75742 13.7079 1.73956 10.6359C3.01658 10.3323 3.97212 9.18028 3.97212 7.81395C3.97212 6.44763 3.01658 5.29563 1.73956 4.992C1.75742 1.92 2.39147 1.33953 5.53491 1.33953H7.54421V2.90233C7.54421 3.26847 7.84784 3.57209 8.21398 3.57209C8.58012 3.57209 8.88375 3.26847 8.88375 2.90233V1.33953H14.4651C17.6622 1.33953 18.2605 1.94679 18.2605 5.13488V5.43851C16.9835 5.74214 16.0279 6.89414 16.0279 8.26046C16.0279 9.62679 16.9745 10.7788 18.2516 11.0824C18.1712 13.7615 17.4478 14.2884 14.4651 14.2884H8.88375V12.7256C8.88375 12.3594 8.58012 12.0558 8.21398 12.0558C7.84784 12.0558 7.54421 12.3594 7.54421 12.7256V14.2884ZM8.21398 10.1181C7.84784 10.1181 7.54421 9.81446 7.54421 9.44832V6.17093C7.54421 5.80479 7.84784 5.50116 8.21398 5.50116C8.58012 5.50116 8.88375 5.80479 8.88375 6.17093V9.44832C8.88375 9.82339 8.58012 10.1181 8.21398 10.1181Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const UploadIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0101 19.1998H9.99148C6.35464 19.1998 4.80078 17.6459 4.80078 14.0091V9.9905C4.80078 6.35367 6.35464 4.7998 9.99148 4.7998H13.3403C13.4569 4.7998 13.565 4.84082 13.6508 4.90904C13.6662 4.92085 13.6811 4.93356 13.6953 4.94715L19.0534 10.3053C19.0916 10.3434 19.1228 10.3874 19.1465 10.4351C19.1812 10.5031 19.2008 10.5797 19.2008 10.6603V14.0091C19.2008 17.6459 17.6469 19.1998 14.0101 19.1998ZM18.1961 11.1626V14.0091C18.1961 17.0967 17.0977 18.1952 14.0101 18.1952H9.99148C6.90385 18.1952 5.80543 17.0967 5.80543 14.0091V9.9905C5.80543 6.90287 6.90385 5.80446 9.99148 5.80446H12.838V7.98119C12.838 10.2718 13.7288 11.1626 16.0194 11.1626H18.1961ZM9.48911 15.3486C9.48911 15.6232 9.71684 15.851 9.99144 15.851C10.266 15.851 10.4938 15.6232 10.4938 15.3486V12.5423L10.976 13.0245C11.0765 13.125 11.2037 13.1719 11.331 13.1719C11.4582 13.1719 11.5855 13.125 11.686 13.0245C11.8802 12.8303 11.8802 12.5088 11.686 12.3146L10.3705 10.9991C10.3229 10.9443 10.2631 10.8999 10.1938 10.8712C10.1873 10.8683 10.1807 10.8657 10.1742 10.8631C10.0699 10.8216 9.95612 10.8187 9.85202 10.8487C9.77276 10.8712 9.69819 10.9133 9.63646 10.975L9.63308 10.9784L8.29693 12.3146C8.1027 12.5088 8.1027 12.8303 8.29693 13.0245C8.49116 13.2188 8.81265 13.2188 9.00688 13.0245L9.48911 12.5423V15.3486ZM13.8426 7.98119V6.5144L17.4862 10.1579H16.0194C14.2914 10.1579 13.8426 9.70919 13.8426 7.98119Z"
        fill="currentColor"
      />
    </svg>
  );
};

const UploadIconAlt = (props) => {
  return (
    <svg
      width="12"
      height="15"
      viewBox="0 0 12 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M3.50008 11.3333H8.50008V6.33333H11.8334L6.00008 0.5L0.166748 6.33333H3.50008V11.3333ZM0.166748 13H11.8334V14.6667H0.166748V13Z"
        fill="currentColor"
      />
    </svg>
  );
};
const UserGroupIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.85764 11.8105H9.91173H9.93201C11.8182 11.7496 13.3055 10.2082 13.3123 8.30853C13.3123 6.37501 11.7371 4.7998 9.80356 4.7998C7.87004 4.7998 6.29484 6.37501 6.29484 8.30853C6.29484 10.2082 7.77539 11.7496 9.73595 11.8105C9.77652 11.8037 9.82384 11.8037 9.85764 11.8105ZM7.30892 8.30853C7.30892 6.93614 8.43117 5.81389 9.80356 5.81389C11.176 5.81389 12.2982 6.93614 12.2982 8.30853C12.2914 9.64712 11.2503 10.7356 9.92525 10.7964C9.83736 10.7897 9.74947 10.7897 9.70891 10.7964C8.36356 10.7491 7.30892 9.66064 7.30892 8.30853ZM14.8402 11.8916C14.8605 11.8984 14.8808 11.8984 14.901 11.8984H14.9213C16.4695 11.8375 17.6864 10.5801 17.6864 9.02515C17.6864 7.44318 16.3951 6.15191 14.8132 6.15191C14.536 6.15191 14.3061 6.38177 14.3061 6.65896C14.3061 6.93614 14.536 7.166 14.8132 7.15924C15.8408 7.15924 16.6723 7.99078 16.6723 9.01839C16.6723 10.0122 15.9016 10.8235 14.9146 10.8775C14.8402 10.8775 14.7523 10.8775 14.6712 10.8843C14.394 10.9181 14.225 11.1682 14.252 11.4454C14.2791 11.7226 14.563 11.9187 14.8402 11.8916ZM9.91852 19.1998C8.59345 19.1998 7.26162 18.8617 6.2543 18.1857C5.31458 17.5637 4.80078 16.7119 4.80078 15.7857C4.80078 14.8595 5.31458 14.0009 6.2543 13.3722C8.28246 12.0268 11.5681 12.0268 13.5827 13.3722C14.5157 13.9942 15.0363 14.846 15.0363 15.7722C15.0363 16.6984 14.5224 17.557 13.5827 18.1857C12.5687 18.8617 11.2436 19.1998 9.91852 19.1998ZM6.81542 14.224C6.16641 14.6567 5.81486 15.211 5.81486 15.7925C5.81486 16.3671 6.17317 16.9215 6.81542 17.3474C8.4988 18.4764 11.3382 18.4764 13.0216 17.3474C13.6706 16.9147 14.0222 16.3603 14.0222 15.7789C14.0222 15.2043 13.6639 14.6499 13.0216 14.224C11.3382 13.1018 8.4988 13.1018 6.81542 14.224ZM15.6244 17.5773C15.6717 17.8206 15.8813 17.9829 16.1179 17.9829C16.1517 17.9829 16.1855 17.9829 16.2261 17.9694C16.8075 17.8544 17.3348 17.6178 17.754 17.2933C18.3827 16.8133 18.7478 16.144 18.7478 15.4409C18.7478 14.7378 18.3894 14.0685 17.7607 13.5953C17.3483 13.2775 16.8413 13.0477 16.2599 12.9192C15.9827 12.8584 15.7123 13.0342 15.6514 13.3046C15.5906 13.5818 15.7664 13.8522 16.0368 13.913C16.4762 14.0144 16.848 14.1767 17.1455 14.4066C17.5241 14.6905 17.7337 15.0556 17.7337 15.4409C17.7337 15.8263 17.5241 16.1913 17.1387 16.482C16.8345 16.7187 16.4424 16.8877 16.0165 16.9756C15.7461 17.0364 15.5703 17.3001 15.6244 17.5773Z"
        fill="currentColor"
      />
    </svg>
  );
};

const UserIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g fill="currentColor" clipPath="url(#clip0_2894_141545)">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM7.35 18.5C8.66 17.56 10.26 17 12 17c1.74 0 3.34.56 4.65 1.5-1.31.94-2.91 1.5-4.65 1.5-1.74 0-3.34-.56-4.65-1.5zm10.79-1.38a9.947 9.947 0 00-12.28 0A7.957 7.957 0 014 12c0-4.42 3.58-8 8-8s8 3.58 8 8c0 1.95-.7 3.73-1.86 5.12z"></path>
        <path d="M12 6c-1.93 0-3.5 1.57-3.5 3.5S10.07 13 12 13s3.5-1.57 3.5-3.5S13.93 6 12 6zm0 5c-.83 0-1.5-.67-1.5-1.5S11.17 8 12 8s1.5.67 1.5 1.5S12.83 11 12 11z"></path>
      </g>
      <defs>
        <clipPath id="clip0_2894_141545">
          <path fill="#fff" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};
export const WarningIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.94377 18.9989H16.055C17.36 18.9989 18.3572 18.5238 18.8658 17.6738C19.3744 16.8105 19.3008 15.7129 18.6651 14.5685L14.6094 7.26709C13.9402 6.06245 13.0166 5.3999 11.9994 5.3999C10.9821 5.3999 10.0586 6.06245 9.38933 7.26709L5.33372 14.5618C4.69793 15.7063 4.63101 16.8105 5.13294 17.6671C5.64157 18.5238 6.63874 18.9989 7.94377 18.9989ZM10.266 7.75564C10.7546 6.88562 11.3703 6.40377 11.9994 6.40377C12.6285 6.40377 13.2442 6.88562 13.7327 7.75564L17.795 15.0571C18.2501 15.8803 18.3304 16.6231 18.0092 17.1652C17.688 17.7073 16.9986 18.0018 16.0617 18.0018H7.95046C7.01352 18.0018 6.3175 17.7073 6.00296 17.1652C5.68841 16.6231 5.76203 15.8736 6.21712 15.0571L10.266 7.75564ZM11.9991 14.0399C11.7247 14.0399 11.4971 13.8124 11.4971 13.538V10.1918C11.4971 9.9174 11.7247 9.68986 11.9991 9.68986C12.2735 9.68986 12.501 9.9174 12.501 10.1918V13.538C12.501 13.8124 12.2735 14.0399 11.9991 14.0399ZM11.9991 16.215C11.9589 16.215 11.9121 16.2083 11.8652 16.2016L11.8652 16.2016C11.8251 16.1949 11.7849 16.1816 11.7448 16.1615C11.7046 16.1481 11.6645 16.128 11.6243 16.1013L11.5239 16.0209C11.4034 15.8938 11.3298 15.7198 11.3298 15.5458C11.3298 15.3718 11.4034 15.1978 11.5239 15.0706L11.6243 14.9903C11.6645 14.9635 11.7046 14.9435 11.7448 14.9301C11.7849 14.91 11.8251 14.8966 11.8652 14.8899C11.9522 14.8698 12.0459 14.8698 12.1262 14.8899C12.1731 14.8966 12.2132 14.91 12.2534 14.9301C12.2935 14.9435 12.3337 14.9635 12.3738 14.9903L12.4742 15.0706C12.5947 15.1978 12.6683 15.3718 12.6683 15.5458C12.6683 15.7198 12.5947 15.8938 12.4742 16.0209L12.3738 16.1013C12.3337 16.128 12.2935 16.1481 12.2534 16.1615C12.2132 16.1816 12.1731 16.1949 12.1262 16.2016C12.0861 16.2083 12.0392 16.215 11.9991 16.215Z"
        fill="#E4291D"
      />
    </svg>
  );
};

const AddIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.93177 18.5332C8.93177 19.1163 9.41533 19.5999 9.99844 19.5999C10.5815 19.5999 11.0651 19.1163 11.0651 18.5332V11.0666H18.5318C19.1149 11.0666 19.5984 10.583 19.5984 9.9999C19.5984 9.41679 19.1149 8.93324 18.5318 8.93324H11.0651V1.46657C11.0651 0.883458 10.5815 0.399902 9.99844 0.399902C9.41533 0.399902 8.93177 0.883458 8.93177 1.46657V8.93324H1.4651C0.881993 8.93324 0.398438 9.41679 0.398438 9.9999C0.398438 10.583 0.881993 11.0666 1.4651 11.0666H8.93177V18.5332Z"
        fill="currentColor"
      />
    </svg>
  );
};

const RoundcloseIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.15703 15.1998C4.18531 15.1998 0.957031 11.9715 0.957031 7.9998C0.957031 4.02808 4.18531 0.799805 8.15703 0.799805C12.1288 0.799805 15.357 4.02808 15.357 7.9998C15.357 11.9715 12.1288 15.1998 8.15703 15.1998ZM8.15703 1.80446C4.74122 1.80446 1.96168 4.58399 1.96168 7.9998C1.96168 11.4156 4.74122 14.1952 8.15703 14.1952C11.5728 14.1952 14.3524 11.4156 14.3524 7.9998C14.3524 4.58399 11.5728 1.80446 8.15703 1.80446ZM6.2615 10.3975C6.13424 10.3975 6.00699 10.3506 5.90652 10.2501C5.71229 10.0559 5.71229 9.73441 5.90652 9.54018L7.44699 7.99971L5.90652 6.45925C5.71229 6.26501 5.71229 5.94353 5.90652 5.74929C6.10075 5.55506 6.42224 5.55506 6.61647 5.74929L8.15694 7.28976L9.6974 5.74929C9.89164 5.55506 10.2131 5.55506 10.4074 5.74929C10.6016 5.94353 10.6016 6.26501 10.4074 6.45925L8.86689 7.99971L10.4074 9.54018C10.6016 9.73441 10.6016 10.0559 10.4074 10.2501C10.3069 10.3506 10.1796 10.3975 10.0524 10.3975C9.92512 10.3975 9.79787 10.3506 9.6974 10.2501L8.15694 8.70967L6.61647 10.2501C6.52271 10.3506 6.38875 10.3975 6.2615 10.3975Z"
        fill="currentColor"
      />
    </svg>
  );
};

const BigCloseIcon = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <rect width="32" height="32" rx="8" fill="#E9E9E9" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.943 21.0911C20.2522 21.4004 20.7651 21.4004 21.0743 21.0911C21.3836 20.7819 21.3836 20.269 21.0743 19.9598L17.1146 16L21.0743 12.0402C21.3836 11.731 21.3836 11.2181 21.0743 10.9089C20.7651 10.5996 20.2522 10.5996 19.943 10.9089L15.9832 14.8686L12.0234 10.9088C11.7141 10.5996 11.2012 10.5996 10.892 10.9088C10.5827 11.218 10.5827 11.7309 10.892 12.0402L14.8518 16L10.892 19.9598C10.5827 20.2691 10.5827 20.782 10.892 21.0912C11.2012 21.4004 11.7141 21.4004 12.0234 21.0912L15.9832 17.1314L19.943 21.0911Z"
        fill="#5A5C61"
      />
    </svg>
  );
};

export const MoveToTextureIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8264 6.157L10.8269 6.15672C11.1201 6.00108 11.5446 5.90768 12.0008 5.90768C12.4569 5.90768 12.8814 6.00108 13.1746 6.15671L13.1751 6.157L16.8659 8.13121C17.1778 8.29731 17.4913 8.60855 17.7281 8.99466C17.9654 9.38177 18.0931 9.79097 18.0931 10.122V11.1259L10.3526 6.41047L10.8264 6.157ZM9.21886 7.01689L7.13565 8.13121C6.95338 8.22827 6.77057 8.3749 6.60284 8.55706L17.5696 15.2379C17.6253 15.1641 17.6784 15.0863 17.7281 15.0053C17.9654 14.6182 18.0931 14.209 18.0931 13.878V12.4229L9.21886 7.01689ZM6.02765 9.50371C5.94929 9.72271 5.90847 9.93484 5.90847 10.122V12.5649L13.9193 17.4449L16.6584 15.9798L6.02765 9.50371ZM5.90847 13.878V13.8619L12.7182 18.0103C12.5005 18.0632 12.2556 18.0923 12.0008 18.0923C11.5446 18.0923 11.1196 17.9986 10.8264 17.843L7.13655 15.8692L7.13565 15.8688C6.82375 15.7027 6.51022 15.3914 6.27349 15.0053C6.03616 14.6182 5.90847 14.209 5.90847 13.878ZM4.80078 10.122V13.878C4.80078 14.4644 5.01525 15.0723 5.32916 15.5843C5.6436 16.0972 6.09069 16.5671 6.61499 16.8465L10.3065 18.8211C10.8014 19.0841 11.4169 19.2 12.0008 19.2C12.5846 19.2 13.2002 19.0841 13.695 18.8211L13.6963 18.8204L17.3866 16.8465L17.3872 16.8461C17.9114 16.5668 18.358 16.0971 18.6724 15.5843C18.9863 15.0723 19.2008 14.4644 19.2008 13.878V10.122C19.2008 9.53558 18.9863 8.92768 18.6724 8.41568C18.358 7.90284 17.9109 7.43285 17.3866 7.15351L13.6963 5.17957L13.695 5.17888C13.2002 4.91588 12.5846 4.79999 12.0008 4.79999C11.4169 4.79999 10.8014 4.91588 10.3065 5.17888L10.3052 5.17957L6.61499 7.15351L6.61448 7.15378C6.09021 7.43312 5.64358 7.90284 5.32916 8.41568C5.01525 8.92768 4.80078 9.53558 4.80078 10.122Z"
        fill="currentColor"
      />
    </svg>
  );
};

// const MoveToTextureIcon = (props) => {
//   return (
//     <svg
//       width="16"
//       height="16"
//       viewBox="0 0 16 16"
//       fill="none"
//       xmlns="http://www.w3.org/2000/svg"
//       {...props}>
//       <path
//         fillRule="evenodd"
//         clipRule="evenodd"
//         d="M6.8264 2.157L6.82693 2.15672C7.12008 2.00108 7.54462 1.90768 8.00077 1.90768C8.45691 1.90768 8.88144 2.00108 9.17459 2.15671L9.17514 2.157L12.8659 4.13121C13.1778 4.29731 13.4913 4.60855 13.7281 4.99466C13.9654 5.38177 14.0931 5.79097 14.0931 6.12198V7.12589L6.35255 2.41047L6.8264 2.157ZM5.21886 3.01689L3.13565 4.13121C2.95338 4.22827 2.77057 4.3749 2.60284 4.55706L13.5696 11.2379C13.6253 11.1641 13.6784 11.0863 13.7281 11.0053C13.9654 10.6182 14.0931 10.209 14.0931 9.878V8.42293L5.21886 3.01689ZM2.02765 5.50371C1.94929 5.72271 1.90847 5.93484 1.90847 6.12198V8.56487L9.91928 13.4449L12.6584 11.9798L2.02765 5.50371ZM1.90847 9.878V9.86192L8.7182 14.0103C8.50051 14.0632 8.25557 14.0923 8.00077 14.0923C7.54457 14.0923 7.11955 13.9986 6.8264 13.843L3.13655 11.8692L3.13565 11.8688C2.82375 11.7027 2.51022 11.3914 2.27349 11.0053C2.03616 10.6182 1.90847 10.209 1.90847 9.878ZM0.800781 6.12198V9.878C0.800781 10.4644 1.01525 11.0723 1.32916 11.5843C1.6436 12.0972 2.09069 12.5671 2.61499 12.8465L6.30654 14.8211C6.80138 15.0841 7.4169 15.2 8.00077 15.2C8.58464 15.2 9.20016 15.0841 9.695 14.8211L9.6963 14.8204L13.3866 12.8465L13.3872 12.8461C13.9114 12.5668 14.358 12.0971 14.6724 11.5843C14.9863 11.0723 15.2008 10.4644 15.2008 9.878V6.12198C15.2008 5.53558 14.9863 4.92768 14.6724 4.41568C14.358 3.90284 13.9109 3.43285 13.3866 3.15351L9.6963 1.17957L9.695 1.17888C9.20016 0.91588 8.58464 0.799988 8.00077 0.799988C7.4169 0.799988 6.80138 0.91588 6.30654 1.17888L6.30524 1.17957L2.61499 3.15351L2.61448 3.15378C2.09021 3.43312 1.64358 3.90284 1.32916 4.41568C1.01525 4.92768 0.800781 5.53558 0.800781 6.12198Z"
//         fill="#5A5C61"
//       />
//     </svg>
//   );
// };

const CollectionNewIcon = (props) => {
  return (
    // <svg
    //   width="16"
    //   height="16"
    //   viewBox="0 0 16 16"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    //   {...props}>
    //   <path
    //     fillRule="evenodd"
    //     clipRule="evenodd"
    //     d="M6.8264 2.157L6.82693 2.15672C7.12008 2.00108 7.54462 1.90768 8.00077 1.90768C8.45691 1.90768 8.88144 2.00108 9.17459 2.15671L9.17514 2.157L12.8659 4.13121C13.1778 4.29731 13.4913 4.60855 13.7281 4.99466C13.9654 5.38177 14.0931 5.79097 14.0931 6.12198V7.12589L6.35255 2.41047L6.8264 2.157ZM5.21886 3.01689L3.13565 4.13121C2.95338 4.22827 2.77057 4.3749 2.60284 4.55706L13.5696 11.2379C13.6253 11.1641 13.6784 11.0863 13.7281 11.0053C13.9654 10.6182 14.0931 10.209 14.0931 9.878V8.42293L5.21886 3.01689ZM2.02765 5.50371C1.94929 5.72271 1.90847 5.93484 1.90847 6.12198V8.56487L9.91928 13.4449L12.6584 11.9798L2.02765 5.50371ZM1.90847 9.878V9.86192L8.7182 14.0103C8.50051 14.0632 8.25557 14.0923 8.00077 14.0923C7.54457 14.0923 7.11955 13.9986 6.8264 13.843L3.13655 11.8692L3.13565 11.8688C2.82375 11.7027 2.51022 11.3914 2.27349 11.0053C2.03616 10.6182 1.90847 10.209 1.90847 9.878ZM0.800781 6.12198V9.878C0.800781 10.4644 1.01525 11.0723 1.32916 11.5843C1.6436 12.0972 2.09069 12.5671 2.61499 12.8465L6.30654 14.8211C6.80138 15.0841 7.4169 15.2 8.00077 15.2C8.58464 15.2 9.20016 15.0841 9.695 14.8211L9.6963 14.8204L13.3866 12.8465L13.3872 12.8461C13.9114 12.5668 14.358 12.0971 14.6724 11.5843C14.9863 11.0723 15.2008 10.4644 15.2008 9.878V6.12198C15.2008 5.53558 14.9863 4.92768 14.6724 4.41568C14.358 3.90284 13.9109 3.43285 13.3866 3.15351L9.6963 1.17957L9.695 1.17888C9.20016 0.91588 8.58464 0.799988 8.00077 0.799988C7.4169 0.799988 6.80138 0.91588 6.30654 1.17888L6.30524 1.17957L2.61499 3.15351L2.61448 3.15378C2.09021 3.43312 1.64358 3.90284 1.32916 4.41568C1.01525 4.92768 0.800781 5.53558 0.800781 6.12198Z"
    //     fill="#5A5C61"
    //   />
    // </svg>
    <svg
      width="14"
      height="14"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.00694 0.799805C4.29077 0.799805 2.94538 1.13965 2.043 2.04202C1.14062 2.9444 0.800781 4.2898 0.800781 6.00596V9.99365C0.800781 11.7098 1.14062 13.0552 2.043 13.9576C2.94538 14.86 4.29077 15.1998 6.00694 15.1998H9.99463C11.7108 15.1998 13.0562 14.86 13.9586 13.9576C14.8609 13.0552 15.2008 11.7098 15.2008 9.99365V6.00596C15.2008 4.2898 14.8609 2.9444 13.9586 2.04202C13.0562 1.13965 11.7108 0.799805 9.99463 0.799805H6.00694ZM1.90847 6.00596C1.90847 4.39905 2.23325 3.41829 2.82626 2.82528C3.41926 2.23227 4.40002 1.9075 6.00694 1.9075H7.40078V7.3998H1.90847V6.00596ZM1.90847 8.5998V9.99365C1.90847 11.6006 2.23325 12.5813 2.82626 13.1743C3.41926 13.7673 4.40002 14.0921 6.00694 14.0921H7.40078V8.5998H1.90847ZM8.60078 8.5998V14.0921H9.99463C11.6015 14.0921 12.5823 13.7673 13.1753 13.1743C13.7683 12.5813 14.0931 11.6006 14.0931 9.99365V8.5998H8.60078ZM14.0931 7.39981V6.00596C14.0931 4.39905 13.7683 3.41829 13.1753 2.82528C12.5823 2.23227 11.6015 1.9075 9.99463 1.9075H8.60078V7.39981H14.0931Z"
        fill="#5A5C61"
      />
    </svg>
  );
};

// sidemenu icons

export const MyTeamIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="currentColor"
      viewBox="0 2 24 24"
      {...props}>
      <g clipPath="url(#clip0_2894_141526)">
        <path
          fill="currentColor"
          d="M4 13c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm1.13 1.1c-.37-.06-.74-.1-1.13-.1-.99 0-1.93.21-2.78.58A2.01 2.01 0 000 16.43V18h4.5v-1.61c0-.83.23-1.61.63-2.29zM20 13c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm4 3.43c0-.81-.48-1.53-1.22-1.85A6.95 6.95 0 0020 14c-.39 0-.76.04-1.13.1.4.68.63 1.46.63 2.29V18H24v-1.57zm-7.76-2.78c-1.17-.52-2.61-.9-4.24-.9-1.63 0-3.07.39-4.24.9A2.988 2.988 0 006 16.39V18h12v-1.61c0-1.18-.68-2.26-1.76-2.74zM8.07 16c.09-.23.13-.39.91-.69a8.25 8.25 0 013.02-.56c1.03 0 2.05.18 3.02.56.77.3.81.46.91.69H8.07zM12 8c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0-2c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"></path>
      </g>
      <defs>
        <clipPath id="clip0_2894_141526">
          <path fill="currentColor" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export const MyTeamIconV2 = (props) => {
  return (
    <svg
      width={17}
      height={15}
      viewBox="0 0 17 15"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.83464 6.9987C8.6763 6.9987 10.168 5.50703 10.168 3.66536C10.168 1.8237 8.6763 0.332031 6.83464 0.332031C4.99297 0.332031 3.5013 1.8237 3.5013 3.66536C3.5013 5.50703 4.99297 6.9987 6.83464 6.9987ZM6.83464 1.9987C7.7513 1.9987 8.5013 2.7487 8.5013 3.66536C8.5013 4.58203 7.7513 5.33203 6.83464 5.33203C5.91797 5.33203 5.16797 4.58203 5.16797 3.66536C5.16797 2.7487 5.91797 1.9987 6.83464 1.9987ZM15.746 9.8289L15.746 9.82889L15.7429 9.80703L16.6929 8.96536L15.8596 7.5237L14.6512 7.93203C14.3846 7.70703 14.0846 7.53203 13.7512 7.40703L13.5012 6.16537H11.8346L11.5846 7.40703C11.2512 7.53203 10.9512 7.70703 10.6846 7.93203L9.47624 7.5237L8.6429 8.96536L9.5929 9.80703L9.58978 9.82891C9.56586 9.99598 9.5429 10.1564 9.5429 10.332C9.5429 10.5077 9.56586 10.6681 9.58977 10.8351L9.5929 10.857L8.6429 11.6987L9.47624 13.1404L10.6846 12.732C10.9512 12.957 11.2512 13.132 11.5846 13.257L11.8346 14.4987H13.5012L13.7512 13.257C14.0846 13.132 14.3846 12.957 14.6512 12.732L15.8596 13.1404L16.6929 11.6987L15.7429 10.857L15.746 10.8352L15.746 10.8352C15.7699 10.6681 15.7929 10.5077 15.7929 10.332C15.7929 10.1564 15.7699 9.99597 15.746 9.8289ZM12.6679 11.9987C11.7512 11.9987 11.0012 11.2487 11.0012 10.332C11.0012 9.41537 11.7512 8.66537 12.6679 8.66537C13.5846 8.66537 14.3346 9.41537 14.3346 10.332C14.3346 11.2487 13.5846 11.9987 12.6679 11.9987ZM1.83464 11.457V11.9987H7.0763C7.25964 12.5987 7.53464 13.1654 7.88464 13.6654H0.167969V11.457C0.167969 10.5987 0.592969 9.78203 1.3263 9.3487C2.93464 8.39036 4.81797 7.83203 6.83464 7.83203C7.0263 7.83203 7.20964 7.84036 7.39297 7.85703C7.1513 8.36536 6.98464 8.9237 6.9013 9.50703C6.8763 9.4987 6.85964 9.4987 6.83464 9.4987C5.19297 9.4987 3.58464 9.94036 2.1763 10.782C1.96797 10.907 1.83464 11.1737 1.83464 11.457Z"
        fill="currentColor"
      />
    </svg>
  );
};
const SharedFilesIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 2 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g clipPath="url(#clip0_2894_141530)">
        <path
          fill="currentColor"
          d="M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-5-5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-4 4h8v-1c0-1.33-2.67-2-4-2s-4 .67-4 2v1z"></path>
      </g>
      <defs>
        <clipPath id="clip0_2894_141530">
          <path fill="currentColor" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};
const CalendarIcon = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.389 10.419C12.0189 10.419 11.712 10.1154 11.712 9.74923V9.11085C9.6321 9.31393 8.59649 10.5042 8.5544 12.7318H23.444C23.4019 10.5042 22.3663 9.31393 20.2864 9.11085V9.74923C20.2864 10.1154 19.9795 10.419 19.6095 10.419C19.2394 10.419 18.9325 10.1154 18.9325 9.74923V9.07946H13.0659V9.74923C13.0659 10.1154 12.759 10.419 12.389 10.419ZM13.0659 7.07016V7.73993H18.9325V7.07016C18.9325 6.70402 19.2394 6.40039 19.6095 6.40039C19.9795 6.40039 20.2864 6.70402 20.2864 7.07016V7.76782C23.1621 8.01174 24.7992 9.84549 24.7992 12.8748V20.4655C24.7992 23.725 22.9038 25.6004 19.6095 25.6004H12.389C9.0946 25.6004 7.19922 23.725 7.19922 20.4655V12.8748C7.19922 9.84549 8.83632 8.01174 11.712 7.76782V7.07016C11.712 6.70402 12.0189 6.40039 12.389 6.40039C12.759 6.40039 13.0659 6.70402 13.0659 7.07016ZM8.55306 20.4655V14.0004H23.4454V20.4655C23.4454 23.0196 22.1908 24.2609 19.6095 24.2609H12.389C9.80763 24.2609 8.55306 23.0196 8.55306 20.4655ZM12.4973 18.1615C12.6056 18.2062 12.7229 18.233 12.8403 18.233C13.0749 18.233 13.3096 18.1347 13.4811 17.974C13.6435 17.8043 13.7428 17.5721 13.7428 17.3399C13.7428 17.2844 13.7357 17.2359 13.7278 17.182L13.7248 17.1613C13.7157 17.1077 13.6977 17.0542 13.6706 17.0006C13.6526 16.947 13.6255 16.8934 13.5894 16.8398C13.5713 16.8101 13.5452 16.7803 13.5192 16.7505C13.5061 16.7357 13.4931 16.7208 13.4811 16.7059L13.3457 16.5987C13.2915 16.563 13.2374 16.5362 13.1832 16.5183C13.1291 16.4916 13.0749 16.4737 13.0208 16.4648C12.8403 16.429 12.6597 16.4469 12.4973 16.5183C12.389 16.563 12.2897 16.6255 12.1994 16.7059C12.037 16.8756 11.9377 17.1078 11.9377 17.3399C11.9377 17.456 11.9648 17.5721 12.0099 17.6793C12.055 17.7865 12.1182 17.8847 12.1994 17.974C12.2897 18.0543 12.389 18.1169 12.4973 18.1615ZM15.9992 18.2327C15.7645 18.2327 15.5299 18.1345 15.3584 17.9738L15.2501 17.8398C15.214 17.7862 15.1869 17.7327 15.1688 17.6791C15.1418 17.6255 15.1237 17.5719 15.1147 17.5183L15.1117 17.4977C15.1038 17.4437 15.0967 17.3953 15.0967 17.3397C15.0967 17.2236 15.1237 17.1075 15.1688 17.0004C15.214 16.8932 15.2772 16.795 15.3584 16.7057C15.6111 16.4556 16.0173 16.3752 16.3422 16.5181C16.4595 16.5628 16.5498 16.6253 16.64 16.7057C16.8025 16.8754 16.9018 17.1075 16.9018 17.3397C16.9018 17.3953 16.8947 17.4437 16.8868 17.4977L16.8837 17.5183C16.8747 17.5719 16.8567 17.6255 16.8296 17.6791C16.8115 17.7327 16.7844 17.7862 16.7483 17.8398L16.64 17.9738C16.5498 18.0541 16.4595 18.1167 16.3422 18.1613C16.2339 18.206 16.1165 18.2327 15.9992 18.2327ZM12.4973 21.287C12.6056 21.3316 12.7229 21.3584 12.8403 21.3584C13.0749 21.3584 13.3096 21.2602 13.4811 21.0994C13.6435 20.9298 13.7428 20.6976 13.7428 20.4654C13.7428 20.4118 13.7338 20.3493 13.7248 20.2957C13.7157 20.2332 13.6977 20.1796 13.6706 20.126C13.6526 20.0725 13.6255 20.0189 13.5894 19.9653C13.5713 19.9355 13.5452 19.9058 13.5192 19.876C13.5061 19.8611 13.4931 19.8462 13.4811 19.8314C13.2283 19.5813 12.8312 19.5009 12.4973 19.6438C12.389 19.6885 12.2897 19.751 12.1994 19.8314C12.037 20.001 11.9377 20.2332 11.9377 20.4654C11.9377 20.5815 11.9648 20.6976 12.0099 20.8047C12.055 20.9208 12.1182 21.0101 12.1994 21.0994C12.2897 21.1798 12.389 21.2423 12.4973 21.287Z"
        fill="currentColor"
      />
    </svg>
  );
};
const CommunityIcon = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9984 25.6004C10.7028 25.6004 6.39844 21.296 6.39844 16.0004C6.39844 10.7048 10.7028 6.40039 15.9984 6.40039C21.2941 6.40039 25.5984 10.7048 25.5984 16.0004C25.5984 21.296 21.2941 25.6004 15.9984 25.6004ZM15.9984 7.73993C15.3058 7.73993 14.6328 7.82564 13.9894 7.98702C13.987 8.05097 13.9752 8.11502 13.9535 8.17742C13.5902 9.26925 13.3055 10.3849 13.0994 11.5142C15.0255 11.3009 16.9735 11.301 18.8985 11.5147C18.6924 10.3826 18.4074 9.26381 18.0436 8.16848C18.0237 8.10874 18.0127 8.04795 18.0099 7.98764C17.3658 7.82586 16.692 7.73993 15.9984 7.73993ZM19.1095 12.8901C17.0461 12.6318 14.9516 12.6314 12.8882 12.8889C12.6299 14.9519 12.6297 17.046 12.8876 19.1104C14.9509 19.3687 17.0455 19.3691 19.1089 19.1116C19.3672 17.0486 19.3674 14.9545 19.1095 12.8901ZM11.7083 11.7061C11.8793 10.6697 12.1127 9.64293 12.4086 8.63286C12.3683 8.63188 12.3289 8.62743 12.2909 8.61981C10.6616 9.44168 9.33979 10.7874 8.54824 12.4342C9.58621 12.1252 10.6422 11.8825 11.7083 11.7061ZM7.98573 13.9888C8.04562 13.9858 8.10634 13.9748 8.16654 13.9552C9.26235 13.5906 10.3826 13.3052 11.5166 13.0989C11.3039 15.0252 11.3038 16.9736 11.5164 18.8999C10.3855 18.6937 9.26839 18.4089 8.17555 18.0452C8.11311 18.0235 8.04902 18.0117 7.98504 18.0093C7.82368 17.366 7.73797 16.693 7.73797 16.0004C7.73797 15.3068 7.82392 14.6329 7.98573 13.9888ZM20.4857 13.1016C21.6148 13.3076 22.7301 13.5922 23.8212 13.9552C23.8847 13.979 23.9482 13.9887 24.0116 13.9906C24.1731 14.6342 24.2589 15.3075 24.2589 16.0004C24.2589 16.6931 24.1732 17.3663 24.0117 18.0097C23.9508 18.0128 23.8897 18.0245 23.8302 18.0452C22.7354 18.4095 21.6162 18.6948 20.4831 18.901C20.6975 16.976 20.6983 15.0278 20.4857 13.1016ZM23.4499 12.4369C22.4136 12.1275 21.359 11.8844 20.2938 11.7077C20.1179 10.6429 19.8759 9.58836 19.5678 8.55169C21.2614 9.36663 22.6363 10.7425 23.4499 12.4369ZM8.63099 19.5902C8.62999 19.6301 8.62541 19.6693 8.61756 19.7074C9.41572 21.29 10.7081 22.5825 12.2906 23.3808C12.3288 23.3732 12.3682 23.3687 12.4086 23.3677C12.1127 22.3575 11.8792 21.3306 11.7082 20.2941C10.6706 20.1228 9.6428 19.8884 8.63099 19.5902ZM15.9984 20.6439C15.0288 20.6439 14.0606 20.5912 13.0984 20.4852C13.3046 21.6175 13.5896 22.7365 13.9535 23.8321C13.9742 23.8916 13.9859 23.9527 13.989 24.0137C14.6325 24.1751 15.3057 24.2609 15.9984 24.2609C16.6907 24.2609 17.3633 24.1752 18.0063 24.0141C18.0089 23.9505 18.0209 23.8862 18.0436 23.8232C18.407 22.731 18.6917 21.6149 18.8978 20.4853C17.9355 20.5912 16.9677 20.6439 15.9984 20.6439ZM19.5588 23.4534C19.869 22.4161 20.1127 21.3604 20.2899 20.2941C21.329 20.1229 22.3591 19.8885 23.3748 19.5902C23.3757 19.626 23.3793 19.6611 23.3854 19.6952C22.5632 21.3322 21.2125 22.6601 19.5588 23.4534Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const MySettingsIcon = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.7984 9.6H15.1984C14.7566 9.6 14.3984 9.95817 14.3984 10.4V12C14.3984 12.4418 14.7566 12.8 15.1984 12.8H20.7984C21.2403 12.8 21.5984 12.4418 21.5984 12V11.2V10.4C21.5984 9.95817 21.2403 9.6 20.7984 9.6ZM24.7984 12H23.1984C23.1984 13.3255 22.1239 14.4 20.7984 14.4H15.1984C13.873 14.4 12.7984 13.3255 12.7984 12H7.19844C6.75661 12 6.39844 11.6418 6.39844 11.2C6.39844 10.7582 6.75661 10.4 7.19844 10.4H12.7984C12.7984 9.07452 13.873 8 15.1984 8H20.7984C22.1239 8 23.1984 9.07452 23.1984 10.4H24.7984C25.2403 10.4 25.5984 10.7582 25.5984 11.2C25.5984 11.6418 25.2403 12 24.7984 12ZM6.39844 20.8C6.39844 20.3582 6.75661 20 7.19844 20H8.79844C8.79844 18.6745 9.87295 17.6 11.1984 17.6H16.7984C18.1239 17.6 19.1984 18.6745 19.1984 20H24.7984C25.2403 20 25.5984 20.3582 25.5984 20.8C25.5984 21.2418 25.2403 21.6 24.7984 21.6H19.1984C19.1984 22.9255 18.1239 24 16.7984 24H11.1984C9.87295 24 8.79844 22.9255 8.79844 21.6H7.19844C6.75661 21.6 6.39844 21.2418 6.39844 20.8ZM10.3984 20.8V21.6C10.3984 22.0418 10.7566 22.4 11.1984 22.4H16.7984C17.2403 22.4 17.5984 22.0418 17.5984 21.6V20C17.5984 19.5582 17.2403 19.2 16.7984 19.2H11.1984C10.7566 19.2 10.3984 19.5582 10.3984 20V20.8Z"
        fill="currentColor"
      />
    </svg>
  );
};
const TrashIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 2 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g clipPath="url(#clip0_2894_141539)">
        <path
          fill="currentColor"
          d="M16 9v10H8V9h8zm-1.5-6h-5l-1 1H5v2h14V4h-3.5l-1-1zM18 7H6v12c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7z"></path>
      </g>
      <defs>
        <clipPath id="clip0_2894_141539">
          <path fill="currentColor" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};
export const TrashV2Icon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <title>{props?.title}</title>
      <g clipPath="url(#clip0_3076_16783)">
        <path
          d="M4.12039 14.3324C3.81948 14.3324 3.56371 14.227 3.35307 14.0164C3.14243 13.8058 3.03712 13.55 3.03712 13.2491V2.95793H2.29688V1.87465H5.69115V1.33301H10.4576V1.87465H13.8519V2.95793H13.1116V13.2491C13.1116 13.538 13.0033 13.7907 12.7866 14.0074C12.57 14.224 12.3172 14.3324 12.0283 14.3324H4.12039ZM12.0283 2.95793H4.12039V13.2491H12.0283V2.95793ZM6.03419 11.6964H7.11747V4.49257H6.03419V11.6964ZM9.03126 11.6964H10.1145V4.49257H9.03126V11.6964ZM4.12039 2.95793V13.2491V2.95793Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_3076_16783">
          <rect width="16" height="16" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};
const MyFilesIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g clipPath="url(#clip0_3076_52815)">
        <path
          d="M2.66536 13.3332C2.2987 13.3332 1.98481 13.2026 1.7237 12.9415C1.46259 12.6804 1.33203 12.3665 1.33203 11.9998V3.99984C1.33203 3.63317 1.46259 3.31928 1.7237 3.05817C1.98481 2.79706 2.2987 2.6665 2.66536 2.6665H6.66536L7.9987 3.99984H13.332C13.6987 3.99984 14.0126 4.13039 14.2737 4.3915C14.5348 4.65261 14.6654 4.9665 14.6654 5.33317V11.9998C14.6654 12.3665 14.5348 12.6804 14.2737 12.9415C14.0126 13.2026 13.6987 13.3332 13.332 13.3332H2.66536ZM2.66536 3.99984V11.9998H13.332V5.33317H7.4487L6.11537 3.99984H2.66536Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_3076_52815">
          <rect width="16" height="16" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};
const TutorialsIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="18"
      viewBox="0 0 22 18"
      fill="none"
      {...props}>
      <path
        d="M11 0L0 6L4 8.18V14.18L11 18L18 14.18V8.18L20 7.09V14H22V6L11 0ZM17.82 6L11 9.72L4.18 6L11 2.28L17.82 6ZM16 12.99L11 15.72L6 12.99V9.27L11 12L16 9.27V12.99Z"
        fill="currentColor"
      />
    </svg>
  );
};
const SupportsIcon = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2124 23.6279H20.4636C24.4018 23.6279 25.5984 22.4313 25.5984 18.493C25.5984 18.1269 25.2948 17.8233 24.9287 17.8233C24.0714 17.8233 23.3659 17.1178 23.3659 16.2605C23.3659 15.4032 24.0714 14.6977 24.9287 14.6977C25.2948 14.6977 25.5984 14.394 25.5984 14.0279V13.1349C25.5984 9.19665 24.4018 8 20.4636 8H14.2124H11.5333C7.59509 8 6.39844 9.19665 6.39844 13.1349V13.5814C6.39844 13.9475 6.70207 14.2512 7.0682 14.2512C7.92551 14.2512 8.631 14.9567 8.631 15.814C8.631 16.6713 7.92551 17.3767 7.0682 17.3767C6.70207 17.3767 6.39844 17.6804 6.39844 18.0465V18.493C6.39844 22.4313 7.59509 23.6279 11.5333 23.6279H14.2124ZM13.5426 22.2884H11.5333C8.38988 22.2884 7.75583 21.7079 7.73797 18.6359C9.015 18.3323 9.97053 17.1803 9.97053 15.814C9.97053 14.4476 9.015 13.2956 7.73797 12.992C7.75583 9.92 8.38988 9.33953 11.5333 9.33953H13.5426V10.9023C13.5426 11.2685 13.8463 11.5721 14.2124 11.5721C14.5785 11.5721 14.8822 11.2685 14.8822 10.9023V9.33953H20.4636C23.6606 9.33953 24.2589 9.94679 24.2589 13.1349V13.4385C22.9819 13.7421 22.0263 14.8941 22.0263 16.2605C22.0263 17.6268 22.9729 18.7788 24.25 19.0824C24.1696 21.7615 23.4463 22.2884 20.4636 22.2884H14.8822V20.7256C14.8822 20.3594 14.5785 20.0558 14.2124 20.0558C13.8463 20.0558 13.5426 20.3594 13.5426 20.7256V22.2884ZM14.2124 18.1181C13.8463 18.1181 13.5426 17.8145 13.5426 17.4483V14.1709C13.5426 13.8048 13.8463 13.5012 14.2124 13.5012C14.5785 13.5012 14.8822 13.8048 14.8822 14.1709V17.4483C14.8822 17.8234 14.5785 18.1181 14.2124 18.1181Z"
        fill="currentColor"
      />
    </svg>
  );
};
const RequestsIcon = (props) => {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.05668 2.05619C3.25985 0.853024 5.05371 0.399902 7.34193 0.399902H12.6589C14.9471 0.399902 16.7409 0.853024 17.9441 2.05619C19.1473 3.25936 19.6004 5.05322 19.6004 7.34144V12.6584C19.6004 14.9466 19.1473 16.7404 17.9441 17.9436C16.7409 19.1468 14.9471 19.5999 12.6589 19.5999H7.34193C5.05371 19.5999 3.25985 19.1468 2.05668 17.9436C0.853512 16.7404 0.400391 14.9466 0.400391 12.6584V11.4768V10.9304V7.34144V7.04606H0.40298C0.441172 4.89849 0.905776 3.2071 2.05668 2.05619ZM1.87731 7.34144V10.9304V11.4768V12.6584C1.87731 14.8009 2.31035 16.1086 3.10102 16.8993C3.8917 17.6899 5.19938 18.123 7.34193 18.123H12.6589C14.8014 18.123 16.1091 17.6899 16.8998 16.8993C17.6904 16.1086 18.1235 14.8009 18.1235 12.6584V7.34144C18.1235 5.19889 17.6904 3.89121 16.8998 3.10053C16.1091 2.30986 14.8014 1.87683 12.6589 1.87683H7.34193C5.19938 1.87683 3.8917 2.30986 3.10102 3.10053C2.31035 3.89121 1.87731 5.19889 1.87731 7.34144ZM10.7389 10.4411V5.13464C10.7389 4.7268 10.4082 4.39618 10.0004 4.39618C9.59255 4.39618 9.26193 4.7268 9.26193 5.13464V10.4411L7.8641 9.04324C7.57571 8.75485 7.10814 8.75485 6.81976 9.04324C6.53137 9.33162 6.53137 9.79919 6.81976 10.0876L9.47758 12.7454L9.48306 12.7508C9.55273 12.8193 9.6326 12.8711 9.71772 12.9063C9.80479 12.9424 9.90026 12.9623 10.0004 12.9623C10.1858 12.9623 10.3713 12.8929 10.5144 12.7541L10.5236 12.745L13.181 10.0876C13.4694 9.79919 13.4694 9.33162 13.181 9.04324C12.8926 8.75485 12.4251 8.75485 12.1367 9.04324L10.7389 10.4411ZM3.98308 13.7621C4.11235 13.3753 4.53072 13.1665 4.91753 13.2958C8.21276 14.397 11.788 14.397 15.0833 13.2958C15.4701 13.1665 15.8884 13.3753 16.0177 13.7621C16.147 14.1489 15.9382 14.5673 15.5514 14.6966C11.9523 15.8993 8.04846 15.8993 4.44941 14.6966C4.06259 14.5673 3.85381 14.1489 3.98308 13.7621Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const RequestsIconV2 = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g clipPath="url(#clip0_3500_89498)">
        <path
          d="M10 2H3.33333C2.6 2 2.00667 2.6 2.00667 3.33333L2 12.6667C2 13.4 2.59333 14 3.32667 14H12.6667C13.4 14 14 13.4 14 12.6667V6L10 2ZM3.33333 12.6667V3.33333H9.33333V6.66667H12.6667V12.6667H3.33333ZM6 5.33333C6 5.7 5.7 6 5.33333 6C4.96667 6 4.66667 5.7 4.66667 5.33333C4.66667 4.96667 4.96667 4.66667 5.33333 4.66667C5.7 4.66667 6 4.96667 6 5.33333ZM6 8C6 8.36667 5.7 8.66667 5.33333 8.66667C4.96667 8.66667 4.66667 8.36667 4.66667 8C4.66667 7.63333 4.96667 7.33333 5.33333 7.33333C5.7 7.33333 6 7.63333 6 8ZM6 10.6667C6 11.0333 5.7 11.3333 5.33333 11.3333C4.96667 11.3333 4.66667 11.0333 4.66667 10.6667C4.66667 10.3 4.96667 10 5.33333 10C5.7 10 6 10.3 6 10.6667Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_3500_89498">
          <rect width="16" height="16" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const TutorialHubIcon = (props) => {
  return (
    <svg
      {...props}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <g mask="url(#mask0_4578_597)">
        <path
          d="M7.66683 9.66658L12.3335 6.66658L7.66683 3.66659V9.66658ZM5.3335 11.9999C4.96683 11.9999 4.65294 11.8694 4.39183 11.6083C4.13072 11.3471 4.00016 11.0333 4.00016 10.6666V2.66659C4.00016 2.29992 4.13072 1.98603 4.39183 1.72492C4.65294 1.46381 4.96683 1.33325 5.3335 1.33325H13.3335C13.7002 1.33325 14.0141 1.46381 14.2752 1.72492C14.5363 1.98603 14.6668 2.29992 14.6668 2.66659V10.6666C14.6668 11.0333 14.5363 11.3471 14.2752 11.6083C14.0141 11.8694 13.7002 11.9999 13.3335 11.9999H5.3335ZM5.3335 10.6666H13.3335V2.66659H5.3335V10.6666ZM2.66683 14.6666C2.30016 14.6666 1.98627 14.536 1.72516 14.2749C1.46405 14.0138 1.3335 13.6999 1.3335 13.3333V3.99992H2.66683V13.3333H12.0002V14.6666H2.66683Z"
          fill="correntColor"
        />
      </g>
    </svg>
  );
};

export const TutorialsIconV2 = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M3.33464 5.0013H16.668V6.66797H3.33464V5.0013ZM5.0013 1.66797H15.0013V3.33464H5.0013V1.66797ZM16.668 8.33464H3.33464C2.41797 8.33464 1.66797 9.08464 1.66797 10.0013V16.668C1.66797 17.5846 2.41797 18.3346 3.33464 18.3346H16.668C17.5846 18.3346 18.3346 17.5846 18.3346 16.668V10.0013C18.3346 9.08464 17.5846 8.33464 16.668 8.33464ZM16.668 16.668H3.33464V10.0013H16.668V16.668ZM8.33464 10.6096V16.0513L13.3346 13.3346L8.33464 10.6096Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const StrikeIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M8.25047 15.83L12.908 10.25H9.30797L9.96047 5.1425L5.79797 11.15H8.92547L8.25047 15.83ZM5.95547 19.25L6.85547 12.95H2.35547L10.4555 1.25H12.2555L11.3555 8.45H16.7555L7.75547 19.25H5.95547Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CopyLinkIcon = (props) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g mask="url(#mask0_4824_2321)">
        <path
          d="M9.1665 14.2269H5.83317C4.68039 14.2269 3.69775 13.8206 2.88525 13.0081C2.07275 12.1956 1.6665 11.213 1.6665 10.0602C1.6665 8.90744 2.07275 7.9248 2.88525 7.1123C3.69775 6.2998 4.68039 5.89355 5.83317 5.89355H9.1665V7.56022H5.83317C5.13873 7.56022 4.54845 7.80328 4.06234 8.28939C3.57623 8.7755 3.33317 9.36578 3.33317 10.0602C3.33317 10.7547 3.57623 11.3449 4.06234 11.8311C4.54845 12.3172 5.13873 12.5602 5.83317 12.5602H9.1665V14.2269ZM6.6665 10.8936V9.22689H13.3332V10.8936H6.6665ZM10.8332 14.2269V12.5602H14.1665C14.8609 12.5602 15.4512 12.3172 15.9373 11.8311C16.4234 11.3449 16.6665 10.7547 16.6665 10.0602C16.6665 9.36578 16.4234 8.7755 15.9373 8.28939C15.4512 7.80328 14.8609 7.56022 14.1665 7.56022H10.8332V5.89355H14.1665C15.3193 5.89355 16.3019 6.2998 17.1144 7.1123C17.9269 7.9248 18.3332 8.90744 18.3332 10.0602C18.3332 11.213 17.9269 12.1956 17.1144 13.0081C16.3019 13.8206 15.3193 14.2269 14.1665 14.2269H10.8332Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const CodeIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <mask
        id="mask0_5384_612"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20">
        <rect width="20" height="20" fill="currentColor" />
      </mask>
      <g mask="url(#mask0_5384_612)">
        <path
          d="M6.6665 15L1.6665 10L6.6665 5L7.854 6.1875L4.02067 10.0208L7.83317 13.8333L6.6665 15ZM13.3332 15L12.1457 13.8125L15.979 9.97917L12.1665 6.16667L13.3332 5L18.3332 10L13.3332 15Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

// top menu icons

export const HomeIcon = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g clipPath="url(#clip0_2841_15638)">
        <path
          d="M3.9974 12.6667H5.9974V8.66667H9.9974V12.6667H11.9974V6.66667L7.9974 3.66667L3.9974 6.66667V12.6667ZM2.66406 14V6L7.9974 2L13.3307 6V14H8.66406V10H7.33073V14H2.66406Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2841_15638">
          <rect width="16" height="16" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};

const MyProductsIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="currentColor"
      viewBox="0 2 24 24"
      {...props}>
      <g clipPath="url(#clip0_2894_141503)">
        <path
          fill="currentColor"
          d="M12 2l-5.5 9h11L12 2zm0 3.84L13.93 9h-3.87L12 5.84zM17.5 13c-2.49 0-4.5 2.01-4.5 4.5s2.01 4.5 4.5 4.5 4.5-2.01 4.5-4.5-2.01-4.5-4.5-4.5zm0 7a2.5 2.5 0 010-5 2.5 2.5 0 010 5zM3 21.5h8v-8H3v8zm2-6h4v4H5v-4z"></path>
      </g>
      <defs>
        <clipPath id="clip0_2894_141503">
          <path fill="currentColor" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};
export const MyProductsIconV2 = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g clipPath="url(#clip0_3500_89481)">
        <path
          d="M4.33333 7.3335L8 1.3335L11.6667 7.3335H4.33333ZM11.6667 14.6668C10.8333 14.6668 10.125 14.3752 9.54167 13.7918C8.95833 13.2085 8.66667 12.5002 8.66667 11.6668C8.66667 10.8335 8.95833 10.1252 9.54167 9.54183C10.125 8.9585 10.8333 8.66683 11.6667 8.66683C12.5 8.66683 13.2083 8.9585 13.7917 9.54183C14.375 10.1252 14.6667 10.8335 14.6667 11.6668C14.6667 12.5002 14.375 13.2085 13.7917 13.7918C13.2083 14.3752 12.5 14.6668 11.6667 14.6668ZM2 14.3335V9.00016H7.33333V14.3335H2ZM11.6667 13.3335C12.1333 13.3335 12.5278 13.1724 12.85 12.8502C13.1722 12.5279 13.3333 12.1335 13.3333 11.6668C13.3333 11.2002 13.1722 10.8057 12.85 10.4835C12.5278 10.1613 12.1333 10.0002 11.6667 10.0002C11.2 10.0002 10.8056 10.1613 10.4833 10.4835C10.1611 10.8057 10 11.2002 10 11.6668C10 12.1335 10.1611 12.5279 10.4833 12.8502C10.8056 13.1724 11.2 13.3335 11.6667 13.3335ZM3.33333 13.0002H6V10.3335H3.33333V13.0002ZM6.7 6.00016H9.3L8 3.90016L6.7 6.00016Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_3500_89481">
          <rect width="16" height="16" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};
const MyProjectsIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="currentColor"
      viewBox="0 2 24 24"
      {...props}>
      <g clipPath="url(#clip0_2894_141506)">
        <path
          fill="currentColor"
          d="M20 4v12H8V4h12zm0-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 9.67l1.69 2.26 2.48-3.1L19 15H9l2.5-3.33zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z"></path>
      </g>
      <defs>
        <clipPath id="clip0_2894_141506">
          <path fill="currentColor" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

const RetailAutomationIconV2 = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      {...props}>
      <g clipPath="url(#clip0_10234_127258)">
        <path
          d="M13.584 3.99935H8.25065L6.91732 2.66602H2.91732C2.18398 2.66602 1.59065 3.26602 1.59065 3.99935L1.58398 11.9993C1.58398 12.7327 2.18398 13.3327 2.91732 13.3327H13.584C14.3173 13.3327 14.9173 12.7327 14.9173 11.9993V5.33268C14.9173 4.59935 14.3173 3.99935 13.584 3.99935ZM13.584 11.9993H2.91732V3.99935H6.36398L7.69732 5.33268H13.584V11.9993ZM10.2507 8.66602C10.984 8.66602 11.584 8.06602 11.584 7.33268C11.584 6.59935 10.984 5.99935 10.2507 5.99935C9.51732 5.99935 8.91732 6.59935 8.91732 7.33268C8.91732 8.06602 9.51732 8.66602 10.2507 8.66602ZM7.58398 11.3327H12.9173V10.666C12.9173 9.77935 11.1373 9.33268 10.2507 9.33268C9.36398 9.33268 7.58398 9.77935 7.58398 10.666V11.3327Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_10234_127258">
          <rect width="16" height="16" fill="white" transform="translate(0.25)" />
        </clipPath>
      </defs>
    </svg>
  );
};

const AutomationIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="currentColor"
      viewBox="0 2 24 24"
      {...props}>
      <g clipPath="url(#clip0_2894_141555)">
        <path
          fill="currentColor"
          d="M20 10V8c0-1.1-.9-2-2-2h-3c0-1.66-1.34-3-3-3S9 4.34 9 6H6c-1.1 0-2 .9-2 2v2c-1.66 0-3 1.34-3 3s1.34 3 3 3v4c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4c1.66 0 3-1.34 3-3s-1.34-3-3-3zm-2 10H6V8h12v12zm-9-6c-.83 0-1.5-.67-1.5-1.5S8.17 11 9 11s1.5.67 1.5 1.5S9.83 14 9 14zm7.5-1.5c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5 1.5.67 1.5 1.5zM8 16h8v2H8v-2z"></path>
      </g>
      <defs>
        <clipPath id="clip0_2894_141555">
          <path fill="currentColor" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};
const RendersPreviewsIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 2 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g clipPath="url(#clip0_2894_141509)">
        <path
          fill="currentColor"
          d="M19 3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2V5a2 2 0 00-2-2zm0 16H5V7h14v12zm-7-8.5c1.84 0 3.48.96 4.34 2.5-.86 1.54-2.5 2.5-4.34 2.5-1.84 0-3.48-.96-4.34-2.5.86-1.54 2.5-2.5 4.34-2.5zM12 9c-2.73 0-5.06 1.66-6 4 .94 2.34 3.27 4 6 4s5.06-1.66 6-4c-.94-2.34-3.27-4-6-4zm0 5.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"></path>
      </g>
      <defs>
        <clipPath id="clip0_2894_141509">
          <path fill="currentColor" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};
const TemplatesIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 2 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g clipPath="url(#clip0_2894_141513)">
        <path
          fill="currentColor"
          d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm-1 4H8c-1.1 0-1.99.9-1.99 2L6 21c0 1.1.89 2 1.99 2H19c1.1 0 2-.9 2-2V11l-6-6zM8 21V7h6v5h5v9H8z"></path>
      </g>
      <defs>
        <clipPath id="clip0_2894_141513">
          <path fill="currentColor" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};
const PropsIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="currentColor"
      viewBox="0 2 24 24"
      {...props}>
      <g fill="currentColor" clipPath="url(#clip0_2894_141516)">
        <path d="M20 2H4c-1 0-2 .9-2 2v3.01c0 .72.43 1.34 1 1.69V20c0 1.1 1.1 2 2 2h14c.9 0 2-.9 2-2V8.7c.57-.35 1-.97 1-1.69V4c0-1.1-1-2-2-2zm-1 18H5V9h14v11zm1-13H4V4h16v3z"></path>
        <path d="M15 12H9v2h6v-2z"></path>
      </g>
      <defs>
        <clipPath id="clip0_2894_141516">
          <path fill="currentColor" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};
const CollectionsIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="currentColor"
      viewBox="0 2 24 24"
      {...props}>
      <g clipPath="url(#clip0_2894_141523)">
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M3 3v8h8V3H3zm6 6H5V5h4v4zm-6 4v8h8v-8H3zm6 6H5v-4h4v4zm4-16v8h8V3h-8zm6 6h-4V5h4v4zm-6 4v8h8v-8h-8zm6 6h-4v-4h4v4z"
          clipRule="evenodd"></path>
      </g>
      <defs>
        <clipPath id="clip0_2894_141523">
          <path fill="currentColor" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};
export const SearchBarIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g clipPath="url(#clip0_2894_141552)">
        <path
          fill="currentColor"
          d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"></path>
      </g>
      <defs>
        <clipPath id="clip0_2894_141552">
          <path fill="currentColor" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};
const NotificationsIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="currentColor"
      viewBox="0 0 24 24"
      {...props}>
      <g clipPath="url(#clip0_2894_141542)">
        <path
          fill="currentColor"
          d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z"></path>
      </g>
      <defs>
        <clipPath id="clip0_2894_141542">
          <path fill="currentColor" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};
const NotificationsActiveIcon = (props) => {
  return (
    <svg
      width="20"
      height="24"
      viewBox="0 0 20 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.76767 0C8.63201 0 7.62157 0.617126 7.09769 1.58639C4.27755 2.66204 2.2672 5.39604 2.2672 8.58784V11.7945C2.2672 12.316 2.0231 13.2037 1.7568 13.6475L0.480787 15.7668C-0.0296184 16.6101 -0.140576 17.5532 0.181201 18.4076C0.491882 19.262 1.20201 19.9166 2.13406 20.2384C3.33246 20.6397 4.56266 20.9429 5.80913 21.148C6.01253 21.7577 6.35587 22.3192 6.81609 22.7795C7.59279 23.5562 8.65799 24 9.75647 24C11.5963 24 13.1585 22.8039 13.7073 21.1474C14.9509 20.9422 16.1769 20.6392 17.3685 20.2384C18.2451 19.9499 18.9441 19.2841 19.2659 18.4076C19.5877 17.531 19.4989 16.5657 19.0218 15.7668L17.7569 13.6586C17.4906 13.2037 17.2465 12.3049 17.2465 11.7945V8.58784C17.2465 5.40701 15.2499 2.68085 12.4451 1.59755C11.9233 0.613963 10.9087 0 9.76767 0ZM11.7097 21.3917C11.0603 21.4439 10.4086 21.47 9.75684 21.47C9.10511 21.47 8.45338 21.4439 7.80378 21.3917C7.86234 21.4656 7.92522 21.5363 7.99224 21.6033C8.45826 22.0693 9.10182 22.3356 9.75647 22.3356C10.5462 22.3356 11.2518 21.9665 11.7097 21.3917ZM3.93157 8.58784C3.93157 5.66689 6.08935 3.24881 8.88606 2.82756C9.4319 2.75399 9.99557 2.75118 10.572 2.81911C13.4037 3.21542 15.5821 5.64671 15.5821 8.58784V11.7834C15.5821 12.5934 15.9039 13.7807 16.3255 14.5019L17.6015 16.6212C17.8235 16.9873 17.8567 17.4201 17.7125 17.8195C17.5683 18.219 17.2576 18.5185 16.8581 18.6517C12.2201 20.2051 7.30468 20.2051 2.66665 18.6517C2.21173 18.4963 1.87885 18.2079 1.7457 17.8306C1.60146 17.4644 1.66803 17.0317 1.91214 16.6212L3.18815 14.5019C3.5987 13.8028 3.93157 12.6045 3.93157 11.7945V8.58784Z"
        fill="#fff"
      />
    </svg>
  );
};
const NotificationsBellIcon = (props) => {
  return (
    <svg
      width="31"
      height="28"
      viewBox="0 0 31 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <mask
        id="path-1-outside-1_20625_425738"
        maskUnits="userSpaceOnUse"
        x="5"
        y="2"
        width="21"
        height="26"
        fill="black">
        <rect fill="white" x="5" y="2" width="21" height="26" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.7677 3C14.632 3 13.6216 3.61713 13.0977 4.58639C10.2776 5.66204 8.2672 8.39604 8.2672 11.5878V14.7945C8.2672 15.316 8.0231 16.2037 7.7568 16.6475L6.48079 18.7668C5.97038 19.6101 5.85942 20.5532 6.1812 21.4076C6.49188 22.262 7.20201 22.9166 8.13406 23.2384C9.33246 23.6397 10.5627 23.9429 11.8091 24.148C12.0125 24.7577 12.3559 25.3192 12.8161 25.7795C13.5928 26.5562 14.658 27 15.7565 27C17.5963 27 19.1585 25.8039 19.7073 24.1474C20.9509 23.9422 22.1769 23.6392 23.3685 23.2384C24.2451 22.9499 24.9441 22.2841 25.2659 21.4076C25.5877 20.531 25.4989 19.5657 25.0218 18.7668L23.7569 16.6586C23.4906 16.2037 23.2465 15.3049 23.2465 14.7945V11.5878C23.2465 8.40701 21.2499 5.68085 18.4451 4.59755C17.9233 3.61396 16.9087 3 15.7677 3ZM17.7097 24.3917C17.0603 24.4439 16.4086 24.47 15.7568 24.47C15.1051 24.47 14.4534 24.4439 13.8038 24.3917C13.8623 24.4656 13.9252 24.5363 13.9922 24.6033C14.4583 25.0693 15.1018 25.3356 15.7565 25.3356C16.5462 25.3356 17.2518 24.9665 17.7097 24.3917ZM9.93157 11.5878C9.93157 8.66689 12.0893 6.24881 14.8861 5.82756C15.4319 5.75399 15.9956 5.75118 16.572 5.81911C19.4037 6.21542 21.5821 8.64671 21.5821 11.5878V14.7834C21.5821 15.5934 21.9039 16.7807 22.3255 17.5019L23.6015 19.6212C23.8235 19.9873 23.8567 20.4201 23.7125 20.8195C23.5683 21.219 23.2576 21.5185 22.8581 21.6517C18.2201 23.2051 13.3047 23.2051 8.66665 21.6517C8.21173 21.4963 7.87885 21.2079 7.7457 20.8306C7.60146 20.4644 7.66803 20.0317 7.91214 19.6212L9.18815 17.5019C9.5987 16.8028 9.93157 15.6045 9.93157 14.7945V11.5878Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7677 3C14.632 3 13.6216 3.61713 13.0977 4.58639C10.2776 5.66204 8.2672 8.39604 8.2672 11.5878V14.7945C8.2672 15.316 8.0231 16.2037 7.7568 16.6475L6.48079 18.7668C5.97038 19.6101 5.85942 20.5532 6.1812 21.4076C6.49188 22.262 7.20201 22.9166 8.13406 23.2384C9.33246 23.6397 10.5627 23.9429 11.8091 24.148C12.0125 24.7577 12.3559 25.3192 12.8161 25.7795C13.5928 26.5562 14.658 27 15.7565 27C17.5963 27 19.1585 25.8039 19.7073 24.1474C20.9509 23.9422 22.1769 23.6392 23.3685 23.2384C24.2451 22.9499 24.9441 22.2841 25.2659 21.4076C25.5877 20.531 25.4989 19.5657 25.0218 18.7668L23.7569 16.6586C23.4906 16.2037 23.2465 15.3049 23.2465 14.7945V11.5878C23.2465 8.40701 21.2499 5.68085 18.4451 4.59755C17.9233 3.61396 16.9087 3 15.7677 3ZM17.7097 24.3917C17.0603 24.4439 16.4086 24.47 15.7568 24.47C15.1051 24.47 14.4534 24.4439 13.8038 24.3917C13.8623 24.4656 13.9252 24.5363 13.9922 24.6033C14.4583 25.0693 15.1018 25.3356 15.7565 25.3356C16.5462 25.3356 17.2518 24.9665 17.7097 24.3917ZM9.93157 11.5878C9.93157 8.66689 12.0893 6.24881 14.8861 5.82756C15.4319 5.75399 15.9956 5.75118 16.572 5.81911C19.4037 6.21542 21.5821 8.64671 21.5821 11.5878V14.7834C21.5821 15.5934 21.9039 16.7807 22.3255 17.5019L23.6015 19.6212C23.8235 19.9873 23.8567 20.4201 23.7125 20.8195C23.5683 21.219 23.2576 21.5185 22.8581 21.6517C18.2201 23.2051 13.3047 23.2051 8.66665 21.6517C8.21173 21.4963 7.87885 21.2079 7.7457 20.8306C7.60146 20.4644 7.66803 20.0317 7.91214 19.6212L9.18815 17.5019C9.5987 16.8028 9.93157 15.6045 9.93157 14.7945V11.5878Z"
        fill="currentColor"
      />
      <path
        d="M13.0977 4.58639L13.2759 5.05356L13.4493 4.98742L13.5376 4.82413L13.0977 4.58639ZM7.7568 16.6475L8.18515 16.9054L8.18555 16.9048L7.7568 16.6475ZM6.48079 18.7668L6.90854 19.0257L6.90914 19.0247L6.48079 18.7668ZM6.1812 21.4076L6.65113 21.2367L6.64912 21.2314L6.1812 21.4076ZM8.13406 23.2384L7.97088 23.711L7.9753 23.7125L8.13406 23.2384ZM11.8091 24.148L12.2834 23.9898L12.188 23.7037L11.8903 23.6547L11.8091 24.148ZM12.8161 25.7795L12.4625 26.133L12.4625 26.133L12.8161 25.7795ZM19.7073 24.1474L19.6259 23.654L19.3277 23.7032L19.2326 23.9901L19.7073 24.1474ZM23.3685 23.2384L23.2122 22.7634L23.2091 22.7645L23.3685 23.2384ZM25.2659 21.4076L25.7353 21.5799L25.7353 21.5799L25.2659 21.4076ZM25.0218 18.7668L25.4511 18.5104L25.4505 18.5095L25.0218 18.7668ZM23.7569 16.6586L23.3254 16.9112L23.3281 16.9158L23.7569 16.6586ZM18.4451 4.59755L18.0034 4.83184L18.0908 4.99673L18.2649 5.06397L18.4451 4.59755ZM17.7097 24.3917L18.1007 24.7033L18.8197 23.801L17.6696 23.8934L17.7097 24.3917ZM13.8038 24.3917L13.8438 23.8933L12.6976 23.8013L13.412 24.7024L13.8038 24.3917ZM13.9922 24.6033L13.6387 24.9569L13.6387 24.9569L13.9922 24.6033ZM14.8861 5.82756L14.8193 5.33198L14.8116 5.33313L14.8861 5.82756ZM16.572 5.81911L16.6413 5.32382L16.6305 5.32255L16.572 5.81911ZM22.3255 17.5019L21.8939 17.7542L21.8972 17.7598L22.3255 17.5019ZM23.6015 19.6212L23.1732 19.8791L23.1739 19.8803L23.6015 19.6212ZM23.7125 20.8195L24.1828 20.9893L24.1828 20.9893L23.7125 20.8195ZM22.8581 21.6517L22.7 21.1773L22.6993 21.1776L22.8581 21.6517ZM8.66665 21.6517L8.50508 22.1249L8.50786 22.1258L8.66665 21.6517ZM7.7457 20.8306L8.2172 20.6642L8.2142 20.6557L8.21091 20.6473L7.7457 20.8306ZM7.91214 19.6212L7.48378 19.3633L7.48237 19.3656L7.91214 19.6212ZM9.18815 17.5019L9.61653 17.7598L9.6193 17.7551L9.18815 17.5019ZM13.5376 4.82413C13.9748 4.01518 14.8171 3.5 15.7677 3.5V2.5C14.4469 2.5 13.2684 3.21907 12.6578 4.34865L13.5376 4.82413ZM8.7672 11.5878C8.7672 8.61092 10.6424 6.05801 13.2759 5.05356L12.9195 4.11922C9.91268 5.26607 7.7672 8.18115 7.7672 11.5878H8.7672ZM8.7672 14.7945V11.5878H7.7672V14.7945H8.7672ZM8.18555 16.9048C8.35146 16.6282 8.49366 16.2471 8.59393 15.8828C8.69428 15.5183 8.7672 15.1178 8.7672 14.7945H7.7672C7.7672 14.9927 7.71808 15.2968 7.6298 15.6174C7.54144 15.9384 7.42844 16.2229 7.32805 16.3903L8.18555 16.9048ZM6.90914 19.0247L8.18515 16.9054L7.32845 16.3896L6.05244 18.5089L6.90914 19.0247ZM6.64912 21.2314C6.38701 20.5354 6.46891 19.752 6.90854 19.0257L6.05304 18.5079C5.47185 19.4681 5.33184 20.571 5.71329 21.5838L6.64912 21.2314ZM8.29722 22.7658C7.48882 22.4867 6.9038 21.9317 6.6511 21.2367L5.7113 21.5785C6.07996 22.5923 6.9152 23.3465 7.97089 23.711L8.29722 22.7658ZM11.8903 23.6547C10.6697 23.4538 9.46546 23.1569 8.29281 22.7643L7.9753 23.7125C9.19945 24.1224 10.4556 24.432 11.7279 24.6414L11.8903 23.6547ZM13.1696 25.4259C12.7651 25.0214 12.4627 24.5271 12.2834 23.9898L11.3348 24.3063C11.5624 24.9884 11.9466 25.6171 12.4625 26.133L13.1696 25.4259ZM15.7565 26.5C14.7914 26.5 13.8531 26.1094 13.1696 25.4259L12.4625 26.133C13.3324 27.0029 14.5246 27.5 15.7565 27.5V26.5ZM19.2326 23.9901C18.7496 25.4483 17.3742 26.5 15.7565 26.5V27.5C17.8184 27.5 19.5674 26.1595 20.1819 24.3046L19.2326 23.9901ZM23.2091 22.7645C22.0435 23.1565 20.8436 23.4531 19.6259 23.654L19.7887 24.6407C21.0582 24.4313 22.3103 24.1219 23.5279 23.7123L23.2091 22.7645ZM24.7965 21.2353C24.5281 21.9666 23.9456 22.5221 23.2122 22.7634L23.5248 23.7133C24.5446 23.3777 25.3602 22.6017 25.7353 21.5799L24.7965 21.2353ZM24.5925 19.0232C24.9918 19.6918 25.0666 20.4995 24.7965 21.2353L25.7353 21.5799C26.1087 20.5626 26.006 19.4396 25.4511 18.5104L24.5925 19.0232ZM23.3281 16.9158L24.5931 19.024L25.4505 18.5095L24.1856 16.4014L23.3281 16.9158ZM22.7465 14.7945C22.7465 15.1126 22.8196 15.5132 22.9195 15.8791C23.0196 16.2455 23.1611 16.6306 23.3254 16.9112L24.1884 16.406C24.0863 16.2316 23.9727 15.9399 23.8842 15.6156C23.7954 15.2908 23.7465 14.9868 23.7465 14.7945H22.7465ZM22.7465 11.5878V14.7945H23.7465V11.5878H22.7465ZM18.2649 5.06397C20.8842 6.07557 22.7465 8.62116 22.7465 11.5878H23.7465C23.7465 8.19286 21.6157 5.28613 18.6252 4.13113L18.2649 5.06397ZM15.7677 3.5C16.7251 3.5 17.569 4.01303 18.0034 4.83184L18.8868 4.36326C18.2776 3.2149 17.0923 2.5 15.7677 2.5V3.5ZM17.6696 23.8934C17.0336 23.9445 16.3952 23.97 15.7568 23.97V24.97C16.4219 24.97 17.087 24.9434 17.7497 24.8901L17.6696 23.8934ZM15.7568 23.97C15.1184 23.97 14.4801 23.9445 13.8438 23.8933L13.7637 24.8901C14.4267 24.9434 15.0918 24.97 15.7568 24.97V23.97ZM13.412 24.7024C13.4823 24.7911 13.5579 24.8761 13.6387 24.9569L14.3458 24.2498C14.2925 24.1965 14.2424 24.1401 14.1956 24.0811L13.412 24.7024ZM13.6387 24.9569C14.1982 25.5164 14.9689 25.8356 15.7565 25.8356V24.8356C15.2348 24.8356 14.7183 24.6222 14.3458 24.2498L13.6387 24.9569ZM15.7565 25.8356C16.7055 25.8356 17.5525 25.3914 18.1007 24.7033L17.3186 24.0802C16.9511 24.5415 16.3868 24.8356 15.7565 24.8356V25.8356ZM14.8116 5.33313C11.7747 5.79056 9.43157 8.41499 9.43157 11.5878H10.4316C10.4316 8.91878 12.404 6.70706 14.9605 6.32198L14.8116 5.33313ZM16.6305 5.32255C16.0147 5.24997 15.4089 5.25258 14.8193 5.33204L14.9528 6.32308C15.4549 6.25541 15.9764 6.25238 16.5134 6.31567L16.6305 5.32255ZM22.0821 11.5878C22.0821 8.39391 19.7165 5.75433 16.6413 5.32394L16.5027 6.31429C19.0908 6.67651 21.0821 8.8995 21.0821 11.5878H22.0821ZM22.0821 14.7834V11.5878H21.0821V14.7834H22.0821ZM22.7572 17.2495C22.3797 16.6038 22.0821 15.5035 22.0821 14.7834H21.0821C21.0821 15.6833 21.4281 16.9575 21.8939 17.7542L22.7572 17.2495ZM24.0299 19.3633L22.7539 17.244L21.8972 17.7598L23.1732 19.8791L24.0299 19.3633ZM24.1828 20.9893C24.3756 20.4555 24.3335 19.8642 24.0291 19.362L23.1739 19.8803C23.3134 20.1104 23.3379 20.3846 23.2422 20.6497L24.1828 20.9893ZM23.0162 22.126C23.5594 21.945 23.986 21.5342 24.1828 20.9893L23.2422 20.6497C23.1505 20.9037 22.9558 21.0921 22.7 21.1773L23.0162 22.126ZM8.50786 22.1258C13.2489 23.7137 18.2758 23.7137 23.0169 22.1258L22.6993 21.1776C18.1644 22.6965 13.3604 22.6965 8.82545 21.1776L8.50786 22.1258ZM7.27421 20.997C7.47125 21.5553 7.94673 21.9342 8.50508 22.1249L8.82822 21.1785C8.47672 21.0585 8.28645 20.8604 8.2172 20.6642L7.27421 20.997ZM7.48237 19.3656C7.18354 19.8682 7.06417 20.4647 7.2805 21.0139L8.21091 20.6473C8.13875 20.4642 8.15253 20.1952 8.34191 19.8767L7.48237 19.3656ZM8.7598 17.244L7.48379 19.3633L8.34049 19.8791L9.6165 17.7598L8.7598 17.244ZM9.43157 14.7945C9.43157 15.5132 9.12366 16.6244 8.75701 17.2487L9.6193 17.7551C10.0737 16.9813 10.4316 15.6959 10.4316 14.7945H9.43157ZM9.43157 11.5878V14.7945H10.4316V11.5878H9.43157Z"
        fill="currentColor"
        mask="url(#path-1-outside-1_20625_425738)"
      />
      <path
        d="M9.14582 2.84278L6.78354 0.84861C3.36332 3.94504 1.31958 8.44392 1.51821 13.3363L4.56468 13.0789C4.45207 9.02299 6.22506 5.31404 9.14582 2.84278V2.84278Z"
        fill="currentColor"
      />
      <path
        d="M26.9052 13.0781L29.9517 13.3355C30.1351 8.44189 28.0914 3.94299 24.6864 0.847827L22.3394 2.84326C25.2296 5.31197 27.0178 9.02222 26.9052 13.0781Z"
        fill="currentColor"
      />
    </svg>
  );
};
const MyAccountIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.236 11.446H12.2873H12.3065C14.0929 11.3883 15.5015 9.92702 15.5079 8.12609C15.5079 6.29311 14.016 4.7998 12.1848 4.7998C10.3536 4.7998 8.86175 6.29311 8.86175 8.12609C8.86175 9.92702 10.264 11.3883 12.1208 11.446C12.1592 11.4395 12.204 11.4395 12.236 11.446ZM9.82218 8.12609C9.82218 6.82505 10.885 5.76116 12.1848 5.76116C13.4846 5.76116 14.5475 6.82505 14.5475 8.12609C14.5411 9.39507 13.555 10.4269 12.3001 10.4846C12.2168 10.4782 12.1272 10.4782 12.0952 10.4846C10.821 10.4397 9.82218 9.40789 9.82218 8.12609ZM8.61591 18.214C9.59703 18.8712 10.8942 19.1998 12.1848 19.1998C13.4754 19.1998 14.766 18.8712 15.7537 18.214C16.669 17.6028 17.1694 16.7681 17.1694 15.8677C17.1694 14.9673 16.6624 14.1392 15.7537 13.5346C13.7915 12.2267 10.5913 12.2267 8.61591 13.5346C7.70063 14.1458 7.2002 14.9804 7.2002 15.8808C7.2002 16.7812 7.70063 17.6093 8.61591 18.214ZM8.1879 15.8874C8.1879 15.3222 8.5303 14.7833 9.16244 14.3627C10.802 13.2717 13.5676 13.2717 15.2072 14.3627C15.8327 14.7767 16.1817 15.3156 16.1817 15.8743C16.1817 16.4395 15.8393 16.9784 15.2072 17.399C13.5676 18.4966 10.802 18.4966 9.16244 17.399C8.53689 16.985 8.1879 16.446 8.1879 15.8874Z"
        fill="currentColor"
      />
    </svg>
  );
};
const AddCreditsIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1998 18.3998C11.1998 18.8371 11.5625 19.1998 11.9998 19.1998C12.4371 19.1998 12.7998 18.8371 12.7998 18.3998V12.7998H18.3998C18.8371 12.7998 19.1998 12.4371 19.1998 11.9998C19.1998 11.5625 18.8371 11.1998 18.3998 11.1998H12.7998V5.5998C12.7998 5.16247 12.4371 4.7998 11.9998 4.7998C11.5625 4.7998 11.1998 5.16247 11.1998 5.5998V11.1998H5.5998C5.16247 11.1998 4.7998 11.5625 4.7998 11.9998C4.7998 12.4371 5.16247 12.7998 5.5998 12.7998H11.1998V18.3998Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const LogoutIcon = (props) => {
  return (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M13.168 3.83333L11.993 5.00833L14.143 7.16667H5.66797V8.83333H14.143L11.993 10.9833L13.168 12.1667L17.3346 8L13.168 3.83333ZM2.33464 2.16667H9.0013V0.5H2.33464C1.41797 0.5 0.667969 1.25 0.667969 2.16667V13.8333C0.667969 14.75 1.41797 15.5 2.33464 15.5H9.0013V13.8333H2.33464V2.16667Z"
        fill="currentColor"
      />
    </svg>
  );
};
const QuitIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.942 17.0911C16.2512 17.4004 16.7641 17.4004 17.0733 17.0911C17.3826 16.7819 17.3826 16.269 17.0733 15.9598L13.1136 12L17.0733 8.04024C17.3826 7.731 17.3826 7.21811 17.0733 6.90887C16.7641 6.59963 16.2512 6.59963 15.942 6.90887L11.9822 10.8686L8.02238 6.90879C7.71314 6.59955 7.20025 6.59955 6.89101 6.9088C6.58177 7.21804 6.58177 7.73092 6.89101 8.04017L10.8508 12L6.89101 15.9598C6.58177 16.2691 6.58177 16.782 6.89101 17.0912C7.20025 17.4004 7.71314 17.4004 8.02238 17.0912L11.9822 13.1314L15.942 17.0911Z"
        fill="currentColor"
      />
    </svg>
  );
};

const VisibilityOffIcon = (props) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5175 4.89336L1.5075 2.88336L2.565 1.81836L15.8625 15.1234L14.805 16.1809L12.24 13.6159C11.235 14.0134 10.14 14.2309 9 14.2309C5.25 14.2309 2.0475 11.8984 0.75 8.60586C1.3275 7.12836 2.295 5.85336 3.5175 4.89336ZM9 4.48086C11.8425 4.48086 14.3775 6.07836 15.615 8.60586C15.1725 9.52086 14.55 10.3084 13.8075 10.9459L14.865 12.0034C15.9075 11.0809 16.7325 9.92586 17.25 8.60586C15.9525 5.31336 12.75 2.98086 9 2.98086C8.0475 2.98086 7.1325 3.13086 6.27 3.40836L7.5075 4.64586C7.995 4.54836 8.49 4.48086 9 4.48086ZM8.1975 5.33586L9.75 6.88836C10.1775 7.07586 10.5225 7.42086 10.71 7.84836L12.2625 9.40086C12.3225 9.14586 12.3675 8.87586 12.3675 8.59836C12.375 6.73836 10.86 5.23086 9 5.23086C8.7225 5.23086 8.46 5.26836 8.1975 5.33586ZM7.1325 8.50836L9.09 10.4659C9.06 10.4734 9.03 10.4809 9 10.4809C7.965 10.4809 7.125 9.64086 7.125 8.60586C7.125 8.58711 7.12687 8.57211 7.12875 8.55711L7.12875 8.5571C7.13063 8.5421 7.1325 8.52711 7.1325 8.50836ZM5.895 7.27086L4.5825 5.95836C3.675 6.64836 2.91 7.53336 2.385 8.60586C3.6225 11.1334 6.1575 12.7309 9 12.7309C9.7125 12.7309 10.4025 12.6259 11.0625 12.4459L10.3275 11.7109C9.9225 11.8834 9.4725 11.9809 9 11.9809C7.14 11.9809 5.625 10.4659 5.625 8.60586C5.625 8.13336 5.7225 7.68336 5.895 7.27086Z"
        fill="currentColor"
      />
    </svg>
  );
};

const VisibilityOnIcon = (props) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g id="icon/action/visibility_24px">
        <path
          id="icon/action/visibility_24px_2"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.75 9C2.0475 5.7075 5.25 3.375 9 3.375C12.75 3.375 15.9525 5.7075 17.25 9C15.9525 12.2925 12.75 14.625 9 14.625C5.25 14.625 2.0475 12.2925 0.75 9ZM15.615 9C14.3775 6.4725 11.8425 4.875 9 4.875C6.1575 4.875 3.6225 6.4725 2.385 9C3.6225 11.5275 6.1575 13.125 9 13.125C11.8425 13.125 14.3775 11.5275 15.615 9ZM9 7.125C10.035 7.125 10.875 7.965 10.875 9C10.875 10.035 10.035 10.875 9 10.875C7.965 10.875 7.125 10.035 7.125 9C7.125 7.965 7.965 7.125 9 7.125ZM5.625 9C5.625 7.14 7.14 5.625 9 5.625C10.86 5.625 12.375 7.14 12.375 9C12.375 10.86 10.86 12.375 9 12.375C7.14 12.375 5.625 10.86 5.625 9Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const TickIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M9.95105 16.926C9.66291 16.926 9.38917 16.8107 9.18747 16.609L5.11023 12.5318C4.69242 12.114 4.69242 11.4224 5.11023 11.0046C5.52804 10.5868 6.21959 10.5868 6.6374 11.0046L9.95105 14.3183L17.3564 6.91297C17.7742 6.49516 18.4657 6.49516 18.8835 6.91297C19.3013 7.33077 19.3013 8.02232 18.8835 8.44013L10.7146 16.609C10.5129 16.8107 10.2392 16.926 9.95105 16.926Z"
        fill="currentColor"
      />
    </svg>
  );
};

const DeleteIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.23865 6.33357L9.0955 7.18597C8.46767 7.22005 7.84106 7.26805 7.2159 7.3315L5.84958 7.46546C5.57497 7.49225 5.37404 7.73336 5.40083 8.01466C5.42762 8.29597 5.67544 8.49689 5.95674 8.4701L6.4494 8.4218L7.27619 16.8624C7.34986 17.9072 7.44363 19.1999 9.78111 19.1999H14.081C16.4185 19.1999 16.5123 17.9072 16.5859 16.8624L17.2815 8.40993C17.4894 8.42919 17.6974 8.44927 17.9054 8.4701H17.9589C18.2135 8.4701 18.4345 8.27587 18.4546 8.01466C18.4814 7.74006 18.2804 7.49225 18.0058 7.46546C16.9267 7.35954 15.8481 7.2727 14.7712 7.2126L14.7709 7.21096L14.6236 6.34027L14.6229 6.33633C14.5225 5.72016 14.3724 4.7998 12.8085 4.7998H11.0537C9.49428 4.7998 9.34603 5.68932 9.23888 6.33219L9.23865 6.33357ZM16.2785 8.32356C13.3233 8.08899 10.3756 8.037 7.45097 8.32341L8.28084 16.7954L8.28097 16.7973C8.35454 17.8139 8.38214 18.1952 9.78111 18.1952H14.081C15.4875 18.1952 15.5143 17.8135 15.5813 16.7954L16.2785 8.32356ZM13.639 6.50771L13.7501 7.16384C12.538 7.11603 11.3285 7.10523 10.1231 7.14238L10.2366 6.50101L10.2376 6.49498C10.3372 5.90429 10.3529 5.81115 11.0604 5.81115H12.8152C13.5252 5.81115 13.5452 5.92501 13.639 6.50771ZM13.043 15.5161H10.8126C10.538 15.5161 10.3103 15.2883 10.3103 15.0137C10.3103 14.7391 10.538 14.5114 10.8126 14.5114H13.043C13.3176 14.5114 13.5453 14.7391 13.5453 15.0137C13.5453 15.2883 13.3176 15.5161 13.043 15.5161ZM10.2567 12.837H13.6055C13.8801 12.837 14.1078 12.6093 14.1078 12.3347C14.1078 12.0601 13.8801 11.8323 13.6055 11.8323H10.2567C9.98209 11.8323 9.75437 12.0601 9.75437 12.3347C9.75437 12.6093 9.98209 12.837 10.2567 12.837Z"
        fill="currentColor"
      />
    </svg>
  );
};

const GreenTickIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M9.95105 16.926C9.66291 16.926 9.38917 16.8107 9.18747 16.609L5.11023 12.5318C4.69242 12.114 4.69242 11.4224 5.11023 11.0046C5.52804 10.5868 6.21959 10.5868 6.6374 11.0046L9.95105 14.3183L17.3564 6.91297C17.7742 6.49516 18.4657 6.49516 18.8835 6.91297C19.3013 7.33077 19.3013 8.02232 18.8835 8.44013L10.7146 16.609C10.5129 16.8107 10.2392 16.926 9.95105 16.926Z"
        fill="#1BB75E"
      />
    </svg>
  );
};

const RedCrossIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.939 17.0911C16.2483 17.4004 16.7612 17.4004 17.0704 17.0911C17.3797 16.7819 17.3797 16.269 17.0704 15.9598L13.1107 12L17.0704 8.04024C17.3797 7.731 17.3797 7.21811 17.0704 6.90887C16.7612 6.59963 16.2483 6.59963 15.939 6.90887L11.9793 10.8686L8.01945 6.90879C7.71021 6.59955 7.19733 6.59955 6.88808 6.90879C6.57884 7.21804 6.57884 7.73092 6.88808 8.04016L10.8479 12L6.88808 15.9598C6.57884 16.2691 6.57884 16.782 6.88808 17.0912C7.19732 17.4004 7.71021 17.4004 8.01945 17.0912L11.9793 13.1314L15.939 17.0911Z"
        fill="#E4291D"
      />
    </svg>
  );
};

const ThreeDotIcon = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.7877 9.10808C13.7877 7.61147 14.9988 6.40039 16.4954 6.40039C17.992 6.40039 19.2031 7.61147 19.2031 9.10808C19.2031 10.6047 17.992 11.8158 16.4954 11.8158C14.9988 11.8158 13.7877 10.6047 13.7877 9.10808ZM17.7262 9.10808C17.7262 8.4287 17.1748 7.87731 16.4954 7.87731C15.816 7.87731 15.2647 8.4287 15.2647 9.10808C15.2647 9.78747 15.816 10.3389 16.4954 10.3389C17.1748 10.3389 17.7262 9.78747 17.7262 9.10808ZM13.7877 22.8927C13.7877 21.3961 14.9988 20.185 16.4954 20.185C17.992 20.185 19.2031 21.3961 19.2031 22.8927C19.2031 24.3893 17.992 25.6004 16.4954 25.6004C14.9988 25.6004 13.7877 24.3893 13.7877 22.8927ZM17.7262 22.8927C17.7262 22.2133 17.1748 21.6619 16.4954 21.6619C15.816 21.6619 15.2647 22.2133 15.2647 22.8927C15.2647 23.5721 15.816 24.1235 16.4954 24.1235C17.1748 24.1235 17.7262 23.5721 17.7262 22.8927ZM16.4954 13.2927C14.9988 13.2927 13.7877 14.5038 13.7877 16.0004C13.7877 17.497 14.9988 18.7081 16.4954 18.7081C17.992 18.7081 19.2031 17.497 19.2031 16.0004C19.2031 14.5038 17.992 13.2927 16.4954 13.2927ZM16.4954 14.7696C17.1748 14.7696 17.7262 15.321 17.7262 16.0004C17.7262 16.6798 17.1748 17.2312 16.4954 17.2312C15.816 17.2312 15.2647 16.6798 15.2647 16.0004C15.2647 15.321 15.816 14.7696 16.4954 14.7696Z"
        fill="#5A5C61"
      />
    </svg>
  );
};

const RequestThreeDotIcon = (props) => {
  return (
    <svg width={15} height={3} viewBox="0 0 15 3" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.5 3C2.32843 3 3 2.32843 3 1.5C3 0.671573 2.32843 0 1.5 0C0.671573 0 0 0.671573 0 1.5C0 2.32843 0.671573 3 1.5 3Z"
        fill="currentColor"
      />
      <path
        d="M7.5 3C8.32843 3 9 2.32843 9 1.5C9 0.671573 8.32843 0 7.5 0C6.67157 0 6 0.671573 6 1.5C6 2.32843 6.67157 3 7.5 3Z"
        fill="currentColor"
      />
      <path
        d="M13.5 3C14.3284 3 15 2.32843 15 1.5C15 0.671573 14.3284 0 13.5 0C12.6716 0 12 0.671573 12 1.5C12 2.32843 12.6716 3 13.5 3Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const LeftArrowIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.6955 17.0449C9.81227 17.1617 9.96018 17.2162 10.1081 17.2162C10.256 17.2162 10.4117 17.1617 10.5207 17.0449C10.7465 16.8192 10.7465 16.4455 10.5207 16.2197L6.79174 12.4908H18.6169C18.9361 12.4908 19.2008 12.2261 19.2008 11.9069C19.2008 11.5877 18.9361 11.323 18.6169 11.323H6.79177L10.5207 7.59412C10.7465 7.36836 10.7465 6.99469 10.5207 6.76893C10.2949 6.54317 9.92126 6.54317 9.6955 6.76893L4.9701 11.4943C4.74434 11.7201 4.74434 12.0938 4.9701 12.3195L9.6955 17.0449Z"
        fill="currentColor"
      />
    </svg>
  );
};

const SmallArrowIcon = (props) => {
  return (
    <svg
      width="10"
      height="9"
      viewBox="0 0 10 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M4.67756 8.31583L0.544034 4.18231L4.67756 0.0487835L5.5554 0.918102L2.92614 3.54736H9.31392V4.81725H2.92614L5.5554 7.44225L4.67756 8.31583Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const CrossIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.943 17.0911C16.2522 17.4004 16.7651 17.4004 17.0743 17.0911C17.3836 16.7819 17.3836 16.269 17.0743 15.9598L13.1146 12L17.0743 8.04024C17.3836 7.731 17.3836 7.21811 17.0743 6.90887C16.7651 6.59963 16.2522 6.59963 15.943 6.90887L11.9832 10.8686L8.02336 6.90879C7.71412 6.59955 7.20123 6.59955 6.89199 6.90879C6.58275 7.21804 6.58275 7.73092 6.89199 8.04016L10.8518 12L6.89199 15.9598C6.58275 16.2691 6.58275 16.782 6.89199 17.0912C7.20123 17.4004 7.71412 17.4004 8.02336 17.0912L11.9832 13.1314L15.943 17.0911Z"
        fill="currentColor"
      />
    </svg>
  );
};

const ExclamationIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.94377 18.9994H16.055C17.36 18.9994 18.3572 18.5243 18.8658 17.6743C19.3744 16.811 19.3008 15.7134 18.6651 14.569L14.6094 7.26758C13.9402 6.06294 13.0166 5.40039 11.9994 5.40039C10.9821 5.40039 10.0586 6.06294 9.38933 7.26758L5.33372 14.5623C4.69793 15.7067 4.63101 16.811 5.13294 17.6676C5.64157 18.5243 6.63874 18.9994 7.94377 18.9994ZM10.266 7.75613C10.7546 6.88611 11.3703 6.40426 11.9994 6.40426C12.6285 6.40426 13.2442 6.88611 13.7327 7.75613L17.795 15.0576C18.2501 15.8807 18.3304 16.6236 18.0092 17.1657C17.688 17.7078 16.9986 18.0022 16.0617 18.0022H7.95046C7.01352 18.0022 6.3175 17.7078 6.00296 17.1657C5.68841 16.6236 5.76203 15.8741 6.21712 15.0576L10.266 7.75613ZM11.9991 14.0404C11.7247 14.0404 11.4971 13.8129 11.4971 13.5385V10.1923C11.4971 9.91789 11.7247 9.69035 11.9991 9.69035C12.2735 9.69035 12.501 9.91789 12.501 10.1923V13.5385C12.501 13.8129 12.2735 14.0404 11.9991 14.0404ZM11.9991 16.2155C11.9589 16.2155 11.9121 16.2088 11.8652 16.2021L11.8652 16.2021C11.8251 16.1954 11.7849 16.1821 11.7448 16.162C11.7046 16.1486 11.6645 16.1285 11.6243 16.1017L11.5239 16.0214C11.4034 15.8943 11.3298 15.7203 11.3298 15.5463C11.3298 15.3723 11.4034 15.1983 11.5239 15.0711L11.6243 14.9908C11.6645 14.964 11.7046 14.9439 11.7448 14.9306C11.7849 14.9105 11.8251 14.8971 11.8652 14.8904C11.9522 14.8703 12.0459 14.8703 12.1262 14.8904C12.1731 14.8971 12.2132 14.9105 12.2534 14.9306C12.2935 14.9439 12.3337 14.964 12.3738 14.9908L12.4742 15.0711C12.5947 15.1983 12.6683 15.3723 12.6683 15.5463C12.6683 15.7203 12.5947 15.8943 12.4742 16.0214L12.3738 16.1017C12.3337 16.1285 12.2935 16.1486 12.2534 16.162C12.2132 16.1821 12.1731 16.1954 12.1262 16.2021C12.0861 16.2088 12.0392 16.2155 11.9991 16.2155Z"
        fill="currentColor"
      />
    </svg>
  );
};

// const RestoreIcon = (props) => {
//   return (
//     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
//       <path fillRule="evenodd" clipRule="evenodd" d="M14.6917 19.2H10.6731C7.03628 19.2 5.48242 17.6462 5.48242 14.0094V9.99075C5.48242 6.35391 7.03628 4.80005 10.6731 4.80005H14.022C14.1385 4.80005 14.2466 4.84107 14.3324 4.90928C14.3478 4.92109 14.3627 4.9338 14.3769 4.94739L19.7351 10.3055C19.7732 10.3437 19.8044 10.3877 19.8281 10.4354C19.8628 10.5033 19.8824 10.5799 19.8824 10.6605V14.0094C19.8824 17.6462 18.3286 19.2 14.6917 19.2ZM18.8778 11.1628V14.0094C18.8778 17.097 17.7794 18.1954 14.6917 18.1954H10.6731C7.58549 18.1954 6.48707 17.097 6.48707 14.0094V9.99075C6.48707 6.90312 7.58549 5.8047 10.6731 5.8047H13.5196V7.98144C13.5196 10.272 14.4104 11.1628 16.701 11.1628H18.8778ZM12.0127 15.8512C11.8854 15.8512 11.7581 15.8043 11.6577 15.7038C11.4634 15.5096 11.4634 15.1881 11.6577 14.9939L12.1399 14.5116H9.33358C9.05898 14.5116 8.83126 14.2839 8.83126 14.0093C8.83126 13.7347 9.05898 13.507 9.33358 13.507H12.1399L11.6577 13.0248C11.5572 12.9243 11.5103 12.797 11.5103 12.6698C11.5103 12.5425 11.5572 12.4153 11.6577 12.3148C11.8519 12.1206 12.1734 12.1206 12.3676 12.3148L13.7072 13.6543C13.7942 13.7414 13.8411 13.8553 13.8478 13.9624V14.0696C13.8344 14.1634 13.7942 14.2504 13.7273 14.3308L13.7005 14.3576L12.3609 15.6971C12.2672 15.8043 12.1399 15.8512 12.0127 15.8512ZM14.5243 7.98144V6.51465L18.1678 10.1582H16.701C14.973 10.1582 14.5243 9.70944 14.5243 7.98144Z" fill="currentColor"/>
//     </svg>
//   )
// }

const RetryIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6917 19.2H10.6731C7.03628 19.2 5.48242 17.6462 5.48242 14.0094V9.99075C5.48242 6.35391 7.03628 4.80005 10.6731 4.80005H14.022C14.1385 4.80005 14.2466 4.84107 14.3324 4.90928C14.3478 4.92109 14.3627 4.9338 14.3769 4.94739L19.7351 10.3055C19.7732 10.3437 19.8044 10.3877 19.8281 10.4354C19.8628 10.5033 19.8824 10.5799 19.8824 10.6605V14.0094C19.8824 17.6462 18.3286 19.2 14.6917 19.2ZM18.8778 11.1628V14.0094C18.8778 17.097 17.7794 18.1954 14.6917 18.1954H10.6731C7.58549 18.1954 6.48707 17.097 6.48707 14.0094V9.99075C6.48707 6.90312 7.58549 5.8047 10.6731 5.8047H13.5196V7.98144C13.5196 10.272 14.4104 11.1628 16.701 11.1628H18.8778ZM12.0127 15.8512C11.8854 15.8512 11.7581 15.8043 11.6577 15.7038C11.4634 15.5096 11.4634 15.1881 11.6577 14.9939L12.1399 14.5116H9.33358C9.05898 14.5116 8.83126 14.2839 8.83126 14.0093C8.83126 13.7347 9.05898 13.507 9.33358 13.507H12.1399L11.6577 13.0248C11.5572 12.9243 11.5103 12.797 11.5103 12.6698C11.5103 12.5425 11.5572 12.4153 11.6577 12.3148C11.8519 12.1206 12.1734 12.1206 12.3676 12.3148L13.7072 13.6543C13.7942 13.7414 13.8411 13.8553 13.8478 13.9624V14.0696C13.8344 14.1634 13.7942 14.2504 13.7273 14.3308L13.7005 14.3576L12.3609 15.6971C12.2672 15.8043 12.1399 15.8512 12.0127 15.8512ZM14.5243 7.98144V6.51465L18.1678 10.1582H16.701C14.973 10.1582 14.5243 9.70944 14.5243 7.98144Z"
        fill="currentColor"
      />
    </svg>
  );
};

const TransactionDetailsIcon = (props) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.3213 25.5999H18.6795C23.5286 25.5999 25.6004 23.5281 25.6004 18.679V13.3208C25.6004 8.47172 23.5286 6.3999 18.6795 6.3999H13.3213C8.4722 6.3999 6.40039 8.47172 6.40039 13.3208V18.679C6.40039 23.5281 8.4722 25.5999 13.3213 25.5999ZM7.73993 13.3208C7.73993 9.204 9.20448 7.73944 13.3213 7.73944H18.6795C22.7963 7.73944 24.2609 9.204 24.2609 13.3208V18.679C24.2609 22.7958 22.7963 24.2604 18.6795 24.2604H13.3213C9.20448 24.2604 7.73993 22.7958 7.73993 18.679V13.3208ZM14.4463 20.0899C14.9196 20.5632 15.5537 20.8043 16.1788 20.8043C16.8128 20.8043 17.438 20.5632 17.9202 20.072L19.9027 18.0895C21.5548 16.4374 21.5548 13.7405 19.9027 12.0884C18.2506 10.4363 15.5537 10.4363 13.9016 12.0884L11.7404 14.2495C11.0349 14.955 10.651 15.8927 10.651 16.8929C10.651 17.893 11.0349 18.8307 11.7404 19.5362C11.9994 19.7952 12.4281 19.7952 12.687 19.5362C12.946 19.2772 12.946 18.8486 12.687 18.5896C12.2316 18.1431 11.9816 17.5358 11.9816 16.9018C11.9816 16.2678 12.2316 15.6694 12.687 15.214L14.8482 13.0529C15.9823 11.9187 17.8219 11.9187 18.9561 13.0529C20.0902 14.187 20.0902 16.0266 18.9561 17.1608L16.9736 19.1433C16.536 19.5808 15.8305 19.5808 15.3929 19.1433C15.1786 18.9379 15.0625 18.6521 15.0625 18.3574C15.0625 18.0627 15.1786 17.7859 15.3929 17.5716L16.6521 16.3124C16.911 16.0534 16.911 15.6248 16.6521 15.3658C16.3931 15.1068 15.9644 15.1068 15.7055 15.3658L14.4463 16.625C13.9819 17.0804 13.723 17.7055 13.723 18.3574C13.723 19.0093 13.9819 19.6255 14.4463 20.0899Z"
      fill="currentColor"
    />
  </svg>
);

const SharedUsersIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M0 4C0 1.79086 1.79086 0 4 0H16C18.2091 0 20 1.79086 20 4V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 0 18.2091 0 16V4Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.51761 6.95407H7.50271C6.1613 6.90944 5.11053 5.8234 5.10308 4.48447C5.10308 3.11578 6.22092 2 7.58468 2C8.94845 2 10.0663 3.11578 10.0663 4.47703C10.0663 5.82341 9.01552 6.90944 7.67411 6.95407H7.56978H7.51761ZM7.59221 5.83829C7.63689 5.83829 7.67414 5.83829 7.71882 5.84572C8.38207 5.81597 8.96335 5.22088 8.96335 4.48447C8.96335 3.73318 8.35227 3.12321 7.59959 3.12321C6.84691 3.12321 6.23582 3.73318 6.23582 4.48447C6.23582 5.21344 6.80219 5.80109 7.52506 5.84572C7.53251 5.83829 7.56242 5.83829 7.59221 5.83829ZM5.03586 11.7446C5.71402 12.1909 6.59339 12.4364 7.51001 12.4364C7.80065 12.4364 8.09129 12.414 8.38193 12.362C8.68747 12.3099 8.88868 12.0198 8.83652 11.7148C8.78435 11.4173 8.49371 11.209 8.18817 11.2611C7.27154 11.4173 6.30275 11.2462 5.6544 10.8148C5.3116 10.5842 5.11784 10.2941 5.11784 10.004C5.11784 9.71386 5.30415 9.43119 5.6544 9.2006C6.3102 8.76916 7.28645 8.59808 8.21053 8.76173C8.51607 8.82124 8.80671 8.61296 8.85887 8.30798C8.91104 8.003 8.70983 7.7129 8.40428 7.66083C7.18957 7.44511 5.93013 7.6757 5.03586 8.27078C4.38006 8.70966 4 9.34193 4 10.004C4 10.6734 4.38006 11.3057 5.03586 11.7446ZM12.0112 12.5105H11.9516H11.9143C10.5059 12.4659 9.45509 11.3798 9.45509 10.0409C9.45509 8.6722 10.5729 7.56386 11.9367 7.56386C13.3005 7.56386 14.4183 8.67964 14.4183 10.0409C14.4108 11.3873 13.3601 12.4733 12.0187 12.5179C12.0187 12.5142 12.0177 12.5114 12.0177 12.5114C12.0177 12.5114 12.0149 12.5105 12.0112 12.5105ZM11.9367 8.6722C11.184 8.6722 10.5729 9.28216 10.5729 10.0335C10.5729 10.7699 11.1468 11.365 11.8845 11.3947C11.892 11.3873 11.9516 11.3873 12.0187 11.3947C12.7415 11.3575 13.3005 10.7624 13.3079 10.0335C13.3079 9.2896 12.6968 8.6722 11.9367 8.6722ZM9.52927 17.3008C10.2223 17.7694 11.1166 18 12.0109 18C12.9051 18 13.7994 17.762 14.4925 17.3008C15.1557 16.8619 15.5283 16.2222 15.5283 15.5602C15.5283 14.8907 15.1483 14.2659 14.4925 13.827C13.1064 12.9046 10.9228 12.9046 9.52927 13.827C8.86602 14.2659 8.49341 14.9056 8.49341 15.5676C8.49341 16.2371 8.87348 16.8619 9.52927 17.3008ZM9.61125 15.575C9.61125 15.2849 9.79756 14.9948 10.1478 14.7642C11.1613 14.0948 12.8679 14.0873 13.8665 14.7642C14.2093 14.9948 14.4031 15.2775 14.4031 15.5676C14.4031 15.8577 14.2167 16.1478 13.8665 16.3784C12.8604 17.0553 11.1539 17.0553 10.1478 16.3784C9.80501 16.1478 9.61125 15.8651 9.61125 15.575Z"
        fill="#5A5C61"
      />
    </svg>
  );
};

const BriefcaseIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5911 8.48354H13.2702C14.6522 8.48354 14.9972 7.8086 15.0834 7.19995C16.6553 7.3881 17.4562 8.09337 17.4562 10.6602V14.6789C17.4562 17.157 16.9673 18.1951 13.94 18.1951H9.92133C6.89398 18.1951 6.40504 17.157 6.40504 14.6789V10.6602C6.40504 8.08536 7.21104 7.38372 8.79264 7.19821C9.01311 8.48354 10.0208 8.48354 10.5911 8.48354ZM8.77617 6.19483C8.957 4.7998 10.005 4.7998 10.5911 4.7998H13.2702C13.8555 4.7998 14.9014 4.7998 15.0844 6.18913C17.4778 6.45404 18.4609 7.7792 18.4609 10.6535V14.6722C18.4609 17.4718 17.7041 19.1998 13.94 19.1998H9.92133C6.15723 19.1998 5.40039 17.4718 5.40039 14.6789V10.6602C5.40039 7.77988 6.38332 6.45433 8.77617 6.19483ZM9.7539 6.63499C9.75482 5.80446 9.9298 5.80446 10.5911 5.80446H13.2702C13.9298 5.80446 14.1056 5.80446 14.1074 6.62857C14.1066 6.6448 14.1066 6.66091 14.1074 6.67687C14.1071 7.31093 14.0924 7.47888 13.2702 7.47888H10.5911C9.93876 7.47888 9.75965 7.47888 9.75403 6.68165C9.75468 6.66628 9.75464 6.65072 9.7539 6.63499Z"
        fill="currentColor"
      />
    </svg>
  );
};

const PhoneIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M15.651 19.1998C14.8942 19.1998 14.0972 19.019 13.2733 18.6707C12.4696 18.3291 11.6592 17.8603 10.8689 17.291C10.0852 16.715 9.32841 16.072 8.61176 15.3687C7.9018 14.6521 7.25883 13.8952 6.68953 13.1183C6.11353 12.3146 5.65139 11.5109 5.3232 10.7339C4.97492 9.90343 4.80078 9.09971 4.80078 8.34287C4.80078 7.82046 4.89455 7.32483 5.07539 6.86269C5.26292 6.38715 5.56432 5.94511 5.97287 5.56334C6.4886 5.05432 7.07799 4.7998 7.70757 4.7998C7.96878 4.7998 8.23669 4.86008 8.46441 4.96725C8.72562 5.0878 8.94664 5.26864 9.10739 5.50976L10.6612 7.6999C10.8019 7.89413 10.9091 8.08167 10.9827 8.2692C11.0698 8.47013 11.1167 8.67106 11.1167 8.86529C11.1167 9.1198 11.043 9.36762 10.9024 9.60204C10.8019 9.78287 10.6479 9.97711 10.4536 10.1713L9.99818 10.6469C10.0049 10.667 10.0116 10.6804 10.0183 10.6938C10.0986 10.8344 10.2594 11.0755 10.5675 11.4372C10.8957 11.8123 11.2038 12.1539 11.5119 12.4686C11.907 12.8571 12.2352 13.1652 12.5433 13.4197C12.9251 13.7412 13.1729 13.9019 13.3202 13.9756L13.3068 14.0091L13.7958 13.5269C14.0034 13.3192 14.2043 13.1652 14.3985 13.0647C14.7669 12.837 15.2358 12.7968 15.7046 12.9911C15.8787 13.0647 16.0663 13.1652 16.2672 13.3059L18.4908 14.8865C18.7386 15.0539 18.9195 15.2683 19.0266 15.5228C19.1271 15.7773 19.174 16.0117 19.174 16.2461C19.174 16.5676 19.1003 16.8891 18.9597 17.1905C18.819 17.4919 18.6449 17.7531 18.4239 17.9942C18.0421 18.4162 17.6268 18.7176 17.1446 18.9118C16.6825 19.0993 16.1801 19.1998 15.651 19.1998ZM7.70757 5.80446C7.3392 5.80446 6.99762 5.9652 6.66943 6.28669C6.36134 6.57469 6.14701 6.88948 6.01306 7.23106C5.87241 7.57934 5.80543 7.94771 5.80543 8.34287C5.80543 8.96576 5.95278 9.64222 6.24748 10.3388C6.54887 11.0487 6.97083 11.7855 7.50664 12.5222C8.04246 13.259 8.65194 13.9756 9.32171 14.6521C9.99148 15.3152 10.7148 15.9313 11.4583 16.4739C12.1816 17.003 12.9251 17.4316 13.6618 17.7397C14.8071 18.2286 15.8787 18.3425 16.7628 17.9741C17.1044 17.8335 17.4058 17.6192 17.6804 17.3111C17.8345 17.1436 17.955 16.9628 18.0555 16.7485C18.1359 16.581 18.176 16.4069 18.176 16.2327C18.176 16.1256 18.1559 16.0184 18.1024 15.8979C18.0823 15.8577 18.0421 15.784 17.9148 15.6969L15.6912 14.1163C15.5572 14.0225 15.4367 13.9555 15.3228 13.9086C15.1755 13.8484 15.1152 13.7881 14.8875 13.9287C14.7535 13.9957 14.633 14.0962 14.499 14.2301L13.99 14.7325C13.7288 14.987 13.3269 15.0472 13.0188 14.9334L12.838 14.853C12.5634 14.7057 12.2419 14.4779 11.8869 14.1765C11.5654 13.9019 11.2172 13.5805 10.7952 13.1652C10.467 12.8303 10.1388 12.4753 9.79725 12.0802C9.48246 11.7118 9.25473 11.397 9.11408 11.1358L9.03371 10.9349C8.99353 10.7808 8.98013 10.6938 8.98013 10.6C8.98013 10.3589 9.0672 10.1445 9.23464 9.97711L9.73697 9.45469C9.87092 9.32073 9.97139 9.19348 10.0384 9.07962C10.0919 8.99255 10.112 8.91887 10.112 8.8519C10.112 8.79832 10.0919 8.71794 10.0585 8.63757C10.0116 8.53041 9.9379 8.40985 9.84413 8.2826L8.29027 6.08576C8.22329 5.99199 8.14292 5.92501 8.04246 5.87813C7.93529 5.83125 7.82143 5.80446 7.70757 5.80446ZM13.3068 14.0158L13.1997 14.4712L13.3805 14.0024C13.347 13.9957 13.3202 14.0024 13.3068 14.0158Z"
        fill="currentColor"
      />
    </svg>
  );
};

const LocationIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.51239 18.0818C10.289 18.8249 11.2865 19.1998 12.2772 19.1998C13.268 19.1998 14.2655 18.8249 15.0421 18.0818C17.017 16.1806 19.1994 13.1546 18.3827 9.54625C17.6396 6.26591 14.781 4.7998 12.2839 4.7998H12.2772C9.78018 4.7998 6.9216 6.26591 6.1785 9.53955C5.35507 13.1479 7.5375 16.1806 9.51239 18.0818ZM7.1626 9.76047C7.82537 6.84164 10.3291 5.80399 12.2772 5.80399C14.2254 5.80399 16.7358 6.84164 17.4053 9.76047C18.1149 12.9136 16.1333 15.6316 14.3459 17.3521C13.1877 18.4701 11.3735 18.4701 10.2153 17.3521C8.42118 15.6316 6.43959 12.9136 7.1626 9.76047ZM9.68643 10.8583C9.68643 12.291 10.8513 13.4491 12.2772 13.4491C13.7032 13.4491 14.868 12.2977 14.868 10.865C14.868 9.4324 13.7032 8.27424 12.2772 8.27424C10.8513 8.27424 9.68643 9.4257 9.68643 10.8583ZM10.6906 10.865C10.6906 9.98805 11.4069 9.27842 12.2772 9.27842C13.1475 9.27842 13.8638 9.98805 13.8638 10.865C13.8638 11.742 13.1542 12.4516 12.2772 12.4516C11.4002 12.4516 10.6906 11.742 10.6906 10.865Z"
        fill="currentColor"
      />
    </svg>
  );
};

const FeedbackIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="currentColor"
      viewBox="0 0 24 24">
      <g clipPath="url(#clip0_2894_141536)">
        <path
          fill="currentColor"
          d="M4.666 3.333h16v12H5.836l-1.17 1.17V3.333zm0-2c-1.1 0-1.99.9-1.99 2l-.01 18 4-4h14c1.1 0 2-.9 2-2v-12c0-1.1-.9-2-2-2h-16zm2 10h8v2h-8v-2zm0-3h12v2h-12v-2zm0-3h12v2h-12v-2z"></path>
      </g>
      <defs>
        <clipPath id="clip0_2894_141536">
          <path fill="currentColor" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

const PricingIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <mask
        id="mask0_6901_52191"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20">
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6901_52191)">
        <path
          d="M9.25033 15.8332H10.7087V14.7915C11.4031 14.6665 12.0003 14.3957 12.5003 13.979C13.0003 13.5623 13.2503 12.9443 13.2503 12.1248C13.2503 11.5415 13.0837 11.0068 12.7503 10.5207C12.417 10.0346 11.7503 9.61095 10.7503 9.24984C9.91699 8.97206 9.3406 8.729 9.02116 8.52067C8.70171 8.31234 8.54199 8.02762 8.54199 7.6665C8.54199 7.30539 8.67046 7.02067 8.92741 6.81234C9.18435 6.604 9.55588 6.49984 10.042 6.49984C10.4864 6.49984 10.8337 6.60748 11.0837 6.82275C11.3337 7.03803 11.5142 7.30539 11.6253 7.62484L12.9587 7.08317C12.8059 6.59706 12.5246 6.17345 12.1149 5.81234C11.7052 5.45123 11.2503 5.24984 10.7503 5.20817V4.1665H9.29199V5.20817C8.59755 5.36095 8.05588 5.6665 7.66699 6.12484C7.2781 6.58317 7.08366 7.09706 7.08366 7.6665C7.08366 8.31928 7.27463 8.84706 7.65658 9.24984C8.03852 9.65262 8.63921 9.99984 9.45866 10.2915C10.3337 10.6109 10.9413 10.8957 11.2816 11.1457C11.6219 11.3957 11.792 11.7221 11.792 12.1248C11.792 12.5832 11.6288 12.92 11.3024 13.1353C10.976 13.3505 10.5837 13.4582 10.1253 13.4582C9.66699 13.4582 9.26074 13.3158 8.90658 13.0311C8.55241 12.7464 8.29199 12.3193 8.12533 11.7498L6.75033 12.2915C6.94477 12.9582 7.24685 13.4964 7.65658 13.9061C8.0663 14.3158 8.59755 14.5971 9.25033 14.7498V15.8332ZM10.0003 18.3332C8.84755 18.3332 7.76421 18.1144 6.75033 17.6769C5.73644 17.2394 4.85449 16.6457 4.10449 15.8957C3.35449 15.1457 2.76074 14.2637 2.32324 13.2498C1.88574 12.2359 1.66699 11.1526 1.66699 9.99984C1.66699 8.84706 1.88574 7.76373 2.32324 6.74984C2.76074 5.73595 3.35449 4.854 4.10449 4.104C4.85449 3.354 5.73644 2.76025 6.75033 2.32275C7.76421 1.88525 8.84755 1.6665 10.0003 1.6665C11.1531 1.6665 12.2364 1.88525 13.2503 2.32275C14.2642 2.76025 15.1462 3.354 15.8962 4.104C16.6462 4.854 17.2399 5.73595 17.6774 6.74984C18.1149 7.76373 18.3337 8.84706 18.3337 9.99984C18.3337 11.1526 18.1149 12.2359 17.6774 13.2498C17.2399 14.2637 16.6462 15.1457 15.8962 15.8957C15.1462 16.6457 14.2642 17.2394 13.2503 17.6769C12.2364 18.1144 11.1531 18.3332 10.0003 18.3332ZM10.0003 16.6665C11.8614 16.6665 13.4378 16.0207 14.7295 14.729C16.0212 13.4373 16.667 11.8609 16.667 9.99984C16.667 8.13873 16.0212 6.56234 14.7295 5.27067C13.4378 3.979 11.8614 3.33317 10.0003 3.33317C8.13921 3.33317 6.56283 3.979 5.27116 5.27067C3.97949 6.56234 3.33366 8.13873 3.33366 9.99984C3.33366 11.8609 3.97949 13.4373 5.27116 14.729C6.56283 16.0207 8.13921 16.6665 10.0003 16.6665Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

const ExpandIcon = (props) => {
  return (
    <svg height="24px" version="1.1" viewBox="0 0 24 24" width="24px" {...props}>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g transform="translate(12.000000, 12.000000) scale(-1, 1) translate(-12.000000, -12.000000) ">
          <path
            d="M19,19 L5,19 L5,5 L12,5 L12,3 L5,3 C3.89,3 3,3.9 3,5 L3,19 C3,20.1 3.89,21 5,21 L19,21 C20.1,21 21,20.1 21,19 L21,12 L19,12 L19,19 Z M14,3 L14,5 L17.59,5 L7.76,14.83 L9.17,16.24 L19,6.41 L19,10 L21,10 L21,3 L14,3 Z"
            fill="currentColor"
            fillRule="nonzero"></path>
        </g>
      </g>
    </svg>
  );
};

export const PlayIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 160 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <circle cx="80" cy="80" r="80" fill="#323031" />
      <path
        d="M121.028 85.0632L53.2084 118.451C49.8858 120.087 46 117.669 46 113.965V46.1459C46 42.4156 49.9373 39.9989 53.2635 41.6876L121.083 76.119C124.757 77.9843 124.724 83.2433 121.028 85.0632Z"
        fill="#fff"
      />
    </svg>
  );
};

export const PlayIconV2 = (props) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 160 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <circle cx="80" cy="80" r="80" fill="#fff" />
      <path
        d="M121.028 85.0632L53.2084 118.451C49.8858 120.087 46 117.669 46 113.965V46.1459C46 42.4156 49.9373 39.9989 53.2635 41.6876L121.083 76.119C124.757 77.9843 124.724 83.2433 121.028 85.0632Z"
        fill="currentColor"
      />
    </svg>
  );
};

const SmallPlayIcon = (props) => {
  return (
    <svg
      width="78"
      height="78"
      viewBox="0 0 78 78"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M75.0279 44.0632L7.20842 77.4512C3.88581 79.087 0 76.6688 0 72.9654V5.14594C0 1.41561 3.93725 -1.00109 7.26346 0.687603L75.0829 35.119C78.7569 36.9843 78.7245 42.2433 75.0279 44.0632Z"
        fill="currentColor"
      />
    </svg>
  );
};

const GraduationFilledIcon = (props) => {
  return (
    <svg
      width="160"
      height="160"
      viewBox="0 0 160 160"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <circle cx="80" cy="80" r="80" fill="#323031" />
      <path
        d="M79.5325 128.12L40.807 107.562C40.4802 107.388 40.2759 107.048 40.2759 106.678V84.3856C40.2759 83.6401 41.0623 83.1567 41.7275 83.4934L79.5511 102.639C79.8335 102.782 80.1669 102.782 80.45 102.641L117.835 83.9485C118.488 83.622 119.259 84.0826 119.282 84.8123L119.95 106.656C119.962 107.038 119.755 107.393 119.417 107.571L80.4681 128.121C80.1753 128.275 79.825 128.275 79.5325 128.12Z"
        fill="currentColor"
      />
      <path
        d="M141.486 65.2499L80.4419 95.5356C80.1633 95.6738 79.8363 95.6745 79.5571 95.5376L17.8027 65.2519C17.0615 64.8884 17.0551 63.8342 17.7917 63.4617L79.5461 32.2296C79.8313 32.0853 80.1683 32.0861 80.4529 32.2317L141.497 63.4638C142.229 63.8379 142.222 64.8849 141.486 65.2499Z"
        fill="currentColor"
      />
      <path
        d="M133.211 104.191V76.3831L139.586 73.1954V104.119C139.586 104.585 139.695 105.044 139.903 105.461L143.318 112.291C143.747 113.148 143.74 114.159 143.3 115.01L137.317 126.591C136.938 127.323 135.887 127.309 135.528 126.567L129.893 114.908C129.509 114.113 129.494 113.19 129.852 112.384L132.952 105.409C133.123 105.026 133.211 104.611 133.211 104.191Z"
        fill="currentColor"
      />
    </svg>
  );
};

const DragIcon = (props) => {
  return (
    <svg width="50.000000pt" height="50.000000pt" viewBox="0 0 50.000000 50.000000" {...props}>
      <g
        transform="translate(0.000000,50.000000) scale(0.100000,-0.100000)"
        fill="currentColor"
        stroke="none">
        <path
          d="M206 401 c-25 -26 -34 -41 -26 -46 6 -4 20 1 31 11 19 17 19 16 19
-39 l0 -57 -57 0 c-56 0 -56 0 -38 20 12 13 15 24 9 30 -7 7 -24 -4 -49 -30
l-39 -40 39 -40 c25 -26 42 -37 49 -30 6 6 3 17 -9 30 -18 20 -18 20 38 20
l57 0 0 -57 c0 -56 0 -56 -20 -38 -13 12 -24 15 -30 9 -7 -7 4 -24 30 -49 l40
-39 40 39 c26 25 37 42 30 49 -6 6 -17 3 -30 -9 -20 -18 -20 -18 -20 38 l0 57
57 0 c56 0 56 0 38 -20 -12 -13 -15 -24 -9 -30 7 -7 24 4 49 30 l39 40 -39 40
c-25 26 -42 37 -49 30 -6 -6 -3 -17 9 -30 18 -20 18 -20 -38 -20 l-57 0 0 57
c0 55 0 56 19 39 11 -10 25 -15 31 -11 8 5 -1 20 -26 46 -21 22 -41 39 -44 39
-3 0 -23 -17 -44 -39z"
        />
      </g>
    </svg>
  );
};

const ConfiguratorsIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="currentColor"
      viewBox="0 0 24 24"
      {...props}>
      <g clipPath="url(#clip0_2894_141558)">
        <path
          fill="currentColor"
          d="M12 7C6.48 7 2 9.24 2 12c0 2.24 2.94 4.13 7 4.77V20l4-4-4-4v2.73c-3.15-.56-5-1.9-5-2.73 0-1.06 3.04-3 8-3s8 1.94 8 3c0 .73-1.46 1.89-4 2.53v2.05c3.53-.77 6-2.53 6-4.58 0-2.76-4.48-5-10-5z"></path>
      </g>
      <defs>
        <clipPath id="clip0_2894_141558">
          <path fill="currentColor" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

const Timer = (props) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="currentColor">
      <path d="M11.5618 13.0209L12.4993 12.0834L9.18685 8.75002V4.56252H7.93685V9.25002L11.5618 13.0209ZM8.49935 17.3334C7.36046 17.3334 6.28407 17.1146 5.27018 16.6771C4.25629 16.2396 3.37088 15.6424 2.61393 14.8854C1.85699 14.1285 1.25977 13.2431 0.822266 12.2292C0.384766 11.2153 0.166016 10.1389 0.166016 9.00002C0.166016 7.86113 0.384766 6.78474 0.822266 5.77085C1.25977 4.75696 1.85699 3.87155 2.61393 3.1146C3.37088 2.35766 4.25629 1.76044 5.27018 1.32294C6.28407 0.885437 7.36046 0.666687 8.49935 0.666687C9.63824 0.666687 10.7146 0.885437 11.7285 1.32294C12.7424 1.76044 13.6278 2.35766 14.3848 3.1146C15.1417 3.87155 15.7389 4.75696 16.1764 5.77085C16.6139 6.78474 16.8327 7.86113 16.8327 9.00002C16.8327 10.1389 16.6139 11.2153 16.1764 12.2292C15.7389 13.2431 15.1417 14.1285 14.3848 14.8854C13.6278 15.6424 12.7424 16.2396 11.7285 16.6771C10.7146 17.1146 9.63824 17.3334 8.49935 17.3334ZM8.49935 16.0834C10.4438 16.0834 12.1105 15.3889 13.4993 14C14.8882 12.6111 15.5827 10.9445 15.5827 9.00002C15.5827 7.05558 14.8882 5.38891 13.4993 4.00002C12.1105 2.61113 10.4438 1.91669 8.49935 1.91669C6.5549 1.91669 4.88824 2.61113 3.49935 4.00002C2.11046 5.38891 1.41602 7.05558 1.41602 9.00002C1.41602 10.9445 2.11046 12.6111 3.49935 14C4.88824 15.3889 6.5549 16.0834 8.49935 16.0834Z" />
    </svg>
  );
};

export const Close = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      {...props}>
      <path
        d="M2.52471 25.1775L2.70079 25.3522L2.87687 25.1775L13.031 15.1027L23.1226 25.1769L23.2987 25.3527L23.4753 25.1775L25.1761 23.49L25.3544 23.313L25.1766 23.1356L15.0232 13L25.1766 2.86443L25.3544 2.68696L25.1761 2.51003L23.4753 0.822532L23.2981 0.646756L23.1221 0.823608L13.031 10.9587L2.87741 0.823067L2.70132 0.647293L2.52471 0.822531L0.823918 2.51003L0.645595 2.68696L0.823379 2.86443L10.9768 13L0.823379 23.1356L0.645595 23.313L0.823918 23.49L2.52471 25.1775Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.5"
      />
    </svg>
  );
};

const ColouredCrownIcon = (props) => {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.49929 0.5L0.726562 11.4091H16.272L8.49929 0.5Z"
        fill="#FF7A00"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2734 0.5V13.2273H2.45526L16.2734 0.5Z"
        fill="#F1A827"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.726562 1.40909V13.2273H15.4084L0.726562 1.40909Z"
        fill="#FFA300"
      />
      <rect x="0.726562" y="14.1364" width="15.5455" height="1.81818" fill="#FF7A00" />
    </svg>
  );
};
const FreeLicenseIcon = (props) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M20.13 3.65031C20.0138 3.55633 19.8781 3.48958 19.7327 3.45497C19.5873 3.42036 19.4361 3.41877 19.29 3.45031C18.2214 3.67425 17.1183 3.67711 16.0486 3.45869C14.9789 3.24028 13.9653 2.80522 13.07 2.18031C12.9026 2.06418 12.7037 2.00195 12.5 2.00195C12.2963 2.00195 12.0974 2.06418 11.93 2.18031C11.0348 2.80522 10.0211 3.24028 8.95137 3.45869C7.88166 3.67711 6.77857 3.67425 5.71001 3.45031C5.56394 3.41877 5.41267 3.42036 5.26731 3.45497C5.12194 3.48958 4.98618 3.55633 4.87001 3.65031C4.75399 3.74443 4.66053 3.86334 4.5965 3.99832C4.53247 4.1333 4.4995 4.28091 4.50001 4.43031V11.8803C4.49912 13.3141 4.84078 14.7273 5.49654 16.0023C6.1523 17.2773 7.10319 18.3771 8.27001 19.2103L11.92 21.8103C12.0894 21.9309 12.2921 21.9957 12.5 21.9957C12.7079 21.9957 12.9106 21.9309 13.08 21.8103L16.73 19.2103C17.8968 18.3771 18.8477 17.2773 19.5035 16.0023C20.1592 14.7273 20.5009 13.3141 20.5 11.8803V4.43031C20.5005 4.28091 20.4675 4.1333 20.4035 3.99832C20.3395 3.86334 20.246 3.74443 20.13 3.65031ZM18.5 11.8803C18.5008 12.9951 18.2353 14.0939 17.7257 15.0853C17.216 16.0768 16.477 16.9322 15.57 17.5803L12.5 19.7703L9.43001 17.5803C8.52304 16.9322 7.78399 16.0768 7.27435 15.0853C6.76472 14.0939 6.49924 12.9951 6.50001 11.8803V5.58031C8.59643 5.75974 10.696 5.27333 12.5 4.19031C14.304 5.27333 16.4036 5.75974 18.5 5.58031V11.8803ZM14.04 9.59031L11.35 12.2903L10.46 11.3903C10.2717 11.202 10.0163 11.0962 9.75001 11.0962C9.4837 11.0962 9.22831 11.202 9.04001 11.3903C8.8517 11.5786 8.74591 11.834 8.74591 12.1003C8.74591 12.3666 8.8517 12.622 9.04001 12.8103L10.64 14.4103C10.733 14.504 10.8436 14.5784 10.9654 14.6292C11.0873 14.68 11.218 14.7061 11.35 14.7061C11.482 14.7061 11.6127 14.68 11.7346 14.6292C11.8564 14.5784 11.967 14.504 12.06 14.4103L15.5 11.0003C15.6883 10.812 15.7941 10.5566 15.7941 10.2903C15.7941 10.024 15.6883 9.76861 15.5 9.58031C15.3117 9.392 15.0563 9.28622 14.79 9.28622C14.5237 9.28622 14.2683 9.392 14.08 9.58031L14.04 9.59031Z"
        fill="currentColor"
        stroke="white"
        strokeWidth="0.5"
      />
    </svg>
  );
};

const AttributionIcon = (props) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M8.00002 6.00002C7.70334 6.00002 7.41333 6.08799 7.16666 6.25281C6.91999 6.41763 6.72773 6.6519 6.6142 6.92599C6.50067 7.20008 6.47096 7.50168 6.52884 7.79265C6.58672 8.08362 6.72958 8.3509 6.93936 8.56068C7.14914 8.77046 7.41641 8.91332 7.70738 8.97119C7.99835 9.02907 8.29995 8.99937 8.57404 8.88584C8.84813 8.7723 9.0824 8.58005 9.24722 8.33337C9.41204 8.0867 9.50002 7.79669 9.50002 7.50002C9.50002 7.10219 9.34198 6.72066 9.06068 6.43936C8.77937 6.15805 8.39784 6.00002 8.00002 6.00002ZM21.62 10.71L13.21 2.29002C13.1166 2.19734 13.0058 2.12401 12.8839 2.07425C12.7621 2.02448 12.6316 1.99926 12.5 2.00002H3.50002C3.2348 2.00002 2.98045 2.10537 2.79291 2.29291C2.60537 2.48045 2.50002 2.7348 2.50002 3.00002V12C2.49926 12.1316 2.52448 12.2621 2.57425 12.3839C2.62401 12.5058 2.69734 12.6166 2.79002 12.71L11.21 21.12C11.7725 21.6818 12.535 21.9974 13.33 21.9974C14.125 21.9974 14.8875 21.6818 15.45 21.12L21.62 15C22.1818 14.4375 22.4974 13.675 22.4974 12.88C22.4974 12.085 22.1818 11.3225 21.62 10.76V10.71ZM20.21 13.53L14.03 19.7C13.8427 19.8863 13.5892 19.9908 13.325 19.9908C13.0608 19.9908 12.8074 19.8863 12.62 19.7L4.50002 11.59V4.00002H12.09L20.21 12.12C20.3027 12.2135 20.376 12.3243 20.4258 12.4461C20.4756 12.5679 20.5008 12.6984 20.5 12.83C20.4989 13.0924 20.3948 13.3438 20.21 13.53Z"
        fill="currentColor"
        stroke="white"
        strokeWidth="0.5"
      />
    </svg>
  );
};

const ARViewerIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      fill="none"
      viewBox="0 0 20 15"
      {...props}>
      <path
        d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5 8 5.961 14.154 3.5 8.186 1.113zM15 4.239l-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923l6.5 2.6zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464L7.443.184z"
        fill="currentColor"
        // stroke="white"
        strokeWidth="0.5"
      />
    </svg>
  );
};

const ImagineIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="26" fill="none" viewBox="0 0 28 26">
      <path fill="#919191" d="M14 17.041l6.783 8.083H28L14 17.04z"></path>
      <path fill="#727272" d="M14 17.041l-.027.016L.001 25.124h7.217L14 17.04z"></path>
      <path fill="#828282" d="M14 17.041l2.942 8.083h3.84L14 17.04z"></path>
      <path
        fill="#828282"
        d="M14 25.124h2.942L14 17.04v8.083zM11.058 25.124H14V17.04l-2.942 8.083z"></path>
      <path fill="#828282" d="M14 17.041l-6.782 8.083h3.84L14 17.04z"></path>
      <path fill="#D7D7D7" d="M14 17.041l.02.011L28 25.124l-3.609-6.25-10.39-1.833z"></path>
      <path
        fill="#E6E6E6"
        d="M14 17.041l10.391 1.832-1.92-3.326L14 17.041zM14 17.041l8.47-1.494L21 13l-7 4.041z"></path>
      <path
        fill="#E6E6E6"
        d="M21 13l-1.47-2.548-5.53 6.59L21 13zM14 17.041l5.53-6.589-1.921-3.326L14 17.041z"></path>
      <path fill="#F6F6F6" d="M14 17.041l3.609-9.915L14 .876V17.04z"></path>
      <path fill="#fff" d="M0 25.124z"></path>
      <path fill="#242424" d="M14 17.041V.876l-3.609 6.25 3.61 9.915z"></path>
      <path fill="#434343" d="M14 17.041L3.61 18.873 0 25.123l14-8.082z"></path>
      <path fill="#333" d="M14 17.041l-3.609-9.915-1.92 3.326 5.53 6.59z"></path>
      <path
        fill="#333"
        d="M8.471 10.452L7.001 13l7 4.041-5.53-6.589zM14 17.041L7 13l-1.47 2.547L14 17.041zM14 17.041l-8.47-1.494-1.92 3.326L14 17.041z"></path>
      <g style={{ mixBlendMode: 'color' }}>
        <mask
          id="mask0_2819_139855"
          style={{ maskType: 'alpha' }}
          width="28"
          height="26"
          x="0"
          y="0"
          maskUnits="userSpaceOnUse">
          <path
            fill="#fff"
            fillRule="evenodd"
            d="M14 17.04l10.391 1.833-1.92-3.326-1.47-2.548-1.472-2.548-1.92-3.326L14 .875l-3.609 6.25-1.92 3.326L7.001 13l-1.472 2.548-1.92 3.326L14 17.04zm-.027.016L.001 25.123h20.781L14 17.041l6.783 8.082H28l-13.506-7.797L28 25.123l-3.609-6.25-10.39-1.832-10.392 1.832L0 25.123l14-8.082-.027.015zM0 25.124z"
            clipRule="evenodd"></path>
        </mask>
        <g mask="url(#mask0_2819_139855)">
          <path fill="#DD5D26" d="M0 0.875H27.795V25.124H0z"></path>
        </g>
      </g>
    </svg>
  );
};

const LifestyleIconTemplate = (props) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g filter="url(#filter0_b_3363_55692)">
        <rect
          width="28"
          height="28"
          rx="2.33333"
          fill={props.currentColor ? 'currentColor' : 'white'}
          fillOpacity="0.3"
        />
        <g clipPath="url(#clip0_3363_55692)">
          <path
            d="M18.0013 14.6667C18.0013 14.3 17.7013 14 17.3346 14H14.668C14.3013 14 14.0013 14.3 14.0013 14.6667V17.3333C14.0013 17.7 14.3013 18 14.668 18H17.3346C17.7013 18 18.0013 17.7 18.0013 17.3333V16.6667L19.3346 17.3733V14.6267L18.0013 15.3333V14.6667ZM14.0013 8L8.66797 12V20H19.3346V18.6667H10.0013V12.6667L14.0013 9.66667L18.0013 12.6667V13.3333H19.3346V12L14.0013 8Z"
            fill={props.currentColor ? 'currentColor' : 'white'}
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_b_3363_55692"
          x="-4.66667"
          y="-4.66667"
          width="37.3333"
          height="37.3333"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="2.33333" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_3363_55692" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_3363_55692"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_3363_55692">
          <rect
            width="16"
            height="16"
            fill={props.currentColor ? 'currentColor' : 'white'}
            transform="translate(6 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

const SiloIconTemplate = (props) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g filter="url(#filter0_b_3363_129386)">
        <rect
          width="28"
          height="28"
          rx="2.33333"
          fill={props.currentColor ? 'currentColor' : 'white'}
          fillOpacity="0.3"
        />
        <g clipPath="url(#clip0_3363_129386)">
          <path
            d="M9.2 9.2H13.4V8H9.2C8.54 8 8 8.54 8 9.2V13.4H9.2V9.2ZM12.8 14.6L10.4 17.6H17.6L15.8 15.2L14.582 16.826L12.8 14.6ZM17 11.9C17 11.402 16.598 11 16.1 11C15.602 11 15.2 11.402 15.2 11.9C15.2 12.398 15.602 12.8 16.1 12.8C16.598 12.8 17 12.398 17 11.9ZM18.8 8H14.6V9.2H18.8V13.4H20V9.2C20 8.54 19.46 8 18.8 8ZM18.8 18.8H14.6V20H18.8C19.46 20 20 19.46 20 18.8V14.6H18.8V18.8ZM9.2 14.6H8V18.8C8 19.46 8.54 20 9.2 20H13.4V18.8H9.2V14.6Z"
            fill={props.currentColor ? 'currentColor' : 'white'}
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_b_3363_129386"
          x="-4.66667"
          y="-4.66667"
          width="37.3333"
          height="37.3333"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="2.33333" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_3363_129386"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_3363_129386"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_3363_129386">
          <rect
            width="16"
            height="16"
            fill={props.currentColor ? 'currentColor' : 'white'}
            transform="translate(6 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

const VignetteIconTemplate = (props) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g filter="url(#filter0_b_3363_129467)">
        <rect
          width="28"
          height="28"
          rx="2.33333"
          fill={props.currentColor ? 'currentColor' : 'white'}
          fillOpacity="0.3"
        />
        <g clipPath="url(#clip0_3363_129467)">
          <path
            d="M18.6667 8H9.33333C8.6 8 8 8.6 8 9.33333V18.6667C8 19.4 8.6 20 9.33333 20H18.6667C19.4 20 20 19.4 20 18.6667V9.33333C20 8.6 19.4 8 18.6667 8ZM18.6667 18.6667H9.33333V9.33333H18.6667V18.6667ZM15.3067 14.1933L13.4733 16.5533L12.1667 14.98L10.3333 17.3333H17.6667L15.3067 14.1933Z"
            fill={props.currentColor ? 'currentColor' : 'white'}
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_b_3363_129467"
          x="-4.66667"
          y="-4.66667"
          width="37.3333"
          height="37.3333"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="2.33333" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_3363_129467"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_3363_129467"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_3363_129467">
          <rect
            width="16"
            height="16"
            fill={props.currentColor ? 'currentColor' : 'white'}
            transform="translate(6 6)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

const VideoIconTemplate = (props) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g filter="url(#filter0_b_3363_55775)">
        <rect width="28" height="28" rx="2.33333" fill="white" fillOpacity="0.3" />
        <g clipPath="url(#clip0_3363_55775)">
          <path
            d="M20.0013 8H8.0013C7.2613 8 6.66797 8.59333 6.66797 9.33333V17.3333C6.66797 18.0667 7.2613 18.6667 8.0013 18.6667H11.3346V20H16.668V18.6667H20.0013C20.7346 18.6667 21.328 18.0667 21.328 17.3333L21.3346 9.33333C21.3346 8.59333 20.7346 8 20.0013 8ZM20.0013 17.3333H8.0013V9.33333H20.0013V17.3333ZM16.668 13.3333L12.0013 16V10.6667L16.668 13.3333Z"
            fill="white"
          />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_b_3363_55775"
          x="-4.66667"
          y="-4.66667"
          width="37.3333"
          height="37.3333"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="2.33333" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_3363_55775" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_3363_55775"
            result="shape"
          />
        </filter>
        <clipPath id="clip0_3363_55775">
          <rect width="16" height="16" fill="white" transform="translate(6 6)" />
        </clipPath>
      </defs>
    </svg>
  );
};

const ListIcon = (props) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M7.85286 15.8752V14.6252H17.4987V15.8752H7.85286ZM7.85286 10.6252V9.37516H17.4987V10.6252H7.85286ZM7.85286 5.35433V4.10433H17.4987V5.35433H7.85286ZM3.9362 16.646C3.54661 16.646 3.21311 16.5141 2.93568 16.2502C2.65825 15.9863 2.51953 15.6564 2.51953 15.2606C2.51953 14.8647 2.65495 14.5314 2.92578 14.2606C3.19661 13.9897 3.52995 13.8543 3.92578 13.8543C4.32161 13.8543 4.65148 13.993 4.91536 14.2705C5.17925 14.5479 5.3112 14.8814 5.3112 15.271C5.3112 15.6491 5.17657 15.9728 4.9073 16.2421C4.63802 16.5114 4.31432 16.646 3.9362 16.646ZM3.9362 11.396C3.54661 11.396 3.21311 11.2593 2.93568 10.986C2.65825 10.7126 2.51953 10.384 2.51953 10.0002C2.51953 9.6163 2.65825 9.2877 2.93568 9.01435C3.21311 8.741 3.54661 8.60433 3.9362 8.60433C4.31432 8.60433 4.63802 8.741 4.9073 9.01435C5.17657 9.2877 5.3112 9.6163 5.3112 10.0002C5.3112 10.384 5.17657 10.7126 4.9073 10.986C4.63802 11.2593 4.31432 11.396 3.9362 11.396ZM3.91536 6.12516C3.53152 6.12516 3.20291 5.98849 2.92955 5.71514C2.6562 5.44179 2.51953 5.11319 2.51953 4.72933C2.51953 4.34547 2.6562 4.01686 2.92955 3.74352C3.20291 3.47017 3.53152 3.3335 3.91536 3.3335C4.29921 3.3335 4.62782 3.47017 4.90118 3.74352C5.17452 4.01686 5.3112 4.34547 5.3112 4.72933C5.3112 5.11319 5.17452 5.44179 4.90118 5.71514C4.62782 5.98849 4.29921 6.12516 3.91536 6.12516Z"
      fill="black"
    />
  </svg>
);

const GridIcon = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M0.5 6.75V0.5H6.75V6.75H0.5ZM1.75 5.5H5.5V1.75H1.75V5.5ZM0.5 15.5V9.25H6.75V15.5H0.5ZM1.75 14.25H5.5V10.5H1.75V14.25ZM9.25 6.75V0.5H15.5V6.75H9.25ZM10.5 5.5H14.25V1.75H10.5V5.5ZM9.25 15.5V9.25H15.5V15.5H9.25ZM10.5 14.25H14.25V10.5H10.5V14.25Z"
      fill="black"
    />
  </svg>
);

const FileFolder = (props) => {
  return (
    <svg
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M15.6667 2.00065H9.00008L7.33342 0.333984H2.33341C1.41675 0.333984 0.675081 1.08398 0.675081 2.00065L0.666748 12.0007C0.666748 12.9173 1.41675 13.6673 2.33341 13.6673H15.6667C16.5834 13.6673 17.3334 12.9173 17.3334 12.0007V3.66732C17.3334 2.75065 16.5834 2.00065 15.6667 2.00065ZM15.6667 12.0007H2.33341V3.66732H15.6667V12.0007ZM5.66675 7.84232L6.84175 9.01732L8.16675 7.70065V11.1673H9.83342V7.70065L11.1584 9.02565L12.3334 7.84232L9.00842 4.50065L5.66675 7.84232Z"
        fill="#181818"
      />
    </svg>
  );
};
const UploadXLXS = (props) => {
  return (
    <svg
      width="16"
      height="10"
      viewBox="0 0 16 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M0.5 2.50065H12.1667V0.833984H0.5V2.50065ZM0.5 5.83398H12.1667V4.16732H0.5V5.83398ZM0.5 9.16732H12.1667V7.50065H0.5V9.16732ZM13.8333 9.16732H15.5V7.50065H13.8333V9.16732ZM13.8333 0.833984V2.50065H15.5V0.833984H13.8333ZM13.8333 5.83398H15.5V4.16732H13.8333V5.83398Z"
        fill="#181818"
      />
    </svg>
  );
};
export const DownloadXLXS = (props) => {
  return (
    <svg
      width="10"
      height="12"
      viewBox="0 0 10 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M7.00008 2.66732L3.00008 2.66732L3.00008 6.66732L0.333414 6.66732L5.00008 11.334L9.66675 6.66732L7.00008 6.66732L7.00008 2.66732ZM9.66675 1.33399L0.333413 1.33399L0.333413 0.000652176L9.66675 0.00065136L9.66675 1.33399Z"
        fill="#404040"
      />
    </svg>
  );
};
const File = (props) => {
  return (
    <svg
      width="16"
      height="21"
      viewBox="0 0 16 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M4 14.5H12V16.5H4V14.5ZM4 10.5H12V12.5H4V10.5ZM10 0.5H2C0.9 0.5 0 1.4 0 2.5V18.5C0 19.6 0.89 20.5 1.99 20.5H14C15.1 20.5 16 19.6 16 18.5V6.5L10 0.5ZM14 18.5H2V2.5H9V7.5H14V18.5Z"
        fill="#7E7E7E"
      />
    </svg>
  );
};
const Refresh = (props) => {
  return (
    <svg
      width="22"
      height="16"
      viewBox="0 0 22 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M18 4L14 8H17C17 11.31 14.31 14 11 14C9.99 14 9.03 13.75 8.2 13.3L6.74 14.76C7.97 15.54 9.43 16 11 16C15.42 16 19 12.42 19 8H22L18 4ZM5 8C5 4.69 7.69 2 11 2C12.01 2 12.97 2.25 13.8 2.7L15.26 1.24C14.03 0.46 12.57 0 11 0C6.58 0 3 3.58 3 8H0L4 12L8 8H5Z"
        fill="black"
      />
    </svg>
  );
};
const RefreshIconV2 = (props) => {
  return (
    <svg
      width={13}
      height={12}
      viewBox="0 0 13 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M6.5 12C4.825 12 3.40625 11.4187 2.24375 10.2563C1.08125 9.09375 0.5 7.675 0.5 6C0.5 4.325 1.08125 2.90625 2.24375 1.74375C3.40625 0.58125 4.825 0 6.5 0C7.3625 0 8.1875 0.178125 8.975 0.534375C9.7625 0.890625 10.4375 1.4 11 2.0625V0H12.5V5.25H7.25V3.75H10.4C10 3.05 9.45312 2.5 8.75937 2.1C8.06562 1.7 7.3125 1.5 6.5 1.5C5.25 1.5 4.1875 1.9375 3.3125 2.8125C2.4375 3.6875 2 4.75 2 6C2 7.25 2.4375 8.3125 3.3125 9.1875C4.1875 10.0625 5.25 10.5 6.5 10.5C7.4625 10.5 8.33125 10.225 9.10625 9.675C9.88125 9.125 10.425 8.4 10.7375 7.5H12.3125C11.9625 8.825 11.25 9.90625 10.175 10.7437C9.1 11.5813 7.875 12 6.5 12Z"
        fill="currentColor"
      />
    </svg>
  );
};
const CheckCircle = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM14.59 5.58L8 12.17L5.41 9.59L4 11L8 15L16 7L14.59 5.58Z"
        fill="#469E00"
      />
    </svg>
  );
};
const ErrorIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M9 13H11V15H9V13ZM9 5H11V11H9V5ZM9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18Z"
        fill="#DD0A0A"
      />
    </svg>
  );
};
const Uploading = (props) => {
  return (
    <svg
      width="22"
      height="16"
      viewBox="0 0 22 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M18 4L14 8H17C17 11.31 14.31 14 11 14C9.99 14 9.03 13.75 8.2 13.3L6.74 14.76C7.97 15.54 9.43 16 11 16C15.42 16 19 12.42 19 8H22L18 4ZM5 8C5 4.69 7.69 2 11 2C12.01 2 12.97 2.25 13.8 2.7L15.26 1.24C14.03 0.46 12.57 0 11 0C6.58 0 3 3.58 3 8H0L4 12L8 8H5Z"
        fill="black"
      />
    </svg>
  );
};

export const CancelIcon = (props) => {
  return (
    <svg
      {...props}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1582_292348)">
        <path
          d="M15.8307 5.34297L14.6557 4.16797L9.9974 8.8263L5.33906 4.16797L4.16406 5.34297L8.8224 10.0013L4.16406 14.6596L5.33906 15.8346L9.9974 11.1763L14.6557 15.8346L15.8307 14.6596L11.1724 10.0013L15.8307 5.34297Z"
          fill={props?.color ? props?.color : '#2B2A28'}
        />
      </g>
      <defs>
        <clipPath id="clip0_1582_292348">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CheckMarkIcon = (props) => {
  return (
    <svg
      width="14"
      height="11"
      viewBox="0 0 14 11"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.96094 11.0013L0.210938 6.2513L1.39844 5.0638L4.96094 8.6263L12.6068 0.980469L13.7943 2.16797L4.96094 11.0013Z"
        fill={props?.color ? props?.color : '#FBFAF9'}
      />
    </svg>
  );
};

export const EditPensilIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g clipPath="url(#clip0_1621_289749)">
        <path
          d="M2.96011 16.2053H3.91054L13.4797 6.63614L12.5292 5.6857L2.96011 15.2548V16.2053ZM16.223 5.7073L13.4581 2.94241L14.3653 2.03518C14.6101 1.79037 14.9125 1.66797 15.2725 1.66797C15.6325 1.66797 15.9349 1.79037 16.1797 2.03518L17.1302 2.98561C17.375 3.23042 17.4974 3.53283 17.4974 3.89284C17.4974 4.25286 17.375 4.55527 17.1302 4.80007L16.223 5.7073ZM15.3157 6.61453L4.42896 17.5013H1.66406V14.7364L12.5508 3.84964L15.3157 6.61453ZM13.0044 6.16092L12.5292 5.6857L13.4797 6.63614L13.0044 6.16092Z"
          fill={props?.color ? props?.color : '#2B2A28'}
        />
      </g>
      <defs>
        <clipPath id="clip0_1621_289749">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const DownloadArrowIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_1621_289773)">
        <path
          d="M15.8307 7.5H12.4974V2.5H7.4974V7.5H4.16406L9.9974 13.3333L15.8307 7.5ZM4.16406 15V16.6667H15.8307V15H4.16406Z"
          fill={props?.color ? props?.color : '#2B2A28'}
        />
      </g>
      <defs>
        <clipPath id="clip0_1621_289773">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DeleteDusbinIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g clipPath="url(#clip0_1621_289880)">
        <path
          d="M5.14659 17.9172C4.77045 17.9172 4.45073 17.7855 4.18743 17.5222C3.92414 17.2589 3.79249 16.9392 3.79249 16.5631V3.69912H2.86719V2.34502H7.11003V1.66797H13.0681V2.34502H17.3109V3.69912H16.3856V16.5631C16.3856 16.9241 16.2502 17.2401 15.9794 17.5109C15.7086 17.7817 15.3926 17.9172 15.0315 17.9172H5.14659ZM15.0315 3.69912H5.14659V16.5631H15.0315V3.69912ZM7.53883 14.6222H8.89293V5.61742H7.53883V14.6222ZM11.2852 14.6222H12.6393V5.61742H11.2852V14.6222ZM5.14659 3.69912V16.5631V3.69912Z"
          fill={props?.color ? props?.color : '#2B2A28'}
        />
      </g>
      <defs>
        <clipPath id="clip0_1621_289880">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AddPlusIcon = (props) => {
  const { color, ...rest } = props || {};
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}>
      <g clipPath="url(#clip0_1621_289742)">
        <path
          d="M15.8307 10.8346H10.8307V15.8346H9.16406V10.8346H4.16406V9.16797H9.16406V4.16797H10.8307V9.16797H15.8307V10.8346Z"
          fill={color || '#2B2A28'}
        />
      </g>
      <defs>
        <clipPath id="clip0_1621_289742">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const UploadFileIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1621_289845)">
        <path
          d="M9.16927 15.8346H10.8359V12.3555L12.1693 13.6888L13.3359 12.5013L10.0026 9.16797L6.66927 12.5013L7.85677 13.668L9.16927 12.3555V15.8346ZM5.0026 18.3346C4.54427 18.3346 4.15191 18.1714 3.82552 17.8451C3.49913 17.5187 3.33594 17.1263 3.33594 16.668V3.33464C3.33594 2.8763 3.49913 2.48394 3.82552 2.15755C4.15191 1.83116 4.54427 1.66797 5.0026 1.66797H11.6693L16.6693 6.66797V16.668C16.6693 17.1263 16.5061 17.5187 16.1797 17.8451C15.8533 18.1714 15.4609 18.3346 15.0026 18.3346H5.0026ZM10.8359 7.5013V3.33464H5.0026V16.668H15.0026V7.5013H10.8359Z"
          fill={props?.color ? props?.color : '#2B2A28'}
        />
      </g>
      <defs>
        <clipPath id="clip0_1621_289845">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const ARIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1567_290710)">
        <path
          d="M15.2057 6.33464L10.6224 3.68464C10.2391 3.45964 9.75573 3.45964 9.3724 3.68464L4.78906 6.33464C4.40573 6.55964 4.16406 6.96797 4.16406 7.41797V12.7096C4.16406 13.1596 4.40573 13.568 4.78906 13.793L9.3724 16.443C9.75573 16.668 10.2391 16.668 10.6224 16.443L15.2057 13.793C15.5891 13.568 15.8307 13.1596 15.8307 12.7096V7.41797C15.8307 6.96797 15.5891 6.55964 15.2057 6.33464ZM5.83073 12.468V8.61797L9.16406 10.5513V14.393L5.83073 12.468ZM9.9974 9.10964L6.66406 7.1763L9.9974 5.2513L13.3307 7.1763L9.9974 9.10964ZM10.8307 14.393V10.5513L14.1641 8.61797V12.468L10.8307 14.393ZM5.83073 1.66797H2.91406C2.2224 1.66797 1.66406 2.2263 1.66406 2.91797V5.83464H3.33073V3.33464H5.83073V1.66797ZM14.1641 1.66797H17.0807C17.7724 1.66797 18.3307 2.2263 18.3307 2.91797V5.83464H16.6641V3.33464H14.1641V1.66797ZM5.83073 18.3346H2.91406C2.2224 18.3346 1.66406 17.7763 1.66406 17.0846V14.168H3.33073V16.668H5.83073V18.3346ZM14.1641 18.3346H17.0807C17.7724 18.3346 18.3307 17.7763 18.3307 17.0846V14.168H16.6641V16.668H14.1641V18.3346Z"
          fill={props?.color ? props?.color : '#2B2A28'}
        />
      </g>
      <defs>
        <clipPath id="clip0_1567_290710">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const FavoriteIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g clipPath="url(#clip0_1567_290717)">
        <path
          d="M9.9974 17.4987L8.78906 16.4154C7.38629 15.1515 6.22656 14.0612 5.3099 13.1445C4.39323 12.2279 3.66406 11.4049 3.1224 10.6758C2.58073 9.94661 2.20226 9.27648 1.98698 8.66536C1.7717 8.05425 1.66406 7.42925 1.66406 6.79036C1.66406 5.48481 2.10156 4.39453 2.97656 3.51953C3.85156 2.64453 4.94184 2.20703 6.2474 2.20703C6.96962 2.20703 7.65712 2.35981 8.3099 2.66536C8.96267 2.97092 9.52517 3.40148 9.9974 3.95703C10.4696 3.40148 11.0321 2.97092 11.6849 2.66536C12.3377 2.35981 13.0252 2.20703 13.7474 2.20703C15.053 2.20703 16.1432 2.64453 17.0182 3.51953C17.8932 4.39453 18.3307 5.48481 18.3307 6.79036C18.3307 7.42925 18.2231 8.05425 18.0078 8.66536C17.7925 9.27648 17.4141 9.94661 16.8724 10.6758C16.3307 11.4049 15.6016 12.2279 14.6849 13.1445C13.7682 14.0612 12.6085 15.1515 11.2057 16.4154L9.9974 17.4987ZM9.9974 15.2487C11.3307 14.0543 12.428 13.0299 13.2891 12.1758C14.1502 11.3216 14.8307 10.5786 15.3307 9.94661C15.8307 9.31467 16.178 8.75217 16.3724 8.25911C16.5668 7.76606 16.6641 7.27648 16.6641 6.79036C16.6641 5.95703 16.3863 5.26259 15.8307 4.70703C15.2752 4.15148 14.5807 3.8737 13.7474 3.8737C13.0946 3.8737 12.4905 4.05773 11.9349 4.42578C11.3793 4.79384 10.9974 5.26259 10.7891 5.83203H9.20573C8.9974 5.26259 8.61545 4.79384 8.0599 4.42578C7.50434 4.05773 6.90017 3.8737 6.2474 3.8737C5.41406 3.8737 4.71962 4.15148 4.16406 4.70703C3.60851 5.26259 3.33073 5.95703 3.33073 6.79036C3.33073 7.27648 3.42795 7.76606 3.6224 8.25911C3.81684 8.75217 4.16406 9.31467 4.66406 9.94661C5.16406 10.5786 5.84462 11.3216 6.70573 12.1758C7.56684 13.0299 8.66406 14.0543 9.9974 15.2487Z"
          fill={props?.color ? props?.color : '#2B2A28'}
        />
      </g>
      <defs>
        <clipPath id="clip0_1567_290717">
          <rect width="20" height="20" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const FavoriteRedIcon = (props) => {
  return (
    <svg
      {...props}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 18.75C10 18.75 4.21875 14.0625 2.5 11.875C0.78125 9.6875 0.78125 6.25 2.5 4.375C4.21875 2.5 7.34375 3.75 10 6.875C12.6562 3.75 15.7812 2.5 17.5 4.375C19.2188 6.25 19.2188 9.6875 17.5 11.875C15.7812 14.0625 10 18.75 10 18.75Z"
        fill={props?.color ? props?.color : '#FF0000'}
      />
    </svg>
  );
};
export const FavoriteRedIconV2 = (props) => {
  return (
    <svg
      version="1.2"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      viewBox="0 0 20 20"
      width="20"
      height="20">
      <defs>
        <clipPath clipPathUnits="userSpaceOnUse" id="cp1">
          <path d="m0 0h20v20h-20z" />
        </clipPath>
        <image
          width="15"
          height="13"
          id="img1"
          href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAANCAMAAABBwMRzAAAAAXNSR0IB2cksfwAAAIpQTFRFAAAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA/wAA535jNgAAAC50Uk5TAB9hczIBPUpqDAiU/P+KJML0Qyu4O/Pr1aNSHb1XEuWiM/vDWrEHOOqgAhqbQtivqvMAAABtSURBVHicXc7ZDoJADIXhH0FZtIqAiCuCirL4/q/HyIQwem7aL2lyClgz2wHmC9fzIViuRGQdbEI1thGxmEnY/Tj98x4y0wc4mucn1XOefFG9XPORN4YUpebd1+bxfUmeFWNeb5G6YUrbffTSA7WUCUioyttMAAAAAElFTkSuQmCC"
        />
      </defs>
      <g id="clipPath" clipPath="url(#cp1)">
        <g id="Layer">
          <path
            id="Layer"
            fillRule="evenodd"
            fill="currentColor"
            d="m10 17.5l-1.2-1.1q-2.1-1.9-3.5-3.3-1.4-1.3-2.2-2.4-0.8-1.1-1.1-2-0.3-1-0.3-1.9 0-2 1.3-3.3 1.3-1.3 3.2-1.3 1.1 0 2.1 0.5 1 0.4 1.7 1.3 0.7-0.9 1.7-1.3 1-0.5 2-0.5 2 0 3.3 1.3 1.3 1.3 1.3 3.3 0 0.9-0.3 1.9-0.3 0.9-1.1 2-0.8 1.1-2.2 2.4-1.4 1.4-3.5 3.3zm0-2.2q2-1.8 3.3-3.1 1.3-1.3 2-2.2 0.8-1 1.1-1.7 0.3-0.8 0.3-1.5 0-1.2-0.9-2.1-0.8-0.8-2-0.8-1 0-1.9 0.5-0.8 0.6-1.1 1.4h-1.6q-0.3-0.8-1.1-1.4-0.9-0.5-1.8-0.5-1.3 0-2.1 0.8-0.9 0.9-0.9 2.1 0 0.7 0.3 1.5 0.3 0.7 1.1 1.7 0.7 0.9 2 2.2 1.3 1.3 3.3 3.1z"
          />
          <g id="Folder 1">
            <use id="Layer 1" href="#img1" x="2" y="3" />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const ShareProductIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g clipPath="url(#clip0_1567_290724)">
        <path
          d="M15 13.4013C14.3667 13.4013 13.8 13.6513 13.3667 14.043L7.425 10.5846C7.46667 10.393 7.5 10.2013 7.5 10.0013C7.5 9.8013 7.46667 9.60964 7.425 9.41797L13.3 5.99297C13.75 6.40964 14.3417 6.66797 15 6.66797C16.3833 6.66797 17.5 5.5513 17.5 4.16797C17.5 2.78464 16.3833 1.66797 15 1.66797C13.6167 1.66797 12.5 2.78464 12.5 4.16797C12.5 4.36797 12.5333 4.55964 12.575 4.7513L6.7 8.1763C6.25 7.75964 5.65833 7.5013 5 7.5013C3.61667 7.5013 2.5 8.61797 2.5 10.0013C2.5 11.3846 3.61667 12.5013 5 12.5013C5.65833 12.5013 6.25 12.243 6.7 11.8263L12.6333 15.293C12.5917 15.468 12.5667 15.6513 12.5667 15.8346C12.5667 17.1763 13.6583 18.268 15 18.268C16.3417 18.268 17.4333 17.1763 17.4333 15.8346C17.4333 14.493 16.3417 13.4013 15 13.4013ZM15 3.33464C15.4583 3.33464 15.8333 3.70964 15.8333 4.16797C15.8333 4.6263 15.4583 5.0013 15 5.0013C14.5417 5.0013 14.1667 4.6263 14.1667 4.16797C14.1667 3.70964 14.5417 3.33464 15 3.33464ZM5 10.8346C4.54167 10.8346 4.16667 10.4596 4.16667 10.0013C4.16667 9.54297 4.54167 9.16797 5 9.16797C5.45833 9.16797 5.83333 9.54297 5.83333 10.0013C5.83333 10.4596 5.45833 10.8346 5 10.8346ZM15 16.6846C14.5417 16.6846 14.1667 16.3096 14.1667 15.8513C14.1667 15.393 14.5417 15.018 15 15.018C15.4583 15.018 15.8333 15.393 15.8333 15.8513C15.8333 16.3096 15.4583 16.6846 15 16.6846Z"
          fill={props?.color ? props?.color : 'currentColor'}
        />
      </g>
      <defs>
        <clipPath id="clip0_1567_290724">
          <rect width="20" height="20" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const ThreeSixtyIcon = (props) => {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1582_292112)">
        <path
          d="M12 7C6.48 7 2 9.24 2 12C2 14.24 4.94 16.13 9 16.77V20L13 16L9 12V14.73C5.85 14.17 4 12.83 4 12C4 10.94 7.04 9 12 9C16.96 9 20 10.94 20 12C20 12.73 18.54 13.89 16 14.53V16.58C19.53 15.81 22 14.05 22 12C22 9.24 17.52 7 12 7Z"
          fill={props?.color ? props?.color : 'black'}
        />
      </g>
      <defs>
        <clipPath id="clip0_1582_292112">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const RedirectionIcon = (props) => {
  return (
    <svg
      {...props}
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 303.000000 295.000000"
      preserveAspectRatio="xMidYMid meet">
      <g
        transform="translate(0.000000,295.000000) scale(0.100000,-0.100000)"
        fill="currentColor"
        stroke="none">
        <path
          d="M865 2056 l-25 -25 0 -591 0 -591 25 -24 24 -25 591 0 591 0 25 25
          24 24 -2 367 c-3 337 -4 368 -20 378 -13 8 -23 8 -35 0 -17 -10 -18 -40 -21
          -363 l-2 -351 -560 0 -560 0 0 560 0 560 351 2 c323 3 353 4 363 21 8 12 8 22
          0 35 -10 16 -41 17 -378 20 l-367 2 -24 -24z"
          fill="currentColor"
        />
        <path
          d="M1812 2068 c-7 -7 -12 -19 -12 -28 0 -31 23 -40 104 -40 l81 0 -273
          -273 c-149 -149 -272 -279 -272 -288 0 -19 20 -39 40 -39 8 0 137 122 285 270
          l270 270 5 -81 c4 -64 9 -84 23 -93 12 -8 22 -8 35 0 15 10 17 30 20 149 2 93
          -1 142 -9 151 -15 19 -279 20 -297 2z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
export const PauseIcon = (props) => {
  return (
    <svg
      {...props}
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="508.000000pt"
      height="523.000000pt"
      viewBox="0 0 508.000000 523.000000"
      preserveAspectRatio="xMidYMid meet">
      <metadata>Created by potrace 1.16, written by Peter Selinger 2001-2019</metadata>
      <g
        transform="translate(0.000000,523.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none">
        <path
          d="M1705 4186 c-37 -17 -70 -52 -84 -89 -8 -20 -11 -528 -11 -1658 0
          -1800 -5 -1671 66 -1725 31 -24 47 -29 94 -29 47 0 63 5 94 29 71 54 66 -78
          64 1740 -3 1643 -3 1645 -24 1672 -11 15 -32 37 -46 47 -34 25 -113 32 -153
          13z"
        />
        <path
          d="M3305 4186 c-37 -17 -70 -52 -84 -89 -8 -20 -11 -528 -11 -1658 0
          -1800 -5 -1671 66 -1725 31 -24 47 -29 94 -29 46 0 63 5 92 27 74 57 68 -92
          66 1741 -3 1644 -3 1646 -24 1673 -11 15 -32 37 -46 47 -34 25 -113 32 -153
          13z"
        />
      </g>
    </svg>
  );
};
export const PlayVideoIcon = (props) => {
  return (
    <svg
      {...props}
      enableBackground="new 0 0 32 32"
      height="32px"
      id="Layer_1"
      version="1.1"
      viewBox="0 0 32 32"
      width="32px"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M28.496,15.132l-21-12C7.188,2.955,6.807,2.958,6.498,3.135C6.189,3.314,6,3.644,6,4v24c0,0.356,0.189,0.686,0.498,0.865  C6.653,28.955,6.826,29,7,29c0.171,0,0.343-0.044,0.496-0.132l21-12C28.808,16.69,29,16.358,29,16S28.808,15.31,28.496,15.132z   M8,26.276V5.724L25.984,16L8,26.276z" />
    </svg>
  );
};

const FilledInfoIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g clipPath="url(#clip0_1057_154463)">
        <path
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V11H13V17ZM13 9H11V7H13V9Z"
          fill="#DD5E27"
        />
      </g>
      <defs>
        <clipPath id="clip0_1057_154463">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const FilterIcon = () => {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_927_257211)">
        <path
          d="M3 17V19H9V17H3ZM3 5V7H13V5H3ZM13 21V19H21V17H13V15H11V21H13ZM7 9V11H3V13H7V15H9V9H7ZM21 13V11H11V13H21ZM15 9H17V7H21V5H17V3H15V9Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_927_257211">
          <rect width={24} height={24} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const RequestFileUploadIcon = () => {
  return (
    <svg width={41} height={40} viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M38.6837 20C38.6837 30.5129 30.3405 39 20.0918 39C9.84319 39 1.5 30.5129 1.5 20C1.5 9.48705 9.84319 1 20.0918 1C30.3405 1 38.6837 9.48705 38.6837 20Z"
        stroke="#DD5E27"
        strokeWidth={2}
      />
      <rect x="19.5" y={11} width={2} height={18} fill="#DD5E27" />
      <rect x="29.5" y={19} width={2} height={18} transform="rotate(90 29.5 19)" fill="#DD5E27" />
    </svg>
  );
};

export const RightCheckIcon = (props) => {
  return (
    <svg
      width={22}
      height={21}
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <rect x="0.5" width={21} height={21} rx="10.5" fill="currentColor" />
      <g clipPath="url(#clip0_1661_257077)">
        <path
          d="M9.37318 12.7758L7.09818 10.5008L6.33984 11.2592L9.37318 14.2925L15.8732 7.79251L15.1148 7.03418L9.37318 12.7758Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1661_257077">
          <rect x="4.5" y={4} width={13} height={13} rx="6.5" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const CheckIcon = (props) => {
  return (
    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1200_158565)">
        <path
          d="M7.49967 13.5001L3.99967 10.0001L2.83301 11.1667L7.49967 15.8334L17.4997 5.83341L16.333 4.66675L7.49967 13.5001Z"
          fill="#DD5E27"
        />
      </g>
      <defs>
        <clipPath id="clip0_1200_158565">
          <rect width={20} height={20} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const WrongCrossIcon = (props) => {
  return (
    <svg
      width={22}
      height={21}
      viewBox="0 0 22 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <rect x="0.5" width={21} height={21} rx="10.5" fill="currentColor" />
      <path
        d="M15.9286 6.76244L14.737 5.5708L10.9995 9.36247L7.26195 5.5708L6.07031 6.76244L9.86198 10.5L6.07031 14.2375L7.26195 15.4291L10.9995 11.6374L14.737 15.4291L15.9286 14.2375L12.137 10.5L15.9286 6.76244Z"
        fill="white"
      />
    </svg>
  );
};

// const RequestDeleteIcon =() => {
//   return (<svg
//     width={21}
//     height={21}
//     viewBox="0 0 21 21"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       d="M19.4844 0.734375H1.51562C1.0835 0.734375 0.734375 1.0835 0.734375 1.51562V19.4844C0.734375 19.9165 1.0835 20.2656 1.51562 20.2656H19.4844C19.9165 20.2656 20.2656 19.9165 20.2656 19.4844V1.51562C20.2656 1.0835 19.9165 0.734375 19.4844 0.734375ZM15.1875 11.0859C15.1875 11.1934 15.0996 11.2812 14.9922 11.2812H6.00781C5.90039 11.2812 5.8125 11.1934 5.8125 11.0859V9.91406C5.8125 9.80664 5.90039 9.71875 6.00781 9.71875H14.9922C15.0996 9.71875 15.1875 9.80664 15.1875 9.91406V11.0859Z"
//       fill="currentColor"
//     />
//   </svg>
//   )
// }

const RequestDeleteIcon = () => {
  return (
    <svg width={22} height={21} viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" width={21} height={21} rx="10.5" fill="currentColor" />
      <path
        d="M15.9286 6.76244L14.737 5.5708L10.9995 9.36247L7.26195 5.5708L6.07031 6.76244L9.86198 10.5L6.07031 14.2375L7.26195 15.4291L10.9995 11.6374L14.737 15.4291L15.9286 14.2375L12.137 10.5L15.9286 6.76244Z"
        fill="white"
      />
    </svg>
  );
};

const RequestLayoutIcon = () => {
  return (
    <svg width={25} height={26} viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="0.5" width={25} height={25} rx={4} fill="currentColor" />
      <rect x="4.5" y={5} width="6.66667" height="6.66667" rx={1} fill="white" />
      <rect x="4.5" y="14.3334" width="6.66667" height="6.66667" rx={1} fill="white" />
      <rect x="13.8359" y={5} width="6.66667" height="6.66667" rx={1} fill="white" />
      <rect x="13.8359" y="14.3334" width="6.66667" height="6.66667" rx={1} fill="white" />
    </svg>
  );
};

const RequestBoardViewIcon = () => {
  return (
    <svg width={19} height={16} viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.03255 0H0.634895C0.560703 0 0.5 0.0859002 0.5 0.190889V15.8091C0.5 15.9141 0.560703 16 0.634895 16H4.03255C4.10674 16 4.16745 15.9141 4.16745 15.8091V0.190889C4.16745 0.0859002 4.10674 0 4.03255 0Z"
        fill="currentColor"
        fillOpacity="0.85"
      />
      <path
        d="M11.1988 0H7.80117C7.72698 0 7.66628 0.0859002 7.66628 0.190889V15.8091C7.66628 15.9141 7.72698 16 7.80117 16H11.1988C11.273 16 11.3337 15.9141 11.3337 15.8091V0.190889C11.3337 0.0859002 11.273 0 11.1988 0Z"
        fill="currentColor"
        fillOpacity="0.85"
      />
      <path
        d="M18.3651 0H14.9674C14.8933 0 14.8326 0.0859002 14.8326 0.190889V15.8091C14.8326 15.9141 14.8933 16 14.9674 16H18.3651C18.4393 16 18.5 15.9141 18.5 15.8091V0.190889C18.5 0.0859002 18.4393 0 18.3651 0Z"
        fill="currentColor"
        fillOpacity="0.85"
      />
    </svg>
  );
};

const ActiveDeactiveIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g clipPath="url(#clip0_1621_177280)">
        <path
          d="M9.88443 20.5V17.6731L6.4998 14.2885V9.30773C6.4998 8.96366 6.57384 8.64111 6.72193 8.34008C6.86999 8.03903 7.09659 7.80966 7.40173 7.65198L8.80745 9.05771H8.1921C8.14082 9.05771 8.09594 9.08014 8.05748 9.12501C8.01901 9.16989 7.99978 9.2308 7.99978 9.30773V13.65L11.3844 17.0346V19H12.6152V17.0346L13.646 16.0038L1.61133 3.96923L2.66515 2.91541L21.0652 21.3154L20.0113 22.3692L14.7152 17.073L14.1151 17.6731V20.5H9.88443ZM16.8613 14.2808L15.9998 13.4193V9.30773C15.9998 9.2308 15.9677 9.16027 15.9036 9.09616C15.8395 9.03206 15.769 9.00001 15.6921 9.00001H11.5805L8.6729 6.09238V3.50003H10.1729V7.50003H13.8267V3.50003H15.3267V8.25003L14.5767 7.50003H15.6921C16.1892 7.50003 16.6147 7.67704 16.9687 8.03106C17.3227 8.38506 17.4998 8.81061 17.4998 9.30773V13.6423L16.8613 14.2808Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1621_177280">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CopyIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g clipPath="url(#clip0_1621_177285)">
        <path
          d="M4.5 21.975C4.1 21.975 3.75 21.825 3.45 21.525C3.15 21.225 3 20.875 3 20.475V5.39998H4.5V20.475H16.35V21.975H4.5ZM7.5 18.975C7.1 18.975 6.75 18.825 6.45 18.525C6.15 18.225 6 17.875 6 17.475V3.47498C6 3.07498 6.15 2.72498 6.45 2.42498C6.75 2.12498 7.1 1.97498 7.5 1.97498H18.5C18.9 1.97498 19.25 2.12498 19.55 2.42498C19.85 2.72498 20 3.07498 20 3.47498V17.475C20 17.875 19.85 18.225 19.55 18.525C19.25 18.825 18.9 18.975 18.5 18.975H7.5ZM7.5 17.475H18.5V3.47498H7.5V17.475ZM7.5 17.475V3.47498V17.475Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1621_177285">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LeftIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      className="cursor-pointer"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g clipPath="url(#clip0_3399_12423)">
        <path
          d="M13.0879 13.825L9.27122 10L13.0879 6.175L11.9129 5L6.91289 10L11.9129 15L13.0879 13.825Z"
          fill="#141414"
        />
      </g>
      <defs>
        <clipPath id="clip0_3399_12423">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LeftArrowIconV2 = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <mask
        id="mask0_9389_1656"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24">
        <rect width="24" height="24" fill="currentColor" />
      </mask>
      <g mask="url(#mask0_9389_1656)">
        <path d="M14 18L8 12L14 6L15.4 7.4L10.8 12L15.4 16.6L14 18Z" fill="#363636" />
      </g>
    </svg>
  );
};

export const LeftArrowIconV3 = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <mask
        id="mask0_9389_1656"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24">
        <rect width="24" height="24" fill="currentColor" />
      </mask>
      <g mask="url(#mask0_9389_1656)">
        <path d="M14 18L8 12L14 6L15.4 7.4L10.8 12L15.4 16.6L14 18Z" fill="currentColor" />
      </g>
    </svg>
  );
};

export const ArrowIconV2 = (props) => {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <mask
        id="mask0_5293_13401"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="18"
        height="19">
        <rect y="0.5" width="18" height="18" fill="currentColor" />
      </mask>
      <g mask="url(#mask0_5293_13401)">
        <path
          d="M9.00049 12.0501L4.50049 7.55012L5.55049 6.50012L9.00049 9.95012L12.4505 6.50012L13.5005 7.55012L9.00049 12.0501Z"
          fill="#363636"
        />
      </g>
    </svg>
  );
};

export const RightIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      className="cursor-pointer"
      fill="none"
      style={{ transform: 'scaleX(-1)' }}
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g clipPath="url(#clip0_3399_12423)">
        <path
          d="M13.0879 13.825L9.27122 10L13.0879 6.175L11.9129 5L6.91289 10L11.9129 15L13.0879 13.825Z"
          fill={props?.color ? props.color : '#141414'}
        />
      </g>
      <defs>
        <clipPath id="clip0_3399_12423">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const RequestInfo = () => {
  return (
    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z"
        fill="currentColor"
      />
    </svg>
  );
};
const JCBCardIcon = (props) => {
  return (
    <svg
      width="800px"
      height="800px"
      viewBox="0 -140 780 780"
      enableBackground="new 0 0 780 500"
      version="1.1"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M40,0h700c22.092,0,40,17.909,40,40v420c0,22.092-17.908,40-40,40H40c-22.091,0-40-17.908-40-40V40   C0,17.909,17.909,0,40,0z"
        fill="#0E4C96"
      />
      <path
        d="m632.24 361.27c0 41.615-33.729 75.36-75.36 75.36h-409.13v-297.88c0-41.626 33.733-75.37 75.365-75.37l409.12-1e-3 1e-3 297.89z"
        fill="#ffffff"
      />
      <linearGradient
        id="c"
        x1="83.977"
        x2="84.977"
        y1="645.5"
        y2="645.5"
        gradientTransform="matrix(132.87 0 0 -323.02 -10686 2.0876e5)"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#007B40" offset="0" />
        <stop stopColor="#55B330" offset="1" />
      </linearGradient>
      <path
        d="m498.86 256.54c11.684 0.253 23.437-0.516 35.076 0.4 11.787 2.199 14.629 20.043 4.156 25.888-7.141 3.851-15.633 1.433-23.379 2.113h-15.852l-1e-3 -28.401zm41.833-32.145c2.596 9.164-6.238 17.392-15.066 16.13h-26.767c0.185-8.642-0.368-18.021 0.271-26.208 10.725 0.301 21.549-0.616 32.21 0.479 4.581 1.151 8.414 4.917 9.352 9.599zm64.428-135.9c0.498 17.501 0.071 35.927 0.214 53.783-0.035 72.596 0.072 145.19-0.055 217.79-0.47 27.207-24.582 50.844-51.601 51.387-27.046 0.111-54.095 0.016-81.142 0.047v-109.75c29.47-0.154 58.959 0.307 88.417-0.232 13.667-0.859 28.632-9.875 29.27-24.914 1.61-15.103-12.632-25.551-26.152-27.201-5.198-0.135-5.044-1.516 0-2.117 12.892-2.787 23.02-16.133 19.226-29.499-3.236-14.058-18.772-19.499-31.697-19.472-26.351-0.18-52.709-0.026-79.062-0.077 0.172-20.489-0.354-41 0.286-61.474 2.087-26.716 26.806-48.747 53.447-48.27h78.849v-1e-3z"
        fill="url(#c)"
      />
      <linearGradient
        id="b"
        x1="83.984"
        x2="84.979"
        y1="645.5"
        y2="645.5"
        gradientTransform="matrix(133.43 0 0 -323.02 -11031 2.0876e5)"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#1D2970" offset="0" />
        <stop stopColor="#006DBA" offset="1" />
      </linearGradient>
      <path
        d="m174.74 139.54c0.674-27.163 24.889-50.611 51.875-51.007 26.944-0.083 53.891-0.012 80.837-0.036-0.074 90.885 0.148 181.78-0.112 272.66-1.038 26.835-24.99 49.835-51.679 50.308-26.996 0.099-53.995 0.014-80.992 0.042v-113.45c26.223 6.194 53.722 8.832 80.473 4.721 15.993-2.574 33.488-10.424 38.902-27.014 3.986-14.191 1.742-29.126 2.334-43.691v-33.824h-46.297c-0.208 22.369 0.426 44.779-0.335 67.125-1.248 13.734-14.846 22.46-27.8 21.994-16.066 0.17-47.898-11.639-47.898-11.639-0.08-41.918 0.466-94.409 0.692-136.18z"
        fill="url(#b)"
      />
      <linearGradient
        id="a"
        x1="83.978"
        x2="84.977"
        y1="645.5"
        y2="645.5"
        gradientTransform="matrix(132.96 0 0 -323.03 -10842 2.0877e5)"
        gradientUnits="userSpaceOnUse">
        <stop stopColor="#6E2B2F" offset="0" />
        <stop stopColor="#E30138" offset="1" />
      </linearGradient>
      <path
        d="m324.72 211.89c-2.434 0.517-0.489-8.301-1.113-11.646 0.165-21.15-0.347-42.323 0.283-63.458 2.083-26.829 26.991-48.916 53.739-48.288h78.766c-0.073 90.884 0.147 181.78-0.111 272.66-1.039 26.834-24.992 49.833-51.681 50.308-26.997 0.1-53.997 0.015-80.997 0.043v-124.3c18.44 15.128 43.5 17.483 66.473 17.524 17.316-6e-3 34.534-2.674 51.35-6.67v-22.772c-18.953 9.446-41.232 15.446-62.243 10.019-14.655-3.65-25.294-17.812-25.056-32.937-1.699-15.728 7.524-32.335 22.981-37.011 19.189-6.008 40.107-1.413 58.096 6.397 3.854 2.019 7.765 4.521 6.222-1.921v-17.9c-30.084-7.156-62.101-9.792-92.329-2.004-8.749 2.469-17.271 6.212-24.38 11.958z"
        fill="url(#a)"
      />
    </svg>
  );
};

const BankAccountIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 88 88" {...props}>
      <path
        d="M73 45a1 1 0 0 0 1-1v-5h3a1 1 0 0 0 1-1v-5h4a1 1 0 0 0 1-1V22a1 1 0 0 0-.534-.885l-38-20a.995.995 0 0 0-.932 0l-38 20A1 1 0 0 0 5 22v10a1 1 0 0 0 1 1h4v5a1 1 0 0 0 1 1h3v5a1 1 0 0 0 1 1h2v22h-2a1 1 0 0 0-1 1v5h-3a1 1 0 0 0-1 1v5H6a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h76a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1h-4v-5a1 1 0 0 0-1-1h-3v-5a1 1 0 0 0-1-1h-2V45zm-1-2H62v-4h10zM61 67a1 1 0 0 0-1 1v5h-9v-5a1 1 0 0 0-1-1h-2V45h2a1 1 0 0 0 1-1v-5h9v5a1 1 0 0 0 1 1h2v22zm-33 6v-5a1 1 0 0 0-1-1h-2V45h2a1 1 0 0 0 1-1v-5h9v5a1 1 0 0 0 1 1h2v22h-2a1 1 0 0 0-1 1v5zm18-6h-4V45h4zm1-24h-8v-4h10v4zm-8 26h10v4H39zM7 22.603 44 3.13l37 19.474V31H7zM12 33h64v4H12zm4 6h10v4H16zm3 6h4v22h-4zm-3 24h10v4H16zm65 16H7v-4h74zm-5-6H12v-4h64zm-4-6H62v-4h10zm-3-6h-4V45h4z"
        style={{ fill: '#202021' }}
      />
      <path
        d="M44.145 21h-.29a.856.856 0 0 1-.855-.855 1 1 0 0 0-2 0 2.848 2.848 0 0 0 2 2.71V23a1 1 0 0 0 2 0v-.145a2.844 2.844 0 0 0 .422-5.262l-1.95-.975A.854.854 0 0 1 43.856 15h.29a.856.856 0 0 1 .855.854 1 1 0 1 0 2 0 2.848 2.848 0 0 0-2-2.709V13a1 1 0 0 0-2 0v.145a2.844 2.844 0 0 0-.422 5.262l1.95.975A.854.854 0 0 1 44.144 21z"
        style={{ fill: '#202021' }}
      />
      <path
        d="M44 28a10 10 0 1 0-10-10 10.012 10.012 0 0 0 10 10zm0-18a8 8 0 1 1-8 8 8.01 8.01 0 0 1 8-8z"
        style={{ fill: '#202021' }}
      />
    </svg>
  );
};

const UnionPayCardIcon = (props) => {
  return (
    <svg
      width="800px"
      height="800px"
      viewBox="0 -140 780 780"
      enableBackground="new 0 0 780 500"
      version="1.1"
      xmlSpace="preserve"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <rect width="780" height="500" fill="#FFF" />
      <path
        d="m216.4 69.791h142.39c19.87 0 32.287 16.406 27.63 36.47l-66.333 287.48c-4.656 20.063-24.629 36.47-44.498 36.47h-142.39c-19.87 0-32.287-16.406-27.63-36.47l66.331-287.48c4.657-20.168 24.526-36.47 44.395-36.47h0.104z"
        fill="#D10429"
      />
      <path
        d="m346.34 69.791h163.82c19.868 0 10.865 16.406 6.209 36.47l-66.334 287.48c-4.657 20.063-3.208 36.47-23.077 36.47h-163.81c-19.972 0-32.287-16.406-27.527-36.47l66.334-287.48c4.656-20.168 24.524-36.47 44.498-36.47h-0.104z"
        fill="#022E64"
      />
      <path
        d="m504.41 69.791h142.4c19.869 0 32.287 16.406 27.629 36.47l-66.332 287.48c-4.658 20.063-24.631 36.47-44.499 36.47h-142.39c-19.973 0-32.287-16.406-27.63-36.47l66.333-287.48c4.656-20.168 24.525-36.47 44.394-36.47h0.104z"
        fill="#076F74"
      />
      <path
        d="m480.5 340.81h13.453l3.829-13.063h-13.351l-3.931 13.063zm10.762-35.95l-4.657 15.467s5.071-2.613 7.865-3.449c2.794-0.627 6.933-1.15 6.933-1.15l3.208-10.763h-13.451l0.102-0.105zm6.726-22.153l-4.449 14.839s4.967-2.3 7.761-3.029c2.794-0.732 6.933-0.941 6.933-0.941l3.208-10.764h-13.349l-0.104-0.105zm29.701 0l-17.386 57.997h4.657l-3.622 12.018h-4.657l-1.138 3.657h-16.559l1.14-3.657h-33.529l3.311-11.076h3.415l17.594-58.938 3.518-11.913h16.868l-1.76 5.956s4.449-3.239 8.797-4.39c4.243-1.148 28.665-1.566 28.665-1.566l-3.622 11.809h-5.795l0.103 0.103z"
        fill="#FEFEFE"
      />
      <path
        d="m534.59 270.79h18.006l0.207 6.792c-0.103 1.149 0.828 1.672 3.001 1.672h3.622l-3.311 11.183h-9.729c-8.382 0.627-11.59-3.03-11.383-7.106l-0.311-12.437-0.102-0.104zm2.216 53.2h-17.178l2.896-9.927h19.662l2.794-9.092h-19.351l3.311-11.182h53.812l-3.312 11.182h-18.109l-2.794 9.092h18.109l-3.002 9.927h-19.558l-3.518 4.18h7.968l1.966 12.54c0.207 1.254 0.207 2.09 0.62 2.613 0.415 0.418 2.795 0.627 4.14 0.627h2.38l-3.725 12.227h-6.106c-0.93 0-2.38-0.104-4.346-0.104-1.863-0.21-3.104-1.255-4.346-1.882-1.139-0.522-2.794-1.881-3.208-4.284l-1.863-12.54-8.899 12.331c-2.795 3.866-6.622 6.897-13.143 6.897h-12.418l3.311-10.869h4.761c1.346 0 2.588-0.521 3.52-1.045 0.931-0.418 1.758-0.836 2.586-2.193l13.04-18.498zm-187.9-27.2h45.429l-3.312 10.973h-18.109l-2.793 9.299h18.627l-3.415 11.287h-18.524l-4.553 15.152c-0.517 1.672 4.45 1.881 6.209 1.881l9.313-1.254-3.726 12.54h-20.904c-1.654 0-2.896-0.209-4.76-0.627-1.76-0.418-2.587-1.254-3.311-2.403-0.726-1.254-1.968-2.195-1.14-4.912l6.002-20.063h-10.348l3.415-11.495h10.348l2.794-9.3h-10.347l3.312-10.974-0.207-0.104zm31.387-19.835h18.627l-3.415 11.39h-25.457l-2.794 2.404c-1.242 1.15-1.552 0.732-3.105 1.568-1.447 0.73-4.449 2.193-8.382 2.193h-8.175l3.311-10.972h2.484c2.07 0 3.52-0.21 4.243-0.627 0.828-0.522 1.76-1.672 2.69-3.554l4.656-8.568h18.525l-3.208 6.27v-0.104zm35.107 18.81s5.07-4.701 13.764-6.164c1.966-0.418 14.384-0.211 14.384-0.211l1.863-6.27h-26.182l-3.83 12.75 1e-3 -0.105zm24.629 4.807h-25.975l-1.552 5.329h22.56c2.69-0.313 3.208 0.104 3.415-0.104l1.655-5.225h-0.103zm-33.735-29.678h15.833l-2.276 8.047s4.967-4.075 8.485-5.539c3.519-1.254 11.383-2.508 11.383-2.508l25.664-0.104-8.796 29.469c-1.449 5.016-3.208 8.256-4.243 9.823-0.93 1.463-2.07 2.821-4.346 4.075-2.173 1.15-4.141 1.881-6.002 1.986-1.656 0.104-4.347 0.209-7.865 0.209h-24.732l-6.934 23.303c-0.62 2.299-0.931 3.447-0.517 4.074 0.31 0.523 1.241 1.15 2.38 1.15l10.865-1.045-3.726 12.749h-12.21c-3.933 0-6.727-0.104-8.693-0.21-1.862-0.208-3.83 0-5.175-1.044-1.138-1.045-2.896-2.403-2.794-3.763 0.104-1.254 0.621-3.344 1.45-6.27l22.249-74.402z"
        fill="#FEFEFE"
      />
      <path
        d="m452.43 317.79l-1.449 7.105c-0.619 2.194-1.138 3.867-2.794 5.33-1.759 1.463-3.725 3.03-8.484 3.03l-8.796 0.418-0.104 7.942c-0.103 2.193 0.519 1.984 0.828 2.402 0.414 0.418 0.724 0.523 1.138 0.732l2.794-0.21 8.384-0.417-3.52 11.704h-9.624c-6.726 0-11.797-0.21-13.35-1.463-1.655-1.046-1.862-2.3-1.862-4.599l0.62-31.141h15.42l-0.207 6.374h3.725c1.242 0 2.175-0.104 2.691-0.418s0.828-0.836 1.035-1.567l1.552-5.016h12.108l-0.105-0.206zm-219.37-156c-0.517 2.508-10.451 48.592-10.451 48.592-2.174 9.3-3.726 15.989-8.9 20.273-3.001 2.508-6.52 3.657-10.555 3.657-6.52 0-10.245-3.239-10.866-9.404l-0.104-2.09s1.966-12.436 1.966-12.54c0 0 10.349-42.009 12.212-47.548 0.103-0.313 0.103-0.522 0.103-0.627-20.18 0.21-23.801 0-24.008-0.313-0.104 0.418-0.621 3.03-0.621 3.03l-10.556 47.34-0.932 3.97-1.758 13.168c0 3.866 0.724 7.105 2.277 9.718 4.863 8.569 18.627 9.823 26.388 9.823 10.038 0 19.455-2.195 25.767-6.061 11.073-6.584 13.97-16.929 16.454-26.02l1.242-4.703s10.659-43.576 12.522-49.219c0.103-0.314 0.103-0.523 0.207-0.627-14.695 0.104-18.938 0-20.387-0.314v-0.105zm59.03 86.623c-7.141-0.105-9.728-0.105-18.11 0.313l-0.311-0.627c0.724-3.24 1.552-6.374 2.173-9.614l1.035-4.389c1.552-6.792 3.001-14.839 3.208-17.242 0.207-1.463 0.62-5.12-3.519-5.12-1.759 0-3.518 0.835-5.38 1.671-1.036 3.658-3.002 13.899-4.037 18.497-2.07 9.823-2.173 10.972-3.104 15.78l-0.621 0.626c-7.347-0.104-9.934-0.104-18.42 0.314l-0.414-0.732c1.449-5.852 2.794-11.704 4.14-17.556 3.518-15.78 4.45-21.84 5.38-29.887l0.725-0.418c8.279-1.149 10.245-1.463 19.248-3.239l0.724 0.836-1.345 5.016c1.552-0.94 3.001-1.881 4.553-2.613 4.243-2.09 8.9-2.717 11.487-2.717 3.932 0 8.279 1.15 10.038 5.748 1.656 4.075 0.62 9.091-1.656 19.019l-1.138 5.016c-2.277 11.077-2.69 13.062-3.933 20.586l-0.827 0.627 0.104 0.105zm29.057 0.027c-4.346 0-7.14-0.104-9.83 0-2.691 0-5.278 0.21-9.314 0.314l-0.207-0.314-0.207-0.418c1.138-4.18 1.656-5.643 2.277-7.106 0.517-1.463 1.034-2.926 2.07-7.21 1.241-5.539 2.069-9.405 2.586-12.854 0.621-3.24 0.932-6.06 1.346-9.3l0.31-0.209 0.31-0.313c4.347-0.627 7.038-1.045 9.832-1.463s5.691-0.94 10.141-1.776l0.207 0.418 0.103 0.418-2.482 10.345c-0.828 3.449-1.656 6.897-2.38 10.346-1.554 7.315-2.277 10.032-2.587 12.017-0.414 1.881-0.519 2.822-1.14 6.584l-0.414 0.313-0.414 0.314-0.207-0.106zm45.942-25.675c-0.31 1.881-1.966 8.883-4.139 11.809-1.553 2.194-3.312 3.553-5.382 3.553-0.62 0-4.14 0-4.242-5.33 0-2.612 0.517-5.33 1.138-8.255 1.863-8.465 4.14-15.466 9.831-15.466 4.45 0 4.76 5.225 2.794 13.689zm18.73 0.836c2.483-11.077 0.518-16.302-1.862-19.437-3.726-4.807-10.348-6.374-17.178-6.374-4.141 0-13.867 0.418-21.525 7.524-5.484 5.12-8.071 12.122-9.52 18.81-1.554 6.792-3.312 19.019 7.864 23.617 3.414 1.463 8.382 1.88 11.59 1.88 8.176 0 16.558-2.298 22.87-8.986 4.863-5.434 7.036-13.585 7.864-17.034h-0.103zm174.43 26.08c-8.693-0.104-11.176-0.104-19.146 0.314l-0.517-0.627c2.173-8.256 4.346-16.616 6.312-24.976 2.483-10.868 3.104-15.466 3.933-21.84l0.62-0.522c8.59-1.254 10.97-1.567 19.973-3.239l0.207 0.731c-1.656 6.897-3.208 13.69-4.864 20.482-3.311 14.317-4.45 21.632-5.69 29.156l-0.828 0.627v-0.106z"
        fill="#FEFEFE"
      />
      <path
        d="m547.75 224.16c-0.414 1.776-2.07 8.882-4.243 11.808-1.449 2.09-4.967 3.449-6.933 3.449-0.621 0-4.036 0-4.243-5.225 0-2.613 0.517-5.33 1.138-8.256 1.863-8.255 4.141-15.257 9.831-15.257 4.45 0 6.416 5.12 4.45 13.585v-0.104zm17.075 0.836c2.482-11.077-7.658-0.94-9.21-4.598-2.484-5.748-0.933-17.243-10.866-21.109-3.829-1.568-12.832 0.418-20.49 7.524-5.381 5.016-8.072 12.017-9.52 18.705-1.554 6.688-3.312 19.02 7.76 23.304 3.52 1.567 6.727 1.985 9.935 1.776 11.178-0.627 19.662-17.661 25.976-24.349 4.861-5.329 5.69 1.986 6.415-1.253zm-129.94 23.413c-7.14-0.105-9.624-0.105-18.006 0.313l-0.311-0.627c0.725-3.24 1.553-6.374 2.276-9.614l0.931-4.389c1.554-6.792 3.105-14.839 3.208-17.242 0.207-1.463 0.621-5.12-3.415-5.12-1.759 0-3.62 0.835-5.38 1.671-0.932 3.658-3.002 13.899-4.037 18.497-1.966 9.823-2.173 10.972-3.104 15.78l-0.621 0.626c-7.347-0.104-9.934-0.104-18.42 0.314l-0.414-0.732c1.449-5.852 2.794-11.704 4.14-17.556 3.519-15.78 4.347-21.84 5.38-29.887l0.621-0.418c8.28-1.149 10.35-1.463 19.248-3.239l0.726 0.836-1.242 5.016c1.449-0.94 3.001-1.881 4.45-2.613 4.243-2.09 8.899-2.717 11.485-2.717 3.934 0 8.177 1.15 10.038 5.748 1.656 4.075 0.519 9.091-1.759 19.019l-1.138 5.016c-2.38 11.077-2.69 13.062-3.934 20.586l-0.826 0.627 0.104 0.105zm62.001-86.519l-6.002 0.105c-15.523 0.209-21.732 0.104-24.215-0.209-0.207 1.15-0.621 3.135-0.621 3.135s-5.588 25.916-5.588 26.02c0 0-13.246 55.176-13.867 57.788 13.556-0.209 19.041-0.209 21.421 0.105 0.519-2.613 3.622-17.974 3.726-17.974 0 0 2.69-11.286 2.795-11.704 0 0 0.826-1.15 1.654-1.672h1.242c11.694 0 24.836 0 35.186-7.628 7.036-5.225 11.797-13.063 13.97-22.468 0.517-2.299 0.931-5.016 0.931-7.837 0-3.658-0.724-7.21-2.794-10.032-5.279-7.42-15.731-7.524-27.838-7.629zm7.761 27.066c-1.241 5.747-4.967 10.659-9.727 12.958-3.933 1.985-8.693 2.194-13.66 2.194h-3.208l0.207-1.254s5.899-25.916 5.899-25.811l0.206-1.359 0.104-1.045 2.38 0.21s12.211 1.044 12.418 1.044c4.759 1.881 6.83 6.688 5.381 13.063zm127.21 8.666l-0.723-0.836c-8.797 1.776-10.453 2.09-18.525 3.24l-0.619 0.626c0 0.105-0.104 0.21-0.104 0.418v-0.104c-6.002 14.107-5.9 11.077-10.762 22.154 0-0.523 0-0.836-0.105-1.359l-1.242-24.035-0.723-0.836c-9.314 1.777-9.521 2.09-18.007 3.24l-0.621 0.627c-0.104 0.313-0.104 0.627-0.104 0.94l0.104 0.105c1.035 5.538 0.828 4.284 1.863 12.958 0.517 4.284 1.138 8.569 1.655 12.749 0.828 7.106 1.346 10.554 2.381 21.318-5.797 9.613-7.142 13.271-12.729 21.734l0.31 0.836c8.384-0.312 10.246-0.312 16.455-0.312l1.346-1.568c4.656-10.135 40.256-71.79 40.256-71.79l-0.106-0.105zm-302.72 6.922c4.76-3.344 5.38-7.942 1.345-10.345-4.036-2.404-11.176-1.672-15.937 1.672-4.76 3.24-5.277 7.837-1.241 10.345 3.932 2.3 11.072 1.672 15.833-1.672z"
        fill="#FEFEFE"
      />
      <path
        d="m590.33 270.9l-6.935 12.019c-2.173 4.075-6.312 7.21-12.728 7.21l-11.073-0.209 3.208-10.868h2.173c1.138 0 1.966-0.104 2.587-0.418 0.621-0.209 0.933-0.627 1.449-1.254l4.14-6.583h17.282l-0.103 0.103z"
        fill="#FEFEFE"
      />
    </svg>
  );
};

const DiscoverCardIcon = (props) => {
  return (
    <svg
      width="800px"
      height="800px"
      viewBox="0 -9 58 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <rect x="0.5" y="0.5" width="57" height="39" rx="3.5" fill="white" stroke="#F3F3F3" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.0689 20.3224C19.0689 22.7645 20.9865 24.658 23.4543 24.658C24.1518 24.658 24.7494 24.5209 25.4861 24.1739V22.2663C24.8384 22.9147 24.2644 23.1763 23.5297 23.1763C21.8975 23.1763 20.739 21.9928 20.739 20.3102C20.739 18.7152 21.9341 17.4569 23.4543 17.4569C24.2272 17.4569 24.8124 17.7327 25.4861 18.3916V16.485C24.7748 16.1242 24.19 15.9746 23.4925 15.9746C21.0372 15.9746 19.0689 17.9066 19.0689 20.3224ZM14.91 18.3046C14.91 18.7536 15.1954 18.9908 16.168 19.3507C18.0114 20.0251 18.5577 20.6224 18.5577 21.9426C18.5577 23.5508 17.3762 24.6707 15.6923 24.6707C14.459 24.6707 13.5622 24.1851 12.8156 23.0889L13.8626 22.0807C14.2356 22.8022 14.8583 23.189 15.6313 23.189C16.3545 23.189 16.8896 22.6902 16.8896 22.0171C16.8896 21.6682 16.7275 21.3687 16.4036 21.1572C16.2408 21.057 15.9179 20.9081 15.2833 20.684C13.7612 20.1364 13.2393 19.5503 13.2393 18.4057C13.2393 17.046 14.3605 16.0252 15.8306 16.0252C16.7416 16.0252 17.5752 16.3366 18.272 16.9461L17.424 18.0564C17.0019 17.5833 16.6026 17.3836 16.1173 17.3836C15.4188 17.3836 14.91 17.7814 14.91 18.3046ZM10.5846 24.4709H12.2053V16.1625H10.5846V24.4709ZM7.27202 22.4038C6.76294 22.8638 6.10138 23.0644 5.05432 23.0644H4.61938V17.57H5.05432C6.10138 17.57 6.73694 17.7575 7.27202 18.2422C7.83247 18.741 8.16951 19.5146 8.16951 20.3103C8.16951 21.108 7.83247 21.905 7.27202 22.4038ZM5.37884 16.1625H3V24.4706H5.36632C6.62459 24.4706 7.53299 24.174 8.33064 23.5115C9.27852 22.7274 9.83896 21.5452 9.83896 20.3225C9.83896 17.8705 8.00709 16.1625 5.37884 16.1625ZM36.1203 16.1625L38.3357 21.7432L40.5801 16.1625H42.3368L38.7476 24.6841H37.8754L34.3497 16.1625H36.1203ZM43.0697 24.4708H47.6656V23.0642H44.689V20.8215H47.5561V19.4142H44.689V17.5702H47.6656V16.1623H43.0697V24.4708ZM50.3576 19.9874H50.831C51.8662 19.9874 52.4148 19.5377 52.4148 18.7025C52.4148 17.894 51.8662 17.4712 50.8567 17.4712H50.3576V19.9874ZM51.1421 16.1622C53.0109 16.1622 54.0823 17.0597 54.0823 18.6152C54.0823 19.8873 53.4102 20.7225 52.1895 20.9706L54.8052 24.4707H52.8122L50.5691 21.133H50.3576V24.4707H48.7388V16.1622H51.1421Z"
        fill="#1D1D1B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.1585 22.7268C35.4738 20.67 34.8731 17.9376 32.8166 16.6224V16.6224C30.76 15.3072 28.0271 15.9076 26.7117 17.9644V17.9644C25.3967 20.0206 25.9977 22.7539 28.0542 24.0691V24.0691C30.1107 25.3843 32.8434 24.783 34.1585 22.7268Z"
        fill="url(#paint0_linear_545_4255)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_545_4255"
          x1="36.5397"
          y1="19.0034"
          x2="29.0929"
          y2="14.241"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#F6A000" />
          <stop offset="0.623918" stopColor="#E47E02" />
          <stop offset="1" stopColor="#D36002" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const MasterCardIcon = (props) => {
  return (
    <svg
      width="800px"
      height="800px"
      viewBox="0 -9 58 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <rect x="0.5" y="0.5" width="57" height="39" rx="3.5" fill="white" stroke="#F3F3F3" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.2489 30.8906V32.3674V33.8443H20.6016V33.4857C20.3963 33.7517 20.0848 33.9186 19.6614 33.9186C18.8266 33.9186 18.1722 33.27 18.1722 32.3674C18.1722 31.4656 18.8266 30.8163 19.6614 30.8163C20.0848 30.8163 20.3963 30.9832 20.6016 31.2492V30.8906H21.2489ZM19.7419 31.4218C19.1816 31.4218 18.8387 31.8483 18.8387 32.3674C18.8387 32.8866 19.1816 33.3131 19.7419 33.3131C20.2773 33.3131 20.6387 32.905 20.6387 32.3674C20.6387 31.8299 20.2773 31.4218 19.7419 31.4218ZM43.1228 32.3674C43.1228 31.8483 43.4657 31.4218 44.026 31.4218C44.5621 31.4218 44.9228 31.8299 44.9228 32.3674C44.9228 32.905 44.5621 33.3131 44.026 33.3131C43.4657 33.3131 43.1228 32.8866 43.1228 32.3674ZM45.5338 29.7044V32.3674V33.8443H44.8858V33.4857C44.6804 33.7517 44.3689 33.9186 43.9455 33.9186C43.1107 33.9186 42.4563 33.27 42.4563 32.3674C42.4563 31.4656 43.1107 30.8163 43.9455 30.8163C44.3689 30.8163 44.6804 30.9832 44.8858 31.2492V29.7044H45.5338ZM29.2838 31.3914C29.7008 31.3914 29.9688 31.6509 30.0373 32.1079H28.4925C28.5616 31.6814 28.8225 31.3914 29.2838 31.3914ZM27.8138 32.3674C27.8138 31.4465 28.424 30.8163 29.2966 30.8163C30.1307 30.8163 30.7038 31.4465 30.7102 32.3674C30.7102 32.4537 30.7038 32.5344 30.6974 32.6143H28.4868C28.5802 33.1462 28.9601 33.3379 29.3771 33.3379C29.6758 33.3379 29.9938 33.2261 30.2433 33.0288L30.5605 33.5048C30.1991 33.8075 29.7885 33.9186 29.3401 33.9186C28.449 33.9186 27.8138 33.3068 27.8138 32.3674ZM37.1126 32.3674C37.1126 31.8483 37.4555 31.4218 38.0158 31.4218C38.5511 31.4218 38.9126 31.8299 38.9126 32.3674C38.9126 32.905 38.5511 33.3131 38.0158 33.3131C37.4555 33.3131 37.1126 32.8866 37.1126 32.3674ZM39.5228 30.8906V32.3674V33.8443H38.8755V33.4857C38.6695 33.7517 38.3587 33.9186 37.9352 33.9186C37.1004 33.9186 36.446 33.27 36.446 32.3674C36.446 31.4656 37.1004 30.8163 37.9352 30.8163C38.3587 30.8163 38.6695 30.9832 38.8755 31.2492V30.8906H39.5228ZM33.4569 32.3674C33.4569 33.2636 34.0857 33.9186 35.0452 33.9186C35.4936 33.9186 35.7923 33.8196 36.116 33.5663L35.8051 33.0472C35.5621 33.2205 35.3068 33.3131 35.026 33.3131C34.5091 33.3068 34.1292 32.9361 34.1292 32.3674C34.1292 31.7988 34.5091 31.4281 35.026 31.4218C35.3068 31.4218 35.5621 31.5144 35.8051 31.6877L36.116 31.1685C35.7923 30.9153 35.4936 30.8163 35.0452 30.8163C34.0857 30.8163 33.4569 31.4713 33.4569 32.3674ZM41.0177 31.2492C41.1859 30.9896 41.429 30.8163 41.8026 30.8163C41.9337 30.8163 42.1205 30.8411 42.2638 30.8969L42.0642 31.5024C41.9273 31.4465 41.7904 31.4281 41.6593 31.4281C41.2358 31.4281 41.0241 31.6997 41.0241 32.1885V33.8443H40.3761V30.8906H41.0177V31.2492ZM24.4505 31.1254C24.1389 30.9217 23.7098 30.8163 23.2364 30.8163C22.4822 30.8163 21.9967 31.1749 21.9967 31.762C21.9967 32.2437 22.3582 32.5407 23.024 32.6334L23.3298 32.6765C23.6848 32.7261 23.8524 32.8187 23.8524 32.9856C23.8524 33.2141 23.6157 33.3442 23.1737 33.3442C22.7253 33.3442 22.4017 33.2021 22.1835 33.0351L21.8784 33.5352C22.2334 33.7948 22.6818 33.9186 23.1673 33.9186C24.027 33.9186 24.5253 33.5168 24.5253 32.9545C24.5253 32.4353 24.1332 32.1637 23.4852 32.0711L23.1801 32.0272C22.9 31.9904 22.6754 31.9353 22.6754 31.7372C22.6754 31.5208 22.8871 31.3914 23.2421 31.3914C23.6221 31.3914 23.9899 31.5335 24.1703 31.6446L24.4505 31.1254ZM32.0184 31.2492C32.1859 30.9896 32.429 30.8163 32.8025 30.8163C32.9337 30.8163 33.1205 30.8411 33.2637 30.8969L33.0641 31.5024C32.9273 31.4465 32.7904 31.4281 32.6592 31.4281C32.2358 31.4281 32.0241 31.6997 32.0241 32.1885V33.8443H31.3768V30.8906H32.0184V31.2492ZM27.2784 30.8906H26.2198V29.9944H25.5654V30.8906H24.9616V31.4776H25.5654V32.8251C25.5654 33.5105 25.8334 33.9186 26.5991 33.9186C26.8799 33.9186 27.2036 33.8323 27.4089 33.6901L27.2221 33.1398C27.0289 33.2509 26.8172 33.3068 26.649 33.3068C26.3253 33.3068 26.2198 33.1087 26.2198 32.8123V31.4776H27.2784V30.8906ZM17.5997 31.9904V33.8443H16.9453V32.2005C16.9453 31.6997 16.7336 31.4218 16.2916 31.4218C15.8617 31.4218 15.563 31.6941 15.563 32.2069V33.8443H14.9086V32.2005C14.9086 31.6997 14.6912 31.4218 14.2613 31.4218C13.8186 31.4218 13.5321 31.6941 13.5321 32.2069V33.8443H12.8784V30.8906H13.5264V31.2548C13.7695 30.909 14.0803 30.8163 14.3982 30.8163C14.853 30.8163 15.1767 31.0144 15.382 31.3418C15.6564 30.9274 16.0485 30.8099 16.4285 30.8163C17.1513 30.8227 17.5997 31.2923 17.5997 31.9904Z"
        fill="#231F20"
      />
      <path d="M34.0465 25.8715H24.2359V8.3783H34.0465V25.8715Z" fill="#FF5F00" />
      <path
        d="M24.8583 17.1253C24.8583 13.5767 26.5328 10.4157 29.1405 8.37867C27.2336 6.88907 24.8269 5.99998 22.2114 5.99998C16.0194 5.99998 11 10.9809 11 17.1253C11 23.2697 16.0194 28.2506 22.2114 28.2506C24.8269 28.2506 27.2336 27.3615 29.1405 25.8719C26.5328 23.8349 24.8583 20.6739 24.8583 17.1253"
        fill="#EB001B"
      />
      <path
        d="M47.2818 17.1253C47.2818 23.2697 42.2624 28.2506 36.0704 28.2506C33.4548 28.2506 31.0482 27.3615 29.1405 25.8719C31.7489 23.8349 33.4235 20.6739 33.4235 17.1253C33.4235 13.5767 31.7489 10.4157 29.1405 8.37867C31.0482 6.88907 33.4548 5.99998 36.0704 5.99998C42.2624 5.99998 47.2818 10.9809 47.2818 17.1253"
        fill="#F79E1B"
      />
    </svg>
  );
};

const AmexCardIcon = (props) => {
  return (
    <svg
      width="800px"
      height="800px"
      viewBox="0 -9 58 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <rect x="0.5" y="0.5" width="57" height="39" rx="3.5" fill="#006FCF" stroke="#F3F3F3" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.8632 28.8937V20.6592H21.1869L22.1872 21.8787L23.2206 20.6592H57.0632V28.3258C57.0632 28.3258 56.1782 28.8855 55.1546 28.8937H36.4152L35.2874 27.5957V28.8937H31.5916V26.6779C31.5916 26.6779 31.0867 26.9872 29.9953 26.9872H28.7373V28.8937H23.1415L22.1426 27.6481L21.1284 28.8937H11.8632ZM1 14.4529L3.09775 9.86914H6.7256L7.9161 12.4368V9.86914H12.4258L13.1346 11.7249L13.8216 9.86914H34.0657V10.8021C34.0657 10.8021 35.1299 9.86914 36.8789 9.86914L43.4474 9.89066L44.6173 12.4247V9.86914H48.3913L49.43 11.3247V9.86914H53.2386V18.1037H49.43L48.4346 16.6434V18.1037H42.8898L42.3321 16.8056H40.8415L40.293 18.1037H36.5327C35.0277 18.1037 34.0657 17.1897 34.0657 17.1897V18.1037H28.3961L27.2708 16.8056V18.1037H6.18816L5.63093 16.8056H4.14505L3.59176 18.1037H1V14.4529ZM1.01082 17.05L3.84023 10.8843H5.98528L8.81199 17.05H6.92932L6.40997 15.8154H3.37498L2.85291 17.05H1.01082ZM5.81217 14.4768L4.88706 12.3192L3.95925 14.4768H5.81217ZM9.00675 17.049V10.8832L11.6245 10.8924L13.147 14.8676L14.6331 10.8832H17.2299V17.049H15.5853V12.5058L13.8419 17.049H12.3996L10.6514 12.5058V17.049H9.00675ZM18.3552 17.049V10.8832H23.7219V12.2624H20.0171V13.3171H23.6353V14.6151H20.0171V15.7104H23.7219V17.049H18.3552ZM24.674 17.05V10.8843H28.3339C29.5465 10.8843 30.6331 11.5871 30.6331 12.8846C30.6331 13.9938 29.717 14.7082 28.8289 14.7784L30.9929 17.05H28.9831L27.0111 14.8596H26.3186V17.05H24.674ZM28.1986 12.2635H26.3186V13.5615H28.223C28.5526 13.5615 28.9776 13.3221 28.9776 12.9125C28.9776 12.5941 28.6496 12.2635 28.1986 12.2635ZM32.9837 17.049H31.3045V10.8832H32.9837V17.049ZM36.9655 17.049H36.603C34.8492 17.049 33.7844 15.754 33.7844 13.9915C33.7844 12.1854 34.8373 10.8832 37.052 10.8832H38.8698V12.3436H36.9856C36.0865 12.3436 35.4507 13.0012 35.4507 14.0067C35.4507 15.2008 36.1777 15.7023 37.2251 15.7023H37.6579L36.9655 17.049ZM37.7147 17.05L40.5441 10.8843H42.6892L45.5159 17.05H43.6332L43.1139 15.8154H40.0789L39.5568 17.05H37.7147ZM42.5161 14.4768L41.591 12.3192L40.6632 14.4768H42.5161ZM45.708 17.049V10.8832H47.7989L50.4687 14.7571V10.8832H52.1134V17.049H50.09L47.3526 13.0737V17.049H45.708ZM12.9885 27.8391V21.6733H18.3552V23.0525H14.6504V24.1072H18.2686V25.4052H14.6504V26.5005H18.3552V27.8391H12.9885ZM39.2853 27.8391V21.6733H44.6519V23.0525H40.9472V24.1072H44.5481V25.4052H40.9472V26.5005H44.6519V27.8391H39.2853ZM18.5635 27.8391L21.1765 24.7942L18.5012 21.6733H20.5733L22.1665 23.6026L23.7651 21.6733H25.756L23.1159 24.7562L25.7338 27.8391H23.6621L22.1151 25.9402L20.6057 27.8391H18.5635ZM25.9291 27.8401V21.6744H29.5619C31.0525 21.6744 31.9234 22.5748 31.9234 23.7482C31.9234 25.1647 30.8131 25.893 29.3482 25.893H27.617V27.8401H25.9291ZM29.4402 23.0687H27.617V24.4885H29.4348C29.9151 24.4885 30.2517 24.1901 30.2517 23.7786C30.2517 23.3406 29.9134 23.0687 29.4402 23.0687ZM32.6375 27.8391V21.6733H36.2973C37.51 21.6733 38.5966 22.3761 38.5966 23.6736C38.5966 24.7828 37.6805 25.4972 36.7923 25.5675L38.9563 27.8391H36.9465L34.9746 25.6486H34.2821V27.8391H32.6375ZM36.1621 23.0525H34.2821V24.3505H36.1864C36.5161 24.3505 36.9411 24.1112 36.9411 23.7015C36.9411 23.3831 36.6131 23.0525 36.1621 23.0525ZM45.4137 27.8391V26.5005H48.7051C49.1921 26.5005 49.403 26.2538 49.403 25.9833C49.403 25.7241 49.1928 25.462 48.7051 25.462H47.2177C45.9249 25.462 45.2048 24.7237 45.2048 23.6153C45.2048 22.6267 45.8642 21.6733 47.7854 21.6733H50.9881L50.2956 23.0606H47.5257C46.9962 23.0606 46.8332 23.321 46.8332 23.5697C46.8332 23.8253 47.0347 24.1072 47.4392 24.1072H48.9972C50.4384 24.1072 51.0638 24.8734 51.0638 25.8768C51.0638 26.9555 50.367 27.8391 48.9188 27.8391H45.4137ZM51.2088 27.8391V26.5005H54.5002C54.9873 26.5005 55.1981 26.2538 55.1981 25.9833C55.1981 25.7241 54.9879 25.462 54.5002 25.462H53.0129C51.72 25.462 51 24.7237 51 23.6153C51 22.6267 51.6594 21.6733 53.5806 21.6733H56.7833L56.0908 23.0606H53.3209C52.7914 23.0606 52.6284 23.321 52.6284 23.5697C52.6284 23.8253 52.8298 24.1072 53.2343 24.1072H54.7924C56.2336 24.1072 56.859 24.8734 56.859 25.8768C56.859 26.9555 56.1621 27.8391 54.7139 27.8391H51.2088Z"
        fill="white"
      />
    </svg>
  );
};

const VisaCardIcon = (props) => {
  return (
    <svg
      width="800px"
      height="800px"
      viewBox="0 0 192.756 192.756"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g fillRule="evenodd" clipRule="evenodd">
        <path fill="#ffffff" d="M0 0h192.756v192.756H0V0z" />
        <path
          d="M189.922 50.809c0-8.986-4.67-13.444-13.729-13.444H16.562c-4.528 0-7.854 1.203-10.048 3.679-2.476 2.477-3.68 5.661-3.68 9.765v91.138c0 4.104 1.204 7.217 3.68 9.764 2.548 2.477 5.803 3.68 10.048 3.68h159.631c9.059 0 13.729-4.527 13.729-13.443V50.809zm-13.729-11.321c7.5 0 11.322 3.821 11.322 11.321v91.138c0 7.57-3.822 11.32-11.322 11.32H16.562c-3.609 0-6.368-1.061-8.42-3.184-2.123-2.053-3.184-4.883-3.184-8.137V50.809c0-7.5 3.75-11.321 11.604-11.321h159.631z"
          fill="#315881"
        />
        <path
          d="M17.835 44.724c-3.042 0-4.953.495-6.014 1.557-.92 1.203-1.344 3.184-1.344 6.085v19.741h171.802V52.366c0-5.165-2.549-7.642-7.643-7.642H17.835z"
          fill="#315881"
        />
        <path
          d="M10.477 140.107c0 5.234 2.476 7.924 7.358 7.924h156.801c5.094 0 7.643-2.689 7.643-7.924v-19.742H10.477v19.742z"
          fill="#dfa43b"
        />
        <path
          d="M67.367 80.528c0 .92-.142 1.627-.495 2.123l-12.383 21.582-.779-26.323H33.898l6.651 3.184c1.91 1.203 2.901 2.759 2.901 4.741l1.839 27.951h9.694l23.21-35.876H66.306c.707.637 1.061 1.627 1.061 2.618zM147.467 78.971l.777-1.062h-12.1c.424.424.566.637.566.778-.143.565-.426.92-.566 1.344l-17.619 32.124c-.424.566-.85 1.062-1.344 1.629h9.977l-.496-1.062c0-.92.496-2.617 1.557-5.023l2.123-3.963h10.26c.426 3.326.709 6.086.85 8.139l-.85 1.91h12.383l-1.84-2.689-3.678-32.125zm-7.36 19.742h-7.359l6.297-12.1 1.062 12.1zM109.539 76.07c-3.82 0-7.076 1.062-9.977 3.184-3.185 1.84-4.741 4.175-4.741 7.077 0 3.326 1.132 6.227 3.396 8.42l6.865 4.74c2.477 1.77 3.68 3.326 3.68 4.742 0 1.344-.639 2.547-1.84 3.467-1.203.92-2.549 1.344-4.246 1.344-2.477 0-6.722-1.768-12.595-5.023v6.58c4.599 2.76 9.058 4.176 13.373 4.176 4.105 0 7.572-1.133 10.545-3.68 3.184-2.336 4.74-5.094 4.74-8.137 0-2.549-1.133-4.883-3.68-7.36l-6.582-4.741c-2.191-1.769-3.395-3.326-3.395-4.528 0-2.759 1.627-4.175 4.953-4.175 2.264 0 5.59 1.274 10.047 3.963l1.346-6.864c-3.752-2.124-7.643-3.185-11.889-3.185zM83.217 113.785c-.142-1.486-.425-2.83-.567-4.246l8.987-29.011 2.123-2.618H80.811c.142.637.283 1.486.425 2.123 0 .637 0 1.416-.142 2.123l-8.986 28.728-1.84 2.902h12.949v-.001z"
          fill="#315881"
        />
      </g>
    </svg>
  );
};

const DinersClubCardIcon = (props) => {
  return (
    <svg
      width="800px"
      height="800px"
      viewBox="0 -9 58 58"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <rect x="0.5" y="0.5" width="57" height="39" rx="3.5" fill="white" stroke="#F3F3F3" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.83219 24.2047C8.83219 23.4203 8.42237 23.4718 8.03033 23.4636V23.2368C8.37026 23.2533 8.71882 23.2533 9.05965 23.2533C9.42581 23.2533 9.92294 23.2368 10.5688 23.2368C12.8276 23.2368 14.058 24.7451 14.058 26.2897C14.058 27.1541 13.552 29.3255 10.4639 29.3255C10.0194 29.3255 9.60889 29.3083 9.19907 29.3083C8.80685 29.3083 8.42237 29.3164 8.03033 29.3255V29.0986C8.55316 29.0458 8.80685 29.0287 8.83219 28.4357V24.2047ZM9.68704 28.2957C9.68704 28.9676 10.1673 29.0458 10.5945 29.0458C12.4792 29.0458 13.0977 27.6243 13.0977 26.3247C13.0977 24.6936 12.0511 23.5162 10.3678 23.5162C10.0094 23.5162 9.84443 23.5417 9.68704 23.5511V28.2957Z"
        fill="#1A1919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3636 29.0987H14.5289C14.7731 29.0987 14.9477 29.0987 14.9477 28.8102V26.4465C14.9477 26.0633 14.8171 26.0103 14.4939 25.8363V25.6971C14.9039 25.5738 15.3928 25.4093 15.4273 25.383C15.4887 25.348 15.5403 25.3387 15.5847 25.3387C15.6274 25.3387 15.6454 25.3911 15.6454 25.4616V28.8102C15.6454 29.0987 15.8376 29.0987 16.0822 29.0987H16.2298V29.3256C15.9332 29.3256 15.6274 29.3084 15.3144 29.3084C15.0004 29.3084 14.6861 29.3165 14.3636 29.3256V29.0987ZM15.2968 23.9958C15.0696 23.9958 14.8694 23.7865 14.8694 23.5598C14.8694 23.3413 15.0791 23.1403 15.2968 23.1403C15.5232 23.1403 15.7244 23.3241 15.7244 23.5598C15.7244 23.7957 15.532 23.9958 15.2968 23.9958Z"
        fill="#1A1919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0588 26.4989C17.0588 26.1768 16.9625 26.0896 16.5532 25.9236V25.758C16.9276 25.636 17.285 25.5221 17.7042 25.3386C17.7306 25.3386 17.7559 25.3561 17.7559 25.4258V25.993C18.2539 25.636 18.6814 25.3386 19.2667 25.3386C20.0071 25.3386 20.2687 25.8796 20.2687 26.56V28.8101C20.2687 29.0987 20.4612 29.0987 20.7051 29.0987H20.8625V29.3256C20.5562 29.3256 20.2513 29.3084 19.9376 29.3084C19.6234 29.3084 19.3091 29.3164 18.9951 29.3256V29.0987H19.1525C19.3968 29.0987 19.5705 29.0987 19.5705 28.8101V26.5519C19.5705 26.0541 19.2667 25.8101 18.7689 25.8101C18.4895 25.8101 18.0446 26.0364 17.7559 26.2292V28.8101C17.7559 29.0987 17.9487 29.0987 18.193 29.0987H18.3497V29.3256C18.0446 29.3256 17.7392 29.3084 17.4246 29.3084C17.1113 29.3084 16.7969 29.3164 16.4832 29.3256V29.0987H16.6405C16.8845 29.0987 17.0588 29.0987 17.0588 28.8101V26.4989"
        fill="#1A1919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.5255 26.9183C21.5077 26.9968 21.5077 27.1274 21.5255 27.4242C21.5769 28.2526 22.1102 28.9327 22.8073 28.9327C23.2877 28.9327 23.663 28.6709 23.9852 28.3488L24.107 28.4709C23.7056 29.0029 23.2086 29.4568 22.4939 29.4568C21.1065 29.4568 20.8275 28.1127 20.8275 27.5548C20.8275 25.8449 21.9786 25.3386 22.5886 25.3386C23.296 25.3386 24.0554 25.7835 24.0635 26.7084C24.0635 26.7614 24.0635 26.8131 24.0554 26.8656L23.9765 26.9183H21.5255ZM23.0701 26.6389C23.2877 26.6389 23.3132 26.5253 23.3132 26.4202C23.3132 25.9761 23.043 25.6184 22.5543 25.6184C22.0227 25.6184 21.6561 26.0102 21.5516 26.6389H23.0701Z"
        fill="#1A1919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.2645 29.0987H24.5002C24.7435 29.0987 24.9182 29.0987 24.9182 28.8101V26.3595C24.9182 26.0896 24.5957 26.0364 24.4647 25.9667V25.8363C25.1014 25.5657 25.4505 25.3386 25.5303 25.3386C25.5813 25.3386 25.6075 25.3649 25.6075 25.4525V26.2377H25.6259C25.8433 25.8976 26.2103 25.3386 26.7421 25.3386C26.9601 25.3386 27.2389 25.4868 27.2389 25.8011C27.2389 26.0364 27.074 26.2468 26.8298 26.2468C26.5585 26.2468 26.5585 26.0364 26.2529 26.0364C26.1049 26.0364 25.6163 26.2377 25.6163 26.7614V28.8101C25.6163 29.0987 25.7906 29.0987 26.035 29.0987H26.5229V29.3256C26.0432 29.3164 25.6781 29.3084 25.3026 29.3084C24.9449 29.3084 24.5784 29.3164 24.2645 29.3256V29.0987"
        fill="#1A1919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.6225 28.1126C27.7362 28.6883 28.0844 29.1775 28.7224 29.1775C29.2362 29.1775 29.428 28.8631 29.428 28.558C29.428 27.5282 27.5269 27.86 27.5269 26.4557C27.5269 25.9667 27.9197 25.3387 28.8793 25.3387C29.1579 25.3387 29.5329 25.4178 29.8728 25.5924L29.9341 26.4814H29.7336C29.6464 25.9322 29.3415 25.6183 28.7826 25.6183C28.4337 25.6183 28.1026 25.8186 28.1026 26.1938C28.1026 27.215 30.1258 26.9004 30.1258 28.27C30.1258 28.8453 29.664 29.4567 28.6256 29.4567C28.277 29.4567 27.8663 29.3344 27.5619 29.1599L27.4655 28.1566L27.6225 28.1126"
        fill="#1A1919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.0025 24.8152H37.785C37.619 23.7956 36.8949 23.3851 35.9186 23.3851C34.9143 23.3851 33.4581 24.0563 33.4581 26.1498C33.4581 27.9125 34.7146 29.1775 36.0576 29.1775C36.9204 29.1775 37.6373 28.5841 37.8114 27.6676L38.0121 27.7197L37.8114 28.9937C37.445 29.2208 36.459 29.4567 35.8827 29.4567C33.8424 29.4567 32.5515 28.1393 32.5515 26.1767C32.5515 24.388 34.1478 23.1053 35.8575 23.1053C36.5638 23.1053 37.244 23.3328 37.9158 23.5685L38.0025 24.8152"
        fill="#1A1919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.3175 29.0987H38.4826C38.7277 29.0987 38.9018 29.0987 38.9018 28.8102V23.9527C38.9018 23.3851 38.7712 23.3679 38.4393 23.2717V23.132C38.7881 23.0188 39.1548 22.8621 39.3384 22.7566C39.4331 22.7051 39.5035 22.6605 39.5292 22.6605C39.5825 22.6605 39.5998 22.7135 39.5998 22.7836V28.8102C39.5998 29.0987 39.7919 29.0987 40.0358 29.0987H40.1835V29.3256C39.8878 29.3256 39.5825 29.3084 39.2683 29.3084C38.9544 29.3084 38.6407 29.3165 38.3175 29.3256V29.0987"
        fill="#1A1919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.9183 28.8453C43.9183 29.0029 44.0137 29.0111 44.1616 29.0111C44.2668 29.0111 44.3971 29.0029 44.5114 29.0029V29.1865C44.136 29.221 43.4204 29.4043 43.2544 29.4567L43.2109 29.4301V28.7235C42.6881 29.1507 42.2864 29.4567 41.6662 29.4567C41.1953 29.4567 40.7071 29.1507 40.7071 28.419V26.1852C40.7071 25.9581 40.6724 25.74 40.1846 25.697V25.5308C40.4989 25.5222 41.1953 25.4701 41.309 25.4701C41.4058 25.4701 41.4058 25.5308 41.4058 25.7231V27.9734C41.4058 28.2353 41.4058 28.9847 42.1646 28.9847C42.4606 28.9847 42.8532 28.7585 43.2194 28.4536V26.1065C43.2194 25.9322 42.8009 25.8363 42.4874 25.7495V25.5926C43.2717 25.5394 43.7607 25.4701 43.8479 25.4701C43.9183 25.4701 43.9183 25.5308 43.9183 25.6271V28.8453"
        fill="#1A1919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.6536 25.9668C46.0024 25.6708 46.4736 25.3386 46.9533 25.3386C47.9654 25.3386 48.5761 26.2206 48.5761 27.1712C48.5761 28.3136 47.7383 29.4568 46.4903 29.4568C45.8455 29.4568 45.5052 29.2467 45.278 29.1508L45.0171 29.3515L44.8342 29.2559C44.9122 28.7413 44.9562 28.2354 44.9562 27.703V23.9527C44.9562 23.3851 44.8248 23.3679 44.4933 23.2717V23.132C44.8426 23.0188 45.2086 22.8621 45.3917 22.7566C45.488 22.7051 45.5575 22.6605 45.5841 22.6605C45.636 22.6605 45.6536 22.7137 45.6536 22.7836V25.9668ZM45.6536 28.3396C45.6536 28.6709 45.9679 29.2297 46.5521 29.2297C47.4853 29.2297 47.8777 28.3136 47.8777 27.5369C47.8777 26.595 47.1632 25.8101 46.483 25.8101C46.1589 25.8101 45.889 26.0198 45.6536 26.2206V28.3396Z"
        fill="#1A1919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7292 33.6048L12.7387 33.5954V31.816C12.7387 31.4265 12.4678 31.3695 12.3255 31.3695H12.2209V31.2271C12.4444 31.2271 12.6627 31.2459 12.8855 31.2459C13.0801 31.2459 13.2755 31.2271 13.4694 31.2271V31.3695H13.3988C13.1988 31.3695 12.9757 31.4074 12.9757 31.9723V34.1319C12.9757 34.2983 12.9804 34.4643 13.0037 34.6116H12.8233L10.3793 31.8866V33.8426C10.3793 34.2559 10.4596 34.3976 10.8251 34.3976H10.9059V34.5403C10.7018 34.5403 10.4979 34.5218 10.2938 34.5218C10.0807 34.5218 9.86206 34.5403 9.64825 34.5403V34.3976H9.71491C10.0423 34.3976 10.142 34.1745 10.142 33.7959V31.7961C10.142 31.5305 9.92296 31.3695 9.71024 31.3695H9.64825V31.2271C9.82828 31.2271 10.0137 31.2459 10.1937 31.2459C10.3366 31.2459 10.4742 31.2271 10.6165 31.2271L12.7292 33.6048"
        fill="#1A1919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0037 34.6315L12.8083 34.6248L10.3995 31.9401V33.8425C10.4052 34.2552 10.4679 34.3726 10.8253 34.3771H10.927V34.5605H10.9059C10.7006 34.5605 10.4963 34.5415 10.2938 34.5415C10.0813 34.5415 9.86316 34.5605 9.6481 34.5605H9.62726V34.3771H9.71494C10.0286 34.3753 10.1183 34.1737 10.1217 33.7957V31.7967C10.1208 31.5439 9.91347 31.3901 9.71044 31.3901H9.62726V31.2063H9.6481C9.82956 31.2063 10.0153 31.2248 10.1934 31.2248C10.335 31.2248 10.4721 31.2063 10.6321 31.2137L12.7181 33.5617V31.8159C12.7157 31.439 12.4638 31.3932 12.3257 31.3901H12.2001V31.2063H12.2211C12.4453 31.2063 12.6638 31.2248 12.8855 31.2248C13.0787 31.2248 13.2732 31.2063 13.4694 31.2063H13.4903V31.3901H13.3988C13.2028 31.3951 13.0018 31.4124 12.996 31.9722V34.1318C12.996 34.298 13.0012 34.4637 13.024 34.6077L13.0284 34.6315H13.0037ZM12.8235 34.5901H12.9806C12.9594 34.4473 12.9556 34.2897 12.9556 34.1318V31.9722C12.9556 31.4025 13.1944 31.3488 13.3988 31.3484H13.4488V31.2474C13.2617 31.2489 13.0743 31.2661 12.8855 31.2661C12.6681 31.2661 12.4568 31.2489 12.2423 31.2474L12.2418 31.3484H12.3257C12.4716 31.3488 12.7592 31.4136 12.7592 31.8159L12.7529 33.6102L12.7436 33.6194L12.7274 33.6347L10.6165 31.2474C10.4755 31.2474 10.3382 31.2661 10.1934 31.2661C10.0195 31.2661 9.84124 31.2489 9.66912 31.2474L9.66822 31.3484H9.71044C9.93305 31.3488 10.1621 31.5187 10.1621 31.7967V33.7957C10.1621 34.1755 10.0563 34.418 9.71494 34.4193L9.66912 34.418V34.5199C9.87466 34.5183 10.0865 34.5008 10.2938 34.5008C10.4918 34.5008 10.6894 34.5183 10.8853 34.5199V34.4193H10.8253C10.4517 34.418 10.3592 34.2552 10.3589 33.8425V31.8333L12.8235 34.5901ZM12.7294 33.6047L12.7443 33.591L12.7294 33.6047ZM12.7181 33.5953V33.5935L12.7143 33.5905L12.7181 33.5953Z"
        fill="#1A1919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1807 31.4643C13.8243 31.4643 13.8104 31.5502 13.7393 31.8962H13.5968C13.6155 31.7633 13.639 31.6305 13.6538 31.4929C13.6728 31.3594 13.6823 31.227 13.6823 31.0897H13.7961C13.8343 31.2322 13.9529 31.227 14.0817 31.227H16.5299C16.6587 31.227 16.7771 31.2223 16.7868 31.0798L16.9002 31.0992C16.8818 31.227 16.8624 31.3553 16.8486 31.4837C16.8392 31.6118 16.8392 31.7396 16.8392 31.8677L16.6966 31.9205C16.6869 31.7451 16.6634 31.4643 16.3453 31.4643H15.5668V33.9895C15.5668 34.3557 15.7332 34.3976 15.9607 34.3976H16.0512V34.5402C15.866 34.5402 15.5336 34.5219 15.2778 34.5219C14.9926 34.5219 14.6601 34.5402 14.4748 34.5402V34.3976H14.5654C14.827 34.3976 14.9592 34.3742 14.9592 33.9994V31.4643H14.1807"
        fill="#1A1919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.0516 34.5605C15.8645 34.5605 15.5325 34.5417 15.2777 34.5417C14.993 34.5417 14.6609 34.5605 14.4748 34.5605H14.4545V34.3771H14.5654C14.827 34.371 14.9321 34.3676 14.938 33.9994V31.4847H14.1807V31.4431H14.9791V33.9994C14.9791 34.3805 14.8255 34.419 14.5654 34.4193H14.4951V34.5196C14.6823 34.5183 15.0021 34.5009 15.2777 34.5009C15.5248 34.5009 15.8419 34.5183 16.03 34.5196V34.4193H15.9607C15.731 34.419 15.5463 34.3626 15.5463 33.9896V31.4431H16.3453C16.6637 31.4444 16.7059 31.715 16.7158 31.8916L16.8186 31.8537C16.8186 31.7297 16.8191 31.6056 16.8275 31.4809C16.8416 31.3582 16.8588 31.2376 16.8766 31.116L16.8045 31.1039C16.7824 31.2421 16.6486 31.2495 16.5297 31.2477H14.0569C13.9451 31.2478 13.8235 31.2425 13.7808 31.11H13.7024C13.7017 31.2412 13.6927 31.3686 13.6748 31.4951C13.6606 31.6255 13.6388 31.7507 13.6216 31.8765H13.7229C13.7852 31.5454 13.8259 31.4385 14.1807 31.4431V31.4847C13.8291 31.4917 13.8368 31.5504 13.7594 31.9011L13.756 31.9173H13.5731L13.5756 31.8927C13.595 31.7603 13.6191 31.6269 13.6329 31.4891C13.6527 31.3574 13.6616 31.2258 13.6616 31.0897V31.0687H13.8124L13.816 31.0836C13.8479 31.2033 13.9358 31.2042 14.0569 31.2063H16.5297C16.6619 31.2042 16.7582 31.2024 16.7663 31.0782L16.7679 31.0558L16.7895 31.0601L16.9237 31.0813L16.9203 31.1023C16.9014 31.2297 16.8829 31.3574 16.8685 31.4847C16.8597 31.6119 16.8597 31.7394 16.8597 31.8677V31.8821L16.8459 31.8876L16.6779 31.9491L16.6768 31.9216C16.6637 31.743 16.6454 31.4847 16.3453 31.4847H15.5877V33.9896C15.5923 34.3475 15.7343 34.3726 15.9607 34.3771H16.0717V34.5605H16.0516"
        fill="#1A1919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0518 34.3976H17.1187C17.289 34.3976 17.4699 34.3743 17.4699 34.1272V31.6406C17.4699 31.3932 17.289 31.3697 17.1187 31.3697H17.0518V31.2271C17.3404 31.2271 17.8352 31.2459 18.2331 31.2459C18.6325 31.2459 19.1255 31.2271 19.4482 31.2271C19.4399 31.4312 19.4444 31.7452 19.4585 31.9536L19.3154 31.9914C19.2926 31.6827 19.2357 31.4365 18.7371 31.4365H18.0781V32.6793H18.6419C18.9266 32.6793 18.9886 32.5185 19.0168 32.2619H19.1591C19.1496 32.4473 19.1446 32.6324 19.1446 32.8173C19.1446 32.998 19.1496 33.1782 19.1591 33.3583L19.0168 33.3866C18.9886 33.1022 18.9744 32.9172 18.6465 32.9172H18.0781V34.0225C18.0781 34.3315 18.3522 34.3315 18.6562 34.3315C19.226 34.3315 19.4773 34.2932 19.6198 33.7528L19.7522 33.7855C19.6906 34.0376 19.634 34.2884 19.5914 34.5403C19.2872 34.5403 18.7414 34.522 18.3151 34.522C17.8869 34.522 17.3226 34.5403 17.0518 34.5403V34.3976"
        fill="#1A1919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.591 34.5605C19.2865 34.5605 18.7403 34.5407 18.3145 34.5407C17.8869 34.5407 17.3227 34.5605 17.0516 34.5605H17.0317V34.3771H17.1185C17.2902 34.3742 17.4465 34.3591 17.4487 34.1271V31.6406C17.4465 31.4086 17.2902 31.3932 17.1185 31.3901H17.0317V31.2063H17.0516C17.3416 31.2063 17.8353 31.2248 18.2331 31.2248C18.6321 31.2248 19.125 31.2063 19.4482 31.2063H19.4692L19.4685 31.2282C19.4654 31.2992 19.4635 31.3836 19.4635 31.4729C19.4635 31.637 19.4685 31.8168 19.4778 31.9519L19.4787 31.9688L19.4627 31.9737L19.2958 32.0173L19.2951 31.9929C19.2671 31.6849 19.2258 31.4609 18.7371 31.4562H18.0973L18.0969 32.6584H18.6417C18.9153 32.6555 18.9642 32.5157 18.9965 32.2597L18.9976 32.2406H19.1801L19.1798 32.2624C19.1706 32.4478 19.165 32.6323 19.165 32.8172C19.165 32.9967 19.1706 33.1769 19.1798 33.3573L19.1801 33.3745L19.1629 33.3785L18.9976 33.4113L18.9965 33.3891C18.9636 33.0993 18.9615 32.9404 18.6465 32.937H18.0973V34.0224C18.098 34.3109 18.3467 34.3093 18.656 34.3109C19.2276 34.3075 19.4565 34.2795 19.5995 33.7471L19.6043 33.7279L19.6243 33.7312L19.7764 33.7707L19.7721 33.7903C19.7105 34.0414 19.6539 34.2924 19.611 34.5436L19.6074 34.5605H19.591ZM19.5734 34.5195C19.6149 34.2795 19.669 34.0398 19.7272 33.8009L19.6338 33.7773C19.4917 34.3082 19.2162 34.3557 18.656 34.3521C18.3569 34.3521 18.0579 34.3521 18.0563 34.0224V32.8964H18.6465C18.978 32.893 19.0114 33.0928 19.0351 33.3628L19.1376 33.3418C19.1284 33.1668 19.1237 32.9911 19.1237 32.8172C19.1237 32.639 19.1284 32.4611 19.1376 32.282H19.0351C19.0084 32.5299 18.9309 32.7029 18.6417 32.6999H18.0563V31.4151H18.7371C19.2306 31.4111 19.3124 31.6666 19.3339 31.9652L19.4362 31.9374C19.4279 31.8035 19.4223 31.6314 19.4223 31.4729C19.4223 31.3917 19.4245 31.3146 19.4272 31.2474C19.1047 31.2489 18.6233 31.2661 18.2331 31.2661C17.8431 31.2661 17.363 31.2489 17.0725 31.2474V31.3484H17.1185C17.2873 31.3488 17.4893 31.3781 17.4904 31.6406V34.1271C17.4893 34.3891 17.2873 34.418 17.1185 34.4193H17.0725V34.5195C17.3488 34.5186 17.8975 34.5008 18.3145 34.5008C18.7335 34.5008 19.2675 34.5186 19.5734 34.5195Z"
        fill="#1A1919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.3932 31.7298C20.3932 31.3837 20.2031 31.3695 20.0558 31.3695H19.9701V31.2271C20.1221 31.2271 20.4164 31.2459 20.7062 31.2459C20.9904 31.2459 21.2186 31.2271 21.4701 31.2271C22.0673 31.2271 22.6001 31.3882 22.6001 32.0627C22.6001 32.4896 22.3151 32.7503 21.9403 32.8983L22.7515 34.1127C22.8848 34.3135 22.979 34.3698 23.2122 34.3976V34.5403C23.0552 34.5403 22.9033 34.522 22.7472 34.522C22.6001 34.522 22.4475 34.5403 22.3011 34.5403C21.9353 34.0611 21.6218 33.5487 21.3135 33.002H21.0007V34.0184C21.0007 34.3838 21.1712 34.3976 21.3887 34.3976H21.4748V34.5403C21.2037 34.5403 20.9295 34.522 20.6584 34.522C20.4306 34.522 20.2074 34.5403 19.9701 34.5403V34.3976H20.0558C20.232 34.3976 20.3932 34.3173 20.3932 34.142V31.7298ZM21.0007 32.8308H21.2326C21.7078 32.8308 21.9637 32.6509 21.9637 32.0905C21.9637 31.6685 21.6931 31.3979 21.2702 31.3979C21.1277 31.3979 21.067 31.4125 21.0007 31.4171V32.8308Z"
        fill="#1A1919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.2122 34.5605C23.053 34.5605 22.9021 34.5415 22.746 34.5415C22.6013 34.5415 22.4495 34.5605 22.2842 34.5526C21.92 34.0747 21.608 33.5651 21.3015 33.0233H21.021V34.0174C21.0262 34.3747 21.1694 34.372 21.3888 34.3771H21.4953V34.5605H21.4743C21.203 34.5605 20.9272 34.5415 20.6582 34.5415C20.4315 34.5415 20.2085 34.5605 19.9701 34.5605H19.9495V34.3771H20.0558C20.2265 34.3758 20.3708 34.3014 20.3715 34.1419V31.7297C20.3679 31.3932 20.2032 31.3948 20.0558 31.3901H19.9495V31.2063H19.9701C20.1237 31.2063 20.4168 31.2248 20.7062 31.2248C20.9896 31.2248 21.2172 31.2063 21.4702 31.2063C22.0686 31.2076 22.6193 31.3723 22.6207 32.0619C22.6207 32.4902 22.3376 32.7579 21.9716 32.9072L22.7686 34.1013C22.9014 34.2982 22.984 34.3474 23.2149 34.3771L23.2322 34.3798V34.5605H23.2122ZM21.0005 32.9814H21.3248L21.3307 32.992C21.6398 33.5373 21.9517 34.0499 22.3011 34.5199C22.4456 34.5199 22.5981 34.5008 22.746 34.5008C22.8974 34.5008 23.044 34.5174 23.1914 34.5195V34.4153C22.9689 34.3882 22.8644 34.321 22.7348 34.1243L21.9085 32.8887L21.9319 32.8792C22.3036 32.7327 22.5791 32.4792 22.5792 32.0619C22.5791 31.4034 22.0668 31.2507 21.4702 31.2474C21.2202 31.2474 20.9921 31.2667 20.7062 31.2667C20.4274 31.2667 20.1457 31.2489 19.9904 31.2474V31.3484H20.0558C20.2032 31.3488 20.4128 31.3732 20.4128 31.7297V34.1419C20.4128 34.3323 20.2344 34.4189 20.0558 34.4193H19.9904V34.5195C20.2186 34.5186 20.4353 34.5008 20.6582 34.5008C20.9233 34.5008 21.1913 34.5186 21.4538 34.5195V34.4193H21.3888C21.1726 34.4189 20.9795 34.3921 20.9795 34.0174V32.9814H21.0005ZM21.0005 32.8511H20.9795V31.3978L20.9976 31.3964C21.0627 31.3912 21.1266 31.3781 21.2702 31.3781C21.7025 31.3781 21.984 31.6589 21.9844 32.0917C21.9831 32.6584 21.7115 32.851 21.2326 32.8511H21.0005ZM21.2326 32.8107C21.7025 32.8061 21.9393 32.6431 21.9439 32.0917C21.9411 31.677 21.6836 31.4197 21.2702 31.4179C21.1421 31.4179 21.0815 31.4298 21.021 31.4357V32.8107H21.2326Z"
        fill="#1A1919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.4347 33.6048L26.443 33.5954V31.816C26.443 31.4265 26.1733 31.3695 26.0308 31.3695H25.9268V31.2271C26.1499 31.2271 26.3675 31.2459 26.5912 31.2459C26.7863 31.2459 26.9794 31.2271 27.1755 31.2271V31.3695H27.104C26.9045 31.3695 26.6816 31.4074 26.6816 31.9723V34.1319C26.6816 34.2983 26.6862 34.4643 26.7096 34.6116H26.5299L24.0857 31.8866V33.8426C24.0857 34.2559 24.1659 34.3976 24.5313 34.3976H24.6122V34.5403C24.4082 34.5403 24.2038 34.5218 23.9998 34.5218C23.7855 34.5218 23.5676 34.5403 23.3541 34.5403V34.3976H23.4201C23.7478 34.3976 23.848 34.1745 23.848 33.7959V31.7961C23.848 31.5305 23.6294 31.3695 23.4159 31.3695H23.3541V31.2271C23.5338 31.2271 23.7203 31.2459 23.9003 31.2459C24.0414 31.2459 24.1797 31.2271 24.3224 31.2271L26.4347 33.6048"
        fill="#1A1919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.7094 34.6315L26.5145 34.6248L24.1053 31.9404V33.8424C24.1109 34.2558 24.1734 34.3726 24.5313 34.3771H24.6319V34.5605H24.6113C24.4061 34.5605 24.2024 34.5407 23.999 34.5407C23.7871 34.5407 23.5678 34.5605 23.354 34.5605H23.3328V34.3771H23.4201C23.7336 34.3758 23.8234 34.1737 23.8265 33.7946V31.796C23.8259 31.543 23.619 31.3901 23.4159 31.3901H23.3328V31.2063H23.354C23.5352 31.2063 23.721 31.2248 23.9002 31.2248C24.0396 31.2248 24.177 31.2063 24.3362 31.2124L26.4229 33.5617V31.8159C26.4216 31.439 26.1688 31.3923 26.0308 31.3901H25.9056V31.2063H25.9263C26.1505 31.2063 26.3693 31.2248 26.5912 31.2248C26.7845 31.2248 26.9789 31.2063 27.1746 31.2063H27.1956V31.3901H27.104C26.9081 31.3948 26.7064 31.4124 26.7017 31.9722V34.1318C26.7017 34.298 26.7058 34.4626 26.7301 34.6081L26.7324 34.6315H26.7094ZM26.5298 34.5901H26.6853C26.6645 34.4482 26.6604 34.2897 26.6604 34.1318V31.9722C26.6607 31.4025 26.9008 31.3497 27.104 31.3484H27.1539V31.2474C26.9671 31.2489 26.7795 31.2661 26.5912 31.2661C26.3731 31.2661 26.1616 31.2489 25.9469 31.2474V31.3484H26.0308C26.1771 31.3497 26.4645 31.4136 26.4645 31.8159L26.4577 33.6102L26.4491 33.6194L26.4342 33.635L24.3224 31.2474C24.1812 31.2474 24.0435 31.2661 23.9002 31.2661C23.7241 31.2661 23.5467 31.2489 23.3743 31.2474V31.3484H23.4159C23.6393 31.3497 23.8676 31.518 23.8676 31.796V33.7946C23.8676 34.1755 23.7604 34.418 23.4201 34.4193L23.3743 34.4189V34.5197C23.5793 34.5183 23.7907 34.5008 23.999 34.5008C24.198 34.5008 24.3953 34.5183 24.5915 34.5197V34.4193H24.5313C24.1578 34.4189 24.0647 34.2558 24.0636 33.8424V31.8341L26.5298 34.5901ZM26.4342 33.6047L26.4496 33.591L26.4342 33.6047ZM26.4229 33.5953V33.5941L26.4194 33.5905L26.4229 33.5953Z"
        fill="#1A1919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.9385 33.8616C27.8907 34.0224 27.8334 34.1471 27.8334 34.2314C27.8334 34.3742 28.0334 34.3977 28.1895 34.3977H28.2425V34.5402C28.0519 34.53 27.8582 34.5219 27.6672 34.5219C27.4963 34.5219 27.3264 34.53 27.155 34.5402V34.3977H27.1839C27.3686 34.3977 27.5258 34.2883 27.5962 34.0889L28.3557 31.911C28.4177 31.7349 28.5032 31.4977 28.5321 31.3217C28.683 31.2697 28.8737 31.1754 28.9635 31.1177C28.9782 31.1129 28.987 31.108 29.0014 31.108C29.0158 31.108 29.0246 31.108 29.035 31.1229C29.049 31.1605 29.0628 31.2033 29.0776 31.2412L29.9513 33.724C30.0083 33.8896 30.0647 34.0652 30.1254 34.2084C30.1833 34.3415 30.283 34.3977 30.4402 34.3977H30.4686V34.5402C30.2548 34.53 30.0406 34.5219 29.8139 34.5219C29.5812 34.5219 29.3431 34.53 29.1011 34.5402V34.3977H29.1534C29.2619 34.3977 29.4482 34.3789 29.4482 34.2601C29.4482 34.1988 29.4053 34.0706 29.3523 33.918L29.1674 33.3677H28.0901L27.9385 33.8616ZM28.6315 31.7588H28.6216L28.1805 33.1022H29.0673L28.6315 31.7588Z"
        fill="#1A1919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.4672 34.5605C30.2539 34.5514 30.0399 34.5408 29.8139 34.5408C29.5812 34.5408 29.3444 34.5514 29.1022 34.5605L29.0803 34.5616V34.3762H29.1534C29.2634 34.3762 29.4265 34.3516 29.4269 34.2601C29.428 34.206 29.3854 34.076 29.3331 33.925L29.1524 33.388H28.1054L27.9578 33.8677C27.91 34.0291 27.8523 34.1545 27.8532 34.2317C27.8548 34.3476 28.032 34.3762 28.1895 34.3762H28.2625V34.5616L28.2409 34.5605C28.0512 34.5514 27.8575 34.5408 27.6676 34.5408C27.4982 34.5408 27.3266 34.5514 27.1566 34.5605L27.1345 34.5616V34.3762H27.1838C27.3602 34.3758 27.5075 34.275 27.5761 34.0822L28.3363 31.9036C28.3976 31.7279 28.4838 31.4918 28.5248 31.3021C28.6737 31.2516 28.8647 31.1558 28.9558 31.0985C28.9691 31.0938 28.9822 31.0877 29.0013 31.0877C29.0129 31.087 29.0385 31.0901 29.0539 31.1149C29.0674 31.1539 29.0825 31.1964 29.0968 31.2347L29.9707 33.7172C30.0266 33.8834 30.0834 34.0587 30.1456 34.1994C30.2005 34.3259 30.2877 34.3758 30.4402 34.3762H30.4882V34.5616L30.4672 34.5605ZM29.1218 34.5183C29.3566 34.51 29.5872 34.5009 29.8139 34.5009C30.034 34.5009 30.241 34.51 30.4472 34.5183V34.4189H30.4402C30.2774 34.42 30.1655 34.3561 30.1073 34.2161C30.0455 34.0727 29.9878 33.8965 29.9318 33.7303L29.0579 31.2476C29.0435 31.2097 29.03 31.1673 29.0176 31.1336C29.0129 31.1289 29.014 31.1289 29.0102 31.1289H29.0013C28.9917 31.1289 28.986 31.1318 28.9738 31.1348C28.8825 31.1941 28.6922 31.2877 28.551 31.3247C28.5221 31.5046 28.4366 31.7417 28.3749 31.9176L27.6155 34.0957C27.5433 34.302 27.3764 34.4193 27.1838 34.4189H27.1758V34.5183C27.3386 34.51 27.5028 34.5009 27.6676 34.5009C27.8512 34.5009 28.0384 34.51 28.2201 34.5183V34.4189H28.1895C28.0345 34.4168 27.8185 34.3999 27.8131 34.2317C27.8135 34.1376 27.8717 34.0161 27.9182 33.8557L27.9384 33.8616L27.9182 33.8551L28.0745 33.3479H29.1813L29.3714 33.9116C29.4247 34.0643 29.4679 34.1908 29.4679 34.2601C29.4608 34.4055 29.2611 34.4162 29.1534 34.4189H29.1218V34.5183ZM28.1516 33.1226L28.606 31.7378H28.6315V31.7588L28.6265 31.7602L28.6315 31.7588V31.7378H28.6457L29.0968 33.1226H28.1516ZM28.2084 33.0811H29.0393L28.6263 31.8093L28.2084 33.0811ZM28.6108 31.7649L28.6218 31.7615L28.6108 31.7649Z"
        fill="#1A1919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.6772 31.4643C30.3212 31.4643 30.3069 31.5502 30.2354 31.8962H30.0927C30.1114 31.7633 30.1357 31.6305 30.1504 31.4929C30.1689 31.3594 30.1781 31.227 30.1781 31.0897H30.2929C30.3301 31.2322 30.449 31.227 30.5771 31.227H33.0267C33.1542 31.227 33.2728 31.2223 33.2822 31.0798L33.3957 31.0992C33.3781 31.227 33.3592 31.3553 33.3443 31.4837C33.3339 31.6118 33.3339 31.7396 33.3339 31.8677L33.1921 31.9205C33.1837 31.7451 33.1598 31.4643 32.8411 31.4643H32.0628V33.9895C32.0628 34.3557 32.2291 34.3976 32.4566 34.3976H32.5473V34.5402C32.3619 34.5402 32.0302 34.5219 31.7733 34.5219C31.4891 34.5219 31.156 34.5402 30.9709 34.5402V34.3976H31.0613C31.3229 34.3976 31.4553 34.3742 31.4553 33.9994V31.4643H30.6772"
        fill="#1A1919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.5474 34.5605C32.3609 34.5605 32.0281 34.5417 31.773 34.5417C31.4895 34.5417 31.1571 34.5605 30.9711 34.5605H30.9501V34.3771H31.0613C31.3231 34.371 31.428 34.3676 31.4343 33.9994L31.434 31.4847H30.6772V31.4431H31.4758V33.9994C31.4758 34.3805 31.322 34.4181 31.0613 34.419H30.9914V34.5199C31.179 34.5183 31.4979 34.5009 31.773 34.5009C32.0211 34.5009 32.3388 34.5183 32.5261 34.5199V34.419H32.4564C32.2277 34.4181 32.0428 34.3631 32.0425 33.9896V31.4431H32.8411C33.16 31.4444 33.2015 31.715 33.2107 31.8916L33.3138 31.8537C33.3138 31.7297 33.3145 31.6056 33.3242 31.4814C33.337 31.3591 33.355 31.2376 33.3722 31.1165L33.3005 31.1039C33.2788 31.2421 33.1447 31.2498 33.0267 31.2477H30.5529C30.4409 31.2489 30.3198 31.2425 30.2767 31.1097H30.1991C30.198 31.241 30.1887 31.3686 30.17 31.4951C30.1571 31.626 30.1342 31.7516 30.1161 31.8765H30.2182C30.2805 31.5454 30.3216 31.4379 30.6772 31.4431V31.4847C30.3252 31.4908 30.333 31.5504 30.2555 31.9011L30.2521 31.9173H30.0688L30.0717 31.8938C30.0917 31.7603 30.115 31.6269 30.1289 31.4902C30.1483 31.3574 30.1571 31.2258 30.1571 31.0897V31.0687H30.3078L30.3118 31.0836C30.345 31.2033 30.4314 31.2042 30.5529 31.2063H33.0267C33.158 31.2042 33.2538 31.2024 33.2622 31.0786L33.263 31.0558L33.2851 31.0601L33.4198 31.0813L33.4166 31.1023C33.397 31.2297 33.379 31.3574 33.3647 31.4847C33.355 31.6119 33.355 31.7396 33.355 31.8677V31.8821L33.3411 31.8876L33.1731 31.9491L33.1724 31.9216C33.16 31.743 33.1411 31.4847 32.8411 31.4847H32.0833V33.9896C32.0881 34.3475 32.2302 34.3726 32.4564 34.3771H32.5671V34.5605H32.5474"
        fill="#1A1919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.5714 34.3976H33.6379C33.8089 34.3976 33.9886 34.3743 33.9886 34.1272V31.6406C33.9886 31.3932 33.8089 31.3697 33.6379 31.3697H33.5714V31.2271C33.7566 31.2271 34.0409 31.2459 34.2732 31.2459C34.5111 31.2459 34.796 31.2271 35.0195 31.2271V31.3697H34.9529C34.7813 31.3697 34.6009 31.3932 34.6009 31.6406V34.1272C34.6009 34.3743 34.7813 34.3976 34.9529 34.3976H35.0195V34.5403C34.7915 34.5403 34.5064 34.522 34.2694 34.522C34.0364 34.522 33.7566 34.5403 33.5714 34.5403V34.3976"
        fill="#1A1919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.0196 34.5605C34.7901 34.5605 34.5063 34.5407 34.2695 34.5407C34.0371 34.5407 33.7569 34.5605 33.5714 34.5605H33.5511V34.3771H33.6381C33.8091 34.3742 33.9669 34.3591 33.968 34.1271V31.6406C33.9669 31.4086 33.8091 31.3932 33.6381 31.3901H33.5511V31.2063H33.5714C33.7569 31.2063 34.0424 31.2248 34.2732 31.2248C34.5098 31.2248 34.7946 31.2063 35.0196 31.2063H35.0393V31.3901H34.9531C34.7793 31.3932 34.6232 31.4086 34.6216 31.6406V34.1271C34.6232 34.3591 34.7793 34.3742 34.9531 34.3771H35.0393V34.5605H35.0196ZM34.998 34.5195V34.4189H34.9531C34.7828 34.4189 34.5814 34.3891 34.5814 34.1271V31.6406C34.5814 31.3781 34.7828 31.3488 34.9531 31.3484H34.998V31.2474C34.7792 31.2489 34.5043 31.2661 34.2732 31.2661C34.0479 31.2661 33.7763 31.2489 33.5921 31.2474V31.3484H33.6381C33.8066 31.3488 34.0089 31.3781 34.0095 31.6406V34.1271C34.0089 34.3891 33.8066 34.4189 33.6381 34.4189H33.5921V34.5195C33.775 34.5174 34.0434 34.5008 34.2695 34.5008C34.4996 34.5008 34.7741 34.5183 34.998 34.5195Z"
        fill="#1A1919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.9122 31.1559C37.9241 31.1559 38.7306 31.7831 38.7306 32.7941C38.7306 33.8859 37.9472 34.6116 36.9366 34.6116C35.9299 34.6116 35.1613 33.928 35.1613 32.9073C35.1613 31.9205 35.9253 31.1559 36.9122 31.1559ZM36.9839 34.4026C37.905 34.4026 38.0656 33.5904 38.0656 32.8983C38.0656 32.2046 37.6916 31.3648 36.9032 31.3648C36.0728 31.3648 35.8257 32.1054 35.8257 32.7409C35.8257 33.5904 36.2152 34.4026 36.9839 34.4026Z"
        fill="#1A1919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.1401 32.9073C35.1421 31.9091 35.9148 31.1369 36.9119 31.1353V31.1768C35.9362 31.1768 35.1814 31.931 35.1803 32.9073C35.1823 33.9165 35.9398 34.5899 36.9367 34.5902C37.9371 34.5899 38.7092 33.8746 38.7104 32.7934C38.7095 31.795 37.9157 31.1777 36.9119 31.1768V31.1353C37.931 31.1363 38.749 31.7697 38.7508 32.7934C38.7498 33.8966 37.9571 34.6298 36.9367 34.6316C35.9214 34.6298 35.1421 33.9393 35.1401 32.9073ZM35.8048 32.7409C35.8063 32.1022 36.0555 31.3437 36.903 31.3437C37.709 31.3455 38.0848 32.2009 38.0864 32.8983C38.0848 33.5904 37.922 34.4221 36.984 34.4221V34.3818C37.8865 34.3811 38.0433 33.5904 38.0447 32.8983C38.0447 32.2107 37.6745 31.3868 36.903 31.3855C36.0887 31.3864 35.8481 32.1087 35.846 32.7409C35.8463 33.5864 36.2323 34.3806 36.984 34.3818V34.4221C36.1962 34.4214 35.8063 33.5954 35.8048 32.7409Z"
        fill="#1A1919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.929 33.6048L41.9389 33.5954V31.816C41.9389 31.4265 41.6674 31.3695 41.5251 31.3695H41.4218V31.2271C41.6442 31.2271 41.8631 31.2459 42.0855 31.2459C42.2806 31.2459 42.4752 31.2271 42.67 31.2271V31.3695H42.5986C42.3997 31.3695 42.1757 31.4074 42.1757 31.9723V34.1319C42.1757 34.2983 42.1807 34.4643 42.2048 34.6116H42.0242L39.5793 31.8866V33.8426C39.5793 34.2559 39.6604 34.3976 40.0251 34.3976H40.1065V34.5403C39.9022 34.5403 39.6985 34.5218 39.4944 34.5218C39.2805 34.5218 39.0621 34.5403 38.8484 34.5403V34.3976H38.9151C39.2432 34.3976 39.3422 34.1745 39.3422 33.7959V31.7961C39.3422 31.5305 39.1246 31.3695 38.9099 31.3695H38.8484V31.2271C39.0288 31.2271 39.2137 31.2459 39.3945 31.2459C39.5366 31.2459 39.6735 31.2271 39.8165 31.2271L41.929 33.6048"
        fill="#1A1919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.205 34.6315L42.0086 34.6248L39.5998 31.9404V33.8425C39.6054 34.2558 39.6681 34.372 40.0245 34.3762H40.1268V34.5605H40.1066C39.9011 34.5605 39.6974 34.5415 39.4943 34.5415C39.2816 34.5415 39.0631 34.5605 38.8479 34.5605H38.8285V34.3762H38.9149C39.2277 34.3753 39.3179 34.1737 39.3217 33.7957V31.796C39.3215 31.543 39.114 31.3901 38.9101 31.3901H38.8285V31.2063H38.8479C39.0299 31.2063 39.215 31.2248 39.3943 31.2248C39.5351 31.2248 39.6715 31.2063 39.8325 31.2137L41.918 33.5617V31.8159C41.9164 31.439 41.6636 31.3932 41.5251 31.3901H41.4001V31.2063H41.4218C41.6448 31.2063 41.8638 31.2248 42.085 31.2248C42.2792 31.2248 42.4729 31.2063 42.6701 31.2063H42.6901V31.3901H42.5984C42.4028 31.3951 42.2008 31.4131 42.1969 31.9722V34.1318C42.1969 34.298 42.2007 34.4637 42.2237 34.6081L42.2278 34.6315H42.205ZM42.0242 34.5901H42.1798C42.1597 34.4473 42.155 34.2897 42.155 34.1318V31.9722C42.155 31.4016 42.3947 31.3497 42.5984 31.3484H42.6498V31.2474C42.4614 31.2489 42.2747 31.2661 42.085 31.2661C41.8688 31.2661 41.6566 31.2489 41.4417 31.2474V31.3484H41.5251C41.6717 31.3497 41.9583 31.4145 41.9583 31.8159L41.9533 33.6102L41.9441 33.6194L41.929 33.635L39.8167 31.2474C39.6762 31.2474 39.538 31.2661 39.3943 31.2661C39.2193 31.2661 39.041 31.2489 38.8684 31.2474V31.3484H38.9101C39.1332 31.3497 39.3625 31.518 39.3625 31.796V33.7957C39.3625 34.1755 39.2565 34.418 38.9149 34.4193L38.8684 34.4189V34.5197C39.0745 34.5183 39.2857 34.5008 39.4943 34.5008C39.6923 34.5008 39.8891 34.5183 40.0858 34.5197V34.4193H40.0245C39.6521 34.4189 39.5587 34.2558 39.5587 33.8425V31.8333L42.0242 34.5901ZM41.929 33.6047L41.9441 33.591L41.929 33.6047ZM41.918 33.5953V33.5941L41.9143 33.5905L41.918 33.5953Z"
        fill="#1A1919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M43.4324 33.8616C43.3859 34.0224 43.3286 34.1471 43.3286 34.2314C43.3286 34.3742 43.5285 34.3977 43.6841 34.3977H43.7371V34.5402C43.547 34.53 43.3523 34.5219 43.1622 34.5219C42.9913 34.5219 42.8207 34.53 42.6505 34.5402V34.3977H42.6775C42.8636 34.3977 43.0208 34.2883 43.0902 34.0889L43.8512 31.911C43.9125 31.7349 43.9984 31.4977 44.0257 31.3217C44.1782 31.2697 44.3676 31.1754 44.459 31.1177C44.4723 31.1129 44.4819 31.108 44.4966 31.108C44.5104 31.108 44.5194 31.108 44.5291 31.1229C44.5435 31.1605 44.5577 31.2033 44.572 31.2412L45.4454 33.724C45.502 33.8896 45.5593 34.0652 45.6213 34.2084C45.6783 34.3415 45.7778 34.3977 45.9343 34.3977H45.9636V34.5402C45.7496 34.53 45.5358 34.5219 45.3078 34.5219C45.0757 34.5219 44.838 34.53 44.5956 34.5402V34.3977H44.6482C44.7567 34.3977 44.9429 34.3789 44.9429 34.2601C44.9429 34.1988 44.9003 34.0706 44.8473 33.918L44.6622 33.3677H43.585L43.4324 33.8616ZM44.1265 31.7588H44.117L43.6744 33.1022H44.5634L44.1265 31.7588Z"
        fill="#1A1919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.9614 34.5605C45.7475 34.552 45.5344 34.5414 45.308 34.5414C45.0764 34.5414 44.8385 34.552 44.5967 34.5605L44.5757 34.5616V34.3771H44.6479C44.7582 34.3771 44.9217 34.3515 44.9219 34.2601C44.9231 34.206 44.8802 34.0765 44.8268 33.925L44.6468 33.388H43.599L43.4524 33.8677C43.4046 34.0303 43.3485 34.1544 43.3491 34.2313C43.3491 34.3476 43.5271 34.3771 43.684 34.3771H43.7566V34.5616L43.7352 34.5605C43.5456 34.552 43.3512 34.5414 43.1622 34.5414C42.9921 34.5414 42.8218 34.552 42.6505 34.5605L42.6299 34.5616V34.3771H42.6775C42.8545 34.3762 43.0025 34.2748 43.072 34.0822L43.8311 31.9036C43.892 31.7279 43.9777 31.4918 44.0194 31.3028C44.1685 31.251 44.3592 31.1558 44.4515 31.0985C44.4637 31.0938 44.477 31.0881 44.4964 31.0881C44.5087 31.087 44.5336 31.09 44.5482 31.1159C44.5626 31.1533 44.5766 31.1964 44.592 31.2347L45.4648 33.7171C45.522 33.8833 45.5786 34.0587 45.6402 34.2003C45.6961 34.3258 45.782 34.3758 45.9338 34.3771H45.9828V34.5616L45.9614 34.5605ZM44.6159 34.5186C44.8507 34.51 45.0816 34.5008 45.308 34.5008C45.5286 34.5008 45.7351 34.51 45.9422 34.5183L45.9417 34.4189H45.9338C45.773 34.4193 45.661 34.356 45.6018 34.2161C45.5392 34.0727 45.4828 33.8964 45.4259 33.7308L44.5525 31.2476C44.5385 31.2097 44.5234 31.1673 44.5123 31.1344C44.5083 31.1289 44.5087 31.1289 44.5058 31.1289H44.4964C44.4862 31.1289 44.481 31.1321 44.4697 31.1353C44.3768 31.1934 44.1869 31.2886 44.0467 31.3247C44.0173 31.5045 43.931 31.7413 43.8699 31.9176L43.1098 34.0957C43.0375 34.302 42.8717 34.4193 42.6775 34.4189H42.6705V34.5183C42.834 34.51 42.9971 34.5008 43.1622 34.5008C43.346 34.5008 43.5338 34.51 43.7161 34.5183V34.4189H43.684C43.5297 34.4168 43.3133 34.4004 43.3072 34.2313C43.3085 34.1376 43.3669 34.0165 43.4134 33.8557L43.4325 33.8616L43.4134 33.8551L43.5695 33.3479H44.6759L44.8666 33.9115C44.9188 34.0643 44.9621 34.1907 44.9621 34.2601C44.9553 34.4054 44.7557 34.4162 44.6479 34.4189H44.6159V34.5186ZM43.6461 33.1224L44.1019 31.7377H44.1265V31.7588L44.1211 31.7602L44.1265 31.7588V31.7377H44.1409L44.5897 33.1224H43.6461ZM43.7034 33.0811H44.5338L44.1209 31.81L43.7034 33.0811ZM44.1067 31.7649L44.1161 31.7615L44.1067 31.7649Z"
        fill="#1A1919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.1591 34.0748C47.1591 34.2656 47.291 34.3218 47.4433 34.3416C47.6376 34.3558 47.8514 34.3558 48.0704 34.3315C48.2695 34.3076 48.4403 34.1944 48.5255 34.0748C48.6009 33.9706 48.6437 33.8376 48.6728 33.7334H48.8101C48.7578 34.004 48.6915 34.2701 48.6345 34.5403C48.2177 34.5403 47.7987 34.522 47.3817 34.522C46.9636 34.522 46.5463 34.5403 46.1287 34.5403V34.3976H46.1945C46.3657 34.3976 46.5515 34.3743 46.5515 34.08V31.6406C46.5515 31.3932 46.3657 31.3695 46.1945 31.3695H46.1287V31.2271C46.3799 31.2271 46.6271 31.2459 46.8783 31.2459C47.1208 31.2459 47.3576 31.2271 47.6004 31.2271V31.3695H47.4811C47.3007 31.3695 47.1591 31.3746 47.1591 31.6261V34.0748"
        fill="#1A1919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.6347 34.5605C48.2161 34.5605 47.798 34.5415 47.3817 34.5415C46.9641 34.5415 46.5464 34.5605 46.1278 34.5605H46.1078V34.3771H46.1944C46.366 34.3729 46.529 34.3609 46.531 34.0799V31.6397C46.529 31.4086 46.3667 31.3932 46.1944 31.3901H46.1078V31.2063H46.1278C46.3806 31.2063 46.6276 31.2248 46.8779 31.2248C47.1196 31.2248 47.356 31.2063 47.6003 31.2063H47.6194V31.3901H47.481C47.2969 31.3948 47.1826 31.3865 47.1785 31.626V34.0747C47.1797 34.2522 47.296 34.2996 47.4444 34.3208C47.5279 34.3266 47.6163 34.3296 47.7076 34.3296C47.8237 34.3296 47.9442 34.3242 48.0669 34.3113C48.2603 34.2883 48.4266 34.1765 48.5087 34.0634C48.582 33.9618 48.6234 33.8318 48.6521 33.7285L48.6561 33.7128H48.835L48.8309 33.7378C48.7772 34.0091 48.7118 34.2739 48.6543 34.5445L48.6505 34.5605H48.6347ZM48.6173 34.5195C48.6722 34.2617 48.7342 34.0096 48.7856 33.7536H48.6877C48.6586 33.8569 48.6162 33.9843 48.5418 34.0876C48.453 34.2105 48.2773 34.3266 48.0714 34.3521C47.9473 34.3647 47.8238 34.3711 47.7076 34.3711C47.6156 34.3711 47.5269 34.367 47.4404 34.3609C47.2861 34.344 47.1368 34.2777 47.137 34.0747V31.626C47.137 31.3621 47.3039 31.3484 47.481 31.3484H47.5788V31.2474C47.345 31.2489 47.1142 31.2667 46.8779 31.2667C46.6327 31.2667 46.3921 31.2489 46.1492 31.2474V31.3484H46.1944C46.3637 31.3484 46.5709 31.3781 46.5709 31.6397V34.0799C46.5709 34.3871 46.3646 34.4189 46.1944 34.4189H46.1492V34.5195C46.5592 34.5186 46.9695 34.5008 47.3817 34.5008C47.7944 34.5008 48.2064 34.5186 48.6173 34.5195Z"
        fill="#1A1919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.1061 14.47C19.1061 10.0302 22.7052 6.43115 27.1447 6.43115C31.5845 6.43115 35.1836 10.0302 35.1836 14.47C35.1836 18.9097 31.5845 22.509 27.1447 22.509C22.7052 22.509 19.1061 18.9097 19.1061 14.47"
        fill="#FFFFFE"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.0064 14.3117C32.0031 12.2531 30.7164 10.4974 28.9032 9.80211V18.821C30.7164 18.1248 32.0031 16.3707 32.0064 14.3117ZM25.4442 18.8192V9.80301C23.6326 10.5005 22.3478 12.2537 22.343 14.3117C22.3478 16.3693 23.6326 18.1223 25.4442 18.8192ZM27.1746 6.68866C22.9646 6.69028 19.5538 10.1018 19.5531 14.3117C19.5538 18.5212 22.9646 21.9321 27.1746 21.9328C31.3845 21.9321 34.7961 18.5212 34.7971 14.3117C34.7961 10.1018 31.3845 6.69028 27.1746 6.68866ZM27.1559 22.6522C22.5491 22.6742 18.7574 18.9419 18.7574 14.3987C18.7574 9.43343 22.5491 5.9991 27.1559 6H29.3148C33.8672 5.9991 38.022 9.43182 38.022 14.3987C38.022 18.9403 33.8672 22.6522 29.3148 22.6522H27.1559Z"
        fill="#0069AA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.02069 34.3976H8.08735C8.25803 34.3976 8.43842 34.3743 8.43842 34.1272V31.6406C8.43842 31.3932 8.25803 31.3697 8.08735 31.3697H8.02069V31.2271C8.20575 31.2271 8.49052 31.2459 8.72373 31.2459C8.96089 31.2459 9.2453 31.2271 9.46845 31.2271V31.3697H9.40143C9.23147 31.3697 9.05072 31.3932 9.05072 31.6406V34.1272C9.05072 34.3743 9.23147 34.3976 9.40143 34.3976H9.46845V34.5403C9.24081 34.5403 8.95532 34.522 8.71888 34.522C8.48585 34.522 8.20575 34.5403 8.02069 34.5403V34.3976"
        fill="#1A1919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.46842 34.5605C9.2388 34.5605 8.95475 34.5415 8.71849 34.5415C8.48618 34.5415 8.20698 34.5605 8.02066 34.5605H8V34.3771H8.08696C8.25926 34.3729 8.41593 34.3591 8.41737 34.1271V31.6406C8.41593 31.4082 8.25926 31.3932 8.08696 31.3901H8V31.2063H8.02066C8.20698 31.2063 8.49157 31.2248 8.7237 31.2248C8.95978 31.2248 9.24401 31.2063 9.46842 31.2063H9.48962V31.3901H9.4023C9.22982 31.3932 9.07225 31.4082 9.07135 31.6406V34.1271C9.07225 34.3591 9.22982 34.3729 9.4023 34.3771H9.48962V34.5605H9.46842ZM9.44793 34.5199L9.44811 34.4189H9.4023C9.23251 34.4189 9.03075 34.3891 9.02967 34.1271V31.6406C9.03075 31.3781 9.23251 31.3488 9.4023 31.3488H9.44793V31.2474C9.22892 31.2476 8.95385 31.2667 8.7237 31.2667C8.49822 31.2667 8.2253 31.2489 8.0415 31.2474V31.3488H8.08696C8.2562 31.3488 8.45833 31.3781 8.45833 31.6406V34.1271C8.45833 34.3891 8.2562 34.4189 8.08696 34.4189H8.0415V34.5199C8.2253 34.5183 8.49336 34.5008 8.71849 34.5008C8.94972 34.5008 9.22407 34.5186 9.44793 34.5199Z"
        fill="#1A1919"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.7522 31.0924C49.0386 31.0924 49.2522 31.3123 49.2522 31.5933C49.2522 31.8741 49.0386 32.0917 48.7522 32.0917C48.4665 32.0917 48.2526 31.8741 48.2526 31.5933C48.2526 31.3123 48.4665 31.0924 48.7522 31.0924ZM48.7522 31.9988C48.9764 31.9988 49.1477 31.8082 49.1477 31.5933C49.1477 31.3781 48.9784 31.186 48.7522 31.186C48.5273 31.186 48.3562 31.3781 48.3562 31.5933C48.3562 31.8082 48.5273 31.9988 48.7522 31.9988ZM48.5037 31.8569V31.8326C48.5648 31.8238 48.5763 31.8254 48.5763 31.7881V31.4176C48.5763 31.3655 48.5711 31.3475 48.5057 31.3504V31.3249H48.7616C48.8494 31.3249 48.9304 31.3669 48.9304 31.4578C48.9304 31.5321 48.8816 31.5872 48.8122 31.6086L48.8945 31.7232C48.9328 31.775 48.9764 31.8238 49.0045 31.8411V31.8569H48.9073C48.8606 31.8569 48.8192 31.7588 48.7276 31.6271H48.6723V31.7927C48.6723 31.8254 48.6838 31.8238 48.7452 31.8326V31.8569H48.5037ZM48.6723 31.5933H48.7312C48.7957 31.5933 48.8255 31.5446 48.8255 31.4658C48.8255 31.3863 48.7795 31.3581 48.728 31.3581H48.6723V31.5933Z"
        fill="#1A1919"
      />
    </svg>
  );
};

const CreditCardIcon = (props) => {
  return (
    <svg
      fill="#000000"
      width="800px"
      height="800px"
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path d="M29.005 5.5h-26.009c-1.657 0-3 1.343-3 3v15c0 1.657 1.343 3 3 3h26.009c1.657 0 3-1.343 3-3v-15c0-1.657-1.343-3-3-3zM2.995 7.5h26.009c0.552 0 1 0.448 1 1v2h-28.009v-2c0-0.552 0.449-1 1-1zM29.005 24.5h-26.009c-0.552 0-1-0.448-1-1v-9h28.009v9c0 0.552-0.448 1-1 1z"></path>
    </svg>
  );
};

const CardIconV2 = (props) => {
  return (
    <svg
      className="p-Icon p-Icon--card Icon p-Icon--md p-TabIcon TabIcon"
      role="presentation"
      fill="var(--colorIcon)"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 4a2 2 0 012-2h12a2 2 0 012 2H0zm0 2v6a2 2 0 002 2h12a2 2 0 002-2V6H0zm3 5a1 1 0 011-1h1a1 1 0 110 2H4a1 1 0 01-1-1z"
        fill="currentColor"></path>
    </svg>
  );
};

const BankAccountIconV2 = (props) => {
  return (
    <svg
      className="p-Icon p-Icon--bank Icon p-Icon--md p-TabIcon TabIcon p-TabIcon--selected TabIcon--selected"
      role="presentation"
      fill="var(--colorIcon)"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 7.5V14h1.5V7.5h3V14H11V7.5h3V14h1a1 1 0 011 1v1H0v-1a1 1 0 011-1h1V7.5h3zM8 0c4.681 2.572 7.181 3.95 7.5 4.134A1 1 0 0114.98 6H1.02A1 1 0 01.5 4.134C.82 3.95 3.32 2.572 8 0z"
        fill="currentColor"></path>
    </svg>
  );
};
export const InviteMemberIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M15.0026 11.6668V9.16683H12.5026V7.50016H15.0026V5.00016H16.6693V7.50016H19.1693V9.16683H16.6693V11.6668H15.0026ZM7.5026 10.0002C6.58594 10.0002 5.80122 9.67377 5.14844 9.021C4.49566 8.36822 4.16927 7.5835 4.16927 6.66683C4.16927 5.75016 4.49566 4.96544 5.14844 4.31266C5.80122 3.65988 6.58594 3.3335 7.5026 3.3335C8.41927 3.3335 9.20399 3.65988 9.85677 4.31266C10.5095 4.96544 10.8359 5.75016 10.8359 6.66683C10.8359 7.5835 10.5095 8.36822 9.85677 9.021C9.20399 9.67377 8.41927 10.0002 7.5026 10.0002ZM0.835938 16.6668V14.3335C0.835938 13.8613 0.957465 13.4272 1.20052 13.0314C1.44358 12.6356 1.76649 12.3335 2.16927 12.1252C3.03038 11.6946 3.90538 11.3717 4.79427 11.1564C5.68316 10.9411 6.58594 10.8335 7.5026 10.8335C8.41927 10.8335 9.32205 10.9411 10.2109 11.1564C11.0998 11.3717 11.9748 11.6946 12.8359 12.1252C13.2387 12.3335 13.5616 12.6356 13.8047 13.0314C14.0477 13.4272 14.1693 13.8613 14.1693 14.3335V16.6668H0.835938ZM2.5026 15.0002H12.5026V14.3335C12.5026 14.1807 12.4644 14.0418 12.388 13.9168C12.3116 13.7918 12.2109 13.6946 12.0859 13.6252C11.3359 13.2502 10.579 12.9689 9.8151 12.7814C9.05122 12.5939 8.28038 12.5002 7.5026 12.5002C6.72483 12.5002 5.95399 12.5939 5.1901 12.7814C4.42621 12.9689 3.66927 13.2502 2.91927 13.6252C2.79427 13.6946 2.69358 13.7918 2.61719 13.9168C2.5408 14.0418 2.5026 14.1807 2.5026 14.3335V15.0002ZM7.5026 8.3335C7.96094 8.3335 8.3533 8.1703 8.67969 7.84391C9.00608 7.51752 9.16927 7.12516 9.16927 6.66683C9.16927 6.2085 9.00608 5.81613 8.67969 5.48975C8.3533 5.16336 7.96094 5.00016 7.5026 5.00016C7.04427 5.00016 6.65191 5.16336 6.32552 5.48975C5.99913 5.81613 5.83594 6.2085 5.83594 6.66683C5.83594 7.12516 5.99913 7.51752 6.32552 7.84391C6.65191 8.1703 7.04427 8.3335 7.5026 8.3335Z"
        fill="#2B2A28"
      />
    </svg>
  );
};
export const TermAndConditionIcon = (props) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="512.000000pt"
      height="512.000000pt"
      viewBox="0 0 512.000000 512.000000"
      preserveAspectRatio="xMidYMid meet"
      {...props}>
      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill="currentColor"
        stroke="none">
        <path
          d="M540 4844 c-112 -30 -209 -116 -252 -222 l-23 -57 0 -2005 0 -2005
          24 -60 c33 -82 124 -173 206 -206 l60 -24 1655 -3 c1721 -3 1764 -2 1912 39
          344 96 621 386 710 746 33 132 30 351 -5 483 -99 375 -371 644 -747 739 l-75
          19 -5 1148 -5 1149 -27 57 c-48 103 -147 181 -260 208 -27 6 -599 9 -1578 9
          -1319 0 -1543 -2 -1590 -15z m3116 -328 c19 -14 19 -39 22 -1125 l2 -1111 -23
          0 c-38 0 -167 -39 -244 -75 -440 -203 -677 -695 -562 -1165 38 -151 120 -316
          206 -411 l35 -39 -1231 0 c-1218 0 -1231 0 -1251 20 -20 20 -20 33 -20 1950 0
          1917 0 1930 20 1950 20 20 33 20 1523 20 1282 0 1506 -2 1523 -14z m312 -2562
          c264 -55 468 -245 538 -504 24 -88 24 -253 0 -340 -100 -368 -473 -589 -835
          -495 -247 64 -439 261 -502 515 -19 77 -16 240 5 320 96 353 447 576 794 504z"
        />
        <path
          d="M1079 3976 c-93 -63 -90 -216 4 -275 34 -21 36 -21 1049 -21 l1015 0
          33 23 c57 38 75 71 75 137 0 66 -18 99 -75 138 l-33 22 -1016 0 -1016 0 -36
          -24z"
        />
        <path
          d="M1089 3127 c-18 -12 -44 -38 -57 -57 -20 -29 -23 -44 -20 -93 5 -69
          27 -103 88 -134 l44 -23 992 0 991 0 43 23 c50 26 90 90 90 141 0 42 -38 115
          -73 140 -28 21 -37 21 -1046 24 l-1018 2 -34 -23z"
        />
        <path
          d="M1101 2278 c-62 -32 -84 -66 -89 -135 -3 -49 0 -64 20 -93 13 -19 39
          -45 57 -57 l34 -23 739 0 c715 0 740 1 777 20 107 54 111 208 8 284 -28 21
          -35 21 -765 24 l-737 2 -44 -22z"
        />
        <path
          d="M1079 1416 c-93 -63 -90 -216 4 -275 34 -21 42 -21 677 -21 635 0
          643 0 677 21 95 59 95 219 0 278 -34 21 -42 21 -678 21 l-644 0 -36 -24z"
        />
        <path
          d="M4105 1650 c-17 -6 -98 -78 -200 -180 l-170 -170 -55 56 c-68 69
          -100 86 -160 86 -68 0 -118 -29 -147 -86 -20 -38 -20 -114 0 -152 9 -16 71
          -84 139 -151 153 -152 198 -174 286 -137 45 18 484 452 507 500 35 74 11 167
          -55 216 -30 22 -104 31 -145 18z"
        />
      </g>
    </svg>
  );
};

export const TermAndConditionIconV2 = (props) => {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M11.6667 15.5L9.375 13L10.3417 12.0333L11.6667 13.3583L14.6583 10.3667L15.625 11.5417M8.16667 15.5H1.66667C0.741667 15.5 0 14.7583 0 13.8333V2.16667C0 1.24167 0.741667 0.5 1.66667 0.5H13.3333C14.2583 0.5 15 1.24167 15 2.16667V8.66667C14.4917 8.375 13.9333 8.16667 13.3333 8.06667V2.16667H1.66667V13.8333H7.56667C7.66667 14.4333 7.875 14.9917 8.16667 15.5ZM7.5 12.1667H3.33333V10.5H7.5M9.73333 8.83333H3.33333V7.16667H11.6667V8.06667C10.9583 8.18333 10.3083 8.45 9.73333 8.83333ZM11.6667 5.5H3.33333V3.83333H11.6667"
        fill="currentColor"
      />
    </svg>
  );
};

export const PrivacyPolicy = (props) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="512.000000pt"
      height="512.000000pt"
      viewBox="0 0 512.000000 512.000000"
      preserveAspectRatio="xMidYMid meet"
      {...props}>
      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill="currentColor"
        stroke="none">
        <path
          d="M2460 4804 c-30 -8 -104 -44 -165 -80 -419 -247 -870 -403 -1385
          -479 -199 -29 -252 -49 -324 -121 -25 -24 -57 -70 -73 -102 l-28 -57 0 -745
          c0 -732 0 -747 23 -865 93 -491 310 -905 653 -1242 206 -203 302 -268 841
          -567 403 -224 473 -256 558 -256 85 0 155 32 558 256 532 295 634 364 831 557
          386 378 625 867 681 1393 7 63 10 350 8 784 l-3 685 -28 57 c-16 32 -48 78
          -73 102 -72 72 -125 92 -324 121 -502 74 -923 216 -1339 454 -211 120 -284
          139 -411 105z m210 -375 c462 -269 1052 -467 1533 -515 42 -4 77 -14 90 -25
          l22 -17 3 -509 c3 -589 -7 -824 -43 -1001 -60 -294 -189 -576 -374 -817 -62
          -82 -221 -245 -306 -315 -123 -100 -221 -161 -632 -389 l-403 -224 -402 224
          c-412 228 -510 289 -633 389 -85 70 -244 233 -306 315 -184 240 -314 524 -374
          817 -36 177 -46 412 -43 1000 3 459 5 509 20 524 11 11 51 21 125 31 516 66
          1026 239 1493 507 63 36 117 66 120 66 3 0 52 -27 110 -61z"
        />
        <path
          d="M2453 3890 c-181 -33 -342 -156 -423 -325 -50 -104 -60 -164 -60
          -360 l0 -162 -55 -12 c-175 -39 -317 -183 -360 -362 -22 -93 -22 -765 0 -858
          40 -168 163 -302 324 -351 60 -19 95 -20 681 -20 586 0 621 1 681 20 161 49
          284 183 324 351 22 93 22 765 0 858 -43 179 -185 323 -360 362 l-55 12 0 162
          c0 197 -10 256 -61 363 -69 143 -209 262 -359 306 -68 20 -208 28 -277 16z
          m225 -354 c27 -14 64 -42 81 -63 51 -62 61 -108 61 -280 l0 -153 -260 0 -260
          0 0 153 c0 186 12 230 79 297 82 82 194 99 299 46z m447 -827 c47 -13 92 -52
          111 -96 20 -47 20 -699 0 -746 -20 -47 -65 -84 -116 -96 -61 -14 -1059 -14
          -1120 0 -51 12 -96 49 -116 96 -20 47 -20 699 0 746 18 43 63 83 106 95 50 14
          1083 15 1135 1z"
        />
      </g>
    </svg>
  );
};

export const PrivacyPolicyV2 = (props) => {
  return (
    <svg
      width={15}
      height={18}
      viewBox="0 0 15 18"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M7.4987 9.83463C6.67925 9.83463 5.98828 9.55339 5.42578 8.99089C4.86328 8.42839 4.58203 7.73741 4.58203 6.91797C4.58203 6.09852 4.86328 5.40755 5.42578 4.84505C5.98828 4.28255 6.67925 4.0013 7.4987 4.0013C8.31814 4.0013 9.00911 4.28255 9.57161 4.84505C10.1341 5.40755 10.4154 6.09852 10.4154 6.91797C10.4154 7.73741 10.1341 8.42839 9.57161 8.99089C9.00911 9.55339 8.31814 9.83463 7.4987 9.83463ZM7.4987 8.16797C7.85981 8.16797 8.15842 8.04991 8.39453 7.8138C8.63064 7.57769 8.7487 7.27908 8.7487 6.91797C8.7487 6.55686 8.63064 6.25825 8.39453 6.02214C8.15842 5.78602 7.85981 5.66797 7.4987 5.66797C7.13759 5.66797 6.83898 5.78602 6.60286 6.02214C6.36675 6.25825 6.2487 6.55686 6.2487 6.91797C6.2487 7.27908 6.36675 7.57769 6.60286 7.8138C6.83898 8.04991 7.13759 8.16797 7.4987 8.16797ZM7.4987 17.3346C5.56814 16.8485 3.97439 15.7409 2.71745 14.0117C1.4605 12.2826 0.832031 10.3624 0.832031 8.2513V3.16797L7.4987 0.667969L14.1654 3.16797V8.2513C14.1654 10.3624 13.5369 12.2826 12.2799 14.0117C11.023 15.7409 9.42925 16.8485 7.4987 17.3346ZM7.4987 2.4388L2.4987 4.3138V8.2513C2.4987 9.0013 2.60286 9.73047 2.8112 10.4388C3.01953 11.1471 3.30425 11.8138 3.66536 12.4388C4.2487 12.1471 4.85981 11.918 5.4987 11.7513C6.13759 11.5846 6.80425 11.5013 7.4987 11.5013C8.19314 11.5013 8.85981 11.5846 9.4987 11.7513C10.1376 11.918 10.7487 12.1471 11.332 12.4388C11.6931 11.8138 11.9779 11.1471 12.1862 10.4388C12.3945 9.73047 12.4987 9.0013 12.4987 8.2513V4.3138L7.4987 2.4388ZM7.4987 13.168C6.9987 13.168 6.51259 13.2235 6.04036 13.3346C5.56814 13.4457 5.11675 13.5985 4.6862 13.793C5.08898 14.2096 5.52648 14.5707 5.9987 14.8763C6.47092 15.1819 6.97092 15.418 7.4987 15.5846C8.02648 15.418 8.52648 15.1819 8.9987 14.8763C9.47092 14.5707 9.90842 14.2096 10.3112 13.793C9.88064 13.5985 9.42925 13.4457 8.95703 13.3346C8.48481 13.2235 7.9987 13.168 7.4987 13.168Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const FilterIcon2 = (props) => {
  return (
    <svg
      width="16"
      height="15"
      viewBox="0 0 16 15"
      {...props}
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <title>{props?.title || ''}</title>
      <path
        d="M0.5 11.6667V13.3333H5.5V11.6667H0.5ZM0.5 1.66667V3.33333H8.83333V1.66667H0.5ZM8.83333 15V13.3333H15.5V11.6667H8.83333V10H7.16667V15H8.83333ZM3.83333 5V6.66667H0.5V8.33333H3.83333V10H5.5V5H3.83333ZM15.5 8.33333V6.66667H7.16667V8.33333H15.5ZM10.5 5H12.1667V3.33333H15.5V1.66667H12.1667V0H10.5V5Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const UploadIconV2 = (props) => {
  return (
    <svg
      {...props}
      width="14"
      height="18"
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.16536 14.8332H7.83203V11.354L9.16536 12.6873L10.332 11.4998L6.9987 8.1665L3.66536 11.4998L4.85286 12.6665L6.16536 11.354V14.8332ZM1.9987 17.3332C1.54036 17.3332 1.148 17.17 0.821615 16.8436C0.495226 16.5172 0.332031 16.1248 0.332031 15.6665V2.33317C0.332031 1.87484 0.495226 1.48248 0.821615 1.15609C1.148 0.829698 1.54036 0.666504 1.9987 0.666504H8.66536L13.6654 5.6665V15.6665C13.6654 16.1248 13.5022 16.5172 13.1758 16.8436C12.8494 17.17 12.457 17.3332 11.9987 17.3332H1.9987ZM7.83203 6.49984V2.33317H1.9987V15.6665H11.9987V6.49984H7.83203Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const SingleSelectIcon = (props) => {
  return (
    <svg
      {...props}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.6667 0H1.33333C0.6 0 0 0.6 0 1.33333V10.6667C0 11.4 0.6 12 1.33333 12H10.6667C11.4 12 12 11.4 12 10.6667V1.33333C12 0.6 11.4 0 10.6667 0ZM10.6667 10.6667H1.33333V1.33333H10.6667V10.6667ZM2.66667 5.33333H9.33333V6.66667H2.66667V5.33333Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const ViewInfoIcon = (props) => {
  return (
    <svg
      {...props}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.33594 4.66732H8.66927V6.00065H7.33594V4.66732ZM7.33594 7.33398H8.66927V11.334H7.33594V7.33398ZM8.0026 1.33398C4.3226 1.33398 1.33594 4.32065 1.33594 8.00065C1.33594 11.6807 4.3226 14.6673 8.0026 14.6673C11.6826 14.6673 14.6693 11.6807 14.6693 8.00065C14.6693 4.32065 11.6826 1.33398 8.0026 1.33398ZM8.0026 13.334C5.0626 13.334 2.66927 10.9407 2.66927 8.00065C2.66927 5.06065 5.0626 2.66732 8.0026 2.66732C10.9426 2.66732 13.3359 5.06065 13.3359 8.00065C13.3359 10.9407 10.9426 13.334 8.0026 13.334Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const AIVideoIcon = (props) => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 10 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M8.75001 0.333008C8.6395 0.333008 8.53352 0.376906 8.45538 0.455047C8.37724 0.533187 8.33334 0.639168 8.33334 0.749674V1.58301H7.50001V0.749674C7.50001 0.639168 7.45611 0.533187 7.37797 0.455047C7.29983 0.376906 7.19385 0.333008 7.08334 0.333008C6.97284 0.333008 6.86686 0.376906 6.78872 0.455047C6.71058 0.533187 6.66668 0.639168 6.66668 0.749674V1.16634H3.33334V0.749674C3.33334 0.639168 3.28944 0.533187 3.2113 0.455047C3.13316 0.376906 3.02718 0.333008 2.91668 0.333008C2.80617 0.333008 2.70019 0.376906 2.62205 0.455047C2.54391 0.533187 2.50001 0.639168 2.50001 0.749674V1.58301H1.66668V0.749674C1.66668 0.639168 1.62278 0.533187 1.54464 0.455047C1.4665 0.376906 1.36052 0.333008 1.25001 0.333008C1.1395 0.333008 1.03352 0.376906 0.955382 0.455047C0.877242 0.533187 0.833344 0.639168 0.833344 0.749674V8.24967C0.833344 8.36018 0.877242 8.46616 0.955382 8.5443C1.03352 8.62244 1.1395 8.66634 1.25001 8.66634C1.36052 8.66634 1.4665 8.62244 1.54464 8.5443C1.62278 8.46616 1.66668 8.36018 1.66668 8.24967V7.41634H2.50001V8.24967C2.50001 8.36018 2.54391 8.46616 2.62205 8.5443C2.70019 8.62244 2.80617 8.66634 2.91668 8.66634C3.02718 8.66634 3.13316 8.62244 3.2113 8.5443C3.28944 8.46616 3.33334 8.36018 3.33334 8.24967V7.83301H6.66668V8.24967C6.66668 8.36018 6.71058 8.46616 6.78872 8.5443C6.86686 8.62244 6.97284 8.66634 7.08334 8.66634C7.19385 8.66634 7.29983 8.62244 7.37797 8.5443C7.45611 8.46616 7.50001 8.36018 7.50001 8.24967V7.41634H8.33334V8.24967C8.33334 8.36018 8.37724 8.46616 8.45538 8.5443C8.53352 8.62244 8.6395 8.66634 8.75001 8.66634C8.86052 8.66634 8.9665 8.62244 9.04464 8.5443C9.12278 8.46616 9.16668 8.36018 9.16668 8.24967V0.749674C9.16668 0.639168 9.12278 0.533187 9.04464 0.455047C8.9665 0.376906 8.86052 0.333008 8.75001 0.333008V0.333008ZM2.50001 6.58301H1.66668V5.74967H2.50001V6.58301ZM2.50001 4.91634H1.66668V4.08301H2.50001V4.91634ZM2.50001 3.24967H1.66668V2.41634H2.50001V3.24967ZM6.66668 6.99967H3.33334V4.91634H6.66668V6.99967ZM6.66668 4.08301H3.33334V1.99967H6.66668V4.08301ZM8.33334 6.58301H7.50001V5.74967H8.33334V6.58301ZM8.33334 4.91634H7.50001V4.08301H8.33334V4.91634ZM8.33334 3.24967H7.50001V2.41634H8.33334V3.24967Z"
        fill="#2B2A28"
      />
    </svg>
  );
};

export const VideoPlayIcon = (props) => {
  return (
    <svg
      width={17}
      height={24}
      viewBox="0 0 17 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M0 3.76757C0 2.11084 0 1.28247 0.531123 1.00052C1.06225 0.718579 1.74837 1.18272 3.12062 2.11101L16.7904 11.3582C16.9215 11.4469 17 11.5948 17 11.753C17 11.9079 16.9248 12.0531 16.7982 12.1424L3.15337 21.7741C1.77104 22.7499 1.07987 23.2377 0.539937 22.958C0 22.6782 0 21.8322 0 20.1402V3.76757Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const GroupIcon = (props) => {
  return (
    <svg
      width="66"
      height="77"
      viewBox="0 0 66 77"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M21.5 53.5V70.5C21.5 72.7091 23.2909 74.5 25.5 74.5H59.5C61.7091 74.5 63.5 72.7091 63.5 70.5V36.5C63.5 34.2909 61.7091 32.5 59.5 32.5H44M44 34V17C44 14.7909 42.2091 13 40 13H6C3.79086 13 2 14.7909 2 17V51C2 53.2091 3.79086 55 6 55H23H40C42.2091 55 44 53.2091 44 51V34Z"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        d="M20.9091 43.6136V21.1136H24.7273V43.6136H20.9091ZM11.5682 34.2727V30.4545H34.0682V34.2727H11.5682Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ImageScanSearchIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g>
        <mask
          id="mask0_3763_157073"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="21">
          <rect y="0.000488281" width="20" height="20" fill="currentColor" />
        </mask>
        <g mask="url(#mask0_3763_157073)">
          <path
            d="M4.16667 17.5005C3.70833 17.5005 3.31597 17.3373 2.98958 17.0109C2.66319 16.6845 2.5 16.2922 2.5 15.8338V12.5005H4.16667V15.8338H7.5V17.5005H4.16667ZM12.5 17.5005V15.8338H15.8333V12.5005H17.5V15.8338C17.5 16.2922 17.3368 16.6845 17.0104 17.0109C16.684 17.3373 16.2917 17.5005 15.8333 17.5005H12.5ZM2.5 7.50049V4.16715C2.5 3.70882 2.66319 3.31646 2.98958 2.99007C3.31597 2.66368 3.70833 2.50049 4.16667 2.50049H7.5V4.16715H4.16667V7.50049H2.5ZM15.8333 7.50049V4.16715H12.5V2.50049H15.8333C16.2917 2.50049 16.684 2.66368 17.0104 2.99007C17.3368 3.31646 17.5 3.70882 17.5 4.16715V7.50049H15.8333ZM10 14.1672C8.84722 14.1672 7.86458 13.7609 7.05208 12.9484C6.23958 12.1359 5.83333 11.1533 5.83333 10.0005C5.83333 8.84771 6.23958 7.86507 7.05208 7.05257C7.86458 6.24007 8.84722 5.83382 10 5.83382C11.1528 5.83382 12.1354 6.24007 12.9479 7.05257C13.7604 7.86507 14.1667 8.84771 14.1667 10.0005C14.1667 11.1533 13.7604 12.1359 12.9479 12.9484C12.1354 13.7609 11.1528 14.1672 10 14.1672ZM10 12.5005C10.6944 12.5005 11.2847 12.2574 11.7708 11.7713C12.2569 11.2852 12.5 10.6949 12.5 10.0005C12.5 9.30604 12.2569 8.71577 11.7708 8.22965C11.2847 7.74354 10.6944 7.50049 10 7.50049C9.30556 7.50049 8.71528 7.74354 8.22917 8.22965C7.74306 8.71577 7.5 9.30604 7.5 10.0005C7.5 10.6949 7.74306 11.2852 8.22917 11.7713C8.71528 12.2574 9.30556 12.5005 10 12.5005Z"
            fill="currentColor"
          />
        </g>
      </g>
    </svg>
  );
};
export const CollectFilesIcon = (props) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 512.000000 512.000000"
      preserveAspectRatio="xMidYMid meet">
      <metadata>Created by potrace 1.16, written by Peter Selinger 2001-2019</metadata>
      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill="currentColor"
        stroke="none">
        <path
          d="M1734 4769 c-29 -30 -29 -32 -32 -160 l-4 -129 -287 0 -287 0 -30
          -31 -29 -30 -3 -179 -3 -179 -499 -3 -499 -3 -30 -29 -31 -30 2 -1818 c3
          -1729 4 -1818 21 -1835 17 -17 82 -18 1125 -26 609 -5 1595 -5 2192 -1 l1084
          6 26 27 c21 21 89 213 344 980 175 526 320 978 323 1006 5 47 3 55 -25 86
          l-30 34 -289 3 -288 3 3 677 c2 372 0 742 -3 822 l-7 145 -346 348 -347 347
          -1011 0 -1010 0 -30 -31z m1886 -464 c0 -227 3 -281 15 -305 30 -57 47 -60
          350 -60 l275 0 0 -740 0 -740 -1170 0 -1170 0 0 1060 0 1060 850 0 850 0 0
          -275z m355 -15 l130 -130 -133 0 -132 0 0 130 c0 72 1 130 3 130 1 0 61 -58
          132 -130z m-2275 -930 l0 -900 -210 0 -210 0 0 900 0 900 210 0 210 0 0 -900z
          m-640 -209 l0 -689 -178 -4 c-147 -2 -182 -6 -204 -20 -23 -15 -53 -98 -241
          -660 l-215 -643 -1 1353 -1 1352 420 0 420 0 0 -689z m3516 -1758 l-283 -848
          -2011 -3 c-1107 -1 -2012 1 -2012 5 0 6 534 1626 551 1670 l9 23 2014 0 2014
          0 -282 -847z"
        />
        <path
          d="M2183 3720 c-17 -10 -37 -28 -42 -39 -24 -45 -3 -129 38 -151 13 -6
          221 -10 598 -10 l579 0 28 28 c34 37 43 89 22 130 -33 63 -18 62 -633 62 -535
          0 -559 -1 -590 -20z"
        />
        <path
          d="M2164 3276 c-28 -28 -34 -42 -34 -76 0 -34 6 -48 34 -76 l34 -34 362
          0 362 0 34 34 c28 28 34 42 34 76 0 34 -6 48 -34 76 l-34 34 -362 0 -362 0
          -34 -34z"
        />
      </g>
    </svg>
  );
};

export const ThreeDRotation = (props) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g clipPath="url(#clip0_2544_26249)">
        <path
          d="M13.282 35.8C7.83203 33.2333 3.93203 27.9333 3.33203 21.6667H0.832031C1.68203 31.9333 10.2654 40 20.7487 40L21.8487 39.95L15.4987 33.6L13.282 35.8ZM14.7654 24.9333C14.4487 24.9333 14.1487 24.8833 13.8987 24.8C13.632 24.7 13.4154 24.5833 13.232 24.4C13.0487 24.2333 12.8987 24.0333 12.7987 23.7833C12.6987 23.55 12.6487 23.2833 12.6487 23H10.482C10.482 23.6 10.5987 24.1333 10.832 24.5833C11.0654 25.0333 11.382 25.4167 11.7654 25.7333C12.1654 26.0333 12.6154 26.2667 13.132 26.4167C13.632 26.5833 14.1654 26.6667 14.732 26.6667C15.3487 26.6667 15.932 26.5833 16.4487 26.4167C16.982 26.25 17.4487 26 17.832 25.6833C18.2154 25.3667 18.532 24.9667 18.7487 24.4833C18.9654 24 19.082 23.4667 19.082 22.8667C19.082 22.55 19.0487 22.2333 18.9654 21.9333C18.882 21.6333 18.7654 21.35 18.582 21.0833C18.4154 20.8167 18.182 20.5833 17.9154 20.3667C17.632 20.15 17.2987 19.9833 16.8987 19.85C17.232 19.7 17.5154 19.5167 17.7654 19.3C18.0154 19.0833 18.2154 18.85 18.382 18.6C18.5487 18.35 18.6654 18.1 18.7487 17.8333C18.832 17.5667 18.8654 17.3 18.8654 17.0333C18.8654 16.4333 18.7654 15.9 18.5654 15.4333C18.3654 14.9667 18.082 14.5833 17.7154 14.2833C17.382 13.9667 16.932 13.7333 16.432 13.5667C15.9154 13.4167 15.3487 13.3333 14.732 13.3333C14.132 13.3333 13.582 13.4167 13.0654 13.6C12.5654 13.7833 12.1154 14.0333 11.7487 14.35C11.3987 14.6667 11.1154 15.0333 10.8987 15.4667C10.6987 15.9 10.5987 16.3667 10.5987 16.8833H12.7654C12.7654 16.6 12.8154 16.35 12.9154 16.1333C13.0154 15.9167 13.1487 15.7167 13.332 15.5667C13.5154 15.4167 13.7154 15.2833 13.9654 15.2C14.2154 15.1167 14.4654 15.0667 14.7654 15.0667C15.432 15.0667 15.932 15.2333 16.2487 15.5833C16.5654 15.9167 16.732 16.4 16.732 17.0167C16.732 17.3167 16.682 17.5833 16.5987 17.8333C16.5154 18.0833 16.3654 18.2833 16.182 18.45C15.9987 18.6167 15.7654 18.75 15.4987 18.85C15.232 18.95 14.8987 19 14.532 19H13.2487V20.7167H14.532C14.8987 20.7167 15.232 20.75 15.532 20.8333C15.832 20.9167 16.082 21.05 16.282 21.2167C16.482 21.4 16.6487 21.6167 16.7654 21.8833C16.882 22.15 16.932 22.4667 16.932 22.8333C16.932 23.5167 16.732 24.0333 16.3487 24.3833C15.9654 24.7667 15.432 24.9333 14.7654 24.9333ZM29.0154 15.0667C28.482 14.5167 27.8487 14.0833 27.1154 13.7833C26.3987 13.4833 25.582 13.3333 24.682 13.3333H20.7487V26.6667H24.582C25.4987 26.6667 26.3487 26.5167 27.0987 26.2167C27.8487 25.9167 28.4987 25.5 29.032 24.95C29.5654 24.4 29.982 23.7333 30.2654 22.9667C30.5487 22.1833 30.6987 21.3167 30.6987 20.35V19.6833C30.6987 18.7167 30.5487 17.85 30.2654 17.0667C29.9654 16.2833 29.5487 15.6167 29.0154 15.0667ZM28.3654 20.3333C28.3654 21.0333 28.282 21.65 28.132 22.2167C27.9654 22.7667 27.732 23.25 27.4154 23.6333C27.0987 24.0167 26.6987 24.3167 26.232 24.5167C25.7487 24.7167 25.1987 24.8167 24.582 24.8167H23.0654V15.2H24.682C25.882 15.2 26.7987 15.5833 27.4154 16.35C28.0487 17.1167 28.3654 18.2167 28.3654 19.6667V20.3333ZM20.7487 0L19.6487 0.05L25.9987 6.4L28.2154 4.18333C33.6654 6.76667 37.5654 12.05 38.1487 18.3167H40.6487C39.8154 8.06667 31.232 0 20.7487 0Z"
          fill={props?.color ? props?.color : 'black'}
        />
      </g>
      <defs>
        <clipPath id="clip0_2544_26249">
          <rect
            width="40"
            height="40"
            fill={props?.color ? props?.color : 'black'}
            transform="translate(0.75)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const RequestImageIcon = (props) => {
  return (
    <svg
      width={30}
      height={30}
      viewBox="0 0 40 40"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M4.44444 40C3.22222 40 2.17593 39.5648 1.30556 38.6944C0.435185 37.8241 0 36.7778 0 35.5556V4.44444C0 3.22222 0.435185 2.17593 1.30556 1.30556C2.17593 0.435185 3.22222 0 4.44444 0H24.4444V4.44444H4.44444V35.5556H35.5556V15.5556H40V35.5556C40 36.7778 39.5648 37.8241 38.6944 38.6944C37.8241 39.5648 36.7778 40 35.5556 40H4.44444ZM31.1111 13.3333V8.88889H26.6667V4.44444H31.1111V0H35.5556V4.44444H40V8.88889H35.5556V13.3333H31.1111ZM6.66667 31.1111H33.3333L25 20L18.3333 28.8889L13.3333 22.2222L6.66667 31.1111Z"
        fill="#EAEAEA"
      />
      <path
        d="M4.44444 40C3.22222 40 2.17593 39.5648 1.30556 38.6944C0.435185 37.8241 0 36.7778 0 35.5556V4.44444C0 3.22222 0.435185 2.17593 1.30556 1.30556C2.17593 0.435185 3.22222 0 4.44444 0H24.4444V4.44444H4.44444V35.5556H35.5556V15.5556H40V35.5556C40 36.7778 39.5648 37.8241 38.6944 38.6944C37.8241 39.5648 36.7778 40 35.5556 40H4.44444ZM31.1111 13.3333V8.88889H26.6667V4.44444H31.1111V0H35.5556V4.44444H40V8.88889H35.5556V13.3333H31.1111ZM6.66667 31.1111H33.3333L25 20L18.3333 28.8889L13.3333 22.2222L6.66667 31.1111Z"
        fill="black"
        fillOpacity="0.2"
      />
    </svg>
  );
};

export const ImagineLogo = (style = {}) => {
  const _style = {
    margin: '0.156rem 0',
    width: '1.281rem',
    verticalAlign: 'bottom',
    ...style,
  };
  return <img src={MAIN_LOGO} style={_style} />;
};

export const ImagineAIIcon = (props) => {
  return (
    <svg
      width={16}
      height={16}
      viewBox="-2 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M1.16667 14.8L8 1.9875L14.8333 14.8H1.16667Z"
        stroke="currentColor"
        strokeWidth="1.4"
      />
      <path
        d="M8 7.5L9.06069 9.43937L11 10.5L9.06069 11.5607L8 13.5L6.93937 11.5607L5 10.5L6.93937 9.43937L8 7.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const AIVideoPlayIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={28} height={28} viewBox="0 0 28 28" fill="none">
      <path
        d="M11.1434 19.362L19.1423 14.2199L11.1434 9.07779V19.362ZM14.0002 25.6468C12.4195 25.6468 10.934 25.3469 9.54368 24.747C8.1534 24.1471 6.94405 23.3329 5.91562 22.3045C4.8872 21.276 4.07303 20.0667 3.47311 18.6764C2.8732 17.2861 2.57324 15.8006 2.57324 14.2199C2.57324 12.6392 2.8732 11.1537 3.47311 9.7634C4.07303 8.37312 4.8872 7.16377 5.91562 6.13535C6.94405 5.10692 8.1534 4.29275 9.54368 3.69284C10.934 3.09293 12.4195 2.79297 14.0002 2.79297C15.5809 2.79297 17.0664 3.09293 18.4567 3.69284C19.847 4.29275 21.0563 5.10692 22.0847 6.13535C23.1132 7.16377 23.9273 8.37312 24.5273 9.7634C25.1272 11.1537 25.4271 12.6392 25.4271 14.2199C25.4271 15.8006 25.1272 17.2861 24.5273 18.6764C23.9273 20.0667 23.1132 21.276 22.0847 22.3045C21.0563 23.3329 19.847 24.1471 18.4567 24.747C17.0664 25.3469 15.5809 25.6468 14.0002 25.6468ZM14.0002 23.3615C16.5522 23.3615 18.7138 22.4759 20.485 20.7047C22.2561 18.9335 23.1417 16.7719 23.1417 14.2199C23.1417 11.6679 22.2561 9.5063 20.485 7.73512C18.7138 5.96394 16.5522 5.07836 14.0002 5.07836C11.4482 5.07836 9.28657 5.96394 7.51539 7.73512C5.74422 9.5063 4.85863 11.6679 4.85863 14.2199C4.85863 16.7719 5.74422 18.9335 7.51539 20.7047C9.28657 22.4759 11.4482 23.3615 14.0002 23.3615Z"
        fill="#EC4E0B"
      />
    </svg>
  );
};

export const DimensionToolIcon = (props) => {
  return (
    <svg
      width="53"
      height="15"
      viewBox="0 0 53 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <rect x="0.5" y="0.5" width="52" height="14" rx="0.5" stroke="#FEFFFF" />
      <line x1="5.5" y1="14" x2="5.5" y2="5" stroke="#FEFFFF" />
      <line x1="15.5" y1="14" x2="15.5" y2="5" stroke="#FEFFFF" />
      <line x1="10.5" y1="14" x2="10.5" y2="9" stroke="#FEFFFF" />
      <line x1="25.5" y1="14" x2="25.5" y2="5" stroke="#FEFFFF" />
      <line x1="35.5" y1="14" x2="35.5" y2="5" stroke="#FEFFFF" />
      <line x1="30.5" y1="14" x2="30.5" y2="9" stroke="#FEFFFF" />
      <line x1="20.5" y1="14" x2="20.5" y2="9" stroke="#FEFFFF" />
      <line x1="40.5" y1="14" x2="40.5" y2="1" stroke="#FEFFFF" />
      <circle cx="46.5" cy="7.5" r="3" stroke="#FEFFFF" />
    </svg>
  );
};

export const DimensionToolIconV2 = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="54"
      height="15"
      viewBox="0 0 54 15"
      fill="none"
      {...props}>
      <path
        d="M3.80176 1.44238H50.8008C52.1639 1.44253 53.2753 2.53458 53.2998 3.89746L53.4453 11.9551C53.4703 13.353 52.3435 14.5 50.9453 14.5H3.94629C2.58317 14.5 1.47092 13.4078 1.44629 12.0449L1.30176 3.9873C1.2782 2.67654 2.26704 1.58707 3.54297 1.45605L3.80176 1.44238Z"
        stroke="#FEFFFF"
      />
      <line x1="6.5" y1="14" x2="6.5" y2="6.21191" stroke="#FEFFFF" />
      <line x1="16.5" y1="14" x2="16.5" y2="6.21191" stroke="#FEFFFF" />
      <line x1="11.5" y1="14" x2="11.5" y2="10.1504" stroke="#FEFFFF" />
      <line x1="26.5" y1="14" x2="26.5" y2="6.21191" stroke="#FEFFFF" />
      <line x1="36.5" y1="14" x2="36.5" y2="6.21191" stroke="#FEFFFF" />
      <line x1="31.5" y1="14" x2="31.5" y2="10.1504" stroke="#FEFFFF" />
      <line x1="21.5" y1="14" x2="21.5" y2="10.1504" stroke="#FEFFFF" />
      <line x1="41.5" y1="14" x2="41.5" y2="1" stroke="#FEFFFF" />
      <circle cx="47.5" cy="7.5" r="2.25039" stroke="#FEFFFF" stroke-width="0.8" />
    </svg>
  );
};

export const MagicToolIcon = (props) => {
  return (
    <svg
      width="24"
      height="23"
      viewBox="0 0 24 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M9.02925 19.9498C9.08531 19.9829 9.14863 20.0002 9.213 20C9.29761 20.0003 9.38014 19.9725 9.44868 19.9205C9.51065 19.874 9.55863 19.8099 9.58694 19.7358C9.61525 19.6617 9.62272 19.5806 9.60846 19.5022L9.02925 19.9498ZM9.02925 19.9498L6.99202 18.8287L4.9468 19.9456C4.8812 19.982 4.8072 19.9986 4.73311 19.9934C4.65902 19.9883 4.58778 19.9616 4.52737 19.9163M9.02925 19.9498L3.01743 15.0304C2.99624 15.103 2.99433 15.1803 3.01193 15.254C3.02952 15.3277 3.06595 15.395 3.11729 15.4487L4.76705 17.122L4.36759 19.498C4.35333 19.5764 4.3608 19.6575 4.38911 19.7316C4.41742 19.8057 4.4654 19.8698 4.52737 19.9163M4.52737 19.9163L4.7374 19.6364C4.72959 19.6305 4.72142 19.6207 4.71607 19.6067C4.71069 19.5926 4.70907 19.5764 4.71194 19.5606L4.71197 19.5606L4.71275 19.556L5.1122 17.18L5.14186 17.0036L5.01628 16.8762L3.36918 15.2056C3.36206 15.1978 3.35569 15.1867 3.35236 15.1728C3.34911 15.1592 3.34924 15.1448 3.35259 15.1314C3.35716 15.1185 3.36424 15.1089 3.37145 15.1025C3.37907 15.0958 3.38653 15.093 3.39252 15.0921L3.39252 15.0921L3.39446 15.0918L5.66737 14.7404L5.85108 14.712L5.93042 14.5439L6.94903 12.3853L6.94904 12.3854L6.95018 12.3829C6.95616 12.37 6.9644 12.3614 6.97193 12.3565C6.97928 12.3516 6.9862 12.35 6.99202 12.35C6.99784 12.35 7.00476 12.3516 7.01211 12.3565C7.01964 12.3614 7.02788 12.37 7.03386 12.3829L7.03385 12.3829L7.03489 12.3851L8.05351 14.5478L8.13296 14.7165L8.31729 14.7447L10.5902 15.0919L10.601 15.0935L10.6118 15.0945C10.6179 15.095 10.6254 15.0975 10.6332 15.1039C10.639 15.1086 10.6449 15.1155 10.6495 15.1246C10.6507 15.136 10.6497 15.1476 10.6464 15.1585C10.642 15.1732 10.6343 15.1841 10.6265 15.191L10.6177 15.1988L10.6095 15.2071L8.95977 16.8804L8.83419 17.0078L8.86384 17.1842L9.2633 19.5602L9.26327 19.5602L9.2641 19.5648C9.26698 19.5806 9.26536 19.5968 9.25998 19.6109C9.25463 19.6249 9.24646 19.6347 9.23864 19.6405L9.23864 19.6405L9.23722 19.6416C9.22879 19.648 9.22076 19.65 9.2143 19.65L9.2118 19.65C9.21123 19.65 9.20973 19.6499 9.20727 19.6485L9.20736 19.6483L9.19799 19.6432L7.16076 18.5221L6.99266 18.4296L6.82427 18.5215L4.77905 19.6384L4.77904 19.6384L4.7769 19.6396C4.76987 19.6435 4.76327 19.6447 4.75749 19.6443C4.75167 19.6439 4.74457 19.6417 4.73713 19.6362L4.52737 19.9163Z"
        stroke="currentColor"
        strokeWidth="0.7"
      />
      <path
        d="M16.5 6L18.5162 10.4872L22.5 12.5L18.5162 14.5453L16.5 19L14.4581 14.5453L10 12.5L14.4581 10.4872L16.5 6Z"
        stroke="currentColor"
        strokeWidth="0.8"
        strokeLinejoin="round"
      />
      <path
        d="M8.8823 0.621094L10.6548 3.23091L13.2646 5.0034L10.6548 6.77588L8.8823 9.3857L7.10981 6.77588L4.5 5.0034L7.10981 3.23091L8.8823 0.621094Z"
        stroke="currentColor"
        strokeWidth="0.8"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ThemedInfoIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g clipPath="url(#clip0_192_6470)">
        <path
          d="M11 17H13V11H11V17ZM12 9C12.2833 9 12.5208 8.90417 12.7125 8.7125C12.9042 8.52083 13 8.28333 13 8C13 7.71667 12.9042 7.47917 12.7125 7.2875C12.5208 7.09583 12.2833 7 12 7C11.7167 7 11.4792 7.09583 11.2875 7.2875C11.0958 7.47917 11 7.71667 11 8C11 8.28333 11.0958 8.52083 11.2875 8.7125C11.4792 8.90417 11.7167 9 12 9ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z"
          fill="#EC4E0B"
        />
      </g>
      <defs>
        <clipPath id="clip0_192_6470">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LinkIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <mask
        id="mask0_121_1471"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_121_1471)">
        <path
          d="M11 17H7C5.61667 17 4.4375 16.5125 3.4625 15.5375C2.4875 14.5625 2 13.3833 2 12C2 10.6167 2.4875 9.4375 3.4625 8.4625C4.4375 7.4875 5.61667 7 7 7H11V9H7C6.16667 9 5.45833 9.29167 4.875 9.875C4.29167 10.4583 4 11.1667 4 12C4 12.8333 4.29167 13.5417 4.875 14.125C5.45833 14.7083 6.16667 15 7 15H11V17ZM8 13V11H16V13H8ZM13 17V15H17C17.8333 15 18.5417 14.7083 19.125 14.125C19.7083 13.5417 20 12.8333 20 12C20 11.1667 19.7083 10.4583 19.125 9.875C18.5417 9.29167 17.8333 9 17 9H13V7H17C18.3833 7 19.5625 7.4875 20.5375 8.4625C21.5125 9.4375 22 10.6167 22 12C22 13.3833 21.5125 14.5625 20.5375 15.5375C19.5625 16.5125 18.3833 17 17 17H13Z"
          fill="#2B2A28"
        />
      </g>
    </svg>
  );
};

export const IFrameIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <mask
        id="mask0_121_1474"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_121_1474)">
        <path
          d="M11.5 13.5H16.5V11.5H11.5V13.5ZM10 15V10H18V15H10ZM4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4ZM4 18H20V8H4V18Z"
          fill="#2B2A28"
        />
      </g>
    </svg>
  );
};

export const AddCircleIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <mask
        id="mask0_121_2216"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_121_2216)">
        <path
          d="M11 17H13V13H17V11H13V7H11V11H7V13H11V17ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z"
          fill="#282828"
        />
      </g>
    </svg>
  );
};

export const RemoveCircleIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <mask
        id="mask0_121_1037"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_121_1037)">
        <path
          d="M7 13H17V11H7V13ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z"
          fill="#FF2F13"
        />
      </g>
    </svg>
  );
};
export const LeftArrowALT = (props) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M3.825 9.5L9.425 15.1L8 16.5L0 8.5L8 0.5L9.425 1.9L3.825 7.5H16V9.5H3.825Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const RightArrowALT = (props) => {
  return (
    <svg
      {...props}
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.175 9.5H0V7.5H12.175L6.575 1.9L8 0.5L16 8.5L8 16.5L6.575 15.1L12.175 9.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const ModelIcon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <mask
        id="mask0_7389_33728"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_7389_33728)">
        <path
          d="M11 19.425V12.575L5 9.1V15.95L11 19.425ZM13 19.425L19 15.95V9.1L13 12.575V19.425ZM12 10.85L17.925 7.425L12 4L6.075 7.425L12 10.85ZM4 17.7C3.68333 17.5167 3.4375 17.275 3.2625 16.975C3.0875 16.675 3 16.3417 3 15.975V8.025C3 7.65833 3.0875 7.325 3.2625 7.025C3.4375 6.725 3.68333 6.48333 4 6.3L11 2.275C11.3167 2.09167 11.65 2 12 2C12.35 2 12.6833 2.09167 13 2.275L20 6.3C20.3167 6.48333 20.5625 6.725 20.7375 7.025C20.9125 7.325 21 7.65833 21 8.025V15.975C21 16.3417 20.9125 16.675 20.7375 16.975C20.5625 17.275 20.3167 17.5167 20 17.7L13 21.725C12.6833 21.9083 12.35 22 12 22C11.65 22 11.3167 21.9083 11 21.725L4 17.7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const PDFIcon = (props) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <mask
        id="mask0_7389_28063"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="25"
        height="24">
        <rect x="0.199951" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_7389_28063)">
        <path
          d="M9.36199 12.5636H10.3851V10.5515H11.4083C11.6982 10.5515 11.9412 10.4551 12.1373 10.2623C12.3334 10.0694 12.4314 9.8305 12.4314 9.54545V8.53939C12.4314 8.25434 12.3334 8.0154 12.1373 7.82258C11.9412 7.62975 11.6982 7.53333 11.4083 7.53333H9.36199V12.5636ZM10.3851 9.54545V8.53939H11.4083V9.54545H10.3851ZM13.4546 12.5636H15.5009C15.7908 12.5636 16.0338 12.4672 16.2299 12.2744C16.426 12.0816 16.524 11.8426 16.524 11.5576V8.53939C16.524 8.25434 16.426 8.0154 16.2299 7.82258C16.0338 7.62975 15.7908 7.53333 15.5009 7.53333H13.4546V12.5636ZM14.4777 11.5576V8.53939H15.5009V11.5576H14.4777ZM17.5472 12.5636H18.5703V10.5515H19.5935V9.54545H18.5703V8.53939H19.5935V7.53333H17.5472V12.5636ZM8.33884 18.097C7.77611 18.097 7.29438 17.9 6.89364 17.5059C6.49291 17.1119 6.29254 16.6382 6.29254 16.0848V4.01212C6.29254 3.45879 6.49291 2.9851 6.89364 2.59106C7.29438 2.19702 7.77611 2 8.33884 2H20.6166C21.1793 2 21.6611 2.19702 22.0618 2.59106C22.4625 2.9851 22.6629 3.45879 22.6629 4.01212V16.0848C22.6629 16.6382 22.4625 17.1119 22.0618 17.5059C21.6611 17.9 21.1793 18.097 20.6166 18.097H8.33884ZM8.33884 16.0848H20.6166V4.01212H8.33884V16.0848ZM4.24625 22.1212C3.68352 22.1212 3.20178 21.9242 2.80105 21.5302C2.40032 21.1361 2.19995 20.6624 2.19995 20.1091V6.02424H4.24625V20.1091H18.5703V22.1212H4.24625Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const FileIcon = (props) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <mask
        id="mask0_7389_28119"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="25"
        height="24">
        <rect x="0.399902" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_7389_28119)">
        <path
          d="M8.3999 18H16.3999V16H8.3999V18ZM8.3999 14H16.3999V12H8.3999V14ZM6.3999 22C5.8499 22 5.37907 21.8042 4.9874 21.4125C4.59574 21.0208 4.3999 20.55 4.3999 20V4C4.3999 3.45 4.59574 2.97917 4.9874 2.5875C5.37907 2.19583 5.8499 2 6.3999 2H14.3999L20.3999 8V20C20.3999 20.55 20.2041 21.0208 19.8124 21.4125C19.4207 21.8042 18.9499 22 18.3999 22H6.3999ZM13.3999 9V4H6.3999V20H18.3999V9H13.3999Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const DownloadV2Icon = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <mask
        id="mask0_7389_33725"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="19"
        height="18">
        <rect x="0.199951" width="18" height="18" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_7389_33725)">
        <path
          d="M9.19995 12L5.44995 8.25L6.49995 7.1625L8.44995 9.1125V3H9.94995V9.1125L11.9 7.1625L12.95 8.25L9.19995 12ZM4.69995 15C4.28745 15 3.93433 14.8531 3.64058 14.5594C3.34683 14.2656 3.19995 13.9125 3.19995 13.5V11.25H4.69995V13.5H13.7V11.25H15.2V13.5C15.2 13.9125 15.0531 14.2656 14.7593 14.5594C14.4656 14.8531 14.1125 15 13.7 15H4.69995Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
export const ProductGroupArrowAlt = (props) => {
  return (
    <svg
      {...props}
      width="8"
      height="12"
      viewBox="0 0 8 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M4.6 6L0 1.4L1.4 0L7.4 6L1.4 12L0 10.6L4.6 6Z" fill="currentColor" />
    </svg>
  );
};
export const ProductGroupFolder = (props) => {
  return (
    <svg
      {...props}
      width="16"
      height="12"
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 12C1.5875 12 1.23438 11.8531 0.940625 11.5594C0.646875 11.2656 0.5 10.9125 0.5 10.5V1.5C0.5 1.0875 0.646875 0.734375 0.940625 0.440625C1.23438 0.146875 1.5875 0 2 0H6.5L8 1.5H14C14.4125 1.5 14.7656 1.64688 15.0594 1.94063C15.3531 2.23438 15.5 2.5875 15.5 3V10.5C15.5 10.9125 15.3531 11.2656 15.0594 11.5594C14.7656 11.8531 14.4125 12 14 12H2ZM2 10.5H14V3H7.38125L5.88125 1.5H2V10.5Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const ProductGroupRightIcon = (props) => {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g mask="url(#mask0_27638_5355)">
        <path d="M15 12L10 17V7L15 12Z" fill="currentColor" />
      </g>
    </svg>
  );
};
export const ProductGroupFileIcon = (props) => {
  return (
    <svg
      {...props}
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.5 15.5C1.0875 15.5 0.734375 15.3531 0.440625 15.0594C0.146875 14.7656 0 14.4125 0 14V2C0 1.5875 0.146875 1.23438 0.440625 0.940625C0.734375 0.646875 1.0875 0.5 1.5 0.5H7.5L12 5V14C12 14.4125 11.8531 14.7656 11.5594 15.0594C11.2656 15.3531 10.9125 15.5 10.5 15.5H1.5ZM6.75 5.75V2H1.5V14H10.5V5.75H6.75Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const RetailAutomationIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <mask
        id="mask0_6282_4642"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6282_4642)">
        <path
          d="M6 17H7.5V15.5H16.5V17H18V12.85C18 12.35 17.8625 11.9042 17.5875 11.5125C17.3125 11.1208 16.95 10.8333 16.5 10.65V9C16.5 8.45 16.3042 7.97917 15.9125 7.5875C15.5208 7.19583 15.05 7 14.5 7H9.5C8.95 7 8.47917 7.19583 8.0875 7.5875C7.69583 7.97917 7.5 8.45 7.5 9V10.65C7.05 10.8333 6.6875 11.1208 6.4125 11.5125C6.1375 11.9042 6 12.35 6 12.85V17ZM7.5 14V12.85C7.5 12.6167 7.58333 12.4167 7.75 12.25C7.91667 12.0833 8.11667 12 8.35 12H15.65C15.8833 12 16.0833 12.0833 16.25 12.25C16.4167 12.4167 16.5 12.6167 16.5 12.85V14H7.5ZM9 10.5V8.5H15V10.5H9ZM4 22C3.45 22 2.97917 21.8042 2.5875 21.4125C2.19583 21.0208 2 20.55 2 20V4C2 3.45 2.19583 2.97917 2.5875 2.5875C2.97917 2.19583 3.45 2 4 2H20C20.55 2 21.0208 2.19583 21.4125 2.5875C21.8042 2.97917 22 3.45 22 4V20C22 20.55 21.8042 21.0208 21.4125 21.4125C21.0208 21.8042 20.55 22 20 22H4Z"
          fill="#2B2A28"
        />
      </g>
    </svg>
  );
};
export const DiscordIcon = (props) => {
  return (
    <svg
      width={24}
      height={19.2}
      viewBox="0 0 24 19.2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M20.33 1.828A19.56 19.56 0 0 0 15.379 0.272c-0.214 0.384 -0.463 0.904 -0.635 1.316a18.24 18.24 0 0 0 -5.488 0A14.4 14.4 0 0 0 8.616 0.272c-1.738 0.3 -3.401 0.83 -4.955 1.56C0.528 6.565 -0.323 11.184 0.102 15.736a19.8 19.8 0 0 0 6.072 3.112q0.736 -1.01 1.301 -2.142a12.84 12.84 0 0 1 -2.047 -0.996q0.258 -0.192 0.502 -0.398c3.948 1.848 8.239 1.848 12.142 0q0.247 0.205 0.502 0.397a12.72 12.72 0 0 1 -2.052 1c0.377 0.751 0.81 1.469 1.301 2.142a19.8 19.8 0 0 0 6.077 -3.114c0.498 -5.278 -0.852 -9.852 -3.568 -13.908M8.014 12.937c-1.186 0 -2.158 -1.106 -2.158 -2.454 0 -1.349 0.95 -2.456 2.158 -2.456 1.206 0 2.178 1.106 2.158 2.456 0.001 1.348 -0.952 2.454 -2.158 2.454m7.973 0c-1.186 0 -2.158 -1.106 -2.158 -2.454 0 -1.349 0.952 -2.456 2.158 -2.456 1.207 0 2.179 1.106 2.158 2.456 0 1.348 -0.95 2.454 -2.158 2.454"
        fill="#5865F2"
      />
    </svg>
  );
};

export const MyPlansIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g>
        <path
          d="M9.16536 15.8327H10.832V14.9993H11.6654C11.9015 14.9993 12.0994 14.9195 12.2591 14.7598C12.4188 14.6 12.4987 14.4021 12.4987 14.166V11.666C12.4987 11.4299 12.4188 11.232 12.2591 11.0723C12.0994 10.9125 11.9015 10.8327 11.6654 10.8327H9.16536V9.99935H12.4987V8.33268H10.832V7.49935H9.16536V8.33268H8.33203C8.09592 8.33268 7.898 8.41254 7.73828 8.57227C7.57856 8.73199 7.4987 8.9299 7.4987 9.16602V11.666C7.4987 11.9021 7.57856 12.1 7.73828 12.2598C7.898 12.4195 8.09592 12.4993 8.33203 12.4993H10.832V13.3327H7.4987V14.9993H9.16536V15.8327ZM4.9987 18.3327C4.54036 18.3327 4.148 18.1695 3.82161 17.8431C3.49523 17.5167 3.33203 17.1243 3.33203 16.666V3.33268C3.33203 2.87435 3.49523 2.48199 3.82161 2.1556C4.148 1.82921 4.54036 1.66602 4.9987 1.66602H11.6654L16.6654 6.66602V16.666C16.6654 17.1243 16.5022 17.5167 16.1758 17.8431C15.8494 18.1695 15.457 18.3327 14.9987 18.3327H4.9987ZM10.832 6.66602V3.33268H4.9987V16.666H14.9987V6.66602H10.832Z"
          fill="#EC4E0B"
        />
      </g>
    </svg>
  );
};

export const WhiteTick = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
      <path
        d="M5.66378 10.27L2.55469 7.16094L3.33196 6.38366L5.66378 8.71548L10.6683 3.71094L11.4456 4.48821L5.66378 10.27Z"
        fill="#FBFAF9"
      />
    </svg>
  );
};
export const InstagramIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={24}
      height={23.999}
      viewBox="0 0 24 23.999"
      {...props}>
      <defs>
        <path id="b" d="">
          <stop offset={0} stopColor="#3771c8" />
          <stop stopColor="#3771c8" offset={0.128} />
          <stop offset={1} stopColor="#60f" stopOpacity={0} />
        </path>
        <path id="a" d="">
          <stop offset={0} stopColor="#fd5" />
          <stop offset={0.1} stopColor="#fd5" />
          <stop offset={0.5} stopColor="#ff543e" />
          <stop offset={1} stopColor="#c837ab" />
        </path>
        <radialGradient
          id="c"
          cx={158.429}
          cy={578.088}
          r={65}
          xlinkHref="#a"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(0 -1.98198 1.8439 0 -1031.402 454.004)"
          fx={158.429}
          fy={578.088}
        />
        <radialGradient
          id="d"
          cx={147.694}
          cy={473.455}
          r={65}
          xlinkHref="#b"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(.17394 .86872 -3.5818 .71718 1648.348 -458.493)"
          fx={147.694}
          fy={473.455}
        />
      </defs>
      <path
        fill="url(#c)"
        d="M11.823 0C6.889 0 5.445 0.005 5.165 0.028c-1.013 0.084 -1.643 0.244 -2.329 0.585 -0.529 0.263 -0.946 0.567 -1.358 0.994C0.727 2.386 0.273 3.344 0.108 4.483c-0.08 0.553 -0.103 0.665 -0.108 3.489 -0.002 0.941 0 2.18 0 3.841 0 4.931 0.005 6.373 0.029 6.653 0.082 0.985 0.236 1.605 0.564 2.284 0.625 1.298 1.82 2.273 3.227 2.636 0.487 0.125 1.025 0.195 1.716 0.227 0.293 0.013 3.276 0.022 6.262 0.022s5.971 -0.004 6.256 -0.018c0.8 -0.038 1.265 -0.1 1.778 -0.233a4.949 4.949 0 0 0 3.227 -2.642c0.321 -0.662 0.484 -1.305 0.557 -2.239 0.016 -0.204 0.023 -3.45 0.023 -6.693 0 -3.243 -0.007 -6.483 -0.023 -6.687 -0.075 -0.949 -0.237 -1.587 -0.569 -2.262 -0.272 -0.552 -0.574 -0.965 -1.012 -1.386C21.254 0.727 20.298 0.273 19.158 0.108 18.606 0.029 18.496 0.005 15.67 0z"
        transform="translate(1.004 1)"
      />
      <path
        fill="url(#d)"
        d="M11.823 0C6.889 0 5.445 0.005 5.165 0.028c-1.013 0.084 -1.643 0.244 -2.329 0.585 -0.529 0.263 -0.946 0.567 -1.358 0.994C0.727 2.386 0.273 3.344 0.108 4.483c-0.08 0.553 -0.103 0.665 -0.108 3.489 -0.002 0.941 0 2.18 0 3.841 0 4.931 0.005 6.373 0.029 6.653 0.082 0.985 0.236 1.605 0.564 2.284 0.625 1.298 1.82 2.273 3.227 2.636 0.487 0.125 1.025 0.195 1.716 0.227 0.293 0.013 3.276 0.022 6.262 0.022s5.971 -0.004 6.256 -0.018c0.8 -0.038 1.265 -0.1 1.778 -0.233a4.949 4.949 0 0 0 3.227 -2.642c0.321 -0.662 0.484 -1.305 0.557 -2.239 0.016 -0.204 0.023 -3.45 0.023 -6.693 0 -3.243 -0.007 -6.483 -0.023 -6.687 -0.075 -0.949 -0.237 -1.587 -0.569 -2.262 -0.272 -0.552 -0.574 -0.965 -1.012 -1.386C21.254 0.727 20.298 0.273 19.158 0.108 18.606 0.029 18.496 0.005 15.67 0z"
        transform="translate(1.004 1)"
      />
      <path
        fill="currentColor"
        d="M12 3.273c-2.37 0 -2.668 0.01 -3.598 0.053 -0.929 0.043 -1.563 0.19 -2.118 0.405 -0.574 0.223 -1.061 0.521 -1.546 1.006 -0.485 0.485 -0.784 0.972 -1.007 1.546 -0.216 0.555 -0.364 1.189 -0.405 2.118C3.284 9.332 3.273 9.63 3.273 12s0.011 2.667 0.053 3.598c0.043 0.929 0.19 1.563 0.405 2.118 0.223 0.574 0.521 1.061 1.007 1.546 0.485 0.485 0.972 0.784 1.545 1.007 0.555 0.216 1.19 0.363 2.118 0.405 0.931 0.042 1.228 0.053 3.598 0.053 2.37 0 2.667 -0.01 3.598 -0.053 0.929 -0.043 1.564 -0.19 2.119 -0.405 0.574 -0.223 1.06 -0.522 1.545 -1.007 0.485 -0.485 0.784 -0.972 1.007 -1.546 0.215 -0.555 0.362 -1.189 0.405 -2.118 0.042 -0.931 0.053 -1.228 0.053 -3.598s-0.011 -2.668 -0.053 -3.598c-0.044 -0.929 -0.191 -1.563 -0.405 -2.118 -0.224 -0.574 -0.522 -1.061 -1.007 -1.546 -0.485 -0.485 -0.971 -0.784 -1.545 -1.006 -0.556 -0.216 -1.191 -0.363 -2.12 -0.405 -0.931 -0.042 -1.227 -0.053 -3.598 -0.053zm-0.783 1.573c0.232 0 0.492 0 0.783 0 2.33 0 2.606 0.008 3.526 0.05 0.851 0.039 1.313 0.181 1.62 0.301 0.407 0.158 0.698 0.347 1.003 0.653 0.305 0.305 0.495 0.596 0.653 1.004 0.119 0.307 0.262 0.769 0.301 1.62 0.042 0.92 0.051 1.196 0.051 3.525s-0.009 2.605 -0.051 3.525c-0.039 0.851 -0.181 1.313 -0.301 1.62 -0.158 0.407 -0.348 0.697 -0.653 1.003s-0.595 0.495 -1.003 0.653c-0.307 0.12 -0.769 0.262 -1.62 0.301 -0.92 0.042 -1.196 0.051 -3.526 0.051s-2.606 -0.009 -3.526 -0.051c-0.851 -0.039 -1.313 -0.181 -1.62 -0.301 -0.407 -0.158 -0.698 -0.347 -1.004 -0.653s-0.495 -0.596 -0.653 -1.003c-0.119 -0.307 -0.262 -0.769 -0.301 -1.62 -0.042 -0.92 -0.05 -1.196 -0.05 -3.527s0.008 -2.605 0.05 -3.525c0.039 -0.851 0.181 -1.313 0.301 -1.62 0.158 -0.407 0.348 -0.698 0.653 -1.004s0.596 -0.495 1.004 -0.653c0.308 -0.12 0.77 -0.262 1.62 -0.301 0.805 -0.036 1.117 -0.047 2.744 -0.049zm5.441 1.449a1.047 1.047 0 1 0 1.047 1.047c0 -0.578 -0.469 -1.047 -1.047 -1.047zm-4.658 1.224c-2.475 0 -4.482 2.007 -4.482 4.482s2.007 4.481 4.482 4.481S16.481 14.475 16.481 12 14.475 7.518 12 7.518zm0 1.573c1.606 0 2.909 1.302 2.909 2.909s-1.303 2.909 -2.909 2.909 -2.909 -1.303 -2.909 -2.909 1.302 -2.909 2.909 -2.909"
      />
    </svg>
  );
};

const EffortlessVariationCreation = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <mask
        id="mask0_6901_52475"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6901_52475)">
        <path
          d="M12.8002 23C11.4335 23 10.1502 22.6875 8.9502 22.0625C7.7502 21.4375 6.76686 20.5667 6.0002 19.45L1.2002 12.4L1.6752 11.925C2.00853 11.575 2.42103 11.375 2.9127 11.325C3.40436 11.275 3.8502 11.3917 4.2502 11.675L7.0002 13.575V4C7.0002 3.71667 7.09603 3.47917 7.2877 3.2875C7.47936 3.09583 7.71686 3 8.0002 3C8.28353 3 8.52103 3.09583 8.7127 3.2875C8.90436 3.47917 9.0002 3.71667 9.0002 4V12H11.0002V2C11.0002 1.71667 11.096 1.47917 11.2877 1.2875C11.4794 1.09583 11.7169 1 12.0002 1C12.2835 1 12.521 1.09583 12.7127 1.2875C12.9044 1.47917 13.0002 1.71667 13.0002 2V12H15.0002V3C15.0002 2.71667 15.096 2.47917 15.2877 2.2875C15.4794 2.09583 15.7169 2 16.0002 2C16.2835 2 16.521 2.09583 16.7127 2.2875C16.9044 2.47917 17.0002 2.71667 17.0002 3V12H19.0002V5C19.0002 4.71667 19.096 4.47917 19.2877 4.2875C19.4794 4.09583 19.7169 4 20.0002 4C20.2835 4 20.521 4.09583 20.7127 4.2875C20.9044 4.47917 21.0002 4.71667 21.0002 5V14.8C21.0002 17.0833 20.2044 19.0208 18.6127 20.6125C17.021 22.2042 15.0835 23 12.8002 23Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
const ComprehensiveCameraControls = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <mask
        id="mask0_6901_52500"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6901_52500)">
        <path
          d="M11.2 8.375L14.7 2.375C16.2167 2.775 17.5625 3.50833 18.7375 4.575C19.9125 5.64167 20.7667 6.90833 21.3 8.375H11.2ZM8.425 10.875L5 4.875C5.9 3.99167 6.94583 3.29167 8.1375 2.775C9.32917 2.25833 10.6167 2 12 2C12.2167 2 12.4667 2.0125 12.75 2.0375C13.0333 2.0625 13.2917 2.09167 13.525 2.125L8.425 10.875ZM2.325 14.5C2.225 14.1 2.14583 13.6917 2.0875 13.275C2.02917 12.8583 2 12.4333 2 12C2 10.8167 2.19167 9.7 2.575 8.65C2.95833 7.6 3.5 6.64167 4.2 5.775L9.25 14.5H2.325ZM9.325 21.625C7.80833 21.225 6.45833 20.4917 5.275 19.425C4.09167 18.3583 3.23333 17.0917 2.7 15.625H12.775L9.325 21.625ZM12 22C11.75 22 11.4958 21.9833 11.2375 21.95C10.9792 21.9167 10.7333 21.8833 10.5 21.85L15.575 13.125L19 19.125C18.1 20.0083 17.0542 20.7083 15.8625 21.225C14.6708 21.7417 13.3833 22 12 22ZM19.8 18.225L14.75 9.5H21.675C21.775 9.9 21.8542 10.3083 21.9125 10.725C21.9708 11.1417 22 11.5667 22 12C22 13.1667 21.7958 14.2833 21.3875 15.35C20.9792 16.4167 20.45 17.375 19.8 18.225Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
const ChatSupport = (props) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <mask
        id="mask0_6901_52516"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="25"
        height="24">
        <rect x="0.333008" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6901_52516)">
        <path
          d="M2.33301 22V4C2.33301 3.45 2.52884 2.97917 2.92051 2.5875C3.31217 2.19583 3.78301 2 4.33301 2H20.333C20.883 2 21.3538 2.19583 21.7455 2.5875C22.1372 2.97917 22.333 3.45 22.333 4V16C22.333 16.55 22.1372 17.0208 21.7455 17.4125C21.3538 17.8042 20.883 18 20.333 18H6.33301L2.33301 22ZM6.33301 14H14.333V12H6.33301V14ZM6.33301 11H18.333V9H6.33301V11ZM6.33301 8H18.333V6H6.33301V8Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
const SceneArchitectureAdjustment = (props) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <mask
        id="mask0_6901_52483"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="25"
        height="24">
        <rect x="0.666992" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6901_52483)">
        <path
          d="M19.517 21.975C19.3837 21.975 19.2587 21.9542 19.142 21.9125C19.0253 21.8708 18.917 21.8 18.817 21.7L13.717 16.6C13.617 16.5 13.5462 16.3917 13.5045 16.275C13.4628 16.1583 13.442 16.0333 13.442 15.9C13.442 15.7667 13.4628 15.6417 13.5045 15.525C13.5462 15.4083 13.617 15.3 13.717 15.2L15.842 13.075C15.942 12.975 16.0503 12.9042 16.167 12.8625C16.2837 12.8208 16.4087 12.8 16.542 12.8C16.6753 12.8 16.8003 12.8208 16.917 12.8625C17.0337 12.9042 17.142 12.975 17.242 13.075L22.342 18.175C22.442 18.275 22.5128 18.3833 22.5545 18.5C22.5962 18.6167 22.617 18.7417 22.617 18.875C22.617 19.0083 22.5962 19.1333 22.5545 19.25C22.5128 19.3667 22.442 19.475 22.342 19.575L20.217 21.7C20.117 21.8 20.0087 21.8708 19.892 21.9125C19.7753 21.9542 19.6503 21.975 19.517 21.975ZM5.79199 22C5.65866 22 5.52949 21.975 5.40449 21.925C5.27949 21.875 5.16699 21.8 5.06699 21.7L2.96699 19.6C2.86699 19.5 2.79199 19.3875 2.74199 19.2625C2.69199 19.1375 2.66699 19.0083 2.66699 18.875C2.66699 18.7417 2.69199 18.6167 2.74199 18.5C2.79199 18.3833 2.86699 18.275 2.96699 18.175L8.26699 12.875H10.392L11.242 12.025L7.11699 7.9H5.69199L2.66699 4.875L5.49199 2.05L8.51699 5.075V6.5L12.642 10.625L15.542 7.725L14.467 6.65L15.867 5.25H13.042L12.342 4.55L15.892 1L16.592 1.7V4.525L17.992 3.125L21.542 6.675C21.8253 6.95833 22.042 7.27917 22.192 7.6375C22.342 7.99583 22.417 8.375 22.417 8.775C22.417 9.175 22.342 9.55833 22.192 9.925C22.042 10.2917 21.8253 10.6167 21.542 10.9L19.417 8.775L18.017 10.175L16.967 9.125L11.792 14.3V16.4L6.49199 21.7C6.39199 21.8 6.28366 21.875 6.16699 21.925C6.05033 21.975 5.92533 22 5.79199 22Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
const PrecisionLightingControl = (props) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <mask
        id="mask0_6901_52508"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="25"
        height="24">
        <rect x="0.666992" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6901_52508)">
        <path
          d="M12.667 17C11.2837 17 10.1045 16.5125 9.12949 15.5375C8.15449 14.5625 7.66699 13.3833 7.66699 12C7.66699 10.6167 8.15449 9.4375 9.12949 8.4625C10.1045 7.4875 11.2837 7 12.667 7C14.0503 7 15.2295 7.4875 16.2045 8.4625C17.1795 9.4375 17.667 10.6167 17.667 12C17.667 13.3833 17.1795 14.5625 16.2045 15.5375C15.2295 16.5125 14.0503 17 12.667 17ZM5.66699 13H1.66699V11H5.66699V13ZM23.667 13H19.667V11H23.667V13ZM11.667 5V1H13.667V5H11.667ZM11.667 23V19H13.667V23H11.667ZM7.06699 7.75L4.54199 5.325L5.96699 3.85L8.36699 6.35L7.06699 7.75ZM19.367 20.15L16.942 17.625L18.267 16.25L20.792 18.675L19.367 20.15ZM16.917 6.4L19.342 3.875L20.817 5.3L18.317 7.7L16.917 6.4ZM4.51699 18.7L7.04199 16.275L8.41699 17.6L5.99199 20.125L4.51699 18.7Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
const CollaborateAndShareProjects = (props) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <mask
        id="mask0_6901_52491"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="25"
        height="24">
        <rect x="0.333008" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6901_52491)">
        <path
          d="M17.333 22C16.4997 22 15.7913 21.7083 15.208 21.125C14.6247 20.5417 14.333 19.8333 14.333 19C14.333 18.9 14.358 18.6667 14.408 18.3L7.38301 14.2C7.11634 14.45 6.80801 14.6458 6.45801 14.7875C6.10801 14.9292 5.73301 15 5.33301 15C4.49967 15 3.79134 14.7083 3.20801 14.125C2.62467 13.5417 2.33301 12.8333 2.33301 12C2.33301 11.1667 2.62467 10.4583 3.20801 9.875C3.79134 9.29167 4.49967 9 5.33301 9C5.73301 9 6.10801 9.07083 6.45801 9.2125C6.80801 9.35417 7.11634 9.55 7.38301 9.8L14.408 5.7C14.3747 5.58333 14.3538 5.47083 14.3455 5.3625C14.3372 5.25417 14.333 5.13333 14.333 5C14.333 4.16667 14.6247 3.45833 15.208 2.875C15.7913 2.29167 16.4997 2 17.333 2C18.1663 2 18.8747 2.29167 19.458 2.875C20.0413 3.45833 20.333 4.16667 20.333 5C20.333 5.83333 20.0413 6.54167 19.458 7.125C18.8747 7.70833 18.1663 8 17.333 8C16.933 8 16.558 7.92917 16.208 7.7875C15.858 7.64583 15.5497 7.45 15.283 7.2L8.25801 11.3C8.29134 11.4167 8.31217 11.5292 8.32051 11.6375C8.32884 11.7458 8.33301 11.8667 8.33301 12C8.33301 12.1333 8.32884 12.2542 8.32051 12.3625C8.31217 12.4708 8.29134 12.5833 8.25801 12.7L15.283 16.8C15.5497 16.55 15.858 16.3542 16.208 16.2125C16.558 16.0708 16.933 16 17.333 16C18.1663 16 18.8747 16.2917 19.458 16.875C20.0413 17.4583 20.333 18.1667 20.333 19C20.333 19.8333 20.0413 20.5417 19.458 21.125C18.8747 21.7083 18.1663 22 17.333 22Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
const DetailedTextureAndDepthMaps = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <mask
        id="mask0_6901_52450"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6901_52450)">
        <path
          d="M4.4 21C4.08333 20.9333 3.7875 20.7625 3.5125 20.4875C3.2375 20.2125 3.06667 19.9167 3 19.6L19.6 3C19.95 3.08333 20.25 3.25417 20.5 3.5125C20.75 3.77083 20.925 4.06667 21.025 4.4L4.4 21ZM3 14.7V11.9L11.9 3H14.7L3 14.7ZM3 7V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H7L3 7ZM17 21L21 17V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H17ZM9.3 21L21 9.3V12.1L12.1 21H9.3Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
const Custom3DModelsOrUploads = (props) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <mask
        id="mask0_6901_52466"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="25"
        height="24">
        <rect x="0.333008" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6901_52466)">
        <path
          d="M4.33301 22V20H20.333V22H4.33301ZM9.33301 18V11H5.33301L12.333 2L19.333 11H15.333V18H9.33301Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
const AdvancedMaterialCustomization = (props) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <mask
        id="mask0_6901_52458"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="25"
        height="24">
        <rect x="0.666992" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6901_52458)">
        <path
          d="M11.667 19.475L6.66699 16.6C6.35033 16.4167 6.10449 16.175 5.92949 15.875C5.75449 15.575 5.66699 15.2417 5.66699 14.875V9.125C5.66699 8.75833 5.75449 8.425 5.92949 8.125C6.10449 7.825 6.35033 7.58333 6.66699 7.4L11.667 4.525C11.9837 4.34167 12.317 4.25 12.667 4.25C13.017 4.25 13.3503 4.34167 13.667 4.525L18.667 7.4C18.9837 7.58333 19.2295 7.825 19.4045 8.125C19.5795 8.425 19.667 8.75833 19.667 9.125V14.875C19.667 15.2417 19.5795 15.575 19.4045 15.875C19.2295 16.175 18.9837 16.4167 18.667 16.6L13.667 19.475C13.3503 19.6583 13.017 19.75 12.667 19.75C12.317 19.75 11.9837 19.6583 11.667 19.475ZM11.667 17.175V12.575L7.66699 10.25V14.875L11.667 17.175ZM13.667 17.175L17.667 14.875V10.25L13.667 12.575V17.175ZM2.66699 7V4C2.66699 3.45 2.86283 2.97917 3.25449 2.5875C3.64616 2.19583 4.11699 2 4.66699 2H7.66699V4H4.66699V7H2.66699ZM7.66699 22H4.66699C4.11699 22 3.64616 21.8042 3.25449 21.4125C2.86283 21.0208 2.66699 20.55 2.66699 20V17H4.66699V20H7.66699V22ZM17.667 22V20H20.667V17H22.667V20C22.667 20.55 22.4712 21.0208 22.0795 21.4125C21.6878 21.8042 21.217 22 20.667 22H17.667ZM20.667 7V4H17.667V2H20.667C21.217 2 21.6878 2.19583 22.0795 2.5875C22.4712 2.97917 22.667 3.45 22.667 4V7H20.667ZM12.667 10.85L16.617 8.525L12.667 6.25L8.71699 8.525L12.667 10.85Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const StarIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
      <g clipPath="url(#clip0_6901_52538)">
        <path
          d="M12.5 17.77L18.68 21.5L17.04 14.47L22.5 9.74L15.31 9.13L12.5 2.5L9.69 9.13L2.5 9.74L7.96 14.47L6.32 21.5L12.5 17.77Z"
          fill={props?.color}
        />
      </g>
      <defs>
        <clipPath id="clip0_6901_52538">
          <rect width="24" height="24" fill="white" transform="translate(0.5 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const WarningInfoIcon = (props) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g mask="url(#mask0_7386_11102)">
        <path
          d="M9 12.75C9.2125 12.75 9.39063 12.6781 9.53438 12.5344C9.67813 12.3906 9.75 12.2125 9.75 12C9.75 11.7875 9.67813 11.6094 9.53438 11.4656C9.39063 11.3219 9.2125 11.25 9 11.25C8.7875 11.25 8.60938 11.3219 8.46563 11.4656C8.32188 11.6094 8.25 11.7875 8.25 12C8.25 12.2125 8.32188 12.3906 8.46563 12.5344C8.60938 12.6781 8.7875 12.75 9 12.75ZM8.25 9.75H9.75V5.25H8.25V9.75ZM6.1875 15.75L2.25 11.8125V6.1875L6.1875 2.25H11.8125L15.75 6.1875V11.8125L11.8125 15.75H6.1875ZM6.825 14.25H11.175L14.25 11.175V6.825L11.175 3.75H6.825L3.75 6.825V11.175L6.825 14.25Z"
          fill="#EC4E0B"
        />
      </g>
    </svg>
  );
};

export const DesignIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g mask="url(#mask0_642_13458)">
        <path
          d="M2.49967 15.8332C2.04134 15.8332 1.64898 15.67 1.32259 15.3436C0.996202 15.0173 0.833008 14.6249 0.833008 14.1666V5.83323C0.833008 5.3749 0.996202 4.98254 1.32259 4.65615C1.64898 4.32976 2.04134 4.16656 2.49967 4.16656H17.4997C17.958 4.16656 18.3504 4.32976 18.6768 4.65615C19.0031 4.98254 19.1663 5.3749 19.1663 5.83323V14.1666C19.1663 14.6249 19.0031 15.0173 18.6768 15.3436C18.3504 15.67 17.958 15.8332 17.4997 15.8332H2.49967ZM3.33301 14.1666V5.83323H2.49967V14.1666H3.33301ZM4.99967 14.1666H14.9997V5.83323H4.99967V14.1666ZM16.6663 14.1666H17.4997V5.83323H16.6663V14.1666Z"
          fill="#141414"
        />
      </g>
    </svg>
  );
};

export const WarningContentInfoIcon = (props) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g mask="url(#mask0_7351_7349)">
        <path
          d="M15.9998 22.667C16.3776 22.667 16.6943 22.5392 16.9498 22.2837C17.2054 22.0281 17.3332 21.7114 17.3332 21.3337C17.3332 20.9559 17.2054 20.6392 16.9498 20.3837C16.6943 20.1281 16.3776 20.0003 15.9998 20.0003C15.6221 20.0003 15.3054 20.1281 15.0498 20.3837C14.7943 20.6392 14.6665 20.9559 14.6665 21.3337C14.6665 21.7114 14.7943 22.0281 15.0498 22.2837C15.3054 22.5392 15.6221 22.667 15.9998 22.667ZM14.6665 17.3337H17.3332V9.33366H14.6665V17.3337ZM15.9998 29.3337C14.1554 29.3337 12.4221 28.9837 10.7998 28.2837C9.17761 27.5837 7.7665 26.6337 6.5665 25.4337C5.3665 24.2337 4.4165 22.8225 3.7165 21.2003C3.0165 19.5781 2.6665 17.8448 2.6665 16.0003C2.6665 14.1559 3.0165 12.4225 3.7165 10.8003C4.4165 9.1781 5.3665 7.76699 6.5665 6.56699C7.7665 5.36699 9.17761 4.41699 10.7998 3.71699C12.4221 3.01699 14.1554 2.66699 15.9998 2.66699C17.8443 2.66699 19.5776 3.01699 21.1998 3.71699C22.8221 4.41699 24.2332 5.36699 25.4332 6.56699C26.6332 7.76699 27.5832 9.1781 28.2832 10.8003C28.9832 12.4225 29.3332 14.1559 29.3332 16.0003C29.3332 17.8448 28.9832 19.5781 28.2832 21.2003C27.5832 22.8225 26.6332 24.2337 25.4332 25.4337C24.2332 26.6337 22.8221 27.5837 21.1998 28.2837C19.5776 28.9837 17.8443 29.3337 15.9998 29.3337Z"
          fill="#EC4E0B"
        />
      </g>
    </svg>
  );
};

export const CardIcon = (props) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g mask="url(#mask0_569_107503)">
        <path
          d="M22.5 6V18C22.5 18.55 22.3042 19.0208 21.9125 19.4125C21.5208 19.8042 21.05 20 20.5 20H4.5C3.95 20 3.47917 19.8042 3.0875 19.4125C2.69583 19.0208 2.5 18.55 2.5 18V6C2.5 5.45 2.69583 4.97917 3.0875 4.5875C3.47917 4.19583 3.95 4 4.5 4H20.5C21.05 4 21.5208 4.19583 21.9125 4.5875C22.3042 4.97917 22.5 5.45 22.5 6ZM4.5 8H20.5V6H4.5V8ZM4.5 12V18H20.5V12H4.5Z"
          fill="#EC4E0B"
        />
      </g>
    </svg>
  );
};

export const GoogleNewIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
      <path
        d="M22.0555 10.0415H21.25V10H12.25V14H17.9015C17.077 16.3285 14.8615 18 12.25 18C8.9365 18 6.25 15.3135 6.25 12C6.25 8.6865 8.9365 6 12.25 6C13.7795 6 15.171 6.577 16.2305 7.5195L19.059 4.691C17.273 3.0265 14.884 2 12.25 2C6.7275 2 2.25 6.4775 2.25 12C2.25 17.5225 6.7275 22 12.25 22C17.7725 22 22.25 17.5225 22.25 12C22.25 11.3295 22.181 10.675 22.0555 10.0415Z"
        fill="#FFC107"
      />
      <path
        d="M3.40302 7.3455L6.68851 9.755C7.57751 7.554 9.73052 6 12.25 6C13.7795 6 15.171 6.577 16.2305 7.5195L19.059 4.691C17.273 3.0265 14.884 2 12.25 2C8.40902 2 5.07802 4.1685 3.40302 7.3455Z"
        fill="#FF3D00"
      />
      <path
        d="M12.25 22C14.833 22 17.18 21.0115 18.9545 19.404L15.8595 16.785C14.8218 17.5742 13.5537 18.001 12.25 18C9.649 18 7.4405 16.3415 6.6085 14.027L3.3475 16.5395C5.0025 19.778 8.3635 22 12.25 22Z"
        fill="#4CAF50"
      />
      <path
        d="M22.0555 10.0415H21.25V10H12.25V14H17.9015C17.5071 15.1082 16.7967 16.0766 15.858 16.7855L15.8595 16.7845L18.9545 19.4035C18.7355 19.6025 22.25 17 22.25 12C22.25 11.3295 22.181 10.675 22.0555 10.0415Z"
        fill="#1976D2"
      />
    </svg>
  );
};

const VerifyEmailIcon = (props) => {
  return (
    <svg
      width="91"
      height="93"
      viewBox="0 0 91 93"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M37 57.5L1 35L0.5 34L13 23.5L78 23L90 34.5L87.5 51.5L41 54.5L37 57.5Z"
        fill="#FF9B71"
      />
      <path
        d="M13.5 6.88492V40.6146C13.5 42.1234 14.1813 43.5515 15.354 44.5009L32.8963 58.7018C33.9234 59.5333 35.2379 59.9243 36.5525 59.7895L52.8059 58.1225C53.5908 58.042 54.3455 57.7768 55.0084 57.3488L75.7126 43.9773C77.1387 43.0563 78 41.4747 78 39.7771V6.61803C78 5.88278 77.8288 5.15763 77.5 4.5C77.1712 3.84237 76.6938 3.27033 76.1056 2.82918L75.8078 2.60582C75.2746 2.20598 74.667 1.91674 74.0204 1.75511L73.5971 1.64929C73.2005 1.55014 72.7933 1.5 72.3845 1.5H18.8849C17.9787 1.5 17.0895 1.74629 16.3124 2.21254L16.0719 2.35688C15.3681 2.77913 14.7791 3.36812 14.3569 4.07187L14.2125 4.31244C13.7463 5.08952 13.5 5.9787 13.5 6.88492Z"
        fill="#F5F5F5"
      />
      <path
        d="M13.5 43V6C13.5 3.23858 15.7386 1 18.5 1H73C75.7614 1 78 3.23858 78 6V42.5"
        stroke="#BC7659"
      />
      <path
        d="M4.5 89.5L6 91L10 92.5H82L86.5 90L86.9998 89L51 55L46 53L40.5 54.5L4.5 89.5Z"
        fill="#FF9B71"
      />
      <path d="M90 84L87.5 89L54.5 57.5L90 35.5V84Z" fill="#FF9B71" />
      <path d="M37 57.5L4 89L2.5 87L1.5 83.5L1 35.5L37 57.5Z" fill="#FF9B71" />
      <path d="M90 84L87.5 89L54.5 57.5L90 35.5V84Z" fill="#FFDECF" />
      <path d="M37 57.5L4 89L2.5 87L1.5 83.5L1 35.5L37 57.5Z" fill="#FFDECF" />
      <path
        d="M1 35L1.4138 82.5869C1.46153 88.0757 5.9245 92.5 11.4134 92.5H80C85.5228 92.5 90 88.0228 90 82.5V35M4 89.5L38.6037 56.147C42.4596 52.4305 48.5588 52.4114 52.4379 56.1035L87 89"
        stroke="#BC7659"
      />
      <path
        d="M36.7978 57.5L1.18219 35.3978C0.601277 35.0373 0.54533 34.2132 1.07219 33.7775L13.5 23.5M54.2022 57.5L89.844 35.3816C90.4173 35.0258 90.481 34.216 89.9703 33.775L78.071 23.5"
        stroke="#BC7659"
      />
      <path d="M29.3438 18.668L32.9016 23.0013H36.6876L29.3438 18.668Z" fill="#919191" />
      <path d="M29.3438 18.668L29.3297 18.6764L22 23.0013H25.7859L29.3438 18.668Z" fill="#727272" />
      <path d="M29.3438 18.6641L30.8871 22.9974H32.9016L29.3438 18.6641Z" fill="#828282" />
      <path d="M29.3438 22.9974H30.8871L29.3438 18.6641V22.9974Z" fill="#828282" />
      <path d="M27.8008 22.9974H29.3441V18.6641L27.8008 22.9974Z" fill="#828282" />
      <path d="M29.344 18.6641L25.7861 22.9974H27.8007L29.344 18.6641Z" fill="#828282" />
      <path
        d="M29.3438 18.668L29.3539 18.674L36.6877 23.0011L34.7946 19.6503L29.3438 18.668Z"
        fill="#D7D7D7"
      />
      <path d="M29.3447 18.668L34.7956 19.6503L33.7883 17.8672L29.3447 18.668Z" fill="#E6E6E6" />
      <path d="M29.3447 18.6667L33.7883 17.8658L33.0168 16.5L29.3447 18.6667Z" fill="#E6E6E6" />
      <path d="M33.0168 16.4987L32.2451 15.1328L29.3447 18.6653L33.0168 16.4987Z" fill="#E6E6E6" />
      <path d="M29.3447 18.6672L32.2451 15.1347L31.2378 13.3516L29.3447 18.6672Z" fill="#E6E6E6" />
      <path d="M29.3438 18.6665L31.2369 13.3508L29.3438 10V18.6665Z" fill="#F6F6F6" />
      <path d="M29.3443 18.6665V10L27.4512 13.3508L29.3443 18.6665Z" fill="#242424" />
      <path d="M29.344 18.668L23.8931 19.6503L22 23.0011L29.344 18.668Z" fill="#434343" />
      <path d="M29.3438 18.6672L27.4507 13.3516L26.4434 15.1347L29.3438 18.6672Z" fill="#333333" />
      <path d="M26.4425 15.1328L25.6709 16.4987L29.343 18.6653L26.4425 15.1328Z" fill="#333333" />
      <path d="M29.343 18.6667L25.6709 16.5L24.8994 17.8658L29.343 18.6667Z" fill="#333333" />
      <path d="M29.3434 18.668L24.8999 17.8672L23.8926 19.6503L29.3434 18.668Z" fill="#333333" />
      <g style={{ mixBlendMode: 'color' }}>
        <mask
          id="mask0_4592_81369"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="22"
          y="10"
          width="15"
          height="13">
          <g style={{ mixBlendMode: 'difference' }}>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M33.0165 16.4987L29.3446 18.6653L33.0165 16.4987L33.788 17.8645L33.788 17.8645L34.7953 19.6476L29.3447 18.6653L29.3459 18.6668L34.795 19.6489L36.6881 22.9997L29.6563 18.8507L36.6879 22.9998H32.902L32.9005 22.9981H30.8875H29.3442H29.3442H27.8009H25.7877L25.7862 22.9998H22.0003L29.33 18.675L29.3414 18.6681L29.3415 18.6681L22.0001 22.9997L23.8933 19.6489L29.3425 18.6668L29.3437 18.6654L29.3436 18.6653L23.893 19.6476L24.9003 17.8645L24.9003 17.8645L25.6718 16.4987L29.3436 18.6653L29.3437 18.6653L25.6718 16.4987L26.4434 15.1329L26.4434 15.1328L27.4507 13.3497L27.4511 13.3507L29.3441 10L31.2372 13.3508L31.2376 13.3497L32.2449 15.1328V15.1329L33.0165 16.4987ZM22.0003 22.9999L22 23.0001V22.9999H22.0003Z"
              fill="white"
            />
          </g>
        </mask>
        <g mask="url(#mask0_4592_81369)">
          <rect x="22" y="10" width="14.5808" height="13.0003" fill="#DD5E27" />
        </g>
      </g>
      <path
        d="M23.9432 35.1818L25.6705 40.0795H25.7386L27.4659 35.1818H28.2045L26.0682 41H25.3409L23.2045 35.1818H23.9432ZM30.4432 41.0909C30.0227 41.0909 29.66 40.9981 29.3551 40.8125C29.0521 40.625 28.8182 40.3636 28.6534 40.0284C28.4905 39.6913 28.4091 39.2992 28.4091 38.8523C28.4091 38.4053 28.4905 38.0114 28.6534 37.6705C28.8182 37.3277 29.0473 37.0606 29.3409 36.8693C29.6364 36.6761 29.9811 36.5795 30.375 36.5795C30.6023 36.5795 30.8267 36.6174 31.0483 36.6932C31.2699 36.7689 31.4716 36.892 31.6534 37.0625C31.8352 37.2311 31.9801 37.4545 32.0881 37.733C32.196 38.0114 32.25 38.3542 32.25 38.7614V39.0455H28.8864V38.4659H31.5682C31.5682 38.2197 31.5189 38 31.4205 37.8068C31.3239 37.6136 31.1856 37.4612 31.0057 37.3494C30.8277 37.2377 30.6174 37.1818 30.375 37.1818C30.108 37.1818 29.8769 37.2481 29.6818 37.3807C29.4886 37.5114 29.34 37.6818 29.2358 37.892C29.1316 38.1023 29.0795 38.3277 29.0795 38.5682V38.9545C29.0795 39.2841 29.1364 39.5634 29.25 39.7926C29.3655 40.0199 29.5256 40.1932 29.7301 40.3125C29.9347 40.4299 30.1723 40.4886 30.4432 40.4886C30.6193 40.4886 30.7784 40.464 30.9205 40.4148C31.0644 40.3636 31.1884 40.2879 31.2926 40.1875C31.3968 40.0852 31.4773 39.9583 31.5341 39.8068L32.1818 39.9886C32.1136 40.2083 31.9991 40.4015 31.8381 40.5682C31.6771 40.733 31.4782 40.8617 31.2415 40.9545C31.0047 41.0455 30.7386 41.0909 30.4432 41.0909ZM33.2699 41V36.6364H33.9176V37.2955H33.9631C34.0426 37.0795 34.1866 36.9044 34.3949 36.7699C34.6032 36.6354 34.8381 36.5682 35.0994 36.5682C35.1487 36.5682 35.2102 36.5691 35.2841 36.571C35.358 36.5729 35.4138 36.5758 35.4517 36.5795V37.2614C35.429 37.2557 35.3769 37.2472 35.2955 37.2358C35.2159 37.2225 35.1316 37.2159 35.0426 37.2159C34.8305 37.2159 34.6411 37.2604 34.4744 37.3494C34.3097 37.4366 34.179 37.5578 34.0824 37.7131C33.9877 37.8665 33.9403 38.0417 33.9403 38.2386V41H33.2699ZM36.2464 41V36.6364H36.9169V41H36.2464ZM36.5874 35.9091C36.4567 35.9091 36.344 35.8646 36.2493 35.7756C36.1565 35.6866 36.1101 35.5795 36.1101 35.4545C36.1101 35.3295 36.1565 35.2225 36.2493 35.1335C36.344 35.0445 36.4567 35 36.5874 35C36.718 35 36.8298 35.0445 36.9226 35.1335C37.0173 35.2225 37.0646 35.3295 37.0646 35.4545C37.0646 35.5795 37.0173 35.6866 36.9226 35.7756C36.8298 35.8646 36.718 35.9091 36.5874 35.9091ZM40.0881 36.6364V37.2045H37.7358V36.6364H40.0881ZM38.4403 41V36.0341C38.4403 35.7841 38.4991 35.5758 38.6165 35.4091C38.7339 35.2424 38.8864 35.1174 39.0739 35.0341C39.2614 34.9508 39.4593 34.9091 39.6676 34.9091C39.8324 34.9091 39.9669 34.9223 40.071 34.9489C40.1752 34.9754 40.2528 35 40.304 35.0227L40.1108 35.6023C40.0767 35.5909 40.0294 35.5767 39.9688 35.5597C39.91 35.5426 39.8324 35.5341 39.7358 35.5341C39.5142 35.5341 39.3542 35.59 39.2557 35.7017C39.1591 35.8134 39.1108 35.9773 39.1108 36.1932V41H38.4403ZM41.4595 42.6364C41.3459 42.6364 41.2446 42.6269 41.1555 42.608C41.0665 42.5909 41.005 42.5739 40.9709 42.5568L41.1413 41.9659C41.3042 42.0076 41.4482 42.0227 41.5732 42.0114C41.6982 42 41.8089 41.9441 41.9055 41.8438C42.004 41.7453 42.094 41.5852 42.1754 41.3636L42.3004 41.0227L40.6868 36.6364H41.4141L42.6186 40.1136H42.6641L43.8686 36.6364H44.5959L42.7436 41.6364C42.6603 41.8617 42.5571 42.0483 42.4339 42.196C42.3108 42.3456 42.1679 42.4564 42.005 42.5284C41.844 42.6004 41.6622 42.6364 41.4595 42.6364ZM49.5604 41.0909C49.1399 41.0909 48.7772 40.9981 48.4723 40.8125C48.1693 40.625 47.9354 40.3636 47.7706 40.0284C47.6077 39.6913 47.5263 39.2992 47.5263 38.8523C47.5263 38.4053 47.6077 38.0114 47.7706 37.6705C47.9354 37.3277 48.1645 37.0606 48.4581 36.8693C48.7536 36.6761 49.0982 36.5795 49.4922 36.5795C49.7195 36.5795 49.9439 36.6174 50.1655 36.6932C50.3871 36.7689 50.5888 36.892 50.7706 37.0625C50.9524 37.2311 51.0973 37.4545 51.2053 37.733C51.3132 38.0114 51.3672 38.3542 51.3672 38.7614V39.0455H48.0036V38.4659H50.6854C50.6854 38.2197 50.6361 38 50.5376 37.8068C50.4411 37.6136 50.3028 37.4612 50.1229 37.3494C49.9448 37.2377 49.7346 37.1818 49.4922 37.1818C49.2251 37.1818 48.9941 37.2481 48.799 37.3807C48.6058 37.5114 48.4571 37.6818 48.353 37.892C48.2488 38.1023 48.1967 38.3277 48.1967 38.5682V38.9545C48.1967 39.2841 48.2536 39.5634 48.3672 39.7926C48.4827 40.0199 48.6428 40.1932 48.8473 40.3125C49.0518 40.4299 49.2895 40.4886 49.5604 40.4886C49.7365 40.4886 49.8956 40.464 50.0376 40.4148C50.1816 40.3636 50.3056 40.2879 50.4098 40.1875C50.514 40.0852 50.5945 39.9583 50.6513 39.8068L51.299 39.9886C51.2308 40.2083 51.1162 40.4015 50.9553 40.5682C50.7943 40.733 50.5954 40.8617 50.3587 40.9545C50.1219 41.0455 49.8558 41.0909 49.5604 41.0909ZM52.3871 41V36.6364H53.0348V37.3182H53.0916C53.1825 37.0852 53.3293 36.9044 53.532 36.7756C53.7346 36.6449 53.978 36.5795 54.2621 36.5795C54.55 36.5795 54.7895 36.6449 54.9808 36.7756C55.174 36.9044 55.3246 37.0852 55.4325 37.3182H55.478C55.5897 37.0928 55.7573 36.9138 55.9808 36.7812C56.2043 36.6468 56.4723 36.5795 56.7848 36.5795C57.175 36.5795 57.4941 36.7017 57.7422 36.946C57.9903 37.1884 58.1143 37.5663 58.1143 38.0795V41H57.4439V38.0795C57.4439 37.7576 57.3558 37.5275 57.1797 37.3892C57.0036 37.2509 56.7962 37.1818 56.5575 37.1818C56.2507 37.1818 56.013 37.2746 55.8445 37.4602C55.6759 37.6439 55.5916 37.8769 55.5916 38.1591V41H54.9098V38.0114C54.9098 37.7633 54.8293 37.5634 54.6683 37.4119C54.5073 37.2585 54.3 37.1818 54.0462 37.1818C53.8719 37.1818 53.709 37.2282 53.5575 37.321C53.4079 37.4138 53.2867 37.5426 53.1939 37.7074C53.103 37.8703 53.0575 38.0587 53.0575 38.2727V41H52.3871ZM60.6243 41.1023C60.3478 41.1023 60.0968 41.0502 59.8714 40.946C59.6461 40.84 59.4671 40.6875 59.3345 40.4886C59.2019 40.2879 59.1357 40.0455 59.1357 39.7614C59.1357 39.5114 59.1849 39.3087 59.2834 39.1534C59.3819 38.9962 59.5135 38.8731 59.6783 38.7841C59.843 38.6951 60.0249 38.6288 60.2237 38.5852C60.4245 38.5398 60.6262 38.5038 60.8288 38.4773C61.094 38.4432 61.3089 38.4176 61.4737 38.4006C61.6404 38.3816 61.7616 38.3504 61.8374 38.3068C61.915 38.2633 61.9538 38.1875 61.9538 38.0795V38.0568C61.9538 37.7765 61.8771 37.5587 61.7237 37.4034C61.5722 37.2481 61.3421 37.1705 61.0334 37.1705C60.7133 37.1705 60.4624 37.2405 60.2805 37.3807C60.0987 37.5208 59.9709 37.6705 59.897 37.8295L59.2607 37.6023C59.3743 37.3371 59.5258 37.1307 59.7152 36.983C59.9065 36.8333 60.1148 36.7292 60.3402 36.6705C60.5675 36.6098 60.791 36.5795 61.0107 36.5795C61.1508 36.5795 61.3118 36.5966 61.4936 36.6307C61.6773 36.6629 61.8544 36.7301 62.0249 36.8324C62.1972 36.9347 62.3402 37.089 62.4538 37.2955C62.5675 37.5019 62.6243 37.7784 62.6243 38.125V41H61.9538V40.4091H61.9197C61.8743 40.5038 61.7985 40.6051 61.6925 40.7131C61.5864 40.821 61.4453 40.9129 61.2692 40.9886C61.093 41.0644 60.8781 41.1023 60.6243 41.1023ZM60.7266 40.5C60.9917 40.5 61.2152 40.4479 61.397 40.3438C61.5807 40.2396 61.719 40.1051 61.8118 39.9403C61.9065 39.7756 61.9538 39.6023 61.9538 39.4205V38.8068C61.9254 38.8409 61.8629 38.8722 61.7663 38.9006C61.6716 38.9271 61.5618 38.9508 61.4368 38.9716C61.3137 38.9905 61.1934 39.0076 61.076 39.0227C60.9605 39.036 60.8667 39.0473 60.7947 39.0568C60.6205 39.0795 60.4576 39.1165 60.3061 39.1676C60.1565 39.2169 60.0353 39.2917 59.9425 39.392C59.8516 39.4905 59.8061 39.625 59.8061 39.7955C59.8061 40.0284 59.8923 40.2045 60.0646 40.3239C60.2389 40.4413 60.4595 40.5 60.7266 40.5ZM63.848 41V36.6364H64.5185V41H63.848ZM64.1889 35.9091C64.0582 35.9091 63.9455 35.8646 63.8509 35.7756C63.758 35.6866 63.7116 35.5795 63.7116 35.4545C63.7116 35.3295 63.758 35.2225 63.8509 35.1335C63.9455 35.0445 64.0582 35 64.1889 35C64.3196 35 64.4313 35.0445 64.5241 35.1335C64.6188 35.2225 64.6662 35.3295 64.6662 35.4545C64.6662 35.5795 64.6188 35.6866 64.5241 35.7756C64.4313 35.8646 64.3196 35.9091 64.1889 35.9091ZM66.4169 35.1818V41H65.7464V35.1818H66.4169Z"
        fill="black"
      />
    </svg>
  );
};

export const RetailAutomationStepLogo = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" fill="white" />
      <rect x="0.5" y="0.5" width="23" height="23" rx="3.5" stroke="#EFEDE8" />
      <rect x="8" y="8" width="8" height="8" rx="2" fill="#EFEDE8" />
    </svg>
  );
};

export const RetailAutomationStepLogoCompleted = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
      <rect x="1" y="1" width="24" height="24" rx="4" fill="#EC4E0B" />
      <rect x="0.5" y="0.5" width="25" height="25" rx="4.5" stroke="#EC4E0B" strokeOpacity="0.5" />
      <rect x="9" y="9" width="8" height="8" rx="2" fill="#FBFAF9" />
    </svg>
  );
};

export const AccordionOpenIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <mask
        id="mask0_7786_43224"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_7786_43224)">
        <path d="M12 10.8L7.4 15.4L6 14L12 8L18 14L16.6 15.4L12 10.8Z" fill="#2B2A28" />
      </g>
    </svg>
  );
};

export const AccordionCloseIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <mask
        id="mask0_7786_38180"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24">
        <rect x="24" y="24" width="24" height="24" transform="rotate(-180 24 24)" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_7786_38180)">
        <path d="M12 13.2L16.6 8.6L18 10L12 16L6 10L7.4 8.6L12 13.2Z" fill="#2B2A28" />
      </g>
    </svg>
  );
};

const BackupIconV2 = (props) => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <mask
        id="mask0_211_21930"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="50"
        height="50">
        <rect width="50" height="50" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_211_21930)">
        <path
          d="M13.5469 39.5885C10.9479 39.5885 8.73576 38.6847 6.91042 36.8771C5.08472 35.0698 4.17188 32.8606 4.17188 30.2495C4.17188 27.7818 5.02118 25.6424 6.71979 23.8312C8.41875 22.0205 10.4141 21.0469 12.7057 20.9104C13.1731 17.8764 14.5686 15.3698 16.8922 13.3906C19.2158 11.4115 21.9201 10.4219 25.0052 10.4219C28.4875 10.4219 31.4413 11.6347 33.8667 14.0604C36.2924 16.4858 37.5052 19.4396 37.5052 22.9219V25.0052H38.7875C40.7826 25.0694 42.4566 25.8019 43.8094 27.2026C45.1622 28.6036 45.8385 30.3017 45.8385 32.2969C45.8385 34.3403 45.1474 36.0663 43.7651 37.475C42.3828 38.884 40.6701 39.5885 38.6271 39.5885H27.3292C26.3701 39.5885 25.5694 39.2674 24.9271 38.625C24.2847 37.9826 23.9635 37.1819 23.9635 36.2229V24.1318L19.5885 28.4828L18.1141 27.0484L25.0052 20.1573L31.8964 27.0484L30.4219 28.4828L26.0469 24.1318V36.2229C26.0469 36.5438 26.1804 36.8377 26.4474 37.1047C26.7144 37.3717 27.0083 37.5052 27.3292 37.5052H38.5469C40.0052 37.5052 41.2379 37.0017 42.2448 35.9948C43.2517 34.9878 43.7552 33.7552 43.7552 32.2969C43.7552 30.8385 43.2517 29.6059 42.2448 28.599C41.2379 27.592 40.0052 27.0885 38.5469 27.0885H35.4219V22.9219C35.4219 20.0399 34.4063 17.5833 32.375 15.5521C30.3438 13.5208 27.8872 12.5052 25.0052 12.5052C22.1233 12.5052 19.6667 13.5208 17.6354 15.5521C15.6042 17.5833 14.5885 20.0399 14.5885 22.9219H13.4667C11.533 22.9219 9.84757 23.6337 8.41042 25.0573C6.97361 26.4809 6.25521 28.1997 6.25521 30.2135C6.25521 32.2274 6.96701 33.9462 8.39063 35.3698C9.81424 36.7934 11.533 37.5052 13.5469 37.5052H18.7552V39.5885H13.5469Z"
          fill="currentColor" // EC4E0B
        />
      </g>
    </svg>
  );
};

const BrowseIconV2 = (props) => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <mask
        id="mask0_211_21950"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="50"
        height="50">
        <rect width="50" height="50" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_211_21950)">
        <path
          d="M8.32812 27.0781V11.6937C8.32812 10.7347 8.64931 9.93403 9.29167 9.29167C9.93403 8.64931 10.7347 8.32812 11.6937 8.32812H22.9115V27.0781H8.32812ZM27.0781 8.32812H38.2958C39.2549 8.32812 40.0556 8.64931 40.6979 9.29167C41.3403 9.93403 41.6615 10.7391 41.6615 11.7068V18.7448H27.0781V8.32812ZM27.0781 41.6615V22.9115H41.6615V38.2958C41.6615 39.2549 41.3403 40.0556 40.6979 40.6979C40.0556 41.3403 39.2549 41.6615 38.2958 41.6615H27.0781ZM8.32812 31.2448H22.9115V41.6615H11.6937C10.7347 41.6615 9.93403 41.3403 9.29167 40.6979C8.64931 40.0556 8.32812 39.2505 8.32812 38.2828V31.2448ZM10.4115 24.9948H20.8281V10.4115H11.6937C11.3198 10.4115 11.0125 10.5316 10.7719 10.7719C10.5316 11.0125 10.4115 11.3198 10.4115 11.6937V24.9948ZM29.1615 16.6615H39.5781V11.6937C39.5781 11.3198 39.458 11.0125 39.2177 10.7719C38.9771 10.5316 38.6698 10.4115 38.2958 10.4115H29.1615V16.6615ZM29.1615 24.9948V39.5781H38.2958C38.6698 39.5781 38.9771 39.458 39.2177 39.2177C39.458 38.9771 39.5781 38.6698 39.5781 38.2958V24.9948H29.1615ZM10.4115 33.3281V38.2958C10.4115 38.6698 10.5316 38.9771 10.7719 39.2177C11.0125 39.458 11.3198 39.5781 11.6937 39.5781H20.8281V33.3281H10.4115Z"
          fill="currentColor" // EC4E0B
        />
      </g>
    </svg>
  );
};

const AddUserIconV2 = (props) => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <mask
        id="mask0_210_15069"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="50"
        height="50">
        <rect width="50" height="50" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_210_15069)">
        <path
          d="M38.0182 28.1221V21.8721H31.7682V19.7888H38.0182V13.5388H40.1016V19.7888H46.3516V21.8721H40.1016V28.1221H38.0182ZM18.7474 23.7148C17.0286 23.7148 15.5573 23.1029 14.3333 21.8789C13.1094 20.6549 12.4974 19.1836 12.4974 17.4648C12.4974 15.7461 13.1094 14.2747 14.3333 13.0508C15.5573 11.8268 17.0286 11.2148 18.7474 11.2148C20.4661 11.2148 21.9375 11.8268 23.1615 13.0508C24.3854 14.2747 24.9974 15.7461 24.9974 17.4648C24.9974 19.1836 24.3854 20.6549 23.1615 21.8789C21.9375 23.1029 20.4661 23.7148 18.7474 23.7148ZM4.16406 38.7794V35.3497C4.16406 34.4897 4.41441 33.685 4.9151 32.9357C5.41615 32.1867 6.08993 31.6051 6.93646 31.1909C8.90243 30.2482 10.8696 29.5411 12.838 29.0695C14.8064 28.5984 16.7762 28.3628 18.7474 28.3628C20.7186 28.3628 22.6884 28.5984 24.6568 29.0695C26.6252 29.5411 28.5924 30.2482 30.5583 31.1909C31.4049 31.6051 32.0786 32.1867 32.5797 32.9357C33.0804 33.685 33.3307 34.4897 33.3307 35.3497V38.7794H4.16406ZM6.2474 36.6961H31.2474V35.3497C31.2474 34.8876 31.0984 34.4536 30.8005 34.0477C30.5029 33.6418 30.091 33.2985 29.5646 33.018C27.85 32.1874 26.0821 31.5511 24.2609 31.1091C22.4398 30.6671 20.6019 30.4461 18.7474 30.4461C16.8929 30.4461 15.055 30.6671 13.2339 31.1091C11.4127 31.5511 9.64479 32.1874 7.93021 33.018C7.40382 33.2985 6.99184 33.6418 6.69427 34.0477C6.39635 34.4536 6.2474 34.8876 6.2474 35.3497V36.6961ZM18.7474 21.6315C19.8932 21.6315 20.8741 21.2235 21.6901 20.4076C22.5061 19.5916 22.9141 18.6107 22.9141 17.4648C22.9141 16.319 22.5061 15.3381 21.6901 14.5221C20.8741 13.7062 19.8932 13.2982 18.7474 13.2982C17.6016 13.2982 16.6207 13.7062 15.8047 14.5221C14.9887 15.3381 14.5807 16.319 14.5807 17.4648C14.5807 18.6107 14.9887 19.5916 15.8047 20.4076C16.6207 21.2235 17.6016 21.6315 18.7474 21.6315Z"
          fill="currentColor" // EC4E0B
        />
      </g>
    </svg>
  );
};

const StarIconV2 = (props) => {
  return (
    <svg
      width={38}
      height={50}
      viewBox="0 0 38 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M11.2635 30.6589L19 26.0032L26.7365 30.711L24.6891 21.9006L31.4958 15.9912L22.5177 15.198L19 6.9089L15.4823 15.1459L6.50417 15.9391L13.3109 21.8688L11.2635 30.6589ZM7.69792 35.5865L10.6828 22.7339L0.710938 14.0922L13.8677 12.9506L19 0.831299L24.1323 12.9506L37.2891 14.0922L27.3172 22.7339L30.3021 35.5865L19 28.7678L7.69792 35.5865Z"
        fill="currentColor"
      />
    </svg>
  );
};

const DollarIcon = (props) => {
  return (
    <svg
      width={17}
      height={18}
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M7.7513 14.8346H9.20964V13.793C9.90408 13.668 10.5013 13.3971 11.0013 12.9805C11.5013 12.5638 11.7513 11.9457 11.7513 11.1263C11.7513 10.543 11.5846 10.0082 11.2513 9.52213C10.918 9.03602 10.2513 8.61241 9.2513 8.2513C8.41797 7.97352 7.84158 7.73047 7.52214 7.52214C7.20269 7.3138 7.04297 7.02908 7.04297 6.66797C7.04297 6.30686 7.17144 6.02214 7.42839 5.8138C7.68533 5.60547 8.05686 5.5013 8.54297 5.5013C8.98741 5.5013 9.33464 5.60894 9.58464 5.82422C9.83464 6.0395 10.0152 6.30686 10.1263 6.6263L11.4596 6.08464C11.3069 5.59852 11.0256 5.17491 10.6159 4.8138C10.2062 4.45269 9.7513 4.2513 9.2513 4.20964V3.16797H7.79297V4.20964C7.09852 4.36241 6.55686 4.66797 6.16797 5.1263C5.77908 5.58464 5.58464 6.09852 5.58464 6.66797C5.58464 7.32075 5.77561 7.84852 6.15755 8.2513C6.5395 8.65408 7.14019 9.0013 7.95964 9.29297C8.83464 9.61241 9.44227 9.89713 9.78255 10.1471C10.1228 10.3971 10.293 10.7235 10.293 11.1263C10.293 11.5846 10.1298 11.9214 9.80338 12.1367C9.477 12.352 9.08464 12.4596 8.6263 12.4596C8.16797 12.4596 7.76172 12.3173 7.40755 12.0326C7.05339 11.7478 6.79297 11.3207 6.6263 10.7513L5.2513 11.293C5.44575 11.9596 5.74783 12.4978 6.15755 12.9076C6.56727 13.3173 7.09852 13.5985 7.7513 13.7513V14.8346ZM8.5013 17.3346C7.34852 17.3346 6.26519 17.1159 5.2513 16.6784C4.23741 16.2409 3.35547 15.6471 2.60547 14.8971C1.85547 14.1471 1.26172 13.2652 0.824219 12.2513C0.386719 11.2374 0.167969 10.1541 0.167969 9.0013C0.167969 7.84852 0.386719 6.76519 0.824219 5.7513C1.26172 4.73741 1.85547 3.85547 2.60547 3.10547C3.35547 2.35547 4.23741 1.76172 5.2513 1.32422C6.26519 0.886719 7.34852 0.667969 8.5013 0.667969C9.65408 0.667969 10.7374 0.886719 11.7513 1.32422C12.7652 1.76172 13.6471 2.35547 14.3971 3.10547C15.1471 3.85547 15.7409 4.73741 16.1784 5.7513C16.6159 6.76519 16.8346 7.84852 16.8346 9.0013C16.8346 10.1541 16.6159 11.2374 16.1784 12.2513C15.7409 13.2652 15.1471 14.1471 14.3971 14.8971C13.6471 15.6471 12.7652 16.2409 11.7513 16.6784C10.7374 17.1159 9.65408 17.3346 8.5013 17.3346ZM8.5013 15.668C10.3624 15.668 11.9388 15.0221 13.2305 13.7305C14.5221 12.4388 15.168 10.8624 15.168 9.0013C15.168 7.14019 14.5221 5.5638 13.2305 4.27214C11.9388 2.98047 10.3624 2.33464 8.5013 2.33464C6.64019 2.33464 5.0638 2.98047 3.77214 4.27214C2.48047 5.5638 1.83464 7.14019 1.83464 9.0013C1.83464 10.8624 2.48047 12.4388 3.77214 13.7305C5.0638 15.0221 6.64019 15.668 8.5013 15.668Z"
        fill="currentColor"
      />
    </svg>
  );
};

const PauseInCircleIcon = (props) => {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M5.75 11H7.25V5H5.75V11ZM8.75 11H10.25V5H8.75V11ZM8 15.5C6.9625 15.5 5.9875 15.3031 5.075 14.9094C4.1625 14.5156 3.36875 13.9813 2.69375 13.3063C2.01875 12.6313 1.48438 11.8375 1.09063 10.925C0.696875 10.0125 0.5 9.0375 0.5 8C0.5 6.9625 0.696875 5.9875 1.09063 5.075C1.48438 4.1625 2.01875 3.36875 2.69375 2.69375C3.36875 2.01875 4.1625 1.48438 5.075 1.09063C5.9875 0.696875 6.9625 0.5 8 0.5C9.0375 0.5 10.0125 0.696875 10.925 1.09063C11.8375 1.48438 12.6313 2.01875 13.3063 2.69375C13.9813 3.36875 14.5156 4.1625 14.9094 5.075C15.3031 5.9875 15.5 6.9625 15.5 8C15.5 9.0375 15.3031 10.0125 14.9094 10.925C14.5156 11.8375 13.9813 12.6313 13.3063 13.3063C12.6313 13.9813 11.8375 14.5156 10.925 14.9094C10.0125 15.3031 9.0375 15.5 8 15.5ZM8 14C9.675 14 11.0938 13.4187 12.2563 12.2563C13.4187 11.0938 14 9.675 14 8C14 6.325 13.4187 4.90625 12.2563 3.74375C11.0938 2.58125 9.675 2 8 2C6.325 2 4.90625 2.58125 3.74375 3.74375C2.58125 4.90625 2 6.325 2 8C2 9.675 2.58125 11.0938 3.74375 12.2563C4.90625 13.4187 6.325 14 8 14Z"
        fill="currentColor"
      />
    </svg>
  );
};

const CancelInCircleIcon = (props) => {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M5.3 11.75L8 9.05L10.7 11.75L11.75 10.7L9.05 8L11.75 5.3L10.7 4.25L8 6.95L5.3 4.25L4.25 5.3L6.95 8L4.25 10.7L5.3 11.75ZM8 15.5C6.9625 15.5 5.9875 15.3031 5.075 14.9094C4.1625 14.5156 3.36875 13.9813 2.69375 13.3063C2.01875 12.6313 1.48438 11.8375 1.09063 10.925C0.696875 10.0125 0.5 9.0375 0.5 8C0.5 6.9625 0.696875 5.9875 1.09063 5.075C1.48438 4.1625 2.01875 3.36875 2.69375 2.69375C3.36875 2.01875 4.1625 1.48438 5.075 1.09063C5.9875 0.696875 6.9625 0.5 8 0.5C9.0375 0.5 10.0125 0.696875 10.925 1.09063C11.8375 1.48438 12.6313 2.01875 13.3063 2.69375C13.9813 3.36875 14.5156 4.1625 14.9094 5.075C15.3031 5.9875 15.5 6.9625 15.5 8C15.5 9.0375 15.3031 10.0125 14.9094 10.925C14.5156 11.8375 13.9813 12.6313 13.3063 13.3063C12.6313 13.9813 11.8375 14.5156 10.925 14.9094C10.0125 15.3031 9.0375 15.5 8 15.5ZM8 14C9.675 14 11.0938 13.4187 12.2563 12.2563C13.4187 11.0938 14 9.675 14 8C14 6.325 13.4187 4.90625 12.2563 3.74375C11.0938 2.58125 9.675 2 8 2C6.325 2 4.90625 2.58125 3.74375 3.74375C2.58125 4.90625 2 6.325 2 8C2 9.675 2.58125 11.0938 3.74375 12.2563C4.90625 13.4187 6.325 14 8 14Z"
        fill="currentColor"
      />
    </svg>
  );
};

const CircleIcon = (props) => {
  return (
    <svg height="4" width="4" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle r="4" cx="50%" cy="50%" fill="currentColor" />
    </svg>
  );
};

const RadioIcon = (props) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g clipPath="url(#clip0_575_46386)">
        <path
          d="M12 19.5C10.9625 19.5 9.9875 19.3031 9.075 18.9094C8.1625 18.5156 7.36875 17.9813 6.69375 17.3063C6.01875 16.6313 5.48438 15.8375 5.09063 14.925C4.69688 14.0125 4.5 13.0375 4.5 12C4.5 10.9625 4.69688 9.9875 5.09063 9.075C5.48438 8.1625 6.01875 7.36875 6.69375 6.69375C7.36875 6.01875 8.1625 5.48438 9.075 5.09063C9.9875 4.69688 10.9625 4.5 12 4.5C13.0375 4.5 14.0125 4.69688 14.925 5.09063C15.8375 5.48438 16.6313 6.01875 17.3063 6.69375C17.9813 7.36875 18.5156 8.1625 18.9094 9.075C19.3031 9.9875 19.5 10.9625 19.5 12C19.5 13.0375 19.3031 14.0125 18.9094 14.925C18.5156 15.8375 17.9813 16.6313 17.3063 17.3063C16.6313 17.9813 15.8375 18.5156 14.925 18.9094C14.0125 19.3031 13.0375 19.5 12 19.5ZM12 18C13.675 18 15.0938 17.4188 16.2563 16.2563C17.4188 15.0938 18 13.675 18 12C18 10.325 17.4188 8.90625 16.2563 7.74375C15.0938 6.58125 13.675 6 12 6C10.325 6 8.90625 6.58125 7.74375 7.74375C6.58125 8.90625 6 10.325 6 12C6 13.675 6.58125 15.0938 7.74375 16.2563C8.90625 17.4188 10.325 18 12 18Z"
          fill="#2B2A28"
        />
      </g>
      <defs>
        <clipPath id="clip0_575_46386">
          <rect width={18} height={18} fill="white" transform="translate(3 3)" />
        </clipPath>
      </defs>
    </svg>
  );
};

const RadioIconFilled = (props) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g clipPath="url(#clip0_575_46395)">
        <path
          d="M12 15.75C13.0375 15.75 13.9219 15.3844 14.6531 14.6531C15.3844 13.9219 15.75 13.0375 15.75 12C15.75 10.9625 15.3844 10.0781 14.6531 9.34688C13.9219 8.61563 13.0375 8.25 12 8.25C10.9625 8.25 10.0781 8.61563 9.34688 9.34688C8.61563 10.0781 8.25 10.9625 8.25 12C8.25 13.0375 8.61563 13.9219 9.34688 14.6531C10.0781 15.3844 10.9625 15.75 12 15.75ZM12 19.5C10.9625 19.5 9.9875 19.3031 9.075 18.9094C8.1625 18.5156 7.36875 17.9813 6.69375 17.3063C6.01875 16.6313 5.48438 15.8375 5.09063 14.925C4.69688 14.0125 4.5 13.0375 4.5 12C4.5 10.9625 4.69688 9.9875 5.09063 9.075C5.48438 8.1625 6.01875 7.36875 6.69375 6.69375C7.36875 6.01875 8.1625 5.48438 9.075 5.09063C9.9875 4.69688 10.9625 4.5 12 4.5C13.0375 4.5 14.0125 4.69688 14.925 5.09063C15.8375 5.48438 16.6313 6.01875 17.3063 6.69375C17.9813 7.36875 18.5156 8.1625 18.9094 9.075C19.3031 9.9875 19.5 10.9625 19.5 12C19.5 13.0375 19.3031 14.0125 18.9094 14.925C18.5156 15.8375 17.9813 16.6313 17.3063 17.3063C16.6313 17.9813 15.8375 18.5156 14.925 18.9094C14.0125 19.3031 13.0375 19.5 12 19.5ZM12 18C13.675 18 15.0938 17.4188 16.2563 16.2563C17.4188 15.0938 18 13.675 18 12C18 10.325 17.4188 8.90625 16.2563 7.74375C15.0938 6.58125 13.675 6 12 6C10.325 6 8.90625 6.58125 7.74375 7.74375C6.58125 8.90625 6 10.325 6 12C6 13.675 6.58125 15.0938 7.74375 16.2563C8.90625 17.4188 10.325 18 12 18Z"
          fill="var(--primary-color)"
        />
      </g>
      <defs>
        <clipPath id="clip0_575_46395">
          <rect width={18} height={18} fill="white" transform="translate(3 3)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ListV2Icon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M1.66699 14.6309V16.4828H7.22255V14.6309H1.66699ZM1.66699 3.51982V5.37167H10.9263V3.51982H1.66699ZM10.9263 18.3346V16.4828H18.3337V14.6309H10.9263V12.7791H9.0744V18.3346H10.9263ZM5.3707 7.22352V9.07538H1.66699V10.9272H5.3707V12.7791H7.22255V7.22352H5.3707ZM18.3337 10.9272V9.07538H9.0744V10.9272H18.3337ZM12.7781 7.22352H14.63V5.37167H18.3337V3.51982H14.63V1.66797H12.7781V7.22352Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const PresentationIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M2.5026 16.6615C2.04427 16.6615 1.65191 16.4983 1.32552 16.1719C0.999132 15.8455 0.835938 15.4531 0.835938 14.9948V4.99479C0.835938 4.53646 0.999132 4.1441 1.32552 3.81771C1.65191 3.49132 2.04427 3.32812 2.5026 3.32812H4.16927C4.6276 3.32812 5.01997 3.49132 5.34635 3.81771C5.67274 4.1441 5.83594 4.53646 5.83594 4.99479V14.9948C5.83594 15.4531 5.67274 15.8455 5.34635 16.1719C5.01997 16.4983 4.6276 16.6615 4.16927 16.6615H2.5026ZM2.5026 15.0156H4.16927V4.97396H2.5026V15.0156ZM9.16927 16.6615C8.71094 16.6615 8.31858 16.4983 7.99219 16.1719C7.6658 15.8455 7.5026 15.4531 7.5026 14.9948V4.99479C7.5026 4.53646 7.6658 4.1441 7.99219 3.81771C8.31858 3.49132 8.71094 3.32812 9.16927 3.32812H17.5026C17.9609 3.32812 18.3533 3.49132 18.6797 3.81771C19.0061 4.1441 19.1693 4.53646 19.1693 4.99479V14.9948C19.1693 15.4531 19.0061 15.8455 18.6797 16.1719C18.3533 16.4983 17.9609 16.6615 17.5026 16.6615H9.16927ZM9.16927 15.0156H17.5026V4.97396H9.16927V15.0156Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const UploadV2Icon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g clipPath="url(#clip0_3091_5025)">
        <path
          d="M4.16634 11.668L7.49967 11.668L7.49967 16.668L12.4997 16.668L12.4997 11.668L15.833 11.668L9.99967 5.83464L4.16634 11.668ZM15.833 4.16797L15.833 2.5013L4.16634 2.5013L4.16634 4.16797L15.833 4.16797Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_3091_5025">
          <rect width="20" height="20" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DraggerIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g clipPath="url(#clip0_3116_16479)">
        <path
          d="M9.16634 14.9987C9.16634 15.9154 8.41634 16.6654 7.49967 16.6654C6.58301 16.6654 5.83301 15.9154 5.83301 14.9987C5.83301 14.082 6.58301 13.332 7.49967 13.332C8.41634 13.332 9.16634 14.082 9.16634 14.9987ZM7.49967 8.33203C6.58301 8.33203 5.83301 9.08203 5.83301 9.9987C5.83301 10.9154 6.58301 11.6654 7.49967 11.6654C8.41634 11.6654 9.16634 10.9154 9.16634 9.9987C9.16634 9.08203 8.41634 8.33203 7.49967 8.33203ZM7.49967 3.33203C6.58301 3.33203 5.83301 4.08203 5.83301 4.9987C5.83301 5.91536 6.58301 6.66536 7.49967 6.66536C8.41634 6.66536 9.16634 5.91536 9.16634 4.9987C9.16634 4.08203 8.41634 3.33203 7.49967 3.33203ZM12.4997 6.66536C13.4163 6.66536 14.1663 5.91536 14.1663 4.9987C14.1663 4.08203 13.4163 3.33203 12.4997 3.33203C11.583 3.33203 10.833 4.08203 10.833 4.9987C10.833 5.91536 11.583 6.66536 12.4997 6.66536ZM12.4997 8.33203C11.583 8.33203 10.833 9.08203 10.833 9.9987C10.833 10.9154 11.583 11.6654 12.4997 11.6654C13.4163 11.6654 14.1663 10.9154 14.1663 9.9987C14.1663 9.08203 13.4163 8.33203 12.4997 8.33203ZM12.4997 13.332C11.583 13.332 10.833 14.082 10.833 14.9987C10.833 15.9154 11.583 16.6654 12.4997 16.6654C13.4163 16.6654 14.1663 15.9154 14.1663 14.9987C14.1663 14.082 13.4163 13.332 12.4997 13.332Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_3116_16479">
          <rect width="20" height="20" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DottedCurveLine = (props) => {
  return (
    <svg
      width="787"
      height="65"
      viewBox="0 0 787 65"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M786.428 -20.2415C786.681 -19.2733 786.851 -18.3005 786.936 -17.3235L786.202 -17.2594C786.243 -16.7903 786.264 -16.3204 786.264 -15.8495C786.264 -15.3784 786.243 -14.9083 786.202 -14.4391L786.936 -14.375C786.851 -13.398 786.681 -12.4252 786.428 -11.457L785.715 -11.6435C785.481 -10.7506 785.173 -9.85934 784.791 -8.96981L785.468 -8.67905C785.092 -7.80231 784.647 -6.92961 784.135 -6.06116L783.5 -6.43549C783.019 -5.62022 782.476 -4.8066 781.871 -3.99488L782.462 -3.55443C781.903 -2.80455 781.293 -2.05807 780.634 -1.31513L780.083 -1.80415C779.452 -1.09253 778.773 -0.382973 778.047 0.324318L778.561 0.852135C777.884 1.51182 777.168 2.16853 776.412 2.82217L775.93 2.26499C775.203 2.89436 774.439 3.52151 773.637 4.14632L774.091 4.7274C773.344 5.3093 772.567 5.88863 771.76 6.46532L771.332 5.86562C770.534 6.43525 769.705 7.00266 768.847 7.56776L769.252 8.18331C768.467 8.69988 767.657 9.21422 766.824 9.72627L766.438 9.0983C765.61 9.6065 764.758 10.1127 763.882 10.6167L764.249 11.2555C763.412 11.7367 762.554 12.2158 761.674 12.6928L761.323 12.0449C760.483 12.5003 759.623 12.9539 758.743 13.4055L759.08 14.0611C758.196 14.5152 757.292 14.9672 756.368 15.4172L756.046 14.7548C755.194 15.1696 754.327 15.5828 753.442 15.9943L753.753 16.6624C752.873 17.0718 751.977 17.4794 751.065 17.8853L750.765 17.212C749.857 17.6162 748.932 18.0186 747.992 18.4193L748.281 19.0972C747.406 19.4699 746.518 19.8409 745.617 20.2103L745.337 19.5285C744.441 19.8958 743.531 20.2615 742.608 20.6257L742.879 21.3111C741.953 21.6764 741.014 22.0401 740.062 22.4021L739.8 21.7133C738.903 22.054 737.995 22.3933 737.076 22.7311L737.33 23.4228C736.421 23.7567 735.501 24.0891 734.569 24.4201L734.323 23.7258C733.394 24.0559 732.454 24.3845 731.502 24.7117L731.742 25.4086C730.813 25.728 729.874 26.0461 728.925 26.3626L728.692 25.6636C727.781 25.9672 726.861 26.2694 725.931 26.5703L726.158 27.2714C725.227 27.573 724.285 27.8732 723.335 28.172L723.114 27.4691C722.165 27.7673 721.207 28.0642 720.24 28.3597L720.455 29.0644C719.53 29.347 718.597 29.6284 717.655 29.9084L717.445 29.2021C716.518 29.4778 715.582 29.7522 714.639 30.0253L714.844 30.7332C713.899 31.0068 712.945 31.2792 711.984 31.5503L711.784 30.8411C710.824 31.1117 709.857 31.3811 708.881 31.6493L709.076 32.3598C708.147 32.615 707.211 32.8691 706.268 33.122L706.078 32.4102C705.14 32.6615 704.196 32.9116 703.245 33.1605L703.432 33.8734C702.479 34.1227 701.52 34.3708 700.553 34.6178L700.371 33.9038C699.406 34.1504 698.434 34.3958 697.455 34.64L697.633 35.355C696.694 35.5893 695.748 35.8225 694.796 36.0546L694.622 35.3387C693.679 35.5685 692.731 35.7972 691.776 36.0248L691.947 36.7416C690.991 36.9695 690.029 37.1963 689.061 37.4219L688.893 36.7043C687.927 36.9297 686.954 37.1539 685.975 37.3771L686.138 38.0956C685.183 38.3134 684.221 38.5302 683.254 38.7459L683.094 38.0267C682.149 38.2374 681.199 38.4471 680.244 38.6557L680.401 39.3756C679.444 39.5845 678.482 39.7923 677.515 39.9991L677.361 39.2785C676.395 39.485 675.423 39.6906 674.447 39.895L674.597 40.6162C673.621 40.8206 672.639 41.0239 671.652 41.2262L671.504 40.5043C670.56 40.6979 669.61 40.8906 668.655 41.0822L668.8 41.8047C667.845 41.9966 666.885 42.1874 665.92 42.3773L665.777 41.6543C664.814 41.844 663.845 42.0327 662.871 42.2204L663.011 42.9439C662.037 43.1318 661.058 43.3186 660.074 43.5045L659.937 42.7804C659.601 42.8439 659.265 42.9072 658.928 42.9704C658.292 43.0898 657.654 43.2087 657.014 43.3272L657.148 44.0518C656.195 44.2283 655.237 44.4039 654.276 44.5785L654.144 43.8535C653.183 44.028 652.218 44.2015 651.249 44.3741L651.378 45.0996C650.408 45.2723 649.434 45.4441 648.456 45.6149L648.329 44.8889C647.352 45.0596 646.37 45.2293 645.384 45.398L645.508 46.1244C644.537 46.2906 643.562 46.4558 642.583 46.6202L642.461 45.8934C641.504 46.0541 640.543 46.2139 639.579 46.3727L639.699 47.0998C638.733 47.2587 637.764 47.4168 636.791 47.5739L636.674 46.8465C636.228 46.9185 635.781 46.9904 635.333 47.062C634.805 47.1465 634.277 47.2307 633.746 47.3147L633.862 48.0425C632.882 48.1978 631.898 48.3522 630.91 48.5056L630.797 47.7774C629.822 47.929 628.843 48.0796 627.86 48.2293L627.971 48.9578C627.011 49.1042 626.047 49.2496 625.079 49.3943L624.97 48.6655C624.004 48.81 623.034 48.9536 622.061 49.0964L622.168 49.8255C621.194 49.9683 620.216 50.1102 619.236 50.2513L619.131 49.5219C618.151 49.6629 617.168 49.803 616.181 49.9422L616.284 50.6718C615.299 50.8108 614.311 50.9489 613.32 51.086L613.219 50.3561C612.257 50.4891 611.293 50.6213 610.326 50.7526L610.425 51.4828C609.457 51.6142 608.486 51.7447 607.512 51.8744L607.415 51.1439C606.441 51.2735 605.465 51.4023 604.486 51.5301L604.581 52.2608C603.601 52.3888 602.618 52.5159 601.633 52.6421L601.539 51.9112C600.554 52.0373 599.566 52.1626 598.575 52.287L598.667 53.0181C597.693 53.1403 596.717 53.2617 595.738 53.3822L595.648 52.6508C594.681 52.7698 593.711 52.8881 592.739 53.0055L592.827 53.737C591.854 53.8545 590.878 53.9711 589.9 54.0869L589.813 53.3551C588.835 53.4709 587.854 53.5858 586.871 53.6998L586.956 54.4318C585.972 54.5459 584.986 54.6592 583.997 54.7716L583.914 54.0394C582.926 54.1517 581.935 54.2632 580.942 54.3738L581.023 55.1061C580.056 55.2138 579.087 55.3207 578.115 55.4268L578.035 54.6942C577.064 54.8002 576.09 54.9054 575.114 55.0098L575.192 55.7425C574.215 55.847 573.236 55.9506 572.255 56.0534L572.178 55.3205C571.197 55.4232 570.214 55.5252 569.228 55.6263L569.303 56.3593C568.317 56.4605 567.328 56.5608 566.338 56.6603L566.264 55.9271C565.28 56.0259 564.293 56.1239 563.305 56.2211L563.377 56.9545C562.406 57.0499 561.434 57.1444 560.459 57.2382L560.389 56.5047C559.415 56.5984 558.438 56.6914 557.46 56.7835L557.529 57.5172C556.55 57.6093 555.569 57.7007 554.586 57.7913L554.518 57.0575C553.935 57.1113 553.35 57.1647 552.766 57.2179C552.365 57.2543 551.964 57.2906 551.563 57.3267L551.629 58.0606C550.642 58.1496 549.652 58.2377 548.66 58.3251L548.596 57.591C547.612 57.6777 546.627 57.7635 545.639 57.8485L545.702 58.5827C544.73 58.6664 543.755 58.7493 542.779 58.8315L542.717 58.0972C541.741 58.1793 540.763 58.2606 539.783 58.3412L539.844 59.0756C538.863 59.1562 537.881 59.236 536.897 59.315L536.838 58.5804C535.854 58.6594 534.869 58.7376 533.881 58.815L533.939 59.5496C532.951 59.6271 531.961 59.7037 530.969 59.7795L530.913 59.0448C529.927 59.1201 528.94 59.1947 527.951 59.2685L528.005 60.0033C527.031 60.076 526.056 60.1478 525.078 60.2189L525.025 59.484C524.048 59.555 523.069 59.6253 522.089 59.6948L522.141 60.4299C521.16 60.4994 520.177 60.5682 519.193 60.6362L519.142 59.9011C518.5 59.9454 517.858 59.9894 517.215 60.033C516.872 60.0563 516.528 60.0795 516.184 60.1027L516.234 60.8379C515.246 60.9043 514.256 60.97 513.265 61.0349L513.217 60.2996C512.227 60.3643 511.236 60.4283 510.243 60.4915L510.29 61.2269C509.316 61.2889 508.339 61.3502 507.361 61.4107L507.316 60.6752C506.95 60.6979 506.583 60.7204 506.216 60.7429C505.604 60.7803 504.992 60.8175 504.378 60.8544L504.423 61.59C503.442 61.649 502.459 61.7072 501.475 61.7647L501.432 61.029C500.448 61.0865 499.462 61.1431 498.475 61.1991L498.517 61.9348C497.53 61.9907 496.541 62.0459 495.55 62.1003L495.51 61.3645C495.152 61.3841 494.794 61.4037 494.435 61.4231C493.802 61.4575 493.169 61.4915 492.535 61.5252L492.574 62.2611C491.594 62.3132 490.613 62.3645 489.63 62.4151L489.593 61.6792C488.615 61.7295 487.636 61.7791 486.655 61.8279L486.692 62.5639C485.711 62.6128 484.729 62.6609 483.745 62.7082L483.709 61.9722C482.726 62.0195 481.741 62.0661 480.755 62.1118L480.789 62.8479C479.802 62.8938 478.814 62.9388 477.825 62.9831L477.792 62.247C476.803 62.2913 475.813 62.3348 474.821 62.3775L474.853 63.1137C473.866 63.1563 472.877 63.198 471.888 63.2391L471.857 62.5028C470.88 62.5433 469.901 62.5831 468.921 62.6221L468.95 63.3584C467.97 63.3975 466.988 63.4358 466.005 63.4733L465.977 62.737C464.994 62.7745 464.01 62.8113 463.025 62.8473L463.052 63.5837C462.066 63.6198 461.079 63.6551 460.091 63.6896L460.065 62.9532C459.077 62.9877 458.088 63.0214 457.098 63.0545L457.122 63.7909C456.132 63.824 455.14 63.8562 454.147 63.8877L454.123 63.1512C453.142 63.1823 452.16 63.2127 451.177 63.2423L451.199 63.9789C450.219 64.0084 449.238 64.0372 448.256 64.0652L448.235 63.3286C447.253 63.3567 446.27 63.384 445.286 63.4105L445.305 64.1471C444.321 64.1737 443.335 64.1995 442.348 64.2245L442.329 63.4879C441.343 63.5129 440.355 63.5372 439.367 63.5608L439.384 64.2975C438.395 64.321 437.405 64.3438 436.413 64.3659L436.397 63.6292C435.408 63.6512 434.417 63.6724 433.425 63.6929L433.44 64.4296C432.461 64.4499 431.481 64.4694 430.499 64.4882L430.485 63.7514C429.504 63.7702 428.522 63.7882 427.539 63.8055L427.552 64.5422C426.568 64.5595 425.584 64.5761 424.598 64.5919L424.587 63.8551C423.601 63.8709 422.615 63.8859 421.628 63.9002L421.639 64.637C420.651 64.6514 419.663 64.6649 418.673 64.6777L418.663 63.9409C417.674 63.9537 416.684 63.9657 415.693 63.9771L415.701 64.7139C414.714 64.7252 413.726 64.7357 412.737 64.7454L412.73 64.0086C411.75 64.0182 410.769 64.0272 409.787 64.0354L409.793 64.7722C408.81 64.7805 407.827 64.7879 406.843 64.7946L406.838 64.0578C405.854 64.0645 404.869 64.0705 403.883 64.0757L403.887 64.8126C402.901 64.8178 401.914 64.8223 400.926 64.8261L400.923 64.0892C399.936 64.0929 398.948 64.0959 397.958 64.0982L397.96 64.8351C396.97 64.8373 395.98 64.8388 394.988 64.8396L394.988 64.1027C394.492 64.1031 393.997 64.1033 393.501 64.1033C393.005 64.1033 392.509 64.1031 392.013 64.1027L392.013 64.8396C391.021 64.8388 390.031 64.8373 389.041 64.8351L389.043 64.0982C388.054 64.0959 387.065 64.0929 386.078 64.0892L386.075 64.8261C385.087 64.8223 384.1 64.8178 383.114 64.8126L383.118 64.0757C382.132 64.0705 381.147 64.0645 380.163 64.0578L380.158 64.7946C379.174 64.7879 378.191 64.7805 377.208 64.7722L377.215 64.0354C376.233 64.0272 375.251 64.0182 374.271 64.0086L374.264 64.7454C373.275 64.7357 372.287 64.7251 371.3 64.7139L371.308 63.977C370.317 63.9657 369.327 63.9537 368.338 63.9409L368.328 64.6777C367.339 64.6649 366.35 64.6513 365.362 64.637L365.373 63.9002C364.386 63.8859 363.4 63.8709 362.415 63.8551L362.403 64.5919C361.417 64.5761 360.433 64.5595 359.449 64.5422L359.462 63.8055C359.145 63.7999 358.829 63.7942 358.512 63.7885C357.846 63.7765 357.181 63.7641 356.516 63.7514L356.502 64.4882C355.52 64.4694 354.54 64.4499 353.561 64.4296L353.576 63.6929C352.584 63.6724 351.594 63.6512 350.604 63.6292L350.588 64.3659C349.596 64.3438 348.606 64.321 347.617 64.2975L347.635 63.5608C346.646 63.5372 345.658 63.5129 344.672 63.4879L344.653 64.2245C343.666 64.1995 342.68 64.1737 341.696 64.1471L341.716 63.4105C340.732 63.384 339.748 63.3567 338.767 63.3286L338.746 64.0652C337.763 64.0372 336.782 64.0084 335.802 63.9789L335.824 63.2423C334.841 63.2127 333.859 63.1823 332.878 63.1512L332.855 63.8877C331.862 63.8562 330.87 63.824 329.879 63.7909L329.903 63.0544C328.913 63.0214 327.924 62.9877 326.936 62.9531L326.911 63.6896C325.922 63.6551 324.935 63.6198 323.95 63.5837L323.977 62.8473C322.991 62.8113 322.008 62.7745 321.025 62.737L320.997 63.4733C320.014 63.4358 319.032 63.3975 318.051 63.3584L318.081 62.6221C317.1 62.5831 316.122 62.5433 315.144 62.5028L315.114 63.2391C314.124 63.198 313.136 63.1563 312.149 63.1137L312.181 62.3775C311.189 62.3348 310.198 62.2912 309.209 62.247L309.176 62.9831C308.187 62.9388 307.199 62.8938 306.212 62.8479L306.246 62.1118C305.26 62.066 304.275 62.0195 303.292 61.9722L303.257 62.7082C302.273 62.6609 301.29 62.6128 300.31 62.5639L300.346 61.8279C299.366 61.7791 298.387 61.7295 297.409 61.6792L297.371 62.4151C296.388 62.3645 295.407 62.3132 294.428 62.2611L294.467 61.5252C293.474 61.4724 292.482 61.4188 291.492 61.3645L291.451 62.1002C290.461 62.0459 289.472 61.9907 288.485 61.9348L288.526 61.1991C287.539 61.1431 286.554 61.0865 285.57 61.029L285.527 61.7646C284.543 61.7072 283.56 61.6489 282.579 61.59L282.623 60.8544C281.642 60.7954 280.663 60.7357 279.686 60.6752L279.64 61.4107C278.662 61.3502 277.686 61.2889 276.711 61.2269L276.758 60.4915C275.765 60.4283 274.774 60.3643 273.785 60.2995L273.737 61.0349C272.745 60.97 271.756 60.9043 270.768 60.8379L270.817 60.1026C269.83 60.0362 268.844 59.969 267.86 59.9011L267.809 60.6362C266.824 60.5682 265.842 60.4994 264.861 60.4299L264.913 59.6948C263.932 59.6253 262.954 59.555 261.977 59.484L261.923 60.2189C260.946 60.1478 259.97 60.076 258.996 60.0033L259.051 59.2685C258.062 59.1947 257.074 59.1201 256.089 59.0448L256.033 59.7795C255.041 59.7037 254.051 59.6271 253.063 59.5496L253.12 58.815C252.133 58.7376 251.147 58.6594 250.164 58.5805L250.105 59.315C249.12 59.236 248.138 59.1562 247.158 59.0756L247.218 58.3412C246.238 58.2606 245.26 58.1793 244.284 58.0972L244.223 58.8315C243.246 58.7493 242.272 58.6664 241.299 58.5827L241.363 57.8485C240.375 57.7635 239.389 57.6777 238.406 57.591L238.341 58.3251C237.349 58.2377 236.36 58.1496 235.372 58.0606L235.438 57.3267C234.451 57.2378 233.466 57.148 232.484 57.0575L232.416 57.7913C231.433 57.7007 230.452 57.6093 229.473 57.5172L229.542 56.7835C228.563 56.6914 227.587 56.5984 226.613 56.5047L226.542 57.2382C225.568 57.1444 224.595 57.0499 223.625 56.9545L223.697 56.2211C222.708 56.124 221.722 56.026 220.738 55.9271L220.664 56.6603C219.673 56.5608 218.685 56.4605 217.698 56.3593L217.774 55.6263C216.788 55.5252 215.805 55.4233 214.824 55.3205L214.747 56.0534C213.765 55.9506 212.786 55.847 211.81 55.7425L211.888 55.0098C210.912 54.9054 209.938 54.8002 208.967 54.6942L208.887 55.4268C207.915 55.3207 206.945 55.2138 205.978 55.1062L206.06 54.3738C205.067 54.2632 204.076 54.1517 203.088 54.0394L203.005 54.7716C202.016 54.6592 201.029 54.5459 200.046 54.4318L200.13 53.6998C199.147 53.5858 198.167 53.4709 197.189 53.3551L197.102 54.0869C196.124 53.9712 195.148 53.8545 194.175 53.7371L194.263 53.0055C193.29 52.8881 192.32 52.7699 191.353 52.6508L191.263 53.3822C190.284 53.2617 189.308 53.1403 188.335 53.0181L188.427 52.287C187.436 52.1626 186.448 52.0373 185.463 51.9112L185.369 52.6421C184.383 52.5159 183.4 52.3888 182.421 52.2608L182.516 51.5302C181.537 51.4023 180.56 51.2735 179.587 51.144L179.49 51.8744C178.516 51.7447 177.545 51.6142 176.577 51.4828L176.676 50.7526C175.709 50.6213 174.744 50.4891 173.783 50.3561L173.682 51.0861C172.691 50.9489 171.702 50.8108 170.717 50.6718L170.82 49.9422C169.834 49.803 168.851 49.6629 167.871 49.5219L167.766 50.2513C166.785 50.1103 165.808 49.9683 164.834 49.8255L164.941 49.0964C163.968 48.9536 162.998 48.81 162.031 48.6655L161.922 49.3943C160.955 49.2497 159.991 49.1042 159.03 48.9578L159.141 48.2293C158.159 48.0796 157.18 47.929 156.204 47.7774L156.091 48.5056C155.104 48.3522 154.12 48.1978 153.14 48.0425L153.255 47.3147C152.276 47.1596 151.3 47.0035 150.328 46.8465L150.21 47.5739C149.238 47.4168 148.268 47.2588 147.303 47.0998L147.423 46.3727C146.458 46.2139 145.497 46.0541 144.54 45.8935L144.418 46.6202C143.439 46.4559 142.464 46.2906 141.493 46.1244L141.617 45.398C140.632 45.2293 139.65 45.0596 138.673 44.889L138.546 45.6149C137.568 45.4441 136.593 45.2723 135.623 45.0996L135.753 44.3741C134.783 44.2015 133.818 44.028 132.857 43.8535L132.726 44.5786C131.764 44.4039 130.807 44.2284 129.853 44.0518L129.988 43.3273C129.009 43.146 128.034 42.9637 127.064 42.7804L126.928 43.5045C125.944 43.3187 124.965 43.1318 123.991 42.9439L124.13 42.2204C123.157 42.0327 122.188 41.844 121.224 41.6543L121.082 42.3773C120.117 42.1874 119.157 41.9966 118.201 41.8047L118.346 41.0822C117.392 40.8906 116.442 40.6979 115.497 40.5043L115.349 41.2262C114.362 41.0239 113.381 40.8206 112.404 40.6163L112.555 39.895C111.578 39.6905 110.607 39.485 109.64 39.2785L109.486 39.9991C108.519 39.7923 107.557 39.5845 106.601 39.3756L106.758 38.6557C105.802 38.447 104.852 38.2374 103.907 38.0266L103.747 38.7459C102.78 38.5302 101.819 38.3134 100.863 38.0956L101.027 37.3771C100.048 37.1539 99.0749 36.9297 98.108 36.7043L97.9407 37.4219C96.9727 37.1963 96.0107 36.9695 95.0547 36.7416L95.2256 36.0248C94.2709 35.7972 93.3223 35.5685 92.3799 35.3387L92.2054 36.0546C91.2534 35.8225 90.3078 35.5893 89.3685 35.355L89.5468 34.64C88.5678 34.3958 87.5958 34.1504 86.6307 33.9038L86.4482 34.6178C85.4817 34.3708 84.5222 34.1227 83.5696 33.8734L83.7562 33.1605C82.8051 32.9116 81.8609 32.6615 80.9239 32.4102L80.733 33.1219C79.7899 32.8691 78.854 32.615 77.9252 32.3598L78.1205 31.6492C77.1448 31.3811 76.1771 31.1117 75.2174 30.841L75.0174 31.5503C74.0561 31.2792 73.1029 31.0068 72.1577 30.7331L72.3627 30.0253C71.4192 29.7521 70.4838 29.4777 69.5567 29.2021L69.3467 29.9084C68.4047 29.6283 67.4711 29.347 66.5461 29.0644L66.7614 28.3597C65.794 28.0642 64.836 27.7673 63.8874 27.469L63.6664 28.172C62.7159 27.8731 61.7748 27.5729 60.8431 27.2714L61.0701 26.5703C60.1404 26.2694 59.2203 25.9671 58.3098 25.6635L58.0768 26.3626C57.1272 26.046 56.188 25.728 55.2593 25.4085L55.4989 24.7117C54.5478 24.3845 53.6076 24.0558 52.6787 23.7257L52.4319 24.4201C51.5006 24.0891 50.5804 23.7566 49.6714 23.4227L49.9255 22.731C49.0059 22.3932 48.0979 22.054 47.2017 21.7132L46.9398 22.402C45.9876 22.04 45.0484 21.6764 44.1225 21.3111L44.3929 20.6256C43.4699 20.2614 42.5602 19.8957 41.6639 19.5284L41.3845 20.2103C40.4829 19.8408 39.5948 19.4698 38.7203 19.0971L39.0091 18.4192C38.0688 18.0185 37.1444 17.6161 36.236 17.2119L35.9364 17.8852C35.0244 17.4793 34.1282 17.0717 33.2482 16.6623L33.5591 15.9942C32.6747 15.5827 31.8069 15.1695 30.9557 14.7547L30.6328 15.4171C29.7096 14.9671 28.8058 14.515 27.9214 14.061L28.258 13.4054C27.3784 12.9538 26.5184 12.5002 25.6784 12.0448L25.3272 12.6926C24.4474 12.2157 23.589 11.7366 22.7522 11.2553L23.1196 10.6165C22.2431 10.1125 21.391 9.60634 20.5633 9.09814L20.1777 9.72609C19.3438 9.21404 18.5343 8.6997 17.7494 8.18314L18.1545 7.56759C17.2958 7.00248 16.4675 6.43506 15.6697 5.86543L15.2415 6.46513C14.4339 5.88844 13.6568 5.3091 12.9106 4.7272L13.3638 4.14612C12.5626 3.52129 11.7982 2.89413 11.0711 2.26476L10.5888 2.82192C9.83366 2.16828 9.11728 1.51157 8.44019 0.851883L8.95442 0.324081C8.22846 -0.383224 7.54965 -1.0928 6.91839 -1.80443L6.36713 -1.31543C5.70811 -2.05836 5.09869 -2.80484 4.53962 -3.55472L5.13039 -3.99517C4.52521 -4.80689 3.98206 -5.62053 3.50129 -6.4358L2.86655 -6.06149C2.35441 -6.92995 1.90955 -7.80267 1.53308 -8.67941L2.21018 -8.97016C1.82821 -9.8597 1.52026 -10.751 1.28668 -11.6439L0.573779 -11.4574C0.320501 -12.4256 0.150463 -13.3984 0.0651069 -14.3754L0.799202 -14.4395C0.758223 -14.9086 0.737654 -15.3785 0.737654 -15.8495C0.737654 -16.3205 0.758235 -16.7906 0.799236 -17.2598L0.0651429 -17.3239C0.150522 -18.3009 0.320581 -19.2737 0.573879 -20.2419L1.28678 -20.0554C1.52037 -20.9483 1.82834 -21.8396 2.21033 -22.7291L1.53323 -23.0199C1.90972 -23.8966 2.35459 -24.7693 2.86674 -25.6377L3.50148 -25.2634C3.98226 -26.0787 4.52541 -26.8923 5.1306 -27.704L4.53984 -28.1445C5.09892 -28.8944 5.70835 -29.6408 6.36739 -30.3838L6.91864 -29.8948C7.5499 -30.6064 8.2287 -31.3159 8.95467 -32.0232L8.44044 -32.551C9.11753 -33.2107 9.83393 -33.8674 10.5891 -34.5211L11.0714 -33.9639C11.7985 -34.5933 12.5628 -35.2204 13.364 -35.8452L12.9109 -36.4263C13.6571 -37.0082 14.4342 -37.5876 15.2418 -38.1642L15.67 -37.5645C16.4677 -38.1342 17.2961 -38.7016 18.1548 -39.2667L17.7496 -39.8822C18.5346 -40.3988 19.3441 -40.9131 20.178 -41.4252L20.5636 -40.7972C21.3912 -41.3054 22.2434 -41.8116 23.1198 -42.3156L22.7525 -42.9544C23.5892 -43.4356 24.4476 -43.9147 25.3275 -44.3917L25.6786 -43.7439C26.5187 -44.1992 27.3786 -44.6528 28.2582 -45.1045L27.9216 -45.76C28.806 -46.2141 29.7099 -46.6661 30.6331 -47.1161L30.9559 -46.4537C31.8071 -46.8686 32.6749 -47.2817 33.5593 -47.6932L33.2484 -48.3613C34.1285 -48.7707 35.0246 -49.1783 35.9366 -49.5842L36.2362 -48.9109C37.1446 -49.3151 38.069 -49.7175 39.0094 -50.1182L38.7205 -50.7961C39.5951 -51.1688 40.4832 -51.5398 41.3847 -51.9093L41.6641 -51.2274C42.5604 -51.5947 43.4701 -51.9604 44.3931 -52.3246L44.1227 -53.01C45.0486 -53.3753 45.9877 -53.739 46.94 -54.101L47.2018 -53.4122C48.0981 -53.7529 49.0061 -54.0922 49.9256 -54.43L49.6715 -55.1217C50.5805 -55.4556 51.5008 -55.7881 52.4321 -56.119L52.6788 -55.4247C53.6078 -55.7548 54.5479 -56.0835 55.4991 -56.4106L55.2594 -57.1075C56.1882 -57.4269 57.1274 -57.745 58.0769 -58.0616L58.31 -57.3625C59.2205 -57.6661 60.1406 -57.9683 61.0702 -58.2692L60.8433 -58.9703C61.7749 -59.2719 62.716 -59.5721 63.6665 -59.871L63.8876 -59.168C64.8361 -59.4662 65.7941 -59.7631 66.7615 -60.0586L66.5462 -60.7634C67.4713 -61.046 68.4048 -61.3273 69.3468 -61.6074L69.5568 -60.901C70.484 -61.1767 71.4193 -61.4511 72.3628 -61.7242L72.1578 -62.4321C73.103 -62.7057 74.0562 -62.9781 75.0175 -63.2492L75.2175 -62.54C76.1772 -62.8107 77.1449 -63.0801 78.1206 -63.3482L77.9253 -64.0587C78.8541 -64.314 79.7901 -64.568 80.7331 -64.8209L80.924 -64.1091C81.861 -64.3604 82.8052 -64.6105 83.7563 -64.8594L83.5697 -65.5723C84.5223 -65.8216 85.4818 -66.0698 86.4483 -66.3167L86.6307 -65.6027C87.5959 -65.8493 88.5679 -66.0947 89.5469 -66.3389L89.3685 -67.0539C90.3079 -67.2882 91.2535 -67.5215 92.2054 -67.7536L92.38 -67.0376C93.3224 -67.2674 94.271 -67.4961 95.2257 -67.7237L95.0548 -68.4405C96.0107 -68.6684 96.9727 -68.8952 97.9408 -69.1209L98.1081 -68.4032C99.0749 -68.6286 100.048 -68.8529 101.027 -69.076L100.863 -69.7945C101.819 -70.0123 102.78 -70.2291 103.747 -70.4448L103.908 -69.7256C104.852 -69.9363 105.802 -70.146 106.758 -70.3546L106.601 -71.0745C107.557 -71.2834 108.519 -71.4912 109.486 -71.698L109.64 -70.9774C110.607 -71.184 111.578 -71.3895 112.555 -71.5939L112.404 -72.3152C113.38 -72.5195 114.362 -72.7228 115.349 -72.9251L115.497 -72.2032C116.442 -72.3968 117.392 -72.5895 118.346 -72.7812L118.201 -73.5036C119.157 -73.6955 120.117 -73.8864 121.082 -74.0762L121.224 -73.3532C122.188 -73.5429 123.157 -73.7316 124.13 -73.9193L123.991 -74.6428C124.965 -74.8307 125.944 -75.0176 126.927 -75.2034L127.064 -74.4793C128.034 -74.6626 129.009 -74.8449 129.988 -75.0262L129.853 -75.7507C130.807 -75.9273 131.764 -76.1028 132.726 -76.2775L132.857 -75.5524C133.818 -75.7269 134.783 -75.9004 135.752 -76.073L135.623 -76.7985C136.593 -76.9712 137.567 -77.143 138.546 -77.3138L138.673 -76.5879C139.65 -76.7585 140.632 -76.9282 141.617 -77.0969L141.493 -77.8233C142.464 -77.9895 143.439 -78.1548 144.418 -78.3191L144.54 -77.5924C145.497 -77.753 146.458 -77.9128 147.423 -78.0716L147.303 -78.7987C148.268 -78.9577 149.237 -79.1157 150.21 -79.2728L150.328 -78.5454C151.3 -78.7024 152.276 -78.8585 153.255 -79.0136L153.14 -79.7414C154.12 -79.8967 155.104 -80.0511 156.091 -80.2045L156.204 -79.4763C157.18 -79.6279 158.159 -79.7785 159.141 -79.9282L159.03 -80.6567C159.991 -80.8031 160.955 -80.9486 161.922 -81.0932L162.031 -80.3644C162.998 -80.5089 163.968 -80.6525 164.941 -80.7953L164.834 -81.5244C165.808 -81.6672 166.785 -81.8092 167.766 -81.9502L167.871 -81.2208C168.851 -81.3618 169.834 -81.5019 170.82 -81.6411L170.717 -82.3707C171.702 -82.5097 172.69 -82.6478 173.682 -82.785L173.783 -82.055C174.744 -82.188 175.709 -82.3202 176.676 -82.4515L176.577 -83.1817C177.545 -83.3131 178.516 -83.4436 179.49 -83.5733L179.587 -82.8428C180.56 -82.9724 181.537 -83.1012 182.516 -83.2291L182.42 -83.9597C183.4 -84.0877 184.383 -84.2148 185.369 -84.341L185.462 -83.6101C186.448 -83.7362 187.436 -83.8615 188.427 -83.9859L188.335 -84.7171C189.308 -84.8392 190.284 -84.9606 191.263 -85.0811L191.353 -84.3497C192.32 -84.4688 193.29 -84.587 194.263 -84.7044L194.174 -85.436C195.148 -85.5534 196.124 -85.6701 197.102 -85.7858L197.189 -85.0541C198.167 -85.1698 199.147 -85.2847 200.13 -85.3987L200.045 -86.1307C201.029 -86.2448 202.016 -86.3581 203.005 -86.4705L203.088 -85.7383C204.076 -85.8506 205.067 -85.9621 206.06 -86.0727L205.978 -86.8051C206.945 -86.9127 207.915 -87.0196 208.887 -87.1257L208.967 -86.3931C209.938 -86.4991 210.912 -86.6043 211.888 -86.7087L211.809 -87.4414C212.786 -87.5459 213.765 -87.6495 214.747 -87.7523L214.823 -87.0194C215.804 -87.1222 216.788 -87.2241 217.773 -87.3252L217.698 -88.0582C218.684 -88.1594 219.673 -88.2597 220.664 -88.3592L220.738 -87.626C221.722 -87.7249 222.708 -87.8229 223.697 -87.92L223.625 -88.6534C224.595 -88.7488 225.568 -88.8433 226.542 -88.9371L226.613 -88.2036C227.587 -88.2973 228.563 -88.3903 229.542 -88.4824L229.473 -89.2161C230.452 -89.3082 231.433 -89.3996 232.416 -89.4902L232.484 -88.7564C233.466 -88.847 234.451 -88.9367 235.438 -89.0256L235.372 -89.7595C236.36 -89.8485 237.349 -89.9366 238.341 -90.024L238.406 -89.2899C239.389 -89.3766 240.375 -89.4624 241.363 -89.5474L241.299 -90.2816C242.272 -90.3653 243.246 -90.4482 244.223 -90.5304L244.284 -89.7961C245.26 -89.8782 246.238 -89.9595 247.218 -90.0401L247.158 -90.7745C248.138 -90.8551 249.12 -90.9349 250.105 -91.0139L250.163 -90.2794C251.147 -90.3583 252.133 -90.4365 253.12 -90.5139L253.063 -91.2485C254.051 -91.326 255.041 -91.4026 256.033 -91.4784L256.089 -90.7437C257.074 -90.8191 258.062 -90.8936 259.051 -90.9674L258.996 -91.7022C259.97 -91.7749 260.946 -91.8467 261.923 -91.9178L261.977 -91.1829C262.954 -91.2539 263.932 -91.3242 264.913 -91.3938L264.861 -92.1288C265.842 -92.1984 266.825 -92.2671 267.809 -92.3351L267.86 -91.6C268.844 -91.668 269.83 -91.7352 270.817 -91.8016L270.768 -92.5368C271.756 -92.6032 272.745 -92.6689 273.737 -92.7338L273.785 -91.9985C274.774 -92.0632 275.765 -92.1272 276.758 -92.1904L276.711 -92.9258C277.686 -92.9878 278.662 -93.0491 279.64 -93.1096L279.686 -92.3741C280.663 -92.4346 281.642 -92.4943 282.623 -92.5533L282.579 -93.2889C283.56 -93.3479 284.543 -93.4061 285.527 -93.4636L285.57 -92.7279C286.554 -92.7854 287.539 -92.8421 288.526 -92.898L288.485 -93.6337C289.472 -93.6896 290.461 -93.7448 291.452 -93.7992L291.492 -93.0634C292.482 -93.1177 293.474 -93.1713 294.467 -93.2242L294.428 -93.96C295.407 -94.0121 296.389 -94.0634 297.371 -94.114L297.409 -93.3781C298.387 -93.4285 299.366 -93.478 300.346 -93.5269L300.31 -94.2628C301.291 -94.3117 302.273 -94.3598 303.257 -94.4071L303.292 -93.6711C304.276 -93.7184 305.26 -93.765 306.247 -93.8108L306.212 -94.5469C307.199 -94.5927 308.187 -94.6377 309.177 -94.682L309.21 -93.9459C310.199 -93.9902 311.189 -94.0337 312.181 -94.0764L312.149 -94.8126C313.136 -94.8552 314.124 -94.897 315.114 -94.938L315.144 -94.2017C316.122 -94.2422 317.101 -94.282 318.081 -94.321L318.051 -95.0573C319.032 -95.0964 320.014 -95.1347 320.997 -95.1722L321.025 -94.4359C322.008 -94.4734 322.992 -94.5102 323.977 -94.5462L323.95 -95.2826C324.936 -95.3187 325.923 -95.354 326.911 -95.3885L326.937 -94.6521C327.924 -94.6866 328.913 -94.7204 329.904 -94.7534L329.879 -95.4899C330.87 -95.5229 331.862 -95.5551 332.855 -95.5866L332.878 -94.8501C333.859 -94.8812 334.841 -94.9116 335.825 -94.9412L335.802 -95.6778C336.782 -95.7073 337.764 -95.7361 338.746 -95.7642L338.767 -95.0276C339.749 -95.0556 340.732 -95.0829 341.716 -95.1094L341.696 -95.846C342.681 -95.8726 343.666 -95.8984 344.653 -95.9235L344.672 -95.1868C345.659 -95.2118 346.646 -95.2361 347.635 -95.2597L347.617 -95.9964C348.606 -96.0199 349.597 -96.0427 350.588 -96.0648L350.604 -95.3281C351.594 -95.3501 352.585 -95.3713 353.576 -95.3918L353.561 -96.1286C354.54 -96.1488 355.521 -96.1683 356.502 -96.1871L356.516 -95.4503C357.497 -95.4691 358.479 -95.4871 359.463 -95.5044L359.45 -96.2412C360.433 -96.2584 361.418 -96.275 362.403 -96.2908L362.415 -95.554C363.4 -95.5698 364.386 -95.5848 365.373 -95.5991L365.363 -96.3359C366.35 -96.3503 367.339 -96.3638 368.329 -96.3766L368.338 -95.6398C369.327 -95.6526 370.317 -95.6647 371.309 -95.676L371.3 -96.4128C372.287 -96.4241 373.275 -96.4346 374.264 -96.4443L374.272 -95.7075C375.252 -95.7172 376.233 -95.7261 377.215 -95.7343L377.209 -96.4712C378.191 -96.4794 379.175 -96.4868 380.159 -96.4936L380.164 -95.7567C381.148 -95.7634 382.133 -95.7694 383.118 -95.7746L383.114 -96.5115C384.1 -96.5167 385.087 -96.5212 386.075 -96.525L386.078 -95.7881C387.066 -95.7918 388.054 -95.7948 389.043 -95.7971L389.042 -96.534C390.031 -96.5362 391.022 -96.5377 392.013 -96.5385L392.014 -95.8016C392.509 -95.802 393.005 -95.8022 393.501 -95.8022C393.997 -95.8022 394.493 -95.802 394.988 -95.8016L394.989 -96.5385C395.98 -96.5377 396.971 -96.5362 397.96 -96.534L397.959 -95.7971C398.948 -95.7948 399.936 -95.7918 400.924 -95.7881L400.927 -96.525C401.915 -96.5212 402.902 -96.5167 403.888 -96.5115L403.884 -95.7746C404.869 -95.7694 405.854 -95.7634 406.838 -95.7567L406.843 -96.4936C407.827 -96.4868 408.811 -96.4794 409.793 -96.4712L409.787 -95.7343C410.769 -95.7261 411.75 -95.7172 412.73 -95.7075L412.738 -96.4443C413.727 -96.4346 414.715 -96.4241 415.702 -96.4128L415.693 -95.676C416.684 -95.6647 417.675 -95.6526 418.664 -95.6398L418.673 -96.3766C419.663 -96.3638 420.651 -96.3502 421.639 -96.3359L421.628 -95.5991C422.616 -95.5848 423.602 -95.5698 424.587 -95.554L424.599 -96.2908C425.584 -96.275 426.569 -96.2584 427.552 -96.2411L427.539 -95.5044C428.522 -95.4871 429.505 -95.4691 430.486 -95.4503L430.5 -96.1871C431.481 -96.1683 432.461 -96.1488 433.441 -96.1286L433.425 -95.3918C434.417 -95.3713 435.408 -95.3501 436.397 -95.3281L436.414 -96.0648C437.405 -96.0427 438.395 -96.0199 439.384 -95.9964L439.367 -95.2597C440.356 -95.2361 441.343 -95.2118 442.33 -95.1868L442.348 -95.9234C443.335 -95.8984 444.321 -95.8726 445.306 -95.846L445.286 -95.1094C446.27 -95.0829 447.253 -95.0556 448.235 -95.0276L448.256 -95.7641C449.238 -95.7361 450.219 -95.7073 451.199 -95.6778L451.177 -94.9412C452.16 -94.9116 453.143 -94.8812 454.124 -94.8501L454.147 -95.5866C455.14 -95.5551 456.132 -95.5229 457.123 -95.4898L457.098 -94.7534C458.088 -94.7204 459.077 -94.6866 460.065 -94.6521L460.091 -95.3885C461.079 -95.354 462.066 -95.3187 463.052 -95.2826L463.025 -94.5462C464.01 -94.5102 464.994 -94.4734 465.977 -94.4359L466.005 -95.1722C466.988 -95.1347 467.97 -95.0964 468.95 -95.0573L468.921 -94.321C469.901 -94.282 470.88 -94.2422 471.857 -94.2017L471.888 -94.938C472.878 -94.897 473.866 -94.8552 474.853 -94.8126L474.821 -94.0764C475.813 -94.0337 476.803 -93.9902 477.792 -93.9459L477.825 -94.682C478.815 -94.6377 479.803 -94.5927 480.789 -94.5469L480.755 -93.8108C481.741 -93.765 482.726 -93.7184 483.709 -93.6711L483.745 -94.4071C484.729 -94.3598 485.711 -94.3117 486.692 -94.2628L486.655 -93.5269C487.636 -93.478 488.615 -93.4284 489.593 -93.3781L489.631 -94.114C490.613 -94.0634 491.594 -94.0121 492.574 -93.96L492.535 -93.2241C493.528 -93.1713 494.52 -93.1177 495.51 -93.0634L495.55 -93.7992C496.541 -93.7448 497.53 -93.6896 498.517 -93.6337L498.475 -92.898C499.462 -92.842 500.448 -92.7854 501.432 -92.7279L501.475 -93.4636C502.459 -93.4061 503.442 -93.3479 504.423 -93.2889L504.379 -92.5533C505.359 -92.4943 506.338 -92.4346 507.316 -92.3741L507.361 -93.1096C508.339 -93.0491 509.316 -92.9878 510.29 -92.9258L510.244 -92.1904C511.236 -92.1272 512.228 -92.0632 513.217 -91.9985L513.265 -92.7338C514.256 -92.6689 515.246 -92.6032 516.234 -92.5368L516.185 -91.8016C517.172 -91.7352 518.158 -91.668 519.142 -91.6L519.193 -92.3351C520.177 -92.2671 521.16 -92.1983 522.141 -92.1288L522.089 -91.3938C523.069 -91.3242 524.048 -91.2539 525.025 -91.1829L525.078 -91.9178C526.056 -91.8467 527.031 -91.7749 528.005 -91.7022L527.951 -90.9674C528.94 -90.8936 529.927 -90.8191 530.913 -90.7437L530.969 -91.4784C531.961 -91.4026 532.951 -91.326 533.939 -91.2485L533.881 -90.5139C534.869 -90.4365 535.854 -90.3583 536.838 -90.2794L536.897 -91.0139C537.881 -90.9349 538.863 -90.8551 539.844 -90.7745L539.783 -90.0401C540.763 -89.9595 541.741 -89.8782 542.717 -89.7961L542.779 -90.5304C543.755 -90.4482 544.73 -90.3653 545.702 -90.2816L545.639 -89.5474C546.627 -89.4624 547.612 -89.3766 548.596 -89.29L548.66 -90.024C549.652 -89.9367 550.642 -89.8485 551.629 -89.7595L551.563 -89.0256C552.55 -88.9367 553.535 -88.847 554.518 -88.7564L554.586 -89.4902C555.569 -89.3996 556.55 -89.3082 557.529 -89.2161L557.46 -88.4824C558.438 -88.3903 559.415 -88.2974 560.389 -88.2036L560.459 -88.9371C561.434 -88.8433 562.406 -88.7488 563.377 -88.6534L563.304 -87.9201C564.293 -87.8229 565.28 -87.7249 566.264 -87.626L566.337 -88.3592C567.328 -88.2597 568.317 -88.1594 569.303 -88.0583L569.228 -87.3252C570.214 -87.2241 571.197 -87.1222 572.178 -87.0194L572.255 -87.7523C573.236 -87.6495 574.215 -87.5459 575.192 -87.4414L575.114 -86.7087C576.09 -86.6044 577.064 -86.4992 578.035 -86.3932L578.115 -87.1257C579.087 -87.0196 580.056 -86.9128 581.023 -86.8051L580.942 -86.0727C581.935 -85.9621 582.926 -85.8506 583.914 -85.7383L583.997 -86.4705C584.986 -86.3581 585.972 -86.2448 586.956 -86.1307L586.871 -85.3987C587.854 -85.2847 588.835 -85.1698 589.813 -85.0541L589.899 -85.7859C590.878 -85.6701 591.854 -85.5534 592.827 -85.436L592.739 -84.7044C593.711 -84.587 594.681 -84.4688 595.648 -84.3497L595.738 -85.0811C596.717 -84.9606 597.693 -84.8392 598.667 -84.7171L598.575 -83.9859C599.566 -83.8615 600.554 -83.7362 601.539 -83.6101L601.633 -84.341C602.618 -84.2148 603.601 -84.0877 604.581 -83.9598L604.486 -83.2291C605.465 -83.1012 606.441 -82.9725 607.414 -82.8429L607.512 -83.5733C608.486 -83.4436 609.457 -83.3131 610.425 -83.1817L610.325 -82.4515C611.293 -82.3202 612.257 -82.188 613.219 -82.055L613.319 -82.785C614.311 -82.6478 615.299 -82.5097 616.284 -82.3707L616.181 -81.6411C617.168 -81.5019 618.151 -81.3618 619.131 -81.2209L619.236 -81.9502C620.216 -81.8092 621.193 -81.6672 622.167 -81.5244L622.06 -80.7953C623.034 -80.6525 624.004 -80.5089 624.97 -80.3644L625.079 -81.0932C626.047 -80.9486 627.011 -80.8031 627.971 -80.6567L627.86 -79.9282C628.843 -79.7785 629.822 -79.6279 630.797 -79.4763L630.91 -80.2045C631.898 -80.0511 632.882 -79.8967 633.862 -79.7414L633.746 -79.0136C634.726 -78.8585 635.702 -78.7024 636.674 -78.5454L636.791 -79.2728C637.764 -79.1157 638.733 -78.9577 639.698 -78.7987L639.579 -78.0716C640.543 -77.9128 641.504 -77.753 642.461 -77.5924L642.583 -78.3191C643.562 -78.1548 644.537 -77.9895 645.508 -77.8233L645.384 -77.097C646.37 -76.9282 647.351 -76.7585 648.329 -76.5879L648.456 -77.3138C649.434 -77.143 650.408 -76.9712 651.378 -76.7985L651.249 -76.073C652.218 -75.9004 653.183 -75.7269 654.144 -75.5524L654.276 -76.2775C655.237 -76.1028 656.195 -75.9273 657.148 -75.7507L657.014 -75.0262C657.993 -74.8449 658.967 -74.6626 659.937 -74.4793L660.074 -75.2034C661.058 -75.0176 662.037 -74.8307 663.011 -74.6428L662.871 -73.9193C663.845 -73.7316 664.813 -73.5429 665.777 -73.3532L665.92 -74.0762C666.885 -73.8864 667.845 -73.6955 668.8 -73.5036L668.655 -72.7812C669.61 -72.5895 670.56 -72.3968 671.504 -72.2032L671.652 -72.9251C672.639 -72.7228 673.621 -72.5195 674.597 -72.3152L674.447 -71.5939C675.423 -71.3895 676.395 -71.184 677.361 -70.9774L677.515 -71.698C678.482 -71.4912 679.444 -71.2834 680.401 -71.0745L680.244 -70.3546C681.199 -70.146 682.149 -69.9363 683.094 -69.7256L683.254 -70.4448C684.222 -70.2291 685.183 -70.0123 686.139 -69.7945L685.975 -69.076C686.954 -68.8529 687.927 -68.6286 688.894 -68.4032L689.061 -69.1208C690.029 -68.8952 690.991 -68.6684 691.947 -68.4405L691.776 -67.7237C692.731 -67.4961 693.679 -67.2674 694.622 -67.0376L694.796 -67.7535C695.748 -67.5214 696.694 -67.2882 697.633 -67.0539L697.455 -66.3389C698.434 -66.0947 699.406 -65.8493 700.371 -65.6027L700.553 -66.3167C701.52 -66.0697 702.479 -65.8216 703.432 -65.5723L703.245 -64.8594C704.196 -64.6105 705.141 -64.3604 706.078 -64.1091L706.269 -64.8209C707.212 -64.568 708.148 -64.3139 709.076 -64.0587L708.881 -63.3481C709.857 -63.08 710.824 -62.8106 711.784 -62.54L711.984 -63.2492C712.945 -62.9781 713.899 -62.7057 714.844 -62.432L714.639 -61.7242C715.582 -61.451 716.518 -61.1766 717.445 -60.901L717.655 -61.6073C718.597 -61.3273 719.53 -61.0459 720.455 -60.7633L720.24 -60.0586C721.208 -59.7631 722.166 -59.4662 723.114 -59.1679L723.335 -59.8709C724.286 -59.5721 725.227 -59.2718 726.158 -58.9703L725.931 -58.2692C726.861 -57.9683 727.781 -57.666 728.692 -57.3624L728.925 -58.0615C729.874 -57.7449 730.814 -57.4269 731.742 -57.1074L731.503 -56.4106C732.454 -56.0834 733.394 -55.7547 734.323 -55.4246L734.57 -56.119C735.501 -55.788 736.421 -55.4556 737.33 -55.1216L737.076 -54.4299C737.996 -54.0921 738.904 -53.7529 739.8 -53.4121L740.062 -54.1009C741.014 -53.7389 741.953 -53.3753 742.879 -53.01L742.609 -52.3245C743.532 -51.9603 744.441 -51.5946 745.338 -51.2273L745.617 -51.9092C746.519 -51.5397 747.407 -51.1687 748.281 -50.796L747.992 -50.1181C748.933 -49.7174 749.857 -49.315 750.766 -48.9108L751.065 -49.5841C751.977 -49.1783 752.873 -48.7706 753.753 -48.3612L753.442 -47.6931C754.327 -47.2816 755.195 -46.8684 756.046 -46.4536L756.369 -47.116C757.292 -46.666 758.196 -46.214 759.08 -45.7599L758.743 -45.1043C759.623 -44.6527 760.483 -44.1991 761.323 -43.7437L761.674 -44.3915C762.554 -43.9146 763.413 -43.4355 764.249 -42.9543L763.882 -42.3155C764.758 -41.8114 765.611 -41.3052 766.438 -40.7971L766.824 -41.425C767.658 -40.9129 768.467 -40.3986 769.252 -39.882L768.847 -39.2665C769.706 -38.7014 770.534 -38.134 771.332 -37.5643L771.76 -38.164C772.568 -37.5874 773.345 -37.008 774.091 -36.4261L773.638 -35.845C774.439 -35.2202 775.203 -34.593 775.93 -33.9637L776.413 -34.5208C777.168 -33.8672 777.884 -33.2105 778.561 -32.5508L778.047 -32.023C778.773 -31.3157 779.452 -30.6061 780.083 -29.8945L780.634 -30.3835C781.293 -29.6405 781.903 -28.8941 782.462 -28.1442L781.871 -27.7037C782.476 -26.892 783.019 -26.0784 783.5 -25.2631L784.135 -25.6374C784.647 -24.769 785.092 -23.8962 785.468 -23.0195L784.791 -22.7288C785.173 -21.8392 785.481 -20.9479 785.715 -20.055L786.428 -20.2415Z"
        stroke="#6E6E6E"
        strokeWidth="1.47378"
        strokeDasharray="2.95 2.95"
      />
    </svg>
  );
};

export const ExpandV2Icon = (props) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M15.75 8.25V2.25H9.75L12.2175 4.7175L4.7175 12.2175L2.25 9.75V15.75H8.25L5.7825 13.2825L13.2825 5.7825L15.75 8.25Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const RemoveWatermarkIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <mask
        id="mask0_3816_33843"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20">
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3816_33843)">
        <path
          d="M8.33366 14.1654H15.8337V9.16536H8.33366V14.1654ZM3.33366 16.6654C2.87533 16.6654 2.48296 16.5022 2.15658 16.1758C1.83019 15.8494 1.66699 15.457 1.66699 14.9987V4.9987C1.66699 4.54036 1.83019 4.148 2.15658 3.82161C2.48296 3.49523 2.87533 3.33203 3.33366 3.33203H16.667C17.1253 3.33203 17.5177 3.49523 17.8441 3.82161C18.1705 4.148 18.3337 4.54036 18.3337 4.9987V14.9987C18.3337 15.457 18.1705 15.8494 17.8441 16.1758C17.5177 16.5022 17.1253 16.6654 16.667 16.6654H3.33366ZM3.33366 14.9987H16.667V4.9987H3.33366V14.9987Z"
          fill="#363636"
        />
      </g>
    </svg>
  );
};

export const CycleIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      {...props}>
      <g clipPath="url(#clip0_3820_73268)">
        <path
          d="M7.04297 17.6055C5.59852 16.9388 4.42491 15.9319 3.52214 14.5846C2.61936 13.2374 2.16797 11.7166 2.16797 10.0221C2.16797 9.66102 2.18533 9.30686 2.22005 8.95964C2.25477 8.61241 2.3138 8.27214 2.39714 7.9388L1.4388 8.5013L0.605469 7.0638L4.58464 4.77214L6.8763 8.73047L5.41797 9.5638L4.29297 7.60547C4.14019 7.98047 4.02561 8.36936 3.94922 8.77214C3.87283 9.17491 3.83464 9.59158 3.83464 10.0221C3.83464 11.3694 4.20269 12.5951 4.9388 13.6992C5.67491 14.8034 6.65408 15.6194 7.8763 16.1471L7.04297 17.6055ZM13.418 7.5013V5.83464H15.6888C15.0499 5.04297 14.2791 4.42839 13.3763 3.99089C12.4735 3.55339 11.5152 3.33464 10.5013 3.33464C9.73741 3.33464 9.01519 3.45269 8.33463 3.6888C7.65408 3.92491 7.02908 4.25825 6.45964 4.6888L5.6263 3.23047C6.32075 2.74436 7.07769 2.36241 7.89713 2.08464C8.71658 1.80686 9.58463 1.66797 10.5013 1.66797C11.5985 1.66797 12.6471 1.87283 13.6471 2.28255C14.6471 2.69227 15.543 3.28602 16.3346 4.0638V2.91797H18.0013V7.5013H13.418ZM12.8763 20.0013L8.89713 17.7096L11.1888 13.7513L12.6263 14.5846L11.4388 16.6263C13.0777 16.3902 14.4423 15.6471 15.5326 14.3971C16.6228 13.1471 17.168 11.6819 17.168 10.0013C17.168 9.84852 17.1645 9.70616 17.1576 9.57422C17.1506 9.44227 17.1332 9.30686 17.1055 9.16797H18.793C18.8069 9.30686 18.8173 9.44227 18.8242 9.57422C18.8312 9.70616 18.8346 9.84852 18.8346 10.0013C18.8346 11.8763 18.2756 13.5534 17.1576 15.0326C16.0395 16.5117 14.5846 17.5082 12.793 18.0221L13.7096 18.5638L12.8763 20.0013Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_3820_73268">
          <rect width="20" height="20" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const UnlockIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      {...props}>
      <mask
        id="mask0_3820_73066"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="21"
        height="20">
        <rect x="0.5" width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3820_73066)">
        <path
          d="M5.49967 6.66536H12.9997V4.9987C12.9997 4.30425 12.7566 3.71398 12.2705 3.22786C11.7844 2.74175 11.1941 2.4987 10.4997 2.4987C9.80523 2.4987 9.21495 2.74175 8.72884 3.22786C8.24273 3.71398 7.99967 4.30425 7.99967 4.9987H6.33301C6.33301 3.84592 6.73926 2.86328 7.55176 2.05078C8.36426 1.23828 9.3469 0.832031 10.4997 0.832031C11.6525 0.832031 12.6351 1.23828 13.4476 2.05078C14.2601 2.86328 14.6663 3.84592 14.6663 4.9987V6.66536H15.4997C15.958 6.66536 16.3504 6.82856 16.6768 7.15495C17.0031 7.48134 17.1663 7.8737 17.1663 8.33203V16.6654C17.1663 17.1237 17.0031 17.5161 16.6768 17.8424C16.3504 18.1688 15.958 18.332 15.4997 18.332H5.49967C5.04134 18.332 4.64898 18.1688 4.32259 17.8424C3.9962 17.5161 3.83301 17.1237 3.83301 16.6654V8.33203C3.83301 7.8737 3.9962 7.48134 4.32259 7.15495C4.64898 6.82856 5.04134 6.66536 5.49967 6.66536ZM5.49967 16.6654H15.4997V8.33203H5.49967V16.6654ZM10.4997 14.1654C10.958 14.1654 11.3504 14.0022 11.6768 13.6758C12.0031 13.3494 12.1663 12.957 12.1663 12.4987C12.1663 12.0404 12.0031 11.648 11.6768 11.3216C11.3504 10.9952 10.958 10.832 10.4997 10.832C10.0413 10.832 9.64898 10.9952 9.32259 11.3216C8.9962 11.648 8.83301 12.0404 8.83301 12.4987C8.83301 12.957 8.9962 13.3494 9.32259 13.6758C9.64898 14.0022 10.0413 14.1654 10.4997 14.1654Z"
          fill="#FBFBFB"
        />
      </g>
    </svg>
  );
};

export const LockIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <mask
        id="mask0_5324_3328"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20">
        <rect width="20" height="20" fill="currentColor" />
      </mask>
      <g mask="url(#mask0_5324_3328)">
        <path
          d="M4.99992 18.3333C4.54159 18.3333 4.14922 18.1701 3.82284 17.8437C3.49645 17.5173 3.33325 17.1249 3.33325 16.6666V8.33325C3.33325 7.87492 3.49645 7.48256 3.82284 7.15617C4.14922 6.82978 4.54159 6.66658 4.99992 6.66658H5.83325V4.99992C5.83325 3.84714 6.2395 2.8645 7.052 2.052C7.8645 1.2395 8.84714 0.833252 9.99992 0.833252C11.1527 0.833252 12.1353 1.2395 12.9478 2.052C13.7603 2.8645 14.1666 3.84714 14.1666 4.99992V6.66658H14.9999C15.4583 6.66658 15.8506 6.82978 16.177 7.15617C16.5034 7.48256 16.6666 7.87492 16.6666 8.33325V16.6666C16.6666 17.1249 16.5034 17.5173 16.177 17.8437C15.8506 18.1701 15.4583 18.3333 14.9999 18.3333H4.99992ZM4.99992 16.6666H14.9999V8.33325H4.99992V16.6666ZM9.99992 14.1666C10.4583 14.1666 10.8506 14.0034 11.177 13.677C11.5034 13.3506 11.6666 12.9583 11.6666 12.4999C11.6666 12.0416 11.5034 11.6492 11.177 11.3228C10.8506 10.9964 10.4583 10.8333 9.99992 10.8333C9.54158 10.8333 9.14922 10.9964 8.82284 11.3228C8.49645 11.6492 8.33325 12.0416 8.33325 12.4999C8.33325 12.9583 8.49645 13.3506 8.82284 13.677C9.14922 14.0034 9.54158 14.1666 9.99992 14.1666ZM7.49992 6.66658H12.4999V4.99992C12.4999 4.30547 12.2569 3.7152 11.7708 3.22909C11.2846 2.74297 10.6944 2.49992 9.99992 2.49992C9.30547 2.49992 8.7152 2.74297 8.22908 3.22909C7.74297 3.7152 7.49992 4.30547 7.49992 4.99992V6.66658Z"
          fill="#363636"
        />
      </g>
    </svg>
  );
};

export const ImagineCheckedIcon = (props) => {
  return (
    <svg
      width={32}
      height={33}
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <mask
        id="mask0_3712_278150"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={32}
        height={33}>
        <rect y="0.5" width={32} height={32} fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_3712_278150)">
        <path
          d="M14.1307 22.6346L23.5307 13.2346L21.6641 11.368L14.1307 18.9013L10.3307 15.1013L8.46406 16.968L14.1307 22.6346ZM15.9974 29.8346C14.153 29.8346 12.4196 29.4846 10.7974 28.7846C9.17517 28.0846 7.76406 27.1346 6.56406 25.9346C5.36406 24.7346 4.41406 23.3235 3.71406 21.7013C3.01406 20.0791 2.66406 18.3457 2.66406 16.5013C2.66406 14.6569 3.01406 12.9235 3.71406 11.3013C4.41406 9.67908 5.36406 8.26797 6.56406 7.06797C7.76406 5.86797 9.17517 4.91797 10.7974 4.21797C12.4196 3.51797 14.153 3.16797 15.9974 3.16797C17.8418 3.16797 19.5752 3.51797 21.1974 4.21797C22.8196 4.91797 24.2307 5.86797 25.4307 7.06797C26.6307 8.26797 27.5807 9.67908 28.2807 11.3013C28.9807 12.9235 29.3307 14.6569 29.3307 16.5013C29.3307 18.3457 28.9807 20.0791 28.2807 21.7013C27.5807 23.3235 26.6307 24.7346 25.4307 25.9346C24.2307 27.1346 22.8196 28.0846 21.1974 28.7846C19.5752 29.4846 17.8418 29.8346 15.9974 29.8346Z"
          fill="#EC4E0B"
        />
      </g>
    </svg>
  );
};

const CloseIconSmallGreyBack = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <rect width="18" height="18" rx="2" fill="#D9D9D9" />
      <path d="M6 12.5195L12.5192 6.00033" stroke="#292929" strokeLinecap="round" />
      <path d="M6 6L12.5192 12.5192" stroke="#292929" strokeLinecap="round" />
    </svg>
  );
};

const HelpIconQuestionMark = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      {...props}>
      <mask
        id="mask0_418_14269"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="25"
        height="25">
        <rect x="0.5" y="0.5" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_418_14269)">
        <path
          d="M12.45 18.5C12.8 18.5 13.0958 18.3792 13.3375 18.1375C13.5792 17.8958 13.7 17.6 13.7 17.25C13.7 16.9 13.5792 16.6042 13.3375 16.3625C13.0958 16.1208 12.8 16 12.45 16C12.1 16 11.8042 16.1208 11.5625 16.3625C11.3208 16.6042 11.2 16.9 11.2 17.25C11.2 17.6 11.3208 17.8958 11.5625 18.1375C11.8042 18.3792 12.1 18.5 12.45 18.5ZM11.55 14.65H13.4C13.4 14.1 13.4625 13.6667 13.5875 13.35C13.7125 13.0333 14.0667 12.6 14.65 12.05C15.0833 11.6167 15.425 11.2042 15.675 10.8125C15.925 10.4208 16.05 9.95 16.05 9.4C16.05 8.46667 15.7083 7.75 15.025 7.25C14.3417 6.75 13.5333 6.5 12.6 6.5C11.65 6.5 10.8792 6.75 10.2875 7.25C9.69583 7.75 9.28333 8.35 9.05 9.05L10.7 9.7C10.7833 9.4 10.9708 9.075 11.2625 8.725C11.5542 8.375 12 8.2 12.6 8.2C13.1333 8.2 13.5333 8.34583 13.8 8.6375C14.0667 8.92917 14.2 9.25 14.2 9.6C14.2 9.93333 14.1 10.2458 13.9 10.5375C13.7 10.8292 13.45 11.1 13.15 11.35C12.4167 12 11.9667 12.4917 11.8 12.825C11.6333 13.1583 11.55 13.7667 11.55 14.65ZM12.5 22.5C11.1167 22.5 9.81667 22.2375 8.6 21.7125C7.38333 21.1875 6.325 20.475 5.425 19.575C4.525 18.675 3.8125 17.6167 3.2875 16.4C2.7625 15.1833 2.5 13.8833 2.5 12.5C2.5 11.1167 2.7625 9.81667 3.2875 8.6C3.8125 7.38333 4.525 6.325 5.425 5.425C6.325 4.525 7.38333 3.8125 8.6 3.2875C9.81667 2.7625 11.1167 2.5 12.5 2.5C13.8833 2.5 15.1833 2.7625 16.4 3.2875C17.6167 3.8125 18.675 4.525 19.575 5.425C20.475 6.325 21.1875 7.38333 21.7125 8.6C22.2375 9.81667 22.5 11.1167 22.5 12.5C22.5 13.8833 22.2375 15.1833 21.7125 16.4C21.1875 17.6167 20.475 18.675 19.575 19.575C18.675 20.475 17.6167 21.1875 16.4 21.7125C15.1833 22.2375 13.8833 22.5 12.5 22.5ZM12.5 20.5C14.7333 20.5 16.625 19.725 18.175 18.175C19.725 16.625 20.5 14.7333 20.5 12.5C20.5 10.2667 19.725 8.375 18.175 6.825C16.625 5.275 14.7333 4.5 12.5 4.5C10.2667 4.5 8.375 5.275 6.825 6.825C5.275 8.375 4.5 10.2667 4.5 12.5C4.5 14.7333 5.275 16.625 6.825 18.175C8.375 19.725 10.2667 20.5 12.5 20.5Z"
          fill="black"
        />
      </g>
    </svg>
  );
};

const TickIconPrimaryColorWhite = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
      <mask
        id="mask0_418_14613"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="32"
        height="33">
        <rect y="0.5" width="32" height="32" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_418_14613)">
        <path
          d="M14.1346 22.6337L23.5346 13.2337L21.668 11.367L14.1346 18.9003L10.3346 15.1003L8.46797 16.967L14.1346 22.6337ZM16.0013 29.8337C14.1569 29.8337 12.4235 29.4837 10.8013 28.7837C9.17908 28.0837 7.76797 27.1337 6.56797 25.9337C5.36797 24.7337 4.41797 23.3225 3.71797 21.7003C3.01797 20.0781 2.66797 18.3448 2.66797 16.5003C2.66797 14.6559 3.01797 12.9225 3.71797 11.3003C4.41797 9.6781 5.36797 8.26699 6.56797 7.06699C7.76797 5.86699 9.17908 4.91699 10.8013 4.21699C12.4235 3.51699 14.1569 3.16699 16.0013 3.16699C17.8457 3.16699 19.5791 3.51699 21.2013 4.21699C22.8235 4.91699 24.2346 5.86699 25.4346 7.06699C26.6346 8.26699 27.5846 9.6781 28.2846 11.3003C28.9846 12.9225 29.3346 14.6559 29.3346 16.5003C29.3346 18.3448 28.9846 20.0781 28.2846 21.7003C27.5846 23.3225 26.6346 24.7337 25.4346 25.9337C24.2346 27.1337 22.8235 28.0837 21.2013 28.7837C19.5791 29.4837 17.8457 29.8337 16.0013 29.8337Z"
          fill="#EC4E0B"
        />
      </g>
    </svg>
  );
};

const BackArrowIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <mask
        id="mask0_77_18953"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_77_18953)">
        <path d="M14 18L8 12L14 6L15.4 7.4L10.8 12L15.4 16.6L14 18Z" fill="#FBFAF9" />
      </g>
    </svg>
  );
};

const ProductBuilderExternalLayer = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <mask
        id="mask0_1857_8934"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16">
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1857_8934)">
        <path
          d="M8 14.0333L2 9.36668L3.1 8.53334L8 12.3333L12.9 8.53334L14 9.36668L8 14.0333ZM8 10.6667L2 6.00001L8 1.33334L14 6.00001L8 10.6667ZM8 8.96668L11.8333 6.00001L8 3.03334L4.16667 6.00001L8 8.96668Z"
          fill="#A1A1A1"
        />
      </g>
    </svg>
  );
};

const ProductBuilderInternalLayer = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <mask
        id="mask0_1857_1996"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20">
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1857_1996)">
        <path
          d="M10.0007 11.6667L0.833984 6.66666L10.0007 1.66666L19.1673 6.66666L10.0007 11.6667ZM10.0007 15L1.31315 10.2708L3.06315 9.31249L10.0007 13.1042L16.9382 9.31249L18.6882 10.2708L10.0007 15ZM10.0007 18.3333L1.31315 13.6042L3.06315 12.6458L10.0007 16.4375L16.9382 12.6458L18.6882 13.6042L10.0007 18.3333ZM10.0007 9.77082L15.6882 6.66666L10.0007 3.56249L4.31315 6.66666L10.0007 9.77082Z"
          fill="#A1A1A1"
        />
      </g>
    </svg>
  );
};
export const SleepReclinerBad = (props) => {
  return (
    <svg width="31" height="9" viewBox="0 0 31 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.375" y="4.69238" width="30" height="4" rx="1" fill="currentColor" />
      <rect x="1.375" y="0.692383" width="6" height="3" rx="1" fill="currentColor" />
    </svg>
  );
};
export const SeatingBad = (props) => {
  return (
    <svg width="29" height="11" viewBox="0 0 29 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="8.125" y="6.5" width="20" height="4" rx="1" fill="currentColor" />
      <rect
        x="1.65625"
        y="3.3623"
        width="10"
        height="4"
        rx="1"
        transform="rotate(22.5 1.65625 3.3623)"
        fill="currentColor"
      />
      <rect
        x="3.27344"
        y="0.5"
        width="6"
        height="3"
        rx="1"
        transform="rotate(22.5 3.27344 0.5)"
        fill="currentColor"
      />
    </svg>
  );
};
export const LagAdjustmentBad = (props) => {
  return (
    <svg width="28" height="12" viewBox="0 0 28 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.990234" width="6" height="3" rx="1" fill="currentColor" />
      <rect x="-0.00976562" y="4" width="20" height="4" rx="1" fill="currentColor" />
      <rect
        x="18.5215"
        y="3.8623"
        width="10"
        height="4"
        rx="1"
        transform="rotate(22.5 18.5215 3.8623)"
        fill="currentColor"
      />
    </svg>
  );
};
export const FullyAdjustmentBad = (props) => {
  return (
    <svg width="27" height="14" viewBox="0 0 27 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="8.74414" y="6.03418" width="10" height="4" rx="1" fill="currentColor" />
      <rect
        x="2.27148"
        y="2.8623"
        width="10"
        height="4"
        rx="1"
        transform="rotate(22.5 2.27148 2.8623)"
        fill="currentColor"
      />
      <rect
        x="17.2715"
        y="5.8623"
        width="10"
        height="4"
        rx="1"
        transform="rotate(22.5 17.2715 5.8623)"
        fill="currentColor"
      />
      <rect
        x="3.88867"
        width="6"
        height="3"
        rx="1"
        transform="rotate(22.5 3.88867 0)"
        fill="currentColor"
      />
    </svg>
  );
};

export const CuratorImageIconSmall = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
      <path
        d="M14.75 3.75V14.25H4.25V3.75H14.75ZM14.75 2.25H4.25C3.425 2.25 2.75 2.925 2.75 3.75V14.25C2.75 15.075 3.425 15.75 4.25 15.75H14.75C15.575 15.75 16.25 15.075 16.25 14.25V3.75C16.25 2.925 15.575 2.25 14.75 2.25ZM11.105 8.895L8.855 11.7975L7.25 9.855L5 12.75H14L11.105 8.895Z"
        fill="#E7E7E7"
      />
    </svg>
  );
};

export const CuratorViewIconSmall = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="39" height="27" viewBox="0 0 39 27" fill="none">
      <circle
        cx="22.7458"
        cy="12.7612"
        r="0.468496"
        fill="#A3A4A6"
        stroke="#A3A4A6"
        strokeWidth="0.5"
      />
      <circle
        cx="24.7068"
        cy="10.3159"
        r="0.468496"
        fill="#A3A4A6"
        stroke="#A3A4A6"
        strokeWidth="0.5"
      />
      <circle
        cx="24.7458"
        cy="15.4253"
        r="0.468496"
        fill="#A3A4A6"
        stroke="#A3A4A6"
        strokeWidth="0.5"
      />
      <circle
        cx="20.7419"
        cy="15.4253"
        r="0.468496"
        fill="#A3A4A6"
        stroke="#A3A4A6"
        strokeWidth="0.5"
      />
      <circle
        cx="26.6404"
        cy="12.7612"
        r="0.468496"
        fill="#A3A4A6"
        stroke="#A3A4A6"
        strokeWidth="0.5"
      />
      <circle
        cx="28.6013"
        cy="10.3159"
        r="0.468496"
        fill="#A3A4A6"
        stroke="#A3A4A6"
        strokeWidth="0.5"
      />
      <circle
        cx="28.6404"
        cy="15.4253"
        r="0.468496"
        fill="#A3A4A6"
        stroke="#A3A4A6"
        strokeWidth="0.5"
      />
      <circle
        cx="30.6169"
        cy="12.7612"
        r="0.468496"
        fill="#A3A4A6"
        stroke="#A3A4A6"
        strokeWidth="0.5"
      />
      <circle
        cx="32.5779"
        cy="10.3159"
        r="0.468496"
        fill="#A3A4A6"
        stroke="#A3A4A6"
        strokeWidth="0.5"
      />
      <circle
        cx="32.6169"
        cy="15.4253"
        r="0.468496"
        fill="#A3A4A6"
        stroke="#A3A4A6"
        strokeWidth="0.5"
      />
      <path
        d="M14.7835 17.9762H35.7399C36.8445 17.9762 37.74 18.8717 37.74 19.9762V24.3047C37.74 25.4093 36.8445 26.3047 35.74 26.3047H0.923222M0.923222 7.84843C0.923222 7.84843 4.26674 7.84843 10.8648 7.84843C13.9119 7.84843 16.3232 6.27007 18.4016 4.44792C20.5581 2.55729 21.3199 0.616699 24.1528 0.893723C26.7944 1.15204 28.4235 3.68578 27.0828 7.02627M25.5166 3.91502C23.1679 3.16202 21.2567 4.55718 21.1489 6.52714C20.9151 10.8044 22.8937 13.3779 19.1986 15.2775C15.4094 17.2253 12.2405 17.2253 12.2405 17.2253C12.2405 17.2253 12.2405 17.2253 12.2405 17.2253H0.671875"
        stroke="#E6E7E9"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
      <path
        d="M24.2773 7.68921H31.9092C34.1183 7.68921 35.9092 9.48007 35.9092 11.6892V17.5899"
        stroke="#E6E7E9"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const CuratorLayerIconSmall = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="53" height="26" viewBox="0 0 53 26" fill="none">
      <path
        d="M1.48828 25H51.511M1.48828 14.1978H51.511M2.67086 16.1277V23.0726M1.48828 5.17874H51.511M1.48828 1.04248H51.511M9.2176 16.2807V23.2256M15.7032 16.1277V23.0726M22.5012 16.1277V23.0726M29.1092 16.1277V23.0726M35.8089 16.3419V23.2868M42.341 16.1277V23.0726M49.0713 16.1277V23.0726"
        stroke="#E6E7E9"
        strokeWidth="1.3"
        strokeLinecap="round"
      />
    </svg>
  );
};

const NormalViewIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="22" viewBox="0 0 26 22" fill="none">
      <path
        d="M0.855469 21.0003L24.9979 20.9999M0.855469 10.1981L24.9979 10.1977M0.855469 1.17909L24.9979 1.17871"
        stroke="#A3A4A6"
        strokeLinecap="round"
      />
      <path
        d="M2.94474 4.17867C2.94474 4.41798 2.75074 4.61198 2.51143 4.61198C2.27212 4.61198 2.07812 4.41798 2.07812 4.17867C2.07812 3.93936 2.27212 3.74536 2.51143 3.74536C2.75074 3.74536 2.94474 3.93936 2.94474 4.17867Z"
        fill="#A3A4A6"
      />
      <path
        d="M7.99118 4.17867C7.99118 4.41798 7.79718 4.61198 7.55787 4.61198C7.31856 4.61198 7.12456 4.41798 7.12456 4.17867C7.12456 3.93936 7.31856 3.74536 7.55787 3.74536C7.79718 3.74536 7.99118 3.93936 7.99118 4.17867Z"
        fill="#A3A4A6"
      />
      <path
        d="M12.7822 4.17867C12.7822 4.41798 12.5882 4.61198 12.3489 4.61198C12.1096 4.61198 11.9156 4.41798 11.9156 4.17867C11.9156 3.93936 12.1096 3.74536 12.3489 3.74536C12.5882 3.74536 12.7822 3.93936 12.7822 4.17867Z"
        fill="#A3A4A6"
      />
      <path
        d="M17.9843 4.17867C17.9843 4.41798 17.7903 4.61198 17.5509 4.61198C17.3116 4.61198 17.1176 4.41798 17.1176 4.17867C17.1176 3.93936 17.3116 3.74536 17.5509 3.74536C17.7903 3.74536 17.9843 3.93936 17.9843 4.17867Z"
        fill="#A3A4A6"
      />
      <path
        d="M23.0974 4.17867C23.0974 4.41798 22.9034 4.61198 22.6641 4.61198C22.4248 4.61198 22.2308 4.41798 22.2308 4.17867C22.2308 3.93936 22.4248 3.74536 22.6641 3.74536C22.9034 3.74536 23.0974 3.93936 23.0974 4.17867Z"
        fill="#A3A4A6"
      />
      <path
        d="M5.52053 7.09547C5.52053 7.33478 5.32653 7.52878 5.08722 7.52878C4.84791 7.52878 4.65391 7.33478 4.65391 7.09547C4.65391 6.85616 4.84791 6.66216 5.08722 6.66216C5.32653 6.66216 5.52053 6.85616 5.52053 7.09547Z"
        fill="#A3A4A6"
      />
      <path
        d="M10.567 7.09547C10.567 7.33478 10.373 7.52878 10.1337 7.52878C9.89435 7.52878 9.70035 7.33478 9.70035 7.09547C9.70035 6.85616 9.89435 6.66216 10.1337 6.66216C10.373 6.66216 10.567 6.85616 10.567 7.09547Z"
        fill="#A3A4A6"
      />
      <path
        d="M15.358 7.09547C15.358 7.33478 15.164 7.52878 14.9247 7.52878C14.6854 7.52878 14.4914 7.33478 14.4914 7.09547C14.4914 6.85616 14.6854 6.66216 14.9247 6.66216C15.164 6.66216 15.358 6.85616 15.358 7.09547Z"
        fill="#A3A4A6"
      />
      <path
        d="M20.56 7.09547C20.56 7.33478 20.366 7.52878 20.1267 7.52878C19.8874 7.52878 19.6934 7.33478 19.6934 7.09547C19.6934 6.85616 19.8874 6.66216 20.1267 6.66216C20.366 6.66216 20.56 6.85616 20.56 7.09547Z"
        fill="#A3A4A6"
      />
      <path
        d="M2.94474 4.17867C2.94474 4.41798 2.75074 4.61198 2.51143 4.61198C2.27212 4.61198 2.07812 4.41798 2.07812 4.17867C2.07812 3.93936 2.27212 3.74536 2.51143 3.74536C2.75074 3.74536 2.94474 3.93936 2.94474 4.17867Z"
        stroke="#A3A4A6"
      />
      <path
        d="M7.99118 4.17867C7.99118 4.41798 7.79718 4.61198 7.55787 4.61198C7.31856 4.61198 7.12456 4.41798 7.12456 4.17867C7.12456 3.93936 7.31856 3.74536 7.55787 3.74536C7.79718 3.74536 7.99118 3.93936 7.99118 4.17867Z"
        stroke="#A3A4A6"
      />
      <path
        d="M12.7822 4.17867C12.7822 4.41798 12.5882 4.61198 12.3489 4.61198C12.1096 4.61198 11.9156 4.41798 11.9156 4.17867C11.9156 3.93936 12.1096 3.74536 12.3489 3.74536C12.5882 3.74536 12.7822 3.93936 12.7822 4.17867Z"
        stroke="#A3A4A6"
      />
      <path
        d="M17.9843 4.17867C17.9843 4.41798 17.7903 4.61198 17.5509 4.61198C17.3116 4.61198 17.1176 4.41798 17.1176 4.17867C17.1176 3.93936 17.3116 3.74536 17.5509 3.74536C17.7903 3.74536 17.9843 3.93936 17.9843 4.17867Z"
        stroke="#A3A4A6"
      />
      <path
        d="M23.0974 4.17867C23.0974 4.41798 22.9034 4.61198 22.6641 4.61198C22.4248 4.61198 22.2308 4.41798 22.2308 4.17867C22.2308 3.93936 22.4248 3.74536 22.6641 3.74536C22.9034 3.74536 23.0974 3.93936 23.0974 4.17867Z"
        stroke="#A3A4A6"
      />
      <path
        d="M5.52053 7.09547C5.52053 7.33478 5.32653 7.52878 5.08722 7.52878C4.84791 7.52878 4.65391 7.33478 4.65391 7.09547C4.65391 6.85616 4.84791 6.66216 5.08722 6.66216C5.32653 6.66216 5.52053 6.85616 5.52053 7.09547Z"
        stroke="#A3A4A6"
      />
      <path
        d="M10.567 7.09547C10.567 7.33478 10.373 7.52878 10.1337 7.52878C9.89435 7.52878 9.70035 7.33478 9.70035 7.09547C9.70035 6.85616 9.89435 6.66216 10.1337 6.66216C10.373 6.66216 10.567 6.85616 10.567 7.09547Z"
        stroke="#A3A4A6"
      />
      <path
        d="M15.358 7.09547C15.358 7.33478 15.164 7.52878 14.9247 7.52878C14.6854 7.52878 14.4914 7.33478 14.4914 7.09547C14.4914 6.85616 14.6854 6.66216 14.9247 6.66216C15.164 6.66216 15.358 6.85616 15.358 7.09547Z"
        stroke="#A3A4A6"
      />
      <path
        d="M20.56 7.09547C20.56 7.33478 20.366 7.52878 20.1267 7.52878C19.8874 7.52878 19.6934 7.33478 19.6934 7.09547C19.6934 6.85616 19.8874 6.66216 20.1267 6.66216C20.366 6.66216 20.56 6.85616 20.56 7.09547Z"
        stroke="#A3A4A6"
      />
      <path
        d="M1.4375 13.4631C2.62518 13.5215 4.3921 12.8936 4.88307 12M1.4375 15.0241C2.62518 15.0824 4.3921 14.4546 4.88307 13.561M1.4375 16.5065C2.62518 16.5649 4.3921 15.937 4.88307 15.0434M1.4375 17.9693C2.62518 18.0276 4.3921 17.3998 4.88307 16.5062M1.4375 19.3535C2.62518 19.4119 4.3921 18.784 4.88307 17.8904"
        stroke="#A3A4A6"
        strokeWidth="0.3"
        strokeLinecap="round"
      />
      <path
        d="M7.97656 13.4631C9.16424 13.5215 10.9312 12.8936 11.4221 12M7.97656 15.0241C9.16424 15.0824 10.9312 14.4546 11.4221 13.561M7.97656 16.5065C9.16424 16.5649 10.9312 15.937 11.4221 15.0434M7.97656 17.9693C9.16424 18.0276 10.9312 17.3998 11.4221 16.5062M7.97656 19.3535C9.16424 19.4119 10.9312 18.784 11.4221 17.8904"
        stroke="#A3A4A6"
        strokeWidth="0.3"
        strokeLinecap="round"
      />
      <path
        d="M21.1602 13.4631C22.3478 13.5215 24.1148 12.8936 24.6057 12M21.1602 15.0241C22.3478 15.0824 24.1148 14.4546 24.6057 13.561M21.1602 16.5065C22.3478 16.5649 24.1148 15.937 24.6057 15.0434M21.1602 17.9693C22.3478 18.0276 24.1148 17.3998 24.6057 16.5062M21.1602 19.3535C22.3478 19.4119 24.1148 18.784 24.6057 17.8904"
        stroke="#A3A4A6"
        strokeWidth="0.3"
        strokeLinecap="round"
      />
      <path
        d="M14.5195 13.4631C15.7072 13.5215 17.4741 12.8936 17.9651 12M14.5195 15.0241C15.7072 15.0824 17.4741 14.4546 17.9651 13.561M14.5195 16.5065C15.7072 16.5649 17.4741 15.937 17.9651 15.0434M14.5195 17.9693C15.7072 18.0276 17.4741 17.3998 17.9651 16.5062M14.5195 19.3535C15.7072 19.4119 17.4741 18.784 17.9651 17.8904"
        stroke="#A3A4A6"
        strokeWidth="0.3"
        strokeLinecap="round"
      />
      <path
        d="M1.48047 11.9986V19.2447M5.00471 11.7773V19.2447"
        stroke="#A3A4A6"
        strokeWidth="0.5"
        strokeLinecap="round"
      />
      <path
        d="M7.98047 11.9986V19.2447M11.5047 11.7773V19.2447"
        stroke="#A3A4A6"
        strokeWidth="0.5"
        strokeLinecap="round"
      />
      <path
        d="M14.5703 11.9986V19.2447M18.0946 11.7773V19.2447"
        stroke="#A3A4A6"
        strokeWidth="0.5"
        strokeLinecap="round"
      />
      <path
        d="M21.0703 11.9986V19.2447M24.5946 11.7773V19.2447"
        stroke="#A3A4A6"
        strokeWidth="0.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const ExplodedViewIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="24" viewBox="0 0 23 24" fill="none">
      <path
        d="M11.2598 11.8688C10.6425 11.8688 10.0139 11.758 9.52238 11.5474L2.77851 8.6434C1.06397 7.90077 0.8125 6.90322 0.8125 6.36011C0.8125 5.817 1.06397 4.81945 2.77851 4.07682L9.52238 1.17284C10.5168 0.740565 12.0142 0.740565 13.0086 1.17284L19.7639 4.07682C21.467 4.80836 21.7299 5.817 21.7299 6.36011C21.7299 6.90322 21.4785 7.90077 19.7639 8.6434L13.0086 11.5474C12.5057 11.7691 11.8884 11.8688 11.2598 11.8688ZM11.2598 2.51399C10.8712 2.51399 10.494 2.56941 10.2196 2.69133L3.47576 5.59532C2.77851 5.90567 2.52704 6.21602 2.52704 6.36011C2.52704 6.5042 2.77851 6.82563 3.46433 7.1249L10.2082 10.0289C10.7569 10.2616 11.7513 10.2616 12.2999 10.0289L19.0552 7.1249C19.7525 6.82563 20.004 6.5042 20.004 6.36011C20.004 6.21602 19.7525 5.89459 19.0552 5.59532L12.3114 2.69133C12.037 2.58049 11.6484 2.51399 11.2598 2.51399Z"
        fill="#C4C4C7"
      />
      <path
        d="M11.5 17.6456C11.0656 17.6456 10.6313 17.5569 10.2198 17.3796L2.45864 14.0323C1.28132 13.5335 0.355469 12.148 0.355469 10.8955C0.355469 10.4411 0.744099 10.0642 1.21274 10.0642C1.68138 10.0642 2.07001 10.4411 2.07001 10.8955C2.07001 11.5051 2.58437 12.2699 3.15589 12.5248L10.9171 15.8722C11.2828 16.0274 11.7057 16.0274 12.0829 15.8722L19.8441 12.5248C20.4156 12.281 20.93 11.5051 20.93 10.8955C20.93 10.4411 21.3186 10.0642 21.7873 10.0642C22.2559 10.0642 22.6445 10.4411 22.6445 10.8955C22.6445 12.148 21.7187 13.5335 20.5414 14.0433L12.7802 17.3907C12.3687 17.5569 11.9344 17.6456 11.5 17.6456Z"
        fill="#C4C4C7"
      />
      <path
        d="M11.5 23.1867C11.0656 23.1867 10.6313 23.098 10.2198 22.9207L2.45864 19.5734C1.17845 19.0192 0.355469 17.7889 0.355469 16.4255C0.355469 15.9711 0.744098 15.5942 1.21274 15.5942C1.68138 15.5942 2.07001 15.9822 2.07001 16.4366C2.07001 17.1349 2.49293 17.7778 3.15589 18.066L10.9171 21.4133C11.2828 21.5685 11.7057 21.5685 12.0829 21.4133L19.8441 18.066C20.5071 17.7778 20.93 17.146 20.93 16.4366C20.93 15.9822 21.3186 15.6053 21.7873 15.6053C22.2559 15.6053 22.6445 15.9822 22.6445 16.4366C22.6445 17.7999 21.8215 19.0303 20.5414 19.5844L12.7802 22.9318C12.3687 23.098 11.9344 23.1867 11.5 23.1867Z"
        fill="#C4C4C7"
      />
    </svg>
  );
};

export const CutawayViewIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <mask
        id="mask0_2143_776"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2143_776)">
        <path
          d="M2 20V18H20V4H22V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H2ZM6 16V6H18V16H6Z"
          fill="#FBFBFB"
          fill-opacity="0.7"
        />
      </g>
    </svg>
  );
};

export const xRayIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
      <mask id="path-1-inside-1_9176_17608" fill="white">
        <rect x="0.421875" y="8.52417" width="19.9025" height="19.2923" rx="1" />
      </mask>
      <rect
        x="0.421875"
        y="8.52417"
        width="19.9025"
        height="19.2923"
        rx="1"
        stroke="#C4C4C7"
        strokeWidth="2.4"
        mask="url(#path-1-inside-1_9176_17608)"
      />
      <path
        d="M5.91016 9.94678V22.0821C5.91016 22.6344 6.35787 23.0821 6.91016 23.0821H18.822"
        stroke="#C4C4C7"
        strokeWidth="1.2"
        strokeDasharray="2 2"
      />
      <path
        d="M5.91016 9.13764V4.79956C5.91016 4.24727 6.35787 3.79956 6.91016 3.79956H24.8126C25.3649 3.79956 25.8126 4.24728 25.8126 4.79956V22.0918C25.8126 22.6441 25.3649 23.0918 24.8126 23.0918H19.9398"
        stroke="#C4C4C7"
        strokeWidth="1.2"
      />
    </svg>
  );
};

export const ReplaceIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="18"
      viewBox="0 0 26 20"
      fill="none"
      {...props}>
      <path
        d="M12.8889 4.57083H18.5278C18.6382 4.57083 18.7278 4.48129 18.7278 4.37083V1.35443C18.7278 1.17624 18.9432 1.08701 19.0692 1.213L25.1161 7.25986C25.1942 7.33797 25.1942 7.4646 25.1161 7.54271L19.0692 13.5896C18.9432 13.7156 18.7278 13.6263 18.7278 13.4481V10.4315C18.7278 10.3211 18.6382 10.2315 18.5278 10.2315H7.87406C7.7636 10.2315 7.67406 10.142 7.67406 10.0315V6.97037C7.67406 6.79219 7.45863 6.70296 7.33264 6.82895L1.50861 12.653C1.4305 12.7311 1.4305 12.8577 1.50861 12.9358L7.33264 18.7599C7.45863 18.8858 7.67406 18.7966 7.67406 18.6184V16.0475C7.67406 15.9371 7.7636 15.8475 7.87406 15.8475H13.4237"
        stroke="#FFF"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const AutoRotateIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fill="currentColor"
      {...props}>
      {/* <path d="M 0,0 H 24 V 24 H 0 Z" fill="none" /> */}
      <path
        d="m 12.026773,0.36314723 c -6.5622212,0 -11.70250223,2.80391217 -11.70250223,6.38343707 0,3.4763387 4.85329023,6.2130107 11.14385023,6.3681137 L 9.1924466,15.390366 10.696824,16.894744 15.525498,12.065607 10.696824,7.2364647 9.1924466,8.741163 11.438538,10.987256 C 6.1152921,10.836874 2.4517569,8.687622 2.4517569,6.7463048 c 0,-2.0128308 3.9320427,-4.255483 9.5746941,-4.255483 5.642274,0 9.574688,2.2426522 9.574688,4.255483 0,1.1172628 -1.215016,2.3039546 -3.258128,3.1398491 v 2.2558901 c 3.257569,-1.121397 5.385942,-3.0961485 5.385942,-5.3956906 0,-3.5795735 -5.140281,-6.38343717 -11.702502,-6.38343717 z"
        style={{ strokeWidth: 0.0464384 }}
      />
    </svg>
  );
};

export const DimensionIcon = (props) => {
  return (
    <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.7029 6.2677L20.7635 5.20711L26.4203 10.864L10.864 26.4203L5.20711 20.7635L6.26779 19.7028L6.26781 19.7028L7.68203 21.117C7.87729 21.3123 8.19387 21.3123 8.38913 21.117C8.58439 20.9217 8.58439 20.6052 8.38913 20.4099L6.97492 18.9957L6.9749 18.9957L8.389 17.5816L11.2173 20.4099C11.4126 20.6051 11.7292 20.6051 11.9244 20.4099C12.1197 20.2146 12.1197 19.898 11.9244 19.7028L9.09611 16.8745L10.5105 15.4601L10.5105 15.4601L11.9247 16.8743C12.12 17.0696 12.4365 17.0696 12.6318 16.8743C12.8271 16.6791 12.8271 16.3625 12.6318 16.1672L11.2176 14.753L11.2176 14.753L12.6317 13.3389L15.46 16.1672C15.6553 16.3625 15.9719 16.3625 16.1671 16.1672C16.3624 15.9719 16.3624 15.6554 16.1671 15.4601L13.3388 12.6318L14.7531 11.2175L14.7532 11.2176L16.1674 12.6318C16.3626 12.827 16.6792 12.827 16.8745 12.6318C17.0697 12.4365 17.0697 12.1199 16.8745 11.9247L15.4603 10.5105L15.4602 10.5104L16.8743 9.09627L19.7027 11.9247C19.8979 12.1199 20.2145 12.1199 20.4098 11.9247C20.6051 11.7294 20.6051 11.4128 20.4098 11.2175L17.5814 8.38916L18.9958 6.97481L18.9958 6.97489L20.4101 8.38911C20.6053 8.58437 20.9219 8.58437 21.1172 8.38911C21.3124 8.19384 21.3124 7.87726 21.1172 7.682L19.7029 6.26778L19.7029 6.2677ZM20.4099 4.14645C20.6052 3.95118 20.9217 3.95118 21.117 4.14645L27.481 10.5104C27.6762 10.7057 27.6762 11.0223 27.481 11.2175L11.2175 27.481C11.0223 27.6762 10.7057 27.6762 10.5104 27.481L4.14645 21.117C3.95118 20.9217 3.95118 20.6052 4.14645 20.4099L20.4099 4.14645Z"
        fill="currentColor"></path>
    </svg>
  );
};

export const ScreenshotIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48pt"
      height="48pt"
      viewBox="0 0 48 48"
      fill="currentColor"
      {...props}>
      <g transform="matrix(0.08998371,0,0,0.08998371,-7.4485118,-1.0273145)">
        <path d="m 107.52,221.2 c 12.879,0 23.52,-10.641 23.52,-23.52 v -82.32 c 0,-15.68 12.879,-28.559 28,-28.559 h 80.641 c 12.879,0 23.52,-10.641 23.52,-23.52 0,-12.879 -10.641,-23.52 -23.52,-23.52 h -80.078 c -41.441,0 -75.602,34.16 -75.602,75.602 v 81.762 c 0,13.434 10.641,24.074 23.52,24.074 z" />
        <path d="m 540.4,39.762 h -80.637 c -12.879,0 -23.52,10.641 -23.52,23.52 0,12.879 10.641,23.52 23.52,23.52 H 540.4 c 15.68,0 28.559,12.879 28.559,28.559 v 81.762 c 0,12.879 10.641,23.52 23.52,23.52 12.879,0 23.52,-10.641 23.52,-23.52 l 0.004,-81.762 c 0,-41.438 -34.16,-75.598 -75.602,-75.598 z" />
        <path d="m 592.48,338.8 c -12.879,0 -23.52,10.641 -23.52,23.52 v 81.762 c 0,15.68 -12.879,28 -28.559,28 l -80.641,-0.004 c -12.879,0 -23.52,10.641 -23.52,23.52 0,12.879 10.641,23.52 23.52,23.52 l 80.637,0.004 c 41.441,0 75.602,-34.16 75.602,-75.602 v -80.641 c 0,-13.438 -10.641,-24.078 -23.52,-24.078 z" />
        <path d="m 240.24,472.64 h -80.637 c -15.68,0 -28,-12.879 -28,-28 v -81.762 c 0,-12.879 -10.641,-23.52 -23.52,-23.52 -12.879,0 -23.52,10.641 -23.52,23.52 v 81.762 c 0,41.441 34.16,75.602 75.602,75.602 h 80.641 c 12.879,0 23.52,-10.641 23.52,-23.52 -0.5625,-13.441 -11.203,-24.082 -24.086,-24.082 z" />
        <path d="m 350,330.4 c 24.641,0 44.238,-20.16 44.238,-44.238 0,-24.641 -20.16,-44.238 -44.238,-44.238 -24.078,0 -44.238,20.16 -44.238,44.238 0,24.078 19.598,44.238 44.238,44.238 z" />
        <path d="m 226.24,186.48 c -18.48,0 -33.602,15.121 -33.602,33.602 v 142.8 c 0,18.48 15.121,33.602 33.602,33.602 H 473.2 c 18.48,0 33.602,-15.121 33.602,-33.602 v -142.8 c 0,-18.48 -15.121,-33.602 -33.602,-33.602 h -36.961 c -6.7188,0 -12.879,-3.3594 -16.238,-8.9609 l -8.3984,-12.875 c -5.6016,-8.9609 -15.121,-14 -25.762,-14 h -72.238 c -10.078,0 -20.16,5.0391 -25.762,14 l -8.3984,13.441 c -3.3594,5.6016 -9.5195,8.9609 -16.238,8.9609 l -36.965,-0.004 z M 350,210 c 42,0 75.602,34.16 75.602,75.602 0,42 -34.16,75.602 -75.602,75.602 C 308.559,361.2 274.398,327.602 274.398,285.602 274.398,244.161 308,210 350,210 Z" />
      </g>
    </svg>
  );
};
export const CopyEmbedLink = (props) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <rect x="0.5" y="0.5" width="39" height="39" rx="4.5" stroke="#201F21" stroke-opacity="0.1" />
      <g>
        <path
          d="M16.667 25L11.667 20L16.667 15L17.8545 16.1875L14.0212 20.0208L17.8337 23.8333L16.667 25ZM23.3337 25L22.1462 23.8125L25.9795 19.9792L22.167 16.1667L23.3337 15L28.3337 20L23.3337 25Z"
          fill="#1C1B1F"
        />
      </g>
    </svg>
  );
};

export const FillTrayIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      {...props}>
      <path
        d="M11.0834 13.2711C10.2668 13.2711 9.50259 12.9153 8.97759 12.2911C8.97176 12.2795 8.93676 12.2503 8.9076 12.2036C8.84343 12.1395 8.76759 12.0228 8.70343 11.912C8.44676 11.4978 8.30676 11.0078 8.30676 10.4945C8.30676 9.6428 8.68593 8.85532 9.3451 8.33032C9.8351 7.93949 10.4534 7.72363 11.0776 7.72363C11.7543 7.72363 12.3784 7.95698 12.8801 8.39448C12.9501 8.44115 13.0318 8.52864 13.1076 8.61031C13.5801 9.12948 13.8426 9.79446 13.8426 10.4886C13.8426 10.9961 13.7026 11.492 13.4401 11.9178C13.3001 12.1628 13.1076 12.3845 12.8859 12.5711C12.4134 13.0261 11.7659 13.2711 11.0834 13.2711ZM11.0834 8.60447C10.6518 8.60447 10.2434 8.75029 9.89926 9.02445C9.45009 9.38029 9.18759 9.92281 9.18759 10.5003C9.18759 10.8445 9.28093 11.1828 9.46176 11.4745C9.50843 11.5561 9.55509 11.6203 9.60759 11.6845C9.61926 11.6962 9.65426 11.7311 9.68343 11.7778C10.0043 12.157 10.5293 12.402 11.0834 12.402C11.5443 12.402 11.9876 12.2328 12.3259 11.9295C12.4776 11.8011 12.6059 11.6495 12.6993 11.4861C12.8859 11.1886 12.9793 10.8503 12.9793 10.5061C12.9793 10.0336 12.7984 9.5728 12.4718 9.21696C12.4309 9.1703 12.3843 9.12365 12.3376 9.08865C11.9701 8.76198 11.5443 8.60447 11.0834 8.60447Z"
        fill="currentColor"
      />
      <path
        d="M11.9525 10.9258H10.2084C9.96921 10.9258 9.77087 10.7274 9.77087 10.4883C9.77087 10.2491 9.96921 10.0508 10.2084 10.0508H11.9525C12.1917 10.0508 12.39 10.2491 12.39 10.4883C12.39 10.7274 12.1975 10.9258 11.9525 10.9258Z"
        fill="currentColor"
      />
      <path
        d="M11.0834 11.8184C10.8442 11.8184 10.6459 11.62 10.6459 11.3809V9.63672C10.6459 9.39755 10.8442 9.19922 11.0834 9.19922C11.3225 9.19922 11.5209 9.39755 11.5209 9.63672V11.3809C11.5209 11.6259 11.3225 11.8184 11.0834 11.8184Z"
        fill="currentColor"
      />
      <path
        d="M6.99958 7.75817C6.92375 7.75817 6.84791 7.74069 6.77791 7.69985L1.62707 4.71903C1.41707 4.59653 1.34708 4.32818 1.46958 4.11818C1.59208 3.90818 1.86041 3.83817 2.06457 3.96067L6.99375 6.81317L11.8937 3.97818C12.1037 3.85568 12.3721 3.93153 12.4887 4.13569C12.6112 4.34569 12.5354 4.61401 12.3312 4.73651L7.21541 7.69985C7.15124 7.73485 7.07541 7.75817 6.99958 7.75817Z"
        fill="currentColor"
      />
      <path
        d="M7 13.0438C6.76083 13.0438 6.5625 12.8454 6.5625 12.6063V7.31543C6.5625 7.07626 6.76083 6.87793 7 6.87793C7.23917 6.87793 7.4375 7.07626 7.4375 7.31543V12.6063C7.4375 12.8454 7.23917 13.0438 7 13.0438Z"
        fill="currentColor"
      />
      <path
        d="M6.99936 13.2706C6.48603 13.2706 5.97269 13.1598 5.57602 12.9323L2.46103 11.2056C1.61519 10.739 0.950195 9.61313 0.950195 8.6448V5.34311C0.950195 4.37478 1.61519 3.2548 2.46103 2.7823L5.57602 1.05562C6.36936 0.606458 7.61769 0.606458 8.41686 1.05562L11.5319 2.7823C12.3777 3.24897 13.0427 4.37478 13.0427 5.34311V8.6448C13.0427 8.70313 13.0427 8.74978 13.031 8.80811C13.0019 8.95978 12.891 9.08811 12.7452 9.13478C12.5994 9.18728 12.436 9.1523 12.3135 9.05314C11.6427 8.4698 10.6044 8.44647 9.89853 9.0123C9.44936 9.36813 9.18686 9.91061 9.18686 10.4881C9.18686 10.8323 9.28019 11.1706 9.46103 11.4623C9.50769 11.544 9.55436 11.6081 9.60686 11.6723C9.69436 11.7715 9.72936 11.9056 9.70603 12.034C9.68269 12.1623 9.60102 12.2731 9.48436 12.3373L8.41686 12.9264C8.02019 13.1598 7.51269 13.2706 6.99936 13.2706ZM6.99936 1.60396C6.63769 1.60396 6.27019 1.6798 6.00769 1.82563L2.8927 3.55231C2.32686 3.86148 1.83686 4.70144 1.83686 5.34311V8.6448C1.83686 9.28646 2.3327 10.1265 2.8927 10.4356L6.00769 12.1623C6.53853 12.4598 7.46603 12.4598 7.99686 12.1623L8.65019 11.8006C8.43436 11.4098 8.31769 10.9548 8.31769 10.4881C8.31769 9.63645 8.69686 8.84897 9.35602 8.32397C10.1494 7.68814 11.2869 7.55395 12.1735 7.93311V5.33147C12.1735 4.6898 11.6777 3.8498 11.1177 3.54063L8.00269 1.81395C7.72853 1.67978 7.36103 1.60396 6.99936 1.60396Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const EmptyTrayIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      {...props}>
      <path
        d="M9.48419 15.6499L11.324 14.2612L5.63667 8.48145L4.52031 9.26632L3.88586 10.7299L4.52031 12.4958L7.59714 15.4686L9.48419 15.6499Z"
        fill="currentColor"
      />
      <path
        d="M6.86395 15.3327L4.38907 12.8578C3.25476 11.7235 3.25476 10.0736 4.38907 8.9393L9.33882 3.98955C10.4731 2.85523 12.1231 2.85523 13.2574 3.98955L15.7322 6.46442C16.8666 7.59874 16.8666 9.24866 15.7322 10.383L10.7825 15.3327C9.64818 16.467 7.99826 16.467 6.86395 15.3327ZM12.6387 4.60827C11.7106 3.68019 10.6258 3.94005 9.95754 4.60827L5.00779 9.55801C4.33958 10.2262 4.07971 11.3111 5.00779 12.2391L7.48266 14.714C8.41074 15.6421 9.49556 15.3822 10.1638 14.714L15.1135 9.76425C15.7817 9.09604 16.0416 8.01122 15.1135 7.08314L12.6387 4.60827Z"
        fill="currentColor"
      />
      <path
        d="M11.0653 14.444L5.29062 8.66929C5.1215 8.50017 5.1215 8.21969 5.29062 8.05057C5.45973 7.88145 5.74022 7.88145 5.90933 8.05057L11.684 13.8253C11.8532 13.9944 11.8532 14.2749 11.684 14.444C11.5149 14.6131 11.2344 14.6131 11.0653 14.444Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const EraseIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="14"
      viewBox="0 0 15 14"
      fill="none"
      {...props}>
      <path
        d="M12.75 13.2715H5.75C5.51083 13.2715 5.3125 13.0732 5.3125 12.834C5.3125 12.5948 5.51083 12.3965 5.75 12.3965H12.75C12.9892 12.3965 13.1875 12.5948 13.1875 12.834C13.1875 13.0732 12.9892 13.2715 12.75 13.2715Z"
        fill="currentColor"
      />
      <path
        d="M5.48207 13.2475C4.89873 13.2475 4.34459 13.02 3.93626 12.6058L1.88875 10.5583C1.03708 9.70666 1.03708 8.31833 1.88875 7.46667L7.97291 1.3825C8.79541 0.56 10.2421 0.56 11.0646 1.3825L13.1121 3.43C13.9637 4.28166 13.9637 5.67 13.1121 6.52166L7.02792 12.6058C6.61958 13.0258 6.07123 13.2475 5.48207 13.2475ZM2.50708 9.94583L4.55459 11.9933C5.05042 12.4892 5.91958 12.4892 6.40958 11.9933L12.4937 5.90916C13.0071 5.39583 13.0071 4.5675 12.4937 4.05416L10.4462 2.00667C9.95624 1.51667 9.08708 1.51083 8.59124 2.00667L2.50708 8.09083C1.99375 8.59833 1.99375 9.4325 2.50708 9.94583Z"
        fill="currentColor"
      />
      <path
        d="M9.17463 10.285C9.0638 10.285 8.95298 10.2442 8.86548 10.1567L4.34465 5.63584C4.17548 5.46667 4.17548 5.18667 4.34465 5.0175C4.51382 4.84833 4.79381 4.84833 4.96298 5.0175L9.48381 9.53833C9.65298 9.7075 9.65298 9.9875 9.48381 10.1567C9.39631 10.2442 9.28546 10.285 9.17463 10.285Z"
        fill="currentColor"
      />
      <path
        d="M2.55325 10.7397C2.44241 10.7397 2.33156 10.6988 2.24406 10.6113C2.0749 10.4422 2.0749 10.1622 2.24406 9.99299L5.54575 6.69133C5.71492 6.52216 5.99491 6.52216 6.16408 6.69133C6.33325 6.86049 6.33325 7.14049 6.16408 7.30966L2.86239 10.6113C2.77489 10.6988 2.66408 10.7397 2.55325 10.7397Z"
        fill="currentColor"
      />
      <path
        d="M4.19778 12.39C4.08694 12.39 3.97609 12.3492 3.88859 12.2617C3.71943 12.0925 3.71943 11.8126 3.88859 11.6434L7.19025 8.34172C7.35941 8.17255 7.63945 8.17255 7.80861 8.34172C7.97778 8.51089 7.97778 8.79088 7.80861 8.96005L4.50693 12.2617C4.42526 12.3434 4.31444 12.39 4.19778 12.39Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const DashboardDimension = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
      <mask
        id="mask0_5915_87310"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="21">
        <rect y="0.6875" width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5915_87310)">
        <path
          d="M7.33366 9.8138L9.12533 8.0013L7.95866 6.8138L7.04199 7.73047L5.87533 6.5638L6.77116 5.64714L5.83366 4.70964L4.02116 6.52214L7.33366 9.8138ZM14.167 16.668L15.9795 14.8555L15.042 13.918L14.1253 14.8138L12.9587 13.6471L13.8545 12.7305L12.667 11.5638L10.8753 13.3555L14.167 16.668ZM6.04199 18.1888H2.50033V14.6471L6.14616 11.0013L1.66699 6.52214L5.83366 2.35547L10.3337 6.85547L13.4795 3.6888C13.6462 3.52214 13.8337 3.39714 14.042 3.3138C14.2503 3.23047 14.4656 3.1888 14.6878 3.1888C14.91 3.1888 15.1253 3.23047 15.3337 3.3138C15.542 3.39714 15.7295 3.52214 15.8962 3.6888L17.0003 4.8138C17.167 4.98047 17.292 5.16797 17.3753 5.3763C17.4587 5.58464 17.5003 5.79991 17.5003 6.02214C17.5003 6.24436 17.4587 6.45616 17.3753 6.65755C17.292 6.85894 17.167 7.04297 17.0003 7.20964L13.8545 10.3763L18.3337 14.8555L14.167 19.0221L9.68783 14.543L6.04199 18.1888ZM4.16699 16.5221H5.33366L13.5003 8.3763L12.3128 7.1888L4.16699 15.3555V16.5221Z"
          fill="#363636"
        />
      </g>
    </svg>
  );
};

export const ResetLeftIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="currentColor"
      height="24"
      width="24"
      {...props}>
      <path d="M22 12C22 17.5228 17.5229 22 12 22C6.4772 22 2 17.5228 2 12C2 6.47715 6.4772 2 12 2V4C7.5817 4 4 7.58172 4 12C4 16.4183 7.5817 20 12 20C16.4183 20 20 16.4183 20 12C20 9.25022 18.6127 6.82447 16.4998 5.38451L16.5 8H14.5V2L20.5 2V4L18.0008 3.99989C20.4293 5.82434 22 8.72873 22 12Z" />
    </svg>
  );
};

export const CheckedIcon = (props) => (
  <svg
    width={13}
    height={13}
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}>
    <rect width={13} height={13} rx={4} fill="url(#pattern0_7740_112047)" />
    <defs>
      <pattern
        id="pattern0_7740_112047"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}>
        <use
          xlinkHref="#image0_7740_112047"
          transform="translate(-0.200962 -0.153846) scale(0.0173077)"
        />
      </pattern>
      <image
        id="image0_7740_112047"
        width={81}
        height={80}
        preserveAspectRatio="none"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFEAAABQCAYAAABh05mTAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAOVSURBVHhe7Zw9ixNBGMefbBJjLi94rwiCCoJNRPwCh4V2IrYWFjbCgYVgJ1hqKygIgo1f4RCxsZH7AuJLIwgqCHJ33sklMZ55OfMPsxAlyd2z82RnZnd+EJKdpJj/j53M7CTPZmq12h55tAjUs0cDL1EAL1EAL1EAL1EAL1EAL1EAL1GAWBbbZ4u7dO5wi04X/tDxfJsWcl0qZnoUZNQHhOj1k7T2AtrsZOlrO08fdw/Rm99FetsqqE9Mh6lJPNaXdbnaoIvlJi3mOqrVDBudHL1qlOj5Tpm+9eVKIy5xLtul63M/6Uq1rlrsYnWnQs+2jtBWN6ta9BGVeKlSp5sL21QKeqrFTpq9gB5vztKLekW16CEm8fbiD2vPvnHgrHywMa+OoiMyO987uu6cQIA+o++6aEtEJ5ZLv9SRe6DvuiK1JGIIuywwBBmQJSqRJWIScXEIjwNZkCkKkSRiGYNZOGkgE7JxiSQR60DblzFRQCZk48KWiCuRJA3j/0E2ZOTAlohLuaTDzciWiGvhpMPNyJKI3RjTmwlxgIzIelBYErGdlRY4WVkSsR+YFjhZWRKxoZoWOFlZErEjnRY4WVkSsaWfFjhZWRKlfxOxGU5WlkRbCZZOUPX+y8GjcOGaao0P5yVC4OzTD5Q/szx4zFy9o96JD6clhgJN46zEUQJ761+o8XBFHcWHkxInCWy/X1Mt8eGcRNsEAqMSIYSDjQKBEYlYhsyvNqh868mBRdoqEBiRGC5DsCSBmP1E2iwQGJHYfvdv8EkibRcIjEhsPFoZiBhmlEgXBAJjE8v2jdpEka4IBMYkgnEiw+/KYWwVCIxKBKNEYiNhGJsFAuMSwSiRIbYLBFZIBKNEuiAQWCMRQGQoDM8uCASsf8q+PvVZvZoumJnHDe84Of/ppHo1GavOxBAbBHJgSUSdSFrgZGVJRKFNWuBkZVlBpVJa4GRlSUSpV1rgZGVJRK1cWuBkZUlEsWFa4GRlSUS1JooNkw4ycipTWRIBqjWTDjcjWyLKXZMONyNbIuqFUViYVJCNWxPNlghQL4xy16SBTMjGJZIJFFyjXjhpIFOUYvLIpxMKrpM0rJElahG51phEwfVac0YduQsy6BSPa3+x3f2+5LRI9B0ZdBCZHdAJF4c2+qwrEPgbaQjgb+kigLjEEH9zIWH8ba48+yIyO6cdL1EAL1EAL1EAL1EAL1EAL1EAL1EAL1EAL1Ebor8usMAnTRNrJAAAAABJRU5ErkJggg=="
      />
    </defs>
  </svg>
);

export const ConfiguratorDownloadIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    fill="#000000"
    {...props}>
    <path d="M480-320 280-520l56-58 104 104v-326h80v326l104-104 56 58-200 200ZM240-160q-33 0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z" />
  </svg>
);

export const CloseFullScreen = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    fill="#000000"
    {...props}>
    <path d="m136-80-56-56 264-264H160v-80h320v320h-80v-184L136-80Zm344-400v-320h80v184l264-264 56 56-264 264h184v80H480Z" />
  </svg>
);

export const OpenFullScreen = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    fill="#000000"
    {...props}>
    <path d="M120-120v-320h80v184l504-504H520v-80h320v320h-80v-184L256-200h184v80H120Z" />
  </svg>
);

export const CircleIconV2 = (props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_3230_18141"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={16}
      height={16}
    >
      <rect width={16} height={16} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_3230_18141)">
      <path
        d="M8.00065 14.6666C7.07843 14.6666 6.21176 14.4916 5.40065 14.1416C4.58954 13.7916 3.88398 13.3166 3.28398 12.7166C2.68398 12.1166 2.20898 11.411 1.85898 10.5999C1.50898 9.78881 1.33398 8.92214 1.33398 7.99992C1.33398 7.0777 1.50898 6.21103 1.85898 5.39992C2.20898 4.58881 2.68398 3.88325 3.28398 3.28325C3.88398 2.68325 4.58954 2.20825 5.40065 1.85825C6.21176 1.50825 7.07843 1.33325 8.00065 1.33325C8.92287 1.33325 9.78954 1.50825 10.6007 1.85825C11.4118 2.20825 12.1173 2.68325 12.7173 3.28325C13.3173 3.88325 13.7923 4.58881 14.1423 5.39992C14.4923 6.21103 14.6673 7.0777 14.6673 7.99992C14.6673 8.92214 14.4923 9.78881 14.1423 10.5999C13.7923 11.411 13.3173 12.1166 12.7173 12.7166C12.1173 13.3166 11.4118 13.7916 10.6007 14.1416C9.78954 14.4916 8.92287 14.6666 8.00065 14.6666ZM8.00065 13.3333C9.48954 13.3333 10.7507 12.8166 11.784 11.7833C12.8173 10.7499 13.334 9.48881 13.334 7.99992C13.334 6.51103 12.8173 5.24992 11.784 4.21659C10.7507 3.18325 9.48954 2.66659 8.00065 2.66659C6.51176 2.66659 5.25065 3.18325 4.21732 4.21659C3.18398 5.24992 2.66732 6.51103 2.66732 7.99992C2.66732 9.48881 3.18398 10.7499 4.21732 11.7833C5.25065 12.8166 6.51176 13.3333 8.00065 13.3333Z"
        fill="currentcolor"
      />
    </g>
  </svg>
);


export const SquareIcon = (props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_3230_18144"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={16}
      height={16}
    >
      <rect width={16} height={16} fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_3230_18144)">
      <path
        d="M3.33333 14C2.96667 14 2.65278 13.8694 2.39167 13.6083C2.13056 13.3472 2 13.0333 2 12.6667V3.33333C2 2.96667 2.13056 2.65278 2.39167 2.39167C2.65278 2.13056 2.96667 2 3.33333 2H12.6667C13.0333 2 13.3472 2.13056 13.6083 2.39167C13.8694 2.65278 14 2.96667 14 3.33333V12.6667C14 13.0333 13.8694 13.3472 13.6083 13.6083C13.3472 13.8694 13.0333 14 12.6667 14H3.33333ZM3.33333 12.6667H12.6667V3.33333H3.33333V12.6667Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const DownArrowIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <g clipPath="url(#clip0_10234_127877)">
        <path
          d="M14.325 8.13281L10.5 11.9495L6.675 8.13281L5.5 9.30781L10.5 14.3078L15.5 9.30781L14.325 8.13281Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_10234_127877">
          <rect width="20" height="20" fill="white" transform="translate(0.5 0.974609)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const LinkSquare = (props) => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <rect x="1.07031" y="1.06958" width="12" height="12" rx="4" fill="transparent" />
      <path
        d="M4.84354 9.85209C4.83187 9.85209 4.81437 9.85209 4.80271 9.85209C4.23687 9.79959 3.70604 9.5371 3.30938 9.1171C2.37604 8.1371 2.37604 6.5446 3.30938 5.5646L4.58688 4.22292C5.04188 3.74459 5.65437 3.47626 6.30771 3.47626C6.96104 3.47626 7.57354 3.73876 8.02854 4.22292C8.96187 5.20292 8.96187 6.79542 8.02854 7.77542L7.39271 8.44625C7.22354 8.62125 6.94938 8.6271 6.77438 8.46377C6.59938 8.2946 6.59354 8.02042 6.75688 7.84542L7.39271 7.17459C8.01104 6.52709 8.01104 5.47126 7.39271 4.82959C6.81521 4.22293 5.80021 4.22293 5.21688 4.82959L3.93938 6.17125C3.32104 6.81875 3.32104 7.8746 3.93938 8.51627C4.19021 8.7846 4.52854 8.94793 4.88437 8.98293C5.12354 9.00626 5.29854 9.2221 5.27521 9.46126C5.25771 9.68293 5.0652 9.85209 4.84354 9.85209Z"
        fill="#2B34E1"
      />
      <path
        d="M7.83489 10.6629C7.18156 10.6629 6.56906 10.4004 6.11406 9.91622C5.18073 8.93622 5.18073 7.34372 6.11406 6.36372L6.74989 5.69289C6.91906 5.51789 7.19323 5.51204 7.36823 5.67538C7.54323 5.84454 7.54906 6.11873 7.38573 6.29373L6.74989 6.96456C6.13156 7.61206 6.13156 8.66788 6.74989 9.30955C7.32739 9.91622 8.34239 9.92205 8.92572 9.30955L10.2032 7.96789C10.8216 7.32039 10.8216 6.26454 10.2032 5.62288C9.95239 5.35454 9.61406 5.19122 9.25823 5.15622C9.01906 5.13288 8.84406 4.91705 8.8674 4.67788C8.89073 4.43871 9.10073 4.25789 9.34573 4.28706C9.91156 4.34539 10.4424 4.60205 10.8391 5.02205C11.7724 6.00205 11.7724 7.59454 10.8391 8.57454L9.56156 9.91622C9.10073 10.4004 8.48823 10.6629 7.83489 10.6629Z"
        fill="#2B34E1"
      />
    </svg>
  );
};

export const RegenerateIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}>
      <g clipPath="url(#clip0_1182_415)">
        <path
          d="M6.54297 17.6055C5.09852 16.9388 3.92491 15.9319 3.02214 14.5846C2.11936 13.2374 1.66797 11.7166 1.66797 10.0221C1.66797 9.66102 1.68533 9.30686 1.72005 8.95964C1.75477 8.61241 1.8138 8.27214 1.89714 7.9388L0.938802 8.5013L0.105469 7.0638L4.08464 4.77214L6.3763 8.73047L4.91797 9.5638L3.79297 7.60547C3.64019 7.98047 3.52561 8.36936 3.44922 8.77214C3.37283 9.17491 3.33464 9.59158 3.33464 10.0221C3.33464 11.3694 3.70269 12.5951 4.4388 13.6992C5.17491 14.8034 6.15408 15.6194 7.3763 16.1471L6.54297 17.6055ZM12.918 7.5013V5.83464H15.1888C14.5499 5.04297 13.7791 4.42839 12.8763 3.99089C11.9735 3.55339 11.0152 3.33464 10.0013 3.33464C9.23741 3.33464 8.51519 3.45269 7.83463 3.6888C7.15408 3.92491 6.52908 4.25825 5.95964 4.6888L5.1263 3.23047C5.82075 2.74436 6.57769 2.36241 7.39713 2.08464C8.21658 1.80686 9.08463 1.66797 10.0013 1.66797C11.0985 1.66797 12.1471 1.87283 13.1471 2.28255C14.1471 2.69227 15.043 3.28602 15.8346 4.0638V2.91797H17.5013V7.5013H12.918ZM12.3763 20.0013L8.39713 17.7096L10.6888 13.7513L12.1263 14.5846L10.9388 16.6263C12.5777 16.3902 13.9423 15.6471 15.0326 14.3971C16.1228 13.1471 16.668 11.6819 16.668 10.0013C16.668 9.84852 16.6645 9.70616 16.6576 9.57422C16.6506 9.44227 16.6332 9.30686 16.6055 9.16797H18.293C18.3069 9.30686 18.3173 9.44227 18.3242 9.57422C18.3312 9.70616 18.3346 9.84852 18.3346 10.0013C18.3346 11.8763 17.7756 13.5534 16.6576 15.0326C15.5395 16.5117 14.0846 17.5082 12.293 18.0221L13.2096 18.5638L12.3763 20.0013Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1182_415">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const NotConnectedIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}>
      <mask
        id="mask0_39_128"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16">
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_39_128)">
        <path
          d="M6.60008 10.3334L8.00008 8.93337L9.40008 10.3334L10.3334 9.40004L8.93342 8.00004L10.3334 6.60004L9.40008 5.66671L8.00008 7.06671L6.60008 5.66671L5.66675 6.60004L7.06675 8.00004L5.66675 9.40004L6.60008 10.3334ZM8.00008 14.6667C6.45564 14.2778 5.18064 13.3917 4.17508 12.0084C3.16953 10.625 2.66675 9.08893 2.66675 7.40004V3.33337L8.00008 1.33337L13.3334 3.33337V7.40004C13.3334 9.08893 12.8306 10.625 11.8251 12.0084C10.8195 13.3917 9.54453 14.2778 8.00008 14.6667ZM8.00008 13.2667C9.15564 12.9 10.1112 12.1667 10.8667 11.0667C11.6223 9.96671 12.0001 8.74448 12.0001 7.40004V4.25004L8.00008 2.75004L4.00008 4.25004V7.40004C4.00008 8.74448 4.37786 9.96671 5.13341 11.0667C5.88897 12.1667 6.84453 12.9 8.00008 13.2667Z"
          fill="#C72626"
        />
      </g>
    </svg>
  );
};
export const ImagineAIV2Icon = (props) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M17.0269 11.3494L12.1913 9.5625L10.4101 4.72312C10.3046 4.43656 10.1137 4.18924 9.86327 4.01455C9.61282 3.83985 9.3148 3.74619 9.00944 3.74619C8.70407 3.74619 8.40606 3.83985 8.1556 4.01455C7.90514 4.18924 7.7143 4.43656 7.60881 4.72312L5.81631 9.5625L0.976936 11.3438C0.69037 11.4492 0.443055 11.6401 0.26836 11.8905C0.0936661 12.141 0 12.439 0 12.7444C0 13.0497 0.0936661 13.3478 0.26836 13.5982C0.443055 13.8487 0.69037 14.0395 0.976936 14.145L5.81631 15.9375L7.59756 20.7769C7.70305 21.0634 7.89389 21.3108 8.14435 21.4855C8.39481 21.6601 8.69282 21.7538 8.99819 21.7538C9.30355 21.7538 9.60157 21.6601 9.85202 21.4855C10.1025 21.3108 10.2933 21.0634 10.3988 20.7769L12.1913 15.9375L17.0307 14.1562C17.3173 14.0508 17.5646 13.8599 17.7393 13.6095C17.914 13.359 18.0076 13.061 18.0076 12.7556C18.0076 12.4503 17.914 12.1522 17.7393 11.9018C17.5646 11.6513 17.3173 11.4605 17.0307 11.355L17.0269 11.3494ZM11.3476 14.6456C11.2458 14.6831 11.1533 14.7423 11.0766 14.819C10.9999 14.8957 10.9407 14.9882 10.9032 15.09L9.00381 20.2359L7.10819 15.0938C7.07073 14.9909 7.0112 14.8974 6.93378 14.82C6.85636 14.7426 6.76294 14.6831 6.66006 14.6456L1.51787 12.75L6.66006 10.8544C6.76294 10.8169 6.85636 10.7574 6.93378 10.68C7.0112 10.6026 7.07073 10.5091 7.10819 10.4062L9.00381 5.26406L10.8994 10.4062C10.937 10.5081 10.9961 10.6005 11.0728 10.6772C11.1496 10.7539 11.242 10.8131 11.3438 10.8506L16.4897 12.75L11.3476 14.6456ZM12.0038 3C12.0038 2.80109 12.0828 2.61032 12.2235 2.46967C12.3641 2.32902 12.5549 2.25 12.7538 2.25H14.2538V0.75C14.2538 0.551088 14.3328 0.360322 14.4735 0.21967C14.6141 0.0790176 14.8049 0 15.0038 0C15.2027 0 15.3935 0.0790176 15.5341 0.21967C15.6748 0.360322 15.7538 0.551088 15.7538 0.75V2.25H17.2538C17.4527 2.25 17.6435 2.32902 17.7841 2.46967C17.9248 2.61032 18.0038 2.80109 18.0038 3C18.0038 3.19891 17.9248 3.38968 17.7841 3.53033C17.6435 3.67098 17.4527 3.75 17.2538 3.75H15.7538V5.25C15.7538 5.44891 15.6748 5.63968 15.5341 5.78033C15.3935 5.92098 15.2027 6 15.0038 6C14.8049 6 14.6141 5.92098 14.4735 5.78033C14.3328 5.63968 14.2538 5.44891 14.2538 5.25V3.75H12.7538C12.5549 3.75 12.3641 3.67098 12.2235 3.53033C12.0828 3.38968 12.0038 3.19891 12.0038 3ZM21.7538 7.5C21.7538 7.69891 21.6748 7.88968 21.5341 8.03033C21.3935 8.17098 21.2027 8.25 21.0038 8.25H20.2538V9C20.2538 9.19891 20.1748 9.38968 20.0341 9.53033C19.8935 9.67098 19.7027 9.75 19.5038 9.75C19.3049 9.75 19.1141 9.67098 18.9735 9.53033C18.8328 9.38968 18.7538 9.19891 18.7538 9V8.25H18.0038C17.8049 8.25 17.6141 8.17098 17.4735 8.03033C17.3328 7.88968 17.2538 7.69891 17.2538 7.5C17.2538 7.30109 17.3328 7.11032 17.4735 6.96967C17.6141 6.82902 17.8049 6.75 18.0038 6.75H18.7538V6C18.7538 5.80109 18.8328 5.61032 18.9735 5.46967C19.1141 5.32902 19.3049 5.25 19.5038 5.25C19.7027 5.25 19.8935 5.32902 20.0341 5.46967C20.1748 5.61032 20.2538 5.80109 20.2538 6V6.75H21.0038C21.2027 6.75 21.3935 6.82902 21.5341 6.96967C21.6748 7.11032 21.7538 7.30109 21.7538 7.5Z"
        fill="#363636"
      />
    </svg>
  );
};

export const VariantIcon = (props) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10 1.5L17.5 5.5V14.5L10 18.5L2.5 14.5V5.5L10 1.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path d="M10 18.5V9.5" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
      <path d="M17.5 5.5L10 9.5L2.5 5.5" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
  );
};

export const ChevronDownIcon = (props) => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M3 4.5L6 7.5L9 4.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ArrowLeftIcon = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10 12L6 8L10 4"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const ArrowRightIcon = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6 4L10 8L6 12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const icons = {
  ImagineAIV2Icon,
  NotConnectedIcon,
  RegenerateIcon,
  CheckedIcon,
  ResetLeftIcon,
  CopyEmbedLink,
  LockIcon,
  DimensionIcon,
  AutoRotateIcon,
  ScreenshotIcon,
  SleepReclinerBad,
  SeatingBad,
  LagAdjustmentBad,
  FullyAdjustmentBad,
  ImagineCheckedIcon,
  RemoveWatermarkIcon,
  ExpandV2Icon,
  DottedCurveLine,
  DraggerIcon,
  ListV2Icon,
  PresentationIcon,
  UploadV2Icon,
  RadioIcon,
  RadioIconFilled,
  CircleIcon,
  PauseInCircleIcon,
  CancelInCircleIcon,
  DollarIcon,
  BackupIconV2,
  BrowseIconV2,
  AddUserIconV2,
  StarIconV2,
  MyPlansIcon,
  WarningContentInfoIcon,
  WarningInfoIcon,
  CardIcon,
  DesignIcon,
  DiscordIcon,
  InstagramIcon,
  FileIcon,
  ModelIcon,
  PDFIcon,
  LeftArrowALT,
  RightArrowALT,
  MagicToolIcon,
  ImagineAIIcon,
  AIVideoPlayIcon,
  RequestImageIcon,
  ImagineLogo,
  CollectFilesIcon,
  ViewInfoIcon,
  FavoriteRedIconV2,
  SingleSelectIcon,
  UploadIconV2,
  PrivacyPolicy,
  PrivacyPolicyV2,
  FilterIcon2,
  TermAndConditionIcon,
  TermAndConditionIconV2,
  InviteMemberIcon,
  ActiveDeactiveIcon,
  CopyIcon,
  CheckIcon,
  FilledInfoIcon,
  PlayVideoIcon,
  PauseIcon,
  RedirectionIcon,
  ThreeSixtyIcon,
  FavoriteRedIcon,
  ARIcon,
  FavoriteIcon,
  ShareProductIcon,
  CheckMarkIcon,
  CancelIcon,
  AddPlusIcon,
  EditPensilIcon,
  DownloadArrowIcon,
  UploadFileIcon,
  DeleteDusbinIcon,
  LifestyleIconTemplate,
  SiloIconTemplate,
  VignetteIconTemplate,
  VideoIconTemplate,
  Timer,
  ImagineIcon,
  CollectionNewIcon,
  AddIcon,
  ARViewerIcon,
  ArchiveIcon,
  ArrowDownIcon,
  SelectArrowDownIcon,
  BinIcon,
  CameraIcon,
  ChangeProfileIcon,
  CloseCircleIcon,
  Close,
  CloseIcon,
  CloseIcon2,
  CloseIconSmall,
  RoundcloseIcon,
  BigCloseIcon,
  CollectionIcon,
  CommentIcon,
  CrownIcon,
  DownloadIcon,
  DownloadHollowIcon,
  EditIcon,
  EditIconV3,
  EyeIcon,
  FigureIcon,
  FileUploadIcon,
  FullScreenIcon,
  HeadsetIcon,
  HeartIcon,
  HeartLineIcon,
  ImageIcon,
  InfoIcon,
  LightIcon,
  MetadataIcon,
  MoreIcon,
  MoveToTextureIcon,
  PlusIcon,
  ProductIcon,
  ProfileIcon,
  LeftArrowIconV3,
  ProjectIcon,
  RenderIcon,
  ReRenderIcon,
  RestoreIcon,
  RoomsIcon,
  SearchIcon,
  SettingsIcon,
  ShareIcon,
  ShareIconNew,
  StyleIcon,
  SupportIcon,
  UserIcon,
  UserGroupIcon,
  UploadIcon,
  UploadIconAlt,
  WarningIcon,
  FilterIcon,
  RequestFileUploadIcon,
  RightCheckIcon,
  WrongCrossIcon,
  RequestDeleteIcon,
  RequestLayoutIcon,
  RequestBoardViewIcon,
  RequestInfo,
  VideoPlayIcon,

  // side & top menu icexport ons
  MyTeamIcon,
  MyTeamIconV2,
  SharedFilesIcon,
  CalendarIcon,
  CommunityIcon,
  MySettingsIcon,
  TrashIcon,
  TrashV2Icon,
  MyFilesIcon,
  RequestThreeDotIcon,
  TutorialsIcon,
  SupportsIcon,
  RequestsIcon,
  RequestsIconV2,
  TutorialHubIcon,
  TutorialsIconV2,
  StrikeIcon,
  CopyLinkIcon,
  CodeIcon,
  HomeIcon,
  MyProductsIcon,
  MyProductsIconV2,
  MyProjectsIcon,
  AutomationIcon,
  RendersPreviewsIcon,
  TemplatesIcon,
  PropsIcon,
  CollectionsIcon,
  SearchBarIcon,
  NotificationsIcon,
  NotificationsActiveIcon,
  NotificationsBellIcon,
  MyAccountIcon,
  AddCreditsIcon,
  LogoutIcon,
  QuitIcon,
  VisibilityOffIcon,
  VisibilityOnIcon,
  TickIcon,
  DeleteIcon,
  GreenTickIcon,
  RedCrossIcon,
  ThreeDotIcon,
  LeftArrowIcon,
  LeftArrowIconV2,
  ArrowIconV2,
  SmallArrowIcon,
  CrossIcon,
  ExclamationIcon,
  RetryIcon,
  TransactionDetailsIcon,
  SharedUsersIcon,
  BriefcaseIcon,
  PhoneIcon,
  LocationIcon,
  PricingIcon,
  FeedbackIcon,
  ExpandIcon,
  PlayIcon,
  SmallPlayIcon,
  GraduationFilledIcon,
  DragIcon,
  ColouredCrownIcon,
  FreeLicenseIcon,
  AttributionIcon,
  ConfiguratorsIcon,
  ListIcon,
  GridIcon,
  FileFolder,
  UploadXLXS,
  DownloadXLXS,
  DownloadV2Icon,
  File,
  Refresh,
  RefreshIconV2,
  CheckCircle,
  ErrorIcon,
  Uploading,
  LeftIcon,
  RightIcon,
  BankAccountIcon,
  JCBCardIcon,
  UnionPayCardIcon,
  DiscoverCardIcon,
  MasterCardIcon,
  AmexCardIcon,
  VisaCardIcon,
  DinersClubCardIcon,
  CreditCardIcon,
  CardIconV2,
  BankAccountIconV2,
  GroupIcon,
  ImageScanSearchIcon,
  DimensionToolIcon,
  DimensionToolIconV2,
  ThemedInfoIcon,
  IFrameIcon,
  LinkIcon,
  AddCircleIcon,
  RemoveCircleIcon,
  RetailAutomationIcon,
  RetailAutomationIconV2,
  WhiteTick,
  // pricing page icons
  EffortlessVariationCreation,
  ComprehensiveCameraControls,
  ChatSupport,
  SceneArchitectureAdjustment,
  PrecisionLightingControl,
  CollaborateAndShareProjects,
  DetailedTextureAndDepthMaps,
  Custom3DModelsOrUploads,
  AdvancedMaterialCustomization,
  StarIcon,
  GoogleNewIcon,
  VerifyEmailIcon,
  RetailAutomationStepLogoCompleted,
  RetailAutomationStepLogo,
  AccordionCloseIcon,
  AccordionOpenIcon,
  CloseIconSmallGreyBack,
  HelpIconQuestionMark,
  TickIconPrimaryColorWhite,
  BackArrowIcon,
  ProductBuilderInternalLayer,
  ProductBuilderExternalLayer,
  CuratorImageIconSmall,
  CutawayViewIcon,
  ExplodedViewIcon,
  NormalViewIcon,
  xRayIcon,
  ReplaceIcon,
  FillTrayIcon,
  EmptyTrayIcon,
  DashboardDimension,
  ConfiguratorDownloadIcon,
  CloseFullScreen,
  OpenFullScreen,
  DownArrowIcon,
  LinkSquare,
  EraseIcon,
  VariantIcon,
  ChevronDownIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
};

export default icons;
